import _construct from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/construct.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e66) { throw _e66; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e67) { didErr = true; err = _e67; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { _registerComponent, registerVersion, _getProvider, getApp, _removeServiceInstance, SDK_VERSION } from '@firebase/app';
import { Component } from '@firebase/component';
import { Logger, LogLevel } from '@firebase/logger';
import { FirebaseError, createMockUserToken, getModularInstance, deepEqual, getUA, isIndexedDBAvailable, isSafari, isMobileCordova, isReactNative, isElectron, isIE, isUWP, isBrowserExtension } from '@firebase/util';
import { XhrIo, EventType, ErrorCode, createWebChannelTransport, getStatEventTarget, FetchXmlHttpFactory, WebChannel, Event, Stat } from '@firebase/webchannel-wrapper';
var D = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */

var C = /*#__PURE__*/function () {
  function C(t) {
    _classCallCheck(this, C);

    this.uid = t;
  }

  _createClass(C, [{
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */

  }, {
    key: "toKey",
    value: function toKey() {
      return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t.uid === this.uid;
    }
  }]);

  return C;
}();
/** A user with a null UID. */


C.UNAUTHENTICATED = new C(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
C.GOOGLE_CREDENTIALS = new C("google-credentials-uid"), C.FIRST_PARTY = new C("first-party-uid"), C.MOCK_USER = new C("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var x = "9.8.3";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var N = new Logger("@firebase/firestore"); // Helper methods are needed because variables can't be exported as read/write

function k() {
  return N.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */


function O(t) {
  N.setLogLevel(t);
}

function M(t) {
  if (N.logLevel <= LogLevel.DEBUG) {
    for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      e[_key - 1] = arguments[_key];
    }

    var n = e.map(B);
    N.debug.apply(N, ["Firestore (".concat(x, "): ").concat(t)].concat(_toConsumableArray(n)));
  }
}

function F(t) {
  if (N.logLevel <= LogLevel.ERROR) {
    for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      e[_key2 - 1] = arguments[_key2];
    }

    var n = e.map(B);
    N.error.apply(N, ["Firestore (".concat(x, "): ").concat(t)].concat(_toConsumableArray(n)));
  }
}
/**
 * @internal
 */


function $(t) {
  if (N.logLevel <= LogLevel.WARN) {
    for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      e[_key3 - 1] = arguments[_key3];
    }

    var n = e.map(B);
    N.warn.apply(N, ["Firestore (".concat(x, "): ").concat(t)].concat(_toConsumableArray(n)));
  }
}
/**
 * Converts an additional log parameter to a string representation.
 */


function B(t) {
  if ("string" == typeof t) return t;

  try {
    return e = t, JSON.stringify(e);
  } catch (e) {
    // Converting to JSON failed, just log the object directly
    return t;
  }
  /**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

  /** Formats an object as a JSON string, suitable for logging. */


  var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */


function L() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Unexpected state";
  // Log the failure in addition to throw an exception, just in case the
  // exception is swallowed.
  var e = "FIRESTORE (".concat(x, ") INTERNAL ASSERTION FAILED: ") + t; // NOTE: We don't use FirestoreError here because these are internal failures
  // that cannot be handled by the user. (Also it would create a circular
  // dependency between the error and assert modules which doesn't work.)

  throw F(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */


function U(t, e) {
  t || L();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */


function q(t, e) {
  t || L();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */


function K(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
  return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var G = {
  // Causes are copied from:
  // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h

  /** Not an error; returned on success. */
  OK: "ok",

  /** The operation was cancelled (typically by the caller). */
  CANCELLED: "cancelled",

  /** Unknown error or an error from a different error domain. */
  UNKNOWN: "unknown",

  /**
   * Client specified an invalid argument. Note that this differs from
   * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
   * problematic regardless of the state of the system (e.g., a malformed file
   * name).
   */
  INVALID_ARGUMENT: "invalid-argument",

  /**
   * Deadline expired before operation could complete. For operations that
   * change the state of the system, this error may be returned even if the
   * operation has completed successfully. For example, a successful response
   * from a server could have been delayed long enough for the deadline to
   * expire.
   */
  DEADLINE_EXCEEDED: "deadline-exceeded",

  /** Some requested entity (e.g., file or directory) was not found. */
  NOT_FOUND: "not-found",

  /**
   * Some entity that we attempted to create (e.g., file or directory) already
   * exists.
   */
  ALREADY_EXISTS: "already-exists",

  /**
   * The caller does not have permission to execute the specified operation.
   * PERMISSION_DENIED must not be used for rejections caused by exhausting
   * some resource (use RESOURCE_EXHAUSTED instead for those errors).
   * PERMISSION_DENIED must not be used if the caller can not be identified
   * (use UNAUTHENTICATED instead for those errors).
   */
  PERMISSION_DENIED: "permission-denied",

  /**
   * The request does not have valid authentication credentials for the
   * operation.
   */
  UNAUTHENTICATED: "unauthenticated",

  /**
   * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
   * entire file system is out of space.
   */
  RESOURCE_EXHAUSTED: "resource-exhausted",

  /**
   * Operation was rejected because the system is not in a state required for
   * the operation's execution. For example, directory to be deleted may be
   * non-empty, an rmdir operation is applied to a non-directory, etc.
   *
   * A litmus test that may help a service implementor in deciding
   * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
   *  (a) Use UNAVAILABLE if the client can retry just the failing call.
   *  (b) Use ABORTED if the client should retry at a higher-level
   *      (e.g., restarting a read-modify-write sequence).
   *  (c) Use FAILED_PRECONDITION if the client should not retry until
   *      the system state has been explicitly fixed. E.g., if an "rmdir"
   *      fails because the directory is non-empty, FAILED_PRECONDITION
   *      should be returned since the client should not retry unless
   *      they have first fixed up the directory by deleting files from it.
   *  (d) Use FAILED_PRECONDITION if the client performs conditional
   *      REST Get/Update/Delete on a resource and the resource on the
   *      server does not match the condition. E.g., conflicting
   *      read-modify-write on the same resource.
   */
  FAILED_PRECONDITION: "failed-precondition",

  /**
   * The operation was aborted, typically due to a concurrency issue like
   * sequencer check failures, transaction aborts, etc.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  ABORTED: "aborted",

  /**
   * Operation was attempted past the valid range. E.g., seeking or reading
   * past end of file.
   *
   * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
   * if the system state changes. For example, a 32-bit file system will
   * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
   * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
   * an offset past the current file size.
   *
   * There is a fair bit of overlap between FAILED_PRECONDITION and
   * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
   * when it applies so that callers who are iterating through a space can
   * easily look for an OUT_OF_RANGE error to detect when they are done.
   */
  OUT_OF_RANGE: "out-of-range",

  /** Operation is not implemented or not supported/enabled in this service. */
  UNIMPLEMENTED: "unimplemented",

  /**
   * Internal errors. Means some invariants expected by underlying System has
   * been broken. If you see one of these errors, Something is very broken.
   */
  INTERNAL: "internal",

  /**
   * The service is currently unavailable. This is a most likely a transient
   * condition and may be corrected by retrying with a backoff.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  UNAVAILABLE: "unavailable",

  /** Unrecoverable data loss or corruption. */
  DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */

var Q = /*#__PURE__*/function (_FirebaseError) {
  _inherits(Q, _FirebaseError);

  var _super = _createSuper(Q);

  /** @hideconstructor */
  function Q(
  /**
   * The backend error code associated with this error.
   */
  t,
  /**
   * A custom error description.
   */
  e) {
    var _this;

    _classCallCheck(this, Q);

    _this = _super.call(this, t, e), _this.code = t, _this.message = e, // HACK: We write a toString property directly because Error is not a real
    // class and so inheritance does not work correctly. We could alternatively
    // do the same "back-door inheritance" trick that FirebaseError does.
    _this.toString = function () {
      return "".concat(_this.name, ": [code=").concat(_this.code, "]: ").concat(_this.message);
    };
    return _this;
  }

  return _createClass(Q);
}(FirebaseError);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var j = /*#__PURE__*/_createClass(function j() {
  var _this2 = this;

  _classCallCheck(this, j);

  this.promise = new Promise(function (t, e) {
    _this2.resolve = t, _this2.reject = e;
  });
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var W = /*#__PURE__*/_createClass(function W(t, e) {
  _classCallCheck(this, W);

  this.user = e, this.type = "OAuth", this.headers = new Map(), this.headers.set("Authorization", "Bearer ".concat(t));
});
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */


var z = /*#__PURE__*/function () {
  function z() {
    _classCallCheck(this, z);
  }

  _createClass(z, [{
    key: "getToken",
    value: function getToken() {
      return Promise.resolve(null);
    }
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {}
  }, {
    key: "start",
    value: function start(t, e) {
      // Fire with initial user.
      t.enqueueRetryable(function () {
        return e(C.UNAUTHENTICATED);
      });
    }
  }, {
    key: "shutdown",
    value: function shutdown() {}
  }]);

  return z;
}();
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */


var H = /*#__PURE__*/function () {
  function H(t) {
    _classCallCheck(this, H);

    this.token = t,
    /**
     * Stores the listener registered with setChangeListener()
     * This isn't actually necessary since the UID never changes, but we use this
     * to verify the listen contract is adhered to in tests.
     */
    this.changeListener = null;
  }

  _createClass(H, [{
    key: "getToken",
    value: function getToken() {
      return Promise.resolve(this.token);
    }
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {}
  }, {
    key: "start",
    value: function start(t, e) {
      var _this3 = this;

      this.changeListener = e, // Fire with initial user.
      t.enqueueRetryable(function () {
        return e(_this3.token.user);
      });
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.changeListener = null;
    }
  }]);

  return H;
}();

var J = /*#__PURE__*/function () {
  function J(t) {
    _classCallCheck(this, J);

    this.t = t,
    /** Tracks the current User. */
    this.currentUser = C.UNAUTHENTICATED,
    /**
     * Counter used to detect if the token changed while a getToken request was
     * outstanding.
     */
    this.i = 0, this.forceRefresh = !1, this.auth = null;
  }

  _createClass(J, [{
    key: "start",
    value: function start(t, e) {
      var _this4 = this;

      var n = this.i; // A change listener that prevents double-firing for the same token change.

      var s = function s(t) {
        return _this4.i !== n ? (n = _this4.i, e(t)) : Promise.resolve();
      }; // A promise that can be waited on to block on the next token change.
      // This promise is re-created after each change.


      var i = new j();

      this.o = function () {
        _this4.i++, _this4.currentUser = _this4.u(), i.resolve(), i = new j(), t.enqueueRetryable(function () {
          return s(_this4.currentUser);
        });
      };

      var r = function r() {
        var e = i;
        t.enqueueRetryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return e.promise;

                case 2:
                  _context.next = 4;
                  return s(_this4.currentUser);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      },
          o = function o(t) {
        M("FirebaseAuthCredentialsProvider", "Auth detected"), _this4.auth = t, _this4.auth.addAuthTokenListener(_this4.o), r();
      };

      this.t.onInit(function (t) {
        return o(t);
      }), // Our users can initialize Auth right after Firestore, so we give it
      // a chance to register itself with the component framework before we
      // determine whether to start up in unauthenticated mode.
      setTimeout(function () {
        if (!_this4.auth) {
          var _t2 = _this4.t.getImmediate({
            optional: !0
          });

          _t2 ? o(_t2) : ( // If auth is still not available, proceed with `null` user
          M("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new j());
        }
      }, 0), r();
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this5 = this;

      // Take note of the current value of the tokenCounter so that this method
      // can fail (with an ABORTED error) if there is a token change while the
      // request is outstanding.
      var t = this.i,
          e = this.forceRefresh;
      return this.forceRefresh = !1, this.auth ? this.auth.getToken(e).then(function (e) {
        return (// Cancel the request since the token changed while the request was
          // outstanding so the response is potentially for a previous user (which
          // user, we can't be sure).
          _this5.i !== t ? (M("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), _this5.getToken()) : e ? (U("string" == typeof e.accessToken), new W(e.accessToken, _this5.currentUser)) : null
        );
      }) : Promise.resolve(null);
    }
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {
      this.forceRefresh = !0;
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.auth && this.auth.removeAuthTokenListener(this.o);
    } // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.

  }, {
    key: "u",
    value: function u() {
      var t = this.auth && this.auth.getUid();
      return U(null === t || "string" == typeof t), new C(t);
    }
  }]);

  return J;
}();
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */


var Y = /*#__PURE__*/_createClass(function Y(t, e, n) {
  _classCallCheck(this, Y);

  this.type = "FirstParty", this.user = C.FIRST_PARTY, this.headers = new Map(), this.headers.set("X-Goog-AuthUser", e);
  var s = t.auth.getAuthHeaderValueForFirstParty([]);
  s && this.headers.set("Authorization", s), n && this.headers.set("X-Goog-Iam-Authorization-Token", n);
});
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */


var X = /*#__PURE__*/function () {
  function X(t, e, n) {
    _classCallCheck(this, X);

    this.h = t, this.l = e, this.m = n;
  }

  _createClass(X, [{
    key: "getToken",
    value: function getToken() {
      return Promise.resolve(new Y(this.h, this.l, this.m));
    }
  }, {
    key: "start",
    value: function start(t, e) {
      // Fire with initial uid.
      t.enqueueRetryable(function () {
        return e(C.FIRST_PARTY);
      });
    }
  }, {
    key: "shutdown",
    value: function shutdown() {}
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {}
  }]);

  return X;
}();

var Z = /*#__PURE__*/_createClass(function Z(t) {
  _classCallCheck(this, Z);

  this.value = t, this.type = "AppCheck", this.headers = new Map(), t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
});

var tt = /*#__PURE__*/function () {
  function tt(t) {
    _classCallCheck(this, tt);

    this.g = t, this.forceRefresh = !1, this.appCheck = null, this.p = null;
  }

  _createClass(tt, [{
    key: "start",
    value: function start(t, e) {
      var _this6 = this;

      var n = function n(t) {
        null != t.error && M("FirebaseAppCheckTokenProvider", "Error getting App Check token; using placeholder token instead. Error: ".concat(t.error.message));
        var n = t.token !== _this6.p;
        return _this6.p = t.token, M("FirebaseAppCheckTokenProvider", "Received ".concat(n ? "new" : "existing", " token.")), n ? e(t.token) : Promise.resolve();
      };

      this.o = function (e) {
        t.enqueueRetryable(function () {
          return n(e);
        });
      };

      var s = function s(t) {
        M("FirebaseAppCheckTokenProvider", "AppCheck detected"), _this6.appCheck = t, _this6.appCheck.addTokenListener(_this6.o);
      };

      this.g.onInit(function (t) {
        return s(t);
      }), // Our users can initialize AppCheck after Firestore, so we give it
      // a chance to register itself with the component framework.
      setTimeout(function () {
        if (!_this6.appCheck) {
          var _t3 = _this6.g.getImmediate({
            optional: !0
          });

          _t3 ? s(_t3) : // If AppCheck is still not available, proceed without it.
          M("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
        }
      }, 0);
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _this7 = this;

      var t = this.forceRefresh;
      return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then(function (t) {
        return t ? (U("string" == typeof t.token), _this7.p = t.token, new Z(t.token)) : null;
      }) : Promise.resolve(null);
    }
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {
      this.forceRefresh = !0;
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
  }]);

  return tt;
}();
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */


var et = /*#__PURE__*/function () {
  function et() {
    _classCallCheck(this, et);
  }

  _createClass(et, [{
    key: "getToken",
    value: function getToken() {
      return Promise.resolve(new Z(""));
    }
  }, {
    key: "invalidateToken",
    value: function invalidateToken() {}
  }, {
    key: "start",
    value: function start(t, e) {}
  }, {
    key: "shutdown",
    value: function shutdown() {}
  }]);

  return et;
}();
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */


function nt(t) {
  // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
  var e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
  "undefined" != typeof self && (self.crypto || self.msCrypto),
      n = new Uint8Array(t);
  if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);else // Falls back to Math.random
    for (var _e2 = 0; _e2 < t; _e2++) {
      n[_e2] = Math.floor(256 * Math.random());
    }
  return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var st = /*#__PURE__*/function () {
  function st() {
    _classCallCheck(this, st);
  }

  _createClass(st, null, [{
    key: "I",
    value: function I() {
      // Alphanumeric characters
      var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
          e = Math.floor(256 / t.length) * t.length; // The largest byte value that is a multiple of `char.length`.

      var n = "";

      for (; n.length < 20;) {
        var s = nt(40);

        for (var i = 0; i < s.length; ++i) {
          // Only accept values that are [0, maxMultiple), this ensures they can
          // be evenly mapped to indices of `chars` via a modulo operation.
          n.length < 20 && s[i] < e && (n += t.charAt(s[i] % t.length));
        }
      }

      return n;
    }
  }]);

  return st;
}();

function it(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */


function rt(t, e, n) {
  return t.length === e.length && t.every(function (t, s) {
    return n(t, e[s]);
  });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */


function ot(t) {
  // Return the input string, with an additional NUL byte appended.
  return t + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).

/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */


var ut = /*#__PURE__*/function () {
  /**
   * Creates a new timestamp.
   *
   * @param seconds - The number of seconds of UTC time since Unix epoch
   *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   *     9999-12-31T23:59:59Z inclusive.
   * @param nanoseconds - The non-negative fractions of a second at nanosecond
   *     resolution. Negative second values with fractions must still have
   *     non-negative nanoseconds values that count forward in time. Must be
   *     from 0 to 999,999,999 inclusive.
   */
  function ut(
  /**
   * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
   */
  t,
  /**
   * The fractions of a second at nanosecond resolution.*
   */
  e) {
    _classCallCheck(this, ut);

    if (this.seconds = t, this.nanoseconds = e, e < 0) throw new Q(G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
    if (e >= 1e9) throw new Q(G.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
    if (t < -62135596800) throw new Q(G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t); // This will break in the year 10,000.

    if (t >= 253402300800) throw new Q(G.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
  }
  /**
   * Creates a new timestamp with the current date, with millisecond precision.
   *
   * @returns a new timestamp representing the current date.
   */


  _createClass(ut, [{
    key: "toDate",
    value:
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */
    function toDate() {
      return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */

  }, {
    key: "toMillis",
    value: function toMillis() {
      return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
  }, {
    key: "_compareTo",
    value: function _compareTo(t) {
      return this.seconds === t.seconds ? it(this.nanoseconds, t.nanoseconds) : it(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */

  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */

  }, {
    key: "toString",
    value: function toString() {
      return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        seconds: this.seconds,
        nanoseconds: this.nanoseconds
      };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */

  }, {
    key: "valueOf",
    value: function valueOf() {
      // This method returns a string of the form <seconds>.<nanoseconds> where
      // <seconds> is translated to have a non-negative value and both <seconds>
      // and <nanoseconds> are left-padded with zeroes to be a consistent length.
      // Strings with this format then have a lexiographical ordering that matches
      // the expected ordering. The <seconds> translation is done to avoid having
      // a leading negative sign (i.e. a leading '-' character) in its string
      // representation, which would affect its lexiographical ordering.
      var t = this.seconds - -62135596800; // Note: Up to 12 decimal digits are required to represent all valid
      // 'seconds' values.

      return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
  }], [{
    key: "now",
    value: function now() {
      return ut.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */

  }, {
    key: "fromDate",
    value: function fromDate(t) {
      return ut.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */

  }, {
    key: "fromMillis",
    value: function fromMillis(t) {
      var e = Math.floor(t / 1e3),
          n = Math.floor(1e6 * (t - 1e3 * e));
      return new ut(e, n);
    }
  }]);

  return ut;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */


var ct = /*#__PURE__*/function () {
  function ct(t) {
    _classCallCheck(this, ct);

    this.timestamp = t;
  }

  _createClass(ct, [{
    key: "compareTo",
    value: function compareTo(t) {
      return this.timestamp._compareTo(t.timestamp);
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */

  }, {
    key: "toMicroseconds",
    value: function toMicroseconds() {
      // Convert to microseconds.
      return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
  }, {
    key: "toTimestamp",
    value: function toTimestamp() {
      return this.timestamp;
    }
  }], [{
    key: "fromTimestamp",
    value: function fromTimestamp(t) {
      return new ct(t);
    }
  }, {
    key: "min",
    value: function min() {
      return new ct(new ut(0, 0));
    }
  }, {
    key: "max",
    value: function max() {
      return new ct(new ut(253402300799, 999999999));
    }
  }]);

  return ct;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Path represents an ordered sequence of string segments.
 */


var at = /*#__PURE__*/function () {
  function at(t, e, n) {
    _classCallCheck(this, at);

    void 0 === e ? e = 0 : e > t.length && L(), void 0 === n ? n = t.length - e : n > t.length - e && L(), this.segments = t, this.offset = e, this.len = n;
  }

  _createClass(at, [{
    key: "length",
    get: function get() {
      return this.len;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return 0 === at.comparator(this, t);
    }
  }, {
    key: "child",
    value: function child(t) {
      var e = this.segments.slice(this.offset, this.limit());
      return t instanceof at ? t.forEach(function (t) {
        e.push(t);
      }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */

  }, {
    key: "limit",
    value: function limit() {
      return this.offset + this.length;
    }
  }, {
    key: "popFirst",
    value: function popFirst(t) {
      return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
  }, {
    key: "popLast",
    value: function popLast() {
      return this.construct(this.segments, this.offset, this.length - 1);
    }
  }, {
    key: "firstSegment",
    value: function firstSegment() {
      return this.segments[this.offset];
    }
  }, {
    key: "lastSegment",
    value: function lastSegment() {
      return this.get(this.length - 1);
    }
  }, {
    key: "get",
    value: function get(t) {
      return this.segments[this.offset + t];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return 0 === this.length;
    }
  }, {
    key: "isPrefixOf",
    value: function isPrefixOf(t) {
      if (t.length < this.length) return !1;

      for (var e = 0; e < this.length; e++) {
        if (this.get(e) !== t.get(e)) return !1;
      }

      return !0;
    }
  }, {
    key: "isImmediateParentOf",
    value: function isImmediateParentOf(t) {
      if (this.length + 1 !== t.length) return !1;

      for (var e = 0; e < this.length; e++) {
        if (this.get(e) !== t.get(e)) return !1;
      }

      return !0;
    }
  }, {
    key: "forEach",
    value: function forEach(t) {
      for (var e = this.offset, n = this.limit(); e < n; e++) {
        t(this.segments[e]);
      }
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.segments.slice(this.offset, this.limit());
    }
  }], [{
    key: "comparator",
    value: function comparator(t, e) {
      var n = Math.min(t.length, e.length);

      for (var s = 0; s < n; s++) {
        var _n2 = t.get(s),
            i = e.get(s);

        if (_n2 < i) return -1;
        if (_n2 > i) return 1;
      }

      return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
  }]);

  return at;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */


var ht = /*#__PURE__*/function (_at) {
  _inherits(ht, _at);

  var _super2 = _createSuper(ht);

  function ht() {
    _classCallCheck(this, ht);

    return _super2.apply(this, arguments);
  }

  _createClass(ht, [{
    key: "construct",
    value: function construct(t, e, n) {
      return new ht(t, e, n);
    }
  }, {
    key: "canonicalString",
    value: function canonicalString() {
      // NOTE: The client is ignorant of any path segments containing escape
      // sequences (e.g. __id123__) and just passes them through raw (they exist
      // for legacy reasons and should not be used frequently).
      return this.toArray().join("/");
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */

  }], [{
    key: "fromString",
    value: function fromString() {
      // NOTE: The client is ignorant of any path segments containing escape
      // sequences (e.g. __id123__) and just passes them through raw (they exist
      // for legacy reasons and should not be used frequently).
      var e = [];

      for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        t[_key4] = arguments[_key4];
      }

      for (var _i2 = 0, _t4 = t; _i2 < _t4.length; _i2++) {
        var n = _t4[_i2];
        if (n.indexOf("//") >= 0) throw new Q(G.INVALID_ARGUMENT, "Invalid segment (".concat(n, "). Paths must not contain // in them.")); // Strip leading and traling slashed.

        e.push.apply(e, _toConsumableArray(n.split("/").filter(function (t) {
          return t.length > 0;
        })));
      }

      return new ht(e);
    }
  }, {
    key: "emptyPath",
    value: function emptyPath() {
      return new ht([]);
    }
  }]);

  return ht;
}(at);

var lt = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */

var ft = /*#__PURE__*/function (_at2) {
  _inherits(ft, _at2);

  var _super3 = _createSuper(ft);

  function ft() {
    _classCallCheck(this, ft);

    return _super3.apply(this, arguments);
  }

  _createClass(ft, [{
    key: "construct",
    value: function construct(t, e, n) {
      return new ft(t, e, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */

  }, {
    key: "canonicalString",
    value: function canonicalString() {
      return this.toArray().map(function (t) {
        return t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), ft.isValidIdentifier(t) || (t = "`" + t + "`"), t;
      }).join(".");
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */

  }, {
    key: "isKeyField",
    value: function isKeyField() {
      return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */

  }], [{
    key: "isValidIdentifier",
    value: function isValidIdentifier(t) {
      return lt.test(t);
    }
  }, {
    key: "keyField",
    value: function keyField() {
      return new ft(["__name__"]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */

  }, {
    key: "fromServerFormat",
    value: function fromServerFormat(t) {
      var e = [];
      var n = "",
          s = 0;

      var i = function i() {
        if (0 === n.length) throw new Q(G.INVALID_ARGUMENT, "Invalid field path (".concat(t, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"));
        e.push(n), n = "";
      };

      var r = !1;

      for (; s < t.length;) {
        var _e3 = t[s];

        if ("\\" === _e3) {
          if (s + 1 === t.length) throw new Q(G.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
          var _e4 = t[s + 1];
          if ("\\" !== _e4 && "." !== _e4 && "`" !== _e4) throw new Q(G.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
          n += _e4, s += 2;
        } else "`" === _e3 ? (r = !r, s++) : "." !== _e3 || r ? (n += _e3, s++) : (i(), s++);
      }

      if (i(), r) throw new Q(G.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
      return new ft(e);
    }
  }, {
    key: "emptyPath",
    value: function emptyPath() {
      return new ft([]);
    }
  }]);

  return ft;
}(at);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @internal
 */


var dt = /*#__PURE__*/function () {
  function dt(t) {
    _classCallCheck(this, dt);

    this.path = t;
  }

  _createClass(dt, [{
    key: "collectionGroup",
    get: function get() {
      return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */

  }, {
    key: "hasCollectionId",
    value: function hasCollectionId(t) {
      return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */

  }, {
    key: "getCollectionGroup",
    value: function getCollectionGroup() {
      return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */

  }, {
    key: "getCollectionPath",
    value: function getCollectionPath() {
      return this.path.popLast();
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return null !== t && 0 === ht.comparator(this.path, t.path);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.path.toString();
    }
  }], [{
    key: "fromPath",
    value: function fromPath(t) {
      return new dt(ht.fromString(t));
    }
  }, {
    key: "fromName",
    value: function fromName(t) {
      return new dt(ht.fromString(t).popFirst(5));
    }
  }, {
    key: "empty",
    value: function empty() {
      return new dt(ht.emptyPath());
    }
  }, {
    key: "comparator",
    value: function comparator(t, e) {
      return ht.comparator(t.path, e.path);
    }
  }, {
    key: "isDocumentKey",
    value: function isDocumentKey(t) {
      return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */

  }, {
    key: "fromSegments",
    value: function fromSegments(t) {
      return new dt(new ht(t.slice()));
    }
  }]);

  return dt;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */

/**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */


var _t = /*#__PURE__*/_createClass(function _t(
/**
 * The index ID. Returns -1 if the index ID is not available (e.g. the index
 * has not yet been persisted).
 */
t,
/** The collection ID this index applies to. */
e,
/** The field segments for this index. */
n,
/** Shows how up-to-date the index is for the current user. */
s) {
  _classCallCheck(this, _t);

  this.indexId = t, this.collectionGroup = e, this.fields = n, this.indexState = s;
});
/** An ID for an index that has not yet been added to persistence.  */

/** Returns the ArrayContains/ArrayContainsAny segment for this index. */


function wt(t) {
  return t.fields.find(function (t) {
    return 2
    /* CONTAINS */
    === t.kind;
  });
}
/** Returns all directional (ascending/descending) segments for this index. */


function mt(t) {
  return t.fields.filter(function (t) {
    return 2
    /* CONTAINS */
    !== t.kind;
  });
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */


_t.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */

var gt = /*#__PURE__*/_createClass(function gt(
/** The field path of the component. */
t,
/** The fields sorting order. */
e) {
  _classCallCheck(this, gt);

  this.fieldPath = t, this.kind = e;
});
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */


var yt = /*#__PURE__*/function () {
  function yt(
  /**
   * Indicates when the index was last updated (relative to other indexes).
   */
  t,
  /** The the latest indexed read time, document and batch id. */
  e) {
    _classCallCheck(this, yt);

    this.sequenceNumber = t, this.offset = e;
  }
  /** The state of an index that has not yet been backfilled. */


  _createClass(yt, null, [{
    key: "empty",
    value: function empty() {
      return new yt(0, Tt.min());
    }
  }]);

  return yt;
}();
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */


function pt(t, e) {
  // We want to create an offset that matches all documents with a read time
  // greater than the provided read time. To do so, we technically need to
  // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
  // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
  // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
  // all valid document IDs.
  var n = t.toTimestamp().seconds,
      s = t.toTimestamp().nanoseconds + 1,
      i = ct.fromTimestamp(1e9 === s ? new ut(n + 1, 0) : new ut(n, s));
  return new Tt(i, dt.empty(), e);
}
/** Creates a new offset based on the provided document. */


function It(t) {
  return new Tt(t.readTime, t.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */


var Tt = /*#__PURE__*/function () {
  function Tt(
  /**
   * The latest read time version that has been indexed by Firestore for this
   * field index.
   */
  t,
  /**
   * The key of the last document that was indexed for this query. Use
   * `DocumentKey.empty()` if no document has been indexed.
   */
  e,
  /*
   * The largest mutation batch id that's been processed by Firestore.
   */
  n) {
    _classCallCheck(this, Tt);

    this.readTime = t, this.documentKey = e, this.largestBatchId = n;
  }
  /** Returns an offset that sorts before all regular offsets. */


  _createClass(Tt, null, [{
    key: "min",
    value: function min() {
      return new Tt(ct.min(), dt.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */

  }, {
    key: "max",
    value: function max() {
      return new Tt(ct.max(), dt.empty(), -1);
    }
  }]);

  return Tt;
}();

function Et(t, e) {
  var n = t.readTime.compareTo(e.readTime);
  return 0 !== n ? n : (n = dt.comparator(t.documentKey, e.documentKey), 0 !== n ? n : it(t.largestBatchId, e.largestBatchId));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(indexing): Remove this constant


var At = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */

var Rt = /*#__PURE__*/function () {
  function Rt() {
    _classCallCheck(this, Rt);

    this.onCommittedListeners = [];
  }

  _createClass(Rt, [{
    key: "addOnCommittedListener",
    value: function addOnCommittedListener(t) {
      this.onCommittedListeners.push(t);
    }
  }, {
    key: "raiseOnCommittedEvent",
    value: function raiseOnCommittedEvent() {
      this.onCommittedListeners.forEach(function (t) {
        return t();
      });
    }
  }]);

  return Rt;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */


function bt(_x) {
  return _bt.apply(this, arguments);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */


function _bt() {
  _bt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(t) {
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            if (!(t.code !== G.FAILED_PRECONDITION || t.message !== At)) {
              _context72.next = 2;
              break;
            }

            throw t;

          case 2:
            M("LocalStore", "Unexpectedly lost primary lease");

          case 3:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72);
  }));
  return _bt.apply(this, arguments);
}

var Pt = /*#__PURE__*/function () {
  function Pt(t) {
    var _this8 = this;

    _classCallCheck(this, Pt);

    // NOTE: next/catchCallback will always point to our own wrapper functions,
    // not the user's raw next() or catch() callbacks.
    this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
    this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
    // chaining.
    this.callbackAttached = !1, t(function (t) {
      _this8.isDone = !0, _this8.result = t, _this8.nextCallback && // value should be defined unless T is Void, but we can't express
      // that in the type system.
      _this8.nextCallback(t);
    }, function (t) {
      _this8.isDone = !0, _this8.error = t, _this8.catchCallback && _this8.catchCallback(t);
    });
  }

  _createClass(Pt, [{
    key: "catch",
    value: function _catch(t) {
      return this.next(void 0, t);
    }
  }, {
    key: "next",
    value: function next(t, e) {
      var _this9 = this;

      return this.callbackAttached && L(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(e, this.error) : this.wrapSuccess(t, this.result) : new Pt(function (n, s) {
        _this9.nextCallback = function (e) {
          _this9.wrapSuccess(t, e).next(n, s);
        }, _this9.catchCallback = function (t) {
          _this9.wrapFailure(e, t).next(n, s);
        };
      });
    }
  }, {
    key: "toPromise",
    value: function toPromise() {
      var _this10 = this;

      return new Promise(function (t, e) {
        _this10.next(t, e);
      });
    }
  }, {
    key: "wrapUserFunction",
    value: function wrapUserFunction(t) {
      try {
        var e = t();
        return e instanceof Pt ? e : Pt.resolve(e);
      } catch (t) {
        return Pt.reject(t);
      }
    }
  }, {
    key: "wrapSuccess",
    value: function wrapSuccess(t, e) {
      return t ? this.wrapUserFunction(function () {
        return t(e);
      }) : Pt.resolve(e);
    }
  }, {
    key: "wrapFailure",
    value: function wrapFailure(t, e) {
      return t ? this.wrapUserFunction(function () {
        return t(e);
      }) : Pt.reject(e);
    }
  }], [{
    key: "resolve",
    value: function resolve(t) {
      return new Pt(function (e, n) {
        e(t);
      });
    }
  }, {
    key: "reject",
    value: function reject(t) {
      return new Pt(function (e, n) {
        n(t);
      });
    }
  }, {
    key: "waitFor",
    value: function waitFor( // Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t) {
      return new Pt(function (e, n) {
        var s = 0,
            i = 0,
            r = !1;
        t.forEach(function (t) {
          ++s, t.next(function () {
            ++i, r && i === s && e();
          }, function (t) {
            return n(t);
          });
        }), r = !0, i === s && e();
      });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */

  }, {
    key: "or",
    value: function or(t) {
      var e = Pt.resolve(!1);

      var _iterator = _createForOfIteratorHelper(t),
          _step;

      try {
        var _loop = function _loop() {
          var n = _step.value;
          e = e.next(function (t) {
            return t ? Pt.resolve(t) : n();
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return e;
    }
  }, {
    key: "forEach",
    value: function forEach(t, e) {
      var _this11 = this;

      var n = [];
      return t.forEach(function (t, s) {
        n.push(e.call(_this11, t, s));
      }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */

  }, {
    key: "mapArray",
    value: function mapArray(t, e) {
      return new Pt(function (n, s) {
        var i = t.length,
            r = new Array(i);
        var o = 0;

        var _loop2 = function _loop2(u) {
          var c = u;
          e(t[c]).next(function (t) {
            r[c] = t, ++o, o === i && n(r);
          }, function (t) {
            return s(t);
          });
        };

        for (var u = 0; u < i; u++) {
          _loop2(u);
        }
      });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */

  }, {
    key: "doWhile",
    value: function doWhile(t, e) {
      return new Pt(function (n, s) {
        var i = function i() {
          !0 === t() ? e().next(function () {
            i();
          }, s) : n();
        };

        i();
      });
    }
  }]);

  return Pt;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// References to `window` are guarded by SimpleDb.isAvailable()

/* eslint-disable no-restricted-globals */

/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */


var vt = /*#__PURE__*/function () {
  function vt(t, e) {
    var _this12 = this;

    _classCallCheck(this, vt);

    this.action = t, this.transaction = e, this.aborted = !1,
    /**
     * A `Promise` that resolves with the result of the IndexedDb transaction.
     */
    this.T = new j(), this.transaction.oncomplete = function () {
      _this12.T.resolve();
    }, this.transaction.onabort = function () {
      e.error ? _this12.T.reject(new Dt(t, e.error)) : _this12.T.resolve();
    }, this.transaction.onerror = function (e) {
      var n = Ot(e.target.error);

      _this12.T.reject(new Dt(t, n));
    };
  }

  _createClass(vt, [{
    key: "A",
    get: function get() {
      return this.T.promise;
    }
  }, {
    key: "abort",
    value: function abort(t) {
      t && this.T.reject(t), this.aborted || (M("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
  }, {
    key: "R",
    value: function R() {
      // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
      // speed up index DB processing if the event loop remains blocks.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var t = this.transaction;
      this.aborted || "function" != typeof t.commit || t.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */

  }, {
    key: "store",
    value: function store(t) {
      var e = this.transaction.objectStore(t);
      return new xt(e);
    }
  }], [{
    key: "open",
    value: function open(t, e, n, s) {
      try {
        return new vt(e, t.transaction(s, n));
      } catch (t) {
        throw new Dt(e, t);
      }
    }
  }]);

  return vt;
}();
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */


var Vt = /*#__PURE__*/function () {
  /*
   * Creates a new SimpleDb wrapper for IndexedDb database `name`.
   *
   * Note that `version` must not be a downgrade. IndexedDB does not support
   * downgrading the schema version. We currently do not support any way to do
   * versioning outside of IndexedDB's versioning mechanism, as only
   * version-upgrade transactions are allowed to do things like create
   * objectstores.
   */
  function Vt(t, e, n) {
    _classCallCheck(this, Vt);

    this.name = t, this.version = e, this.P = n; // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
    // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
    // whatever reason it's much harder to hit after 12.2 so we only proactively
    // log on 12.2.

    12.2 === Vt.v(getUA()) && F("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
  }
  /** Deletes the specified database. */


  _createClass(Vt, [{
    key: "k",
    value:
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */
    function () {
      var _k = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.db;

                if (_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                M("SimpleDb", "Opening database:", this.name);
                _context2.next = 5;
                return new Promise(function (e, n) {
                  // TODO(mikelehen): Investigate browser compatibility.
                  // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                  // suggests IE9 and older WebKit browsers handle upgrade
                  // differently. They expect setVersion, as described here:
                  // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                  var s = indexedDB.open(_this13.name, _this13.version);
                  s.onsuccess = function (t) {
                    var n = t.target.result;
                    e(n);
                  }, s.onblocked = function () {
                    n(new Dt(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                  }, s.onerror = function (e) {
                    var s = e.target.error;
                    "VersionError" === s.name ? n(new Q(G.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === s.name ? n(new Q(G.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + s)) : n(new Dt(t, s));
                  }, s.onupgradeneeded = function (t) {
                    M("SimpleDb", 'Database "' + _this13.name + '" requires upgrade from version:', t.oldVersion);
                    var e = t.target.result;

                    _this13.P.O(e, s.transaction, t.oldVersion, _this13.version).next(function () {
                      M("SimpleDb", "Database upgrade to version " + _this13.version + " complete");
                    });
                  };
                });

              case 5:
                this.db = _context2.sent;

              case 6:
                this.M && (this.db.onversionchange = function (t) {
                  return _this13.M(t);
                });
                return _context2.abrupt("return", this.db);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function k(_x2) {
        return _k.apply(this, arguments);
      }

      return k;
    }()
  }, {
    key: "F",
    value: function F(t) {
      this.M = t, this.db && (this.db.onversionchange = function (e) {
        return t(e);
      });
    }
  }, {
    key: "runTransaction",
    value: function () {
      var _runTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t, e, n, s) {
        var _this14 = this;

        var i, r, _ret, _e5;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                i = "readonly" === e;
                r = 0;

              case 2:
                ++r;
                _context4.prev = 3;
                return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var e, r;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this14.k(t);

                        case 2:
                          _this14.db = _context3.sent;
                          e = vt.open(_this14.db, t, i ? "readonly" : "readwrite", n), r = s(e).next(function (t) {
                            return e.R(), t;
                          }).catch(function (t) {
                            return (// Abort the transaction if there was an error.
                              e.abort(t), Pt.reject(t)
                            );
                          }).toPromise(); // As noted above, errors are propagated by aborting the transaction. So
                          // we swallow any error here to avoid the browser logging it as unhandled.

                          r.catch(function () {});
                          _context3.next = 7;
                          return e.A;

                        case 7:
                          _context3.t0 = r;
                          return _context3.abrupt("return", {
                            v: _context3.t0
                          });

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })(), "t0", 5);

              case 5:
                _ret = _context4.t0;

                if (!(typeof _ret === "object")) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", _ret.v);

              case 8:
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t1 = _context4["catch"](3);
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                _e5 = "FirebaseError" !== _context4.t1.name && r < 3;

                if (!(M("SimpleDb", "Transaction failed with error:", _context4.t1.message, "Retrying:", _e5), this.close(), !_e5)) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt("return", Promise.reject(_context4.t1));

              case 15:
                _context4.next = 2;
                break;

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));

      function runTransaction(_x3, _x4, _x5, _x6) {
        return _runTransaction.apply(this, arguments);
      }

      return runTransaction;
    }()
  }, {
    key: "close",
    value: function close() {
      this.db && this.db.close(), this.db = void 0;
    }
  }], [{
    key: "delete",
    value: function _delete(t) {
      return M("SimpleDb", "Removing database:", t), Nt(window.indexedDB.deleteDatabase(t)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */

  }, {
    key: "V",
    value: function V() {
      if (!isIndexedDBAvailable()) return !1;
      if (Vt.S()) return !0; // We extensively use indexed array values and compound keys,
      // which IE and Edge do not support. However, they still have indexedDB
      // defined on the window, so we need to check for them here and make sure
      // to return that persistence is not enabled for those browsers.
      // For tracking support of this feature, see here:
      // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
      // Check the UA string to find out the browser.

      var t = getUA(),
          e = Vt.v(t),
          n = 0 < e && e < 10,
          s = Vt.D(t),
          i = 0 < s && s < 4.5; // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
      // Edge
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
      // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
      // iOS Safari: Disable for users running iOS version < 10.

      return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */

  }, {
    key: "S",
    value: function S() {
      var t;
      return "undefined" != typeof process && "YES" === (null === (t = process.env) || void 0 === t ? void 0 : t.C);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */

  }, {
    key: "N",
    value: function N(t, e) {
      return t.store(e);
    } // visible for testing

    /** Parse User Agent to determine iOS version. Returns -1 if not found. */

  }, {
    key: "v",
    value: function v(t) {
      var e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i),
          n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
      return Number(n);
    } // visible for testing

    /** Parse User Agent to determine Android version. Returns -1 if not found. */

  }, {
    key: "D",
    value: function D(t) {
      var e = t.match(/Android ([\d.]+)/i),
          n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
      return Number(n);
    }
  }]);

  return Vt;
}();
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */


var St = /*#__PURE__*/function () {
  function St(t) {
    _classCallCheck(this, St);

    this.$ = t, this.B = !1, this.L = null;
  }

  _createClass(St, [{
    key: "isDone",
    get: function get() {
      return this.B;
    }
  }, {
    key: "U",
    get: function get() {
      return this.L;
    }
  }, {
    key: "cursor",
    set: function set(t) {
      this.$ = t;
    }
    /**
     * This function can be called to stop iteration at any point.
     */

  }, {
    key: "done",
    value: function done() {
      this.B = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */

  }, {
    key: "q",
    value: function q(t) {
      this.L = t;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */

  }, {
    key: "delete",
    value: function _delete() {
      return Nt(this.$.delete());
    }
  }]);

  return St;
}();
/** An error that wraps exceptions that thrown during IndexedDB execution. */


var Dt = /*#__PURE__*/function (_Q) {
  _inherits(Dt, _Q);

  var _super4 = _createSuper(Dt);

  function Dt(t, e) {
    var _this15;

    _classCallCheck(this, Dt);

    _this15 = _super4.call(this, G.UNAVAILABLE, "IndexedDB transaction '".concat(t, "' failed: ").concat(e)), _this15.name = "IndexedDbTransactionError";
    return _this15;
  }

  return _createClass(Dt);
}(Q);
/** Verifies whether `e` is an IndexedDbTransactionError. */


function Ct(t) {
  // Use name equality, as instanceof checks on errors don't work with errors
  // that wrap other errors.
  return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */


var xt = /*#__PURE__*/function () {
  function xt(t) {
    _classCallCheck(this, xt);

    this.store = t;
  }

  _createClass(xt, [{
    key: "put",
    value: function put(t, e) {
      var n;
      return void 0 !== e ? (M("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : (M("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), Nt(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */

  }, {
    key: "add",
    value: function add(t) {
      M("SimpleDb", "ADD", this.store.name, t, t);
      return Nt(this.store.add(t));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */

  }, {
    key: "get",
    value: function get(t) {
      var _this16 = this;

      // We're doing an unsafe cast to ValueType.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return Nt(this.store.get(t)).next(function (e) {
        return (// Normalize nonexistence to null.
          void 0 === e && (e = null), M("SimpleDb", "GET", _this16.store.name, t, e), e
        );
      });
    }
  }, {
    key: "delete",
    value: function _delete(t) {
      M("SimpleDb", "DELETE", this.store.name, t);
      return Nt(this.store.delete(t));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */

  }, {
    key: "count",
    value: function count() {
      M("SimpleDb", "COUNT", this.store.name);
      return Nt(this.store.count());
    }
  }, {
    key: "K",
    value: function K(t, e) {
      var n = this.options(t, e); // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
      // 20% faster. Unfortunately, getAll() does not support custom indices.

      if (n.index || "function" != typeof this.store.getAll) {
        var _t5 = this.cursor(n),
            _e6 = [];

        return this.G(_t5, function (t, n) {
          _e6.push(n);
        }).next(function () {
          return _e6;
        });
      }

      {
        var _t6 = this.store.getAll(n.range);

        return new Pt(function (e, n) {
          _t6.onerror = function (t) {
            n(t.target.error);
          }, _t6.onsuccess = function (t) {
            e(t.target.result);
          };
        });
      }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */

  }, {
    key: "j",
    value: function j(t, e) {
      var n = this.store.getAll(t, null === e ? void 0 : e);
      return new Pt(function (t, e) {
        n.onerror = function (t) {
          e(t.target.error);
        }, n.onsuccess = function (e) {
          t(e.target.result);
        };
      });
    }
  }, {
    key: "W",
    value: function W(t, e) {
      M("SimpleDb", "DELETE ALL", this.store.name);
      var n = this.options(t, e);
      n.H = !1;
      var s = this.cursor(n);
      return this.G(s, function (t, e, n) {
        return n.delete();
      });
    }
  }, {
    key: "J",
    value: function J(t, e) {
      var n;
      e ? n = t : (n = {}, e = t);
      var s = this.cursor(n);
      return this.G(s, e);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */

  }, {
    key: "Y",
    value: function Y(t) {
      var e = this.cursor({});
      return new Pt(function (n, s) {
        e.onerror = function (t) {
          var e = Ot(t.target.error);
          s(e);
        }, e.onsuccess = function (e) {
          var s = e.target.result;
          s ? t(s.primaryKey, s.value).next(function (t) {
            t ? s.continue() : n();
          }) : n();
        };
      });
    }
  }, {
    key: "G",
    value: function G(t, e) {
      var n = [];
      return new Pt(function (s, i) {
        t.onerror = function (t) {
          i(t.target.error);
        }, t.onsuccess = function (t) {
          var i = t.target.result;
          if (!i) return void s();
          var r = new St(i),
              o = e(i.primaryKey, i.value, r);

          if (o instanceof Pt) {
            var _t7 = o.catch(function (t) {
              return r.done(), Pt.reject(t);
            });

            n.push(_t7);
          }

          r.isDone ? s() : null === r.U ? i.continue() : i.continue(r.U);
        };
      }).next(function () {
        return Pt.waitFor(n);
      });
    }
  }, {
    key: "options",
    value: function options(t, e) {
      var n;
      return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
        index: n,
        range: e
      };
    }
  }, {
    key: "cursor",
    value: function cursor(t) {
      var e = "next";

      if (t.reverse && (e = "prev"), t.index) {
        var n = this.store.index(t.index);
        return t.H ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
      }

      return this.store.openCursor(t.range, e);
    }
  }]);

  return xt;
}();
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */


function Nt(t) {
  return new Pt(function (e, n) {
    t.onsuccess = function (t) {
      var n = t.target.result;
      e(n);
    }, t.onerror = function (t) {
      var e = Ot(t.target.error);
      n(e);
    };
  });
} // Guard so we only report the error once.


var kt = !1;

function Ot(t) {
  var e = Vt.v(getUA());

  if (e >= 12.2 && e < 13) {
    var _e7 = "An internal error was encountered in the Indexed Database server";

    if (t.message.indexOf(_e7) >= 0) {
      // Wrap error in a more descriptive one.
      var _t8 = new Q("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '".concat(_e7, "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround."));

      return kt || (kt = !0, // Throw a global exception outside of this promise chain, for the user to
      // potentially catch.
      setTimeout(function () {
        throw _t8;
      }, 0)), _t8;
    }
  }

  return t;
}
/** This class is responsible for the scheduling of Index Backfiller. */


var Mt = /*#__PURE__*/function () {
  function Mt(t, e) {
    _classCallCheck(this, Mt);

    this.asyncQueue = t, this.X = e, this.task = null;
  }

  _createClass(Mt, [{
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {
      this.task && (this.task.cancel(), this.task = null);
    }
  }, {
    key: "started",
    get: function get() {
      return null !== this.task;
    }
  }, {
    key: "Z",
    value: function Z(t) {
      var _this17 = this;

      M("IndexBackiller", "Scheduled in ".concat(t, "ms")), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill"
      /* IndexBackfill */
      , t, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this17.task = null;
                _context5.prev = 1;
                _context5.t0 = M;
                _context5.t1 = "Documents written: ";
                _context5.next = 6;
                return _this17.X.tt();

              case 6:
                _context5.t2 = _context5.sent;
                _context5.t3 = _context5.t1.concat.call(_context5.t1, _context5.t2);
                (0, _context5.t0)("IndexBackiller", _context5.t3);
                _context5.next = 19;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t4 = _context5["catch"](1);

                if (!Ct(_context5.t4)) {
                  _context5.next = 17;
                  break;
                }

                M("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", _context5.t4);
                _context5.next = 19;
                break;

              case 17:
                _context5.next = 19;
                return bt(_context5.t4);

              case 19:
                _context5.next = 21;
                return _this17.Z(1);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 11]]);
      })));
    }
  }]);

  return Mt;
}();
/** Implements the steps for backfilling indexes. */


var Ft = /*#__PURE__*/function () {
  function Ft(
  /**
   * LocalStore provides access to IndexManager and LocalDocumentView.
   * These properties will update when the user changes. Consequently,
   * making a local copy of IndexManager and LocalDocumentView will require
   * updates over time. The simpler solution is to rely on LocalStore to have
   * an up-to-date references to IndexManager and LocalDocumentStore.
   */
  t, e) {
    _classCallCheck(this, Ft);

    this.localStore = t, this.persistence = e;
  }

  _createClass(Ft, [{
    key: "tt",
    value: function () {
      var _tt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this18 = this;

        var t,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                t = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : 50;
                return _context6.abrupt("return", this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", function (e) {
                  return _this18.et(e, t);
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function tt() {
        return _tt.apply(this, arguments);
      }

      return tt;
    }()
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */

  }, {
    key: "et",
    value: function et(t, e) {
      var _this19 = this;

      var n = new Set();
      var s = e,
          i = !0;
      return Pt.doWhile(function () {
        return !0 === i && s > 0;
      }, function () {
        return _this19.localStore.indexManager.getNextCollectionGroupToUpdate(t).next(function (e) {
          if (null !== e && !n.has(e)) return M("IndexBackiller", "Processing collection: ".concat(e)), _this19.nt(t, e, s).next(function (t) {
            s -= t, n.add(e);
          });
          i = !1;
        });
      }).next(function () {
        return e - s;
      });
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */

  }, {
    key: "nt",
    value: function nt(t, e, n) {
      var _this20 = this;

      // Use the earliest offset of all field indexes to query the local cache.
      return this.localStore.indexManager.getMinOffsetFromCollectionGroup(t, e).next(function (s) {
        return _this20.localStore.localDocuments.getNextDocuments(t, e, s, n).next(function (n) {
          var i = n.changes;
          return _this20.localStore.indexManager.updateIndexEntries(t, i).next(function () {
            return _this20.st(s, n);
          }).next(function (n) {
            return M("IndexBackiller", "Updating offset: ".concat(n)), _this20.localStore.indexManager.updateCollectionGroup(t, e, n);
          }).next(function () {
            return i.size;
          });
        });
      });
    }
    /** Returns the next offset based on the provided documents. */

  }, {
    key: "st",
    value: function st(t, e) {
      var n = t;
      return e.changes.forEach(function (t, e) {
        var s = It(e);
        Et(s, n) > 0 && (n = s);
      }), new Tt(n.readTime, n.documentKey, Math.max(e.batchId, t.largestBatchId));
    }
  }]);

  return Ft;
}();
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */


var $t = /*#__PURE__*/function () {
  function $t(t, e) {
    var _this21 = this;

    _classCallCheck(this, $t);

    this.previousValue = t, e && (e.sequenceNumberHandler = function (t) {
      return _this21.it(t);
    }, this.rt = function (t) {
      return e.writeSequenceNumber(t);
    });
  }

  _createClass($t, [{
    key: "it",
    value: function it(t) {
      return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }
  }, {
    key: "next",
    value: function next() {
      var t = ++this.previousValue;
      return this.rt && this.rt(t), t;
    }
  }]);

  return $t;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Bt(t) {
  var e = 0;

  for (var n in t) {
    Object.prototype.hasOwnProperty.call(t, n) && e++;
  }

  return e;
}

function Lt(t, e) {
  for (var n in t) {
    Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
  }
}

function Ut(t) {
  for (var e in t) {
    if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
  }

  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.


$t.ot = -1;

var qt = /*#__PURE__*/function () {
  function qt(t, e) {
    _classCallCheck(this, qt);

    this.comparator = t, this.root = e || Gt.EMPTY;
  } // Returns a copy of the map, with the specified key/value added or replaced.


  _createClass(qt, [{
    key: "insert",
    value: function insert(t, e) {
      return new qt(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, Gt.BLACK, null, null));
    } // Returns a copy of the map, with the specified key removed.

  }, {
    key: "remove",
    value: function remove(t) {
      return new qt(this.comparator, this.root.remove(t, this.comparator).copy(null, null, Gt.BLACK, null, null));
    } // Returns the value of the node with the given key, or null.

  }, {
    key: "get",
    value: function get(t) {
      var e = this.root;

      for (; !e.isEmpty();) {
        var n = this.comparator(t, e.key);
        if (0 === n) return e.value;
        n < 0 ? e = e.left : n > 0 && (e = e.right);
      }

      return null;
    } // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.

  }, {
    key: "indexOf",
    value: function indexOf(t) {
      // Number of nodes that were pruned when descending right
      var e = 0,
          n = this.root;

      for (; !n.isEmpty();) {
        var s = this.comparator(t, n.key);
        if (0 === s) return e + n.left.size;
        s < 0 ? n = n.left : ( // Count all nodes left of the node plus the node itself
        e += n.left.size + 1, n = n.right);
      } // Node not found


      return -1;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.root.isEmpty();
    } // Returns the total number of nodes in the map.

  }, {
    key: "size",
    get: function get() {
      return this.root.size;
    } // Returns the minimum key in the map.

  }, {
    key: "minKey",
    value: function minKey() {
      return this.root.minKey();
    } // Returns the maximum key in the map.

  }, {
    key: "maxKey",
    value: function maxKey() {
      return this.root.maxKey();
    } // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.

  }, {
    key: "inorderTraversal",
    value: function inorderTraversal(t) {
      return this.root.inorderTraversal(t);
    }
  }, {
    key: "forEach",
    value: function forEach(t) {
      this.inorderTraversal(function (e, n) {
        return t(e, n), !1;
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      var t = [];
      return this.inorderTraversal(function (e, n) {
        return t.push("".concat(e, ":").concat(n)), !1;
      }), "{".concat(t.join(", "), "}");
    } // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.

  }, {
    key: "reverseTraversal",
    value: function reverseTraversal(t) {
      return this.root.reverseTraversal(t);
    } // Returns an iterator over the SortedMap.

  }, {
    key: "getIterator",
    value: function getIterator() {
      return new Kt(this.root, null, this.comparator, !1);
    }
  }, {
    key: "getIteratorFrom",
    value: function getIteratorFrom(t) {
      return new Kt(this.root, t, this.comparator, !1);
    }
  }, {
    key: "getReverseIterator",
    value: function getReverseIterator() {
      return new Kt(this.root, null, this.comparator, !0);
    }
  }, {
    key: "getReverseIteratorFrom",
    value: function getReverseIteratorFrom(t) {
      return new Kt(this.root, t, this.comparator, !0);
    }
  }]);

  return qt;
}(); // end SortedMap
// An iterator over an LLRBNode.


var Kt = /*#__PURE__*/function () {
  function Kt(t, e, n, s) {
    _classCallCheck(this, Kt);

    this.isReverse = s, this.nodeStack = [];
    var i = 1;

    for (; !t.isEmpty();) {
      if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
      e && s && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;else {
        if (0 === i) {
          // This node is exactly equal to our start key. Push it on the stack,
          // but stop iterating;
          this.nodeStack.push(t);
          break;
        } // This node is greater than our start key, add it to the stack and move
        // to the next one


        this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
      }
    }
  }

  _createClass(Kt, [{
    key: "getNext",
    value: function getNext() {
      var t = this.nodeStack.pop();
      var e = {
        key: t.key,
        value: t.value
      };
      if (this.isReverse) for (t = t.left; !t.isEmpty();) {
        this.nodeStack.push(t), t = t.right;
      } else for (t = t.right; !t.isEmpty();) {
        this.nodeStack.push(t), t = t.left;
      }
      return e;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this.nodeStack.length > 0;
    }
  }, {
    key: "peek",
    value: function peek() {
      if (0 === this.nodeStack.length) return null;
      var t = this.nodeStack[this.nodeStack.length - 1];
      return {
        key: t.key,
        value: t.value
      };
    }
  }]);

  return Kt;
}(); // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.


var Gt = /*#__PURE__*/function () {
  function Gt(t, e, n, s, i) {
    _classCallCheck(this, Gt);

    this.key = t, this.value = e, this.color = null != n ? n : Gt.RED, this.left = null != s ? s : Gt.EMPTY, this.right = null != i ? i : Gt.EMPTY, this.size = this.left.size + 1 + this.right.size;
  } // Returns a copy of the current node, optionally replacing pieces of it.


  _createClass(Gt, [{
    key: "copy",
    value: function copy(t, e, n, s, i) {
      return new Gt(null != t ? t : this.key, null != e ? e : this.value, null != n ? n : this.color, null != s ? s : this.left, null != i ? i : this.right);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !1;
    } // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.

  }, {
    key: "inorderTraversal",
    value: function inorderTraversal(t) {
      return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    } // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.

  }, {
    key: "reverseTraversal",
    value: function reverseTraversal(t) {
      return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    } // Returns the minimum node in the tree.

  }, {
    key: "min",
    value: function min() {
      return this.left.isEmpty() ? this : this.left.min();
    } // Returns the maximum key in the tree.

  }, {
    key: "minKey",
    value: function minKey() {
      return this.min().key;
    } // Returns the maximum key in the tree.

  }, {
    key: "maxKey",
    value: function maxKey() {
      return this.right.isEmpty() ? this.key : this.right.maxKey();
    } // Returns new tree, with the key/value added.

  }, {
    key: "insert",
    value: function insert(t, e, n) {
      var s = this;
      var i = n(t, s.key);
      return s = i < 0 ? s.copy(null, null, null, s.left.insert(t, e, n), null) : 0 === i ? s.copy(null, e, null, null, null) : s.copy(null, null, null, null, s.right.insert(t, e, n)), s.fixUp();
    }
  }, {
    key: "removeMin",
    value: function removeMin() {
      if (this.left.isEmpty()) return Gt.EMPTY;
      var t = this;
      return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    } // Returns new tree, with the specified item removed.

  }, {
    key: "remove",
    value: function remove(t, e) {
      var n,
          s = this;
      if (e(t, s.key) < 0) s.left.isEmpty() || s.left.isRed() || s.left.left.isRed() || (s = s.moveRedLeft()), s = s.copy(null, null, null, s.left.remove(t, e), null);else {
        if (s.left.isRed() && (s = s.rotateRight()), s.right.isEmpty() || s.right.isRed() || s.right.left.isRed() || (s = s.moveRedRight()), 0 === e(t, s.key)) {
          if (s.right.isEmpty()) return Gt.EMPTY;
          n = s.right.min(), s = s.copy(n.key, n.value, null, null, s.right.removeMin());
        }

        s = s.copy(null, null, null, null, s.right.remove(t, e));
      }
      return s.fixUp();
    }
  }, {
    key: "isRed",
    value: function isRed() {
      return this.color;
    } // Returns new tree after performing any needed rotations.

  }, {
    key: "fixUp",
    value: function fixUp() {
      var t = this;
      return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
  }, {
    key: "moveRedLeft",
    value: function moveRedLeft() {
      var t = this.colorFlip();
      return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
  }, {
    key: "moveRedRight",
    value: function moveRedRight() {
      var t = this.colorFlip();
      return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
  }, {
    key: "rotateLeft",
    value: function rotateLeft() {
      var t = this.copy(null, null, Gt.RED, null, this.right.left);
      return this.right.copy(null, null, this.color, t, null);
    }
  }, {
    key: "rotateRight",
    value: function rotateRight() {
      var t = this.copy(null, null, Gt.RED, this.left.right, null);
      return this.left.copy(null, null, this.color, null, t);
    }
  }, {
    key: "colorFlip",
    value: function colorFlip() {
      var t = this.left.copy(null, null, !this.left.color, null, null),
          e = this.right.copy(null, null, !this.right.color, null, null);
      return this.copy(null, null, !this.color, t, e);
    } // For testing.

  }, {
    key: "checkMaxDepth",
    value: function checkMaxDepth() {
      var t = this.check();
      return Math.pow(2, t) <= this.size + 1;
    } // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.

  }, {
    key: "check",
    value: function check() {
      if (this.isRed() && this.left.isRed()) throw L();
      if (this.right.isRed()) throw L();
      var t = this.left.check();
      if (t !== this.right.check()) throw L();
      return t + (this.isRed() ? 0 : 1);
    }
  }]);

  return Gt;
}(); // end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any


Gt.EMPTY = null, Gt.RED = !0, Gt.BLACK = !1; // end LLRBEmptyNode

Gt.EMPTY = new (
/*#__PURE__*/
// Represents an empty node (a leaf node in the Red-Black Tree).
function () {
  function _class() {
    _classCallCheck(this, _class);

    this.size = 0;
  }

  _createClass(_class, [{
    key: "key",
    get: function get() {
      throw L();
    }
  }, {
    key: "value",
    get: function get() {
      throw L();
    }
  }, {
    key: "color",
    get: function get() {
      throw L();
    }
  }, {
    key: "left",
    get: function get() {
      throw L();
    }
  }, {
    key: "right",
    get: function get() {
      throw L();
    } // Returns a copy of the current node.

  }, {
    key: "copy",
    value: function copy(t, e, n, s, i) {
      return this;
    } // Returns a copy of the tree, with the specified key/value added.

  }, {
    key: "insert",
    value: function insert(t, e, n) {
      return new Gt(t, e);
    } // Returns a copy of the tree, with the specified key removed.

  }, {
    key: "remove",
    value: function remove(t, e) {
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !0;
    }
  }, {
    key: "inorderTraversal",
    value: function inorderTraversal(t) {
      return !1;
    }
  }, {
    key: "reverseTraversal",
    value: function reverseTraversal(t) {
      return !1;
    }
  }, {
    key: "minKey",
    value: function minKey() {
      return null;
    }
  }, {
    key: "maxKey",
    value: function maxKey() {
      return null;
    }
  }, {
    key: "isRed",
    value: function isRed() {
      return !1;
    } // For testing.

  }, {
    key: "checkMaxDepth",
    value: function checkMaxDepth() {
      return !0;
    }
  }, {
    key: "check",
    value: function check() {
      return 0;
    }
  }]);

  return _class;
}())();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */

var Qt = /*#__PURE__*/function () {
  function Qt(t) {
    _classCallCheck(this, Qt);

    this.comparator = t, this.data = new qt(this.comparator);
  }

  _createClass(Qt, [{
    key: "has",
    value: function has(t) {
      return null !== this.data.get(t);
    }
  }, {
    key: "first",
    value: function first() {
      return this.data.minKey();
    }
  }, {
    key: "last",
    value: function last() {
      return this.data.maxKey();
    }
  }, {
    key: "size",
    get: function get() {
      return this.data.size;
    }
  }, {
    key: "indexOf",
    value: function indexOf(t) {
      return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */

  }, {
    key: "forEach",
    value: function forEach(t) {
      this.data.inorderTraversal(function (e, n) {
        return t(e), !1;
      });
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */

  }, {
    key: "forEachInRange",
    value: function forEachInRange(t, e) {
      var n = this.data.getIteratorFrom(t[0]);

      for (; n.hasNext();) {
        var s = n.getNext();
        if (this.comparator(s.key, t[1]) >= 0) return;
        e(s.key);
      }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */

  }, {
    key: "forEachWhile",
    value: function forEachWhile(t, e) {
      var n;

      for (n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();) {
        if (!t(n.getNext().key)) return;
      }
    }
    /** Finds the least element greater than or equal to `elem`. */

  }, {
    key: "firstAfterOrEqual",
    value: function firstAfterOrEqual(t) {
      var e = this.data.getIteratorFrom(t);
      return e.hasNext() ? e.getNext().key : null;
    }
  }, {
    key: "getIterator",
    value: function getIterator() {
      return new jt(this.data.getIterator());
    }
  }, {
    key: "getIteratorFrom",
    value: function getIteratorFrom(t) {
      return new jt(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */

  }, {
    key: "add",
    value: function add(t) {
      return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */

  }, {
    key: "delete",
    value: function _delete(t) {
      return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.data.isEmpty();
    }
  }, {
    key: "unionWith",
    value: function unionWith(t) {
      var e = this; // Make sure `result` always refers to the larger one of the two sets.

      return e.size < t.size && (e = t, t = this), t.forEach(function (t) {
        e = e.add(t);
      }), e;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      if (!(t instanceof Qt)) return !1;
      if (this.size !== t.size) return !1;
      var e = this.data.getIterator(),
          n = t.data.getIterator();

      for (; e.hasNext();) {
        var _t9 = e.getNext().key,
            s = n.getNext().key;
        if (0 !== this.comparator(_t9, s)) return !1;
      }

      return !0;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = [];
      return this.forEach(function (e) {
        t.push(e);
      }), t;
    }
  }, {
    key: "toString",
    value: function toString() {
      var t = [];
      return this.forEach(function (e) {
        return t.push(e);
      }), "SortedSet(" + t.toString() + ")";
    }
  }, {
    key: "copy",
    value: function copy(t) {
      var e = new Qt(this.comparator);
      return e.data = t, e;
    }
  }]);

  return Qt;
}();

var jt = /*#__PURE__*/function () {
  function jt(t) {
    _classCallCheck(this, jt);

    this.iter = t;
  }

  _createClass(jt, [{
    key: "getNext",
    value: function getNext() {
      return this.iter.getNext().key;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      return this.iter.hasNext();
    }
  }]);

  return jt;
}();
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */

/**
 * Returns the next element from the iterator or `undefined` if none available.
 */


function Wt(t) {
  return t.hasNext() ? t.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */


var zt = /*#__PURE__*/function () {
  function zt(t) {
    _classCallCheck(this, zt);

    this.fields = t, // TODO(dimond): validation of FieldMask
    // Sort the field mask to support `FieldMask.isEqual()` and assert below.
    t.sort(ft.comparator);
  }

  _createClass(zt, [{
    key: "unionWith",
    value:
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */
    function unionWith(t) {
      var e = new Qt(ft.comparator);

      var _iterator2 = _createForOfIteratorHelper(this.fields),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t10 = _step2.value;
          e = e.add(_t10);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var n = _step3.value;
          e = e.add(n);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return new zt(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */

  }, {
    key: "covers",
    value: function covers(t) {
      var _iterator4 = _createForOfIteratorHelper(this.fields),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var e = _step4.value;
          if (e.isPrefixOf(t)) return !0;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return !1;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return rt(this.fields, t.fields, function (t, e) {
        return t.isEqual(e);
      });
    }
  }], [{
    key: "empty",
    value: function empty() {
      return new zt([]);
    }
  }]);

  return zt;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Converts a Base64 encoded string to a binary string. */

/** True if and only if the Base64 conversion functions are available. */


function Ht() {
  return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */


var Jt = /*#__PURE__*/function (_Symbol$iterator) {
  function Jt(t) {
    _classCallCheck(this, Jt);

    this.binaryString = t;
  }

  _createClass(Jt, [{
    key: _Symbol$iterator,
    value: function value() {
      var _this22 = this;

      var t = 0;
      return {
        next: function next() {
          return t < _this22.binaryString.length ? {
            value: _this22.binaryString.charCodeAt(t++),
            done: !1
          } : {
            value: void 0,
            done: !0
          };
        }
      };
    }
  }, {
    key: "toBase64",
    value: function toBase64() {
      return t = this.binaryString, btoa(t);
      /** Converts a binary string to a Base64 encoded string. */

      var t;
    }
  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      return function (t) {
        var e = new Uint8Array(t.length);

        for (var n = 0; n < t.length; n++) {
          e[n] = t.charCodeAt(n);
        }

        return e;
      }
      /**
      * @license
      * Copyright 2020 Google LLC
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *   http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */
      // A RegExp matching ISO 8601 UTC timestamps with optional fraction.
      (this.binaryString);
    }
  }, {
    key: "approximateByteSize",
    value: function approximateByteSize() {
      return 2 * this.binaryString.length;
    }
  }, {
    key: "compareTo",
    value: function compareTo(t) {
      return it(this.binaryString, t.binaryString);
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this.binaryString === t.binaryString;
    }
  }], [{
    key: "fromBase64String",
    value: function fromBase64String(t) {
      var e = atob(t);
      return new Jt(e);
    }
  }, {
    key: "fromUint8Array",
    value: function fromUint8Array(t) {
      // TODO(indexing); Remove the copy of the byte string here as this method
      // is frequently called during indexing.
      var e =
      /**
      * Helper function to convert an Uint8array to a binary string.
      */
      function (t) {
        var e = "";

        for (var n = 0; n < t.length; ++n) {
          e += String.fromCharCode(t[n]);
        }

        return e;
      }
      /**
      * Helper function to convert a binary string to an Uint8Array.
      */
      (t);

      return new Jt(e);
    }
  }]);

  return Jt;
}(Symbol.iterator);

Jt.EMPTY_BYTE_STRING = new Jt("");
var Yt = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */

function Xt(t) {
  // The json interface (for the browser) will return an iso timestamp string,
  // while the proto js library (for node) will return a
  // google.protobuf.Timestamp instance.
  if (U(!!t), "string" == typeof t) {
    // The date string can have higher precision (nanos) than the Date class
    // (millis), so we do some custom parsing here.
    // Parse the nanos right out of the string.
    var e = 0;
    var n = Yt.exec(t);

    if (U(!!n), n[1]) {
      // Pad the fraction out to 9 digits (nanos).
      var _t11 = n[1];
      _t11 = (_t11 + "000000000").substr(0, 9), e = Number(_t11);
    } // Parse the date to get the seconds.


    var s = new Date(t);
    return {
      seconds: Math.floor(s.getTime() / 1e3),
      nanos: e
    };
  }

  return {
    seconds: Zt(t.seconds),
    nanos: Zt(t.nanos)
  };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */


function Zt(t) {
  // TODO(bjornick): Handle int64 greater than 53 bits.
  return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */


function te(t) {
  return "string" == typeof t ? Jt.fromBase64String(t) : Jt.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */


function ee(t) {
  var e, n;
  return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */

/**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */


function ne(t) {
  var e = t.mapValue.fields.__previous_value__;
  return ee(e) ? ne(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */


function se(t) {
  var e = Xt(t.mapValue.fields.__local_write_time__.timestampValue);
  return new ut(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ie = /*#__PURE__*/_createClass(
/**
 * Constructs a DatabaseInfo using the provided host, databaseId and
 * persistenceKey.
 *
 * @param databaseId - The database to use.
 * @param appId - The Firebase App Id.
 * @param persistenceKey - A unique identifier for this Firestore's local
 * storage (used in conjunction with the databaseId).
 * @param host - The Firestore backend host to connect to.
 * @param ssl - Whether to use SSL when connecting.
 * @param forceLongPolling - Whether to use the forceLongPolling option
 * when using WebChannel as the network transport.
 * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
 * option when using WebChannel as the network transport.
 * @param useFetchStreams Whether to use the Fetch API instead of
 * XMLHTTPRequest
 */
function ie(t, e, n, s, i, r, o, u) {
  _classCallCheck(this, ie);

  this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = s, this.ssl = i, this.forceLongPolling = r, this.autoDetectLongPolling = o, this.useFetchStreams = u;
});
/** The default database name for a project. */

/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */


var re = /*#__PURE__*/function () {
  function re(t, e) {
    _classCallCheck(this, re);

    this.projectId = t, this.database = e || "(default)";
  }

  _createClass(re, [{
    key: "isDefaultDatabase",
    get: function get() {
      return "(default)" === this.database;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t instanceof re && t.projectId === this.projectId && t.database === this.database;
    }
  }], [{
    key: "empty",
    value: function empty() {
      return new re("", "");
    }
  }]);

  return re;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Sentinel value that sorts before any Mutation Batch ID. */

/**
 * Returns whether a variable is either undefined or null.
 */


function oe(t) {
  return null == t;
}
/** Returns whether the value represents -0. */


function ue(t) {
  // Detect if the value is -0.0. Based on polyfill from
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */


function ce(t) {
  return "number" == typeof t && Number.isInteger(t) && !ue(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ae = {
  mapValue: {
    fields: {
      __type__: {
        stringValue: "__max__"
      }
    }
  }
},
    he = {
  nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */

function le(t) {
  return "nullValue" in t ? 0
  /* NullValue */
  : "booleanValue" in t ? 1
  /* BooleanValue */
  : "integerValue" in t || "doubleValue" in t ? 2
  /* NumberValue */
  : "timestampValue" in t ? 3
  /* TimestampValue */
  : "stringValue" in t ? 5
  /* StringValue */
  : "bytesValue" in t ? 6
  /* BlobValue */
  : "referenceValue" in t ? 7
  /* RefValue */
  : "geoPointValue" in t ? 8
  /* GeoPointValue */
  : "arrayValue" in t ? 9
  /* ArrayValue */
  : "mapValue" in t ? ee(t) ? 4
  /* ServerTimestampValue */
  : be(t) ? 9007199254740991
  /* MaxValue */
  : 10
  /* ObjectValue */
  : L();
}
/** Tests `left` and `right` for equality based on the backend semantics. */


function fe(t, e) {
  if (t === e) return !0;
  var n = le(t);
  if (n !== le(e)) return !1;

  switch (n) {
    case 0
    /* NullValue */
    :
    case 9007199254740991
    /* MaxValue */
    :
      return !0;

    case 1
    /* BooleanValue */
    :
      return t.booleanValue === e.booleanValue;

    case 4
    /* ServerTimestampValue */
    :
      return se(t).isEqual(se(e));

    case 3
    /* TimestampValue */
    :
      return function (t, e) {
        if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
          return t.timestampValue === e.timestampValue;
        var n = Xt(t.timestampValue),
            s = Xt(e.timestampValue);
        return n.seconds === s.seconds && n.nanos === s.nanos;
      }(t, e);

    case 5
    /* StringValue */
    :
      return t.stringValue === e.stringValue;

    case 6
    /* BlobValue */
    :
      return function (t, e) {
        return te(t.bytesValue).isEqual(te(e.bytesValue));
      }(t, e);

    case 7
    /* RefValue */
    :
      return t.referenceValue === e.referenceValue;

    case 8
    /* GeoPointValue */
    :
      return function (t, e) {
        return Zt(t.geoPointValue.latitude) === Zt(e.geoPointValue.latitude) && Zt(t.geoPointValue.longitude) === Zt(e.geoPointValue.longitude);
      }(t, e);

    case 2
    /* NumberValue */
    :
      return function (t, e) {
        if ("integerValue" in t && "integerValue" in e) return Zt(t.integerValue) === Zt(e.integerValue);

        if ("doubleValue" in t && "doubleValue" in e) {
          var _n3 = Zt(t.doubleValue),
              s = Zt(e.doubleValue);

          return _n3 === s ? ue(_n3) === ue(s) : isNaN(_n3) && isNaN(s);
        }

        return !1;
      }(t, e);

    case 9
    /* ArrayValue */
    :
      return rt(t.arrayValue.values || [], e.arrayValue.values || [], fe);

    case 10
    /* ObjectValue */
    :
      return function (t, e) {
        var n = t.mapValue.fields || {},
            s = e.mapValue.fields || {};
        if (Bt(n) !== Bt(s)) return !1;

        for (var _t12 in n) {
          if (n.hasOwnProperty(_t12) && (void 0 === s[_t12] || !fe(n[_t12], s[_t12]))) return !1;
        }

        return !0;
      }
      /** Returns true if the ArrayValue contains the specified element. */
      (t, e);

    default:
      return L();
  }
}

function de(t, e) {
  return void 0 !== (t.values || []).find(function (t) {
    return fe(t, e);
  });
}

function _e(t, e) {
  if (t === e) return 0;
  var n = le(t),
      s = le(e);
  if (n !== s) return it(n, s);

  switch (n) {
    case 0
    /* NullValue */
    :
    case 9007199254740991
    /* MaxValue */
    :
      return 0;

    case 1
    /* BooleanValue */
    :
      return it(t.booleanValue, e.booleanValue);

    case 2
    /* NumberValue */
    :
      return function (t, e) {
        var n = Zt(t.integerValue || t.doubleValue),
            s = Zt(e.integerValue || e.doubleValue);
        return n < s ? -1 : n > s ? 1 : n === s ? 0 : // one or both are NaN.
        isNaN(n) ? isNaN(s) ? 0 : -1 : 1;
      }(t, e);

    case 3
    /* TimestampValue */
    :
      return we(t.timestampValue, e.timestampValue);

    case 4
    /* ServerTimestampValue */
    :
      return we(se(t), se(e));

    case 5
    /* StringValue */
    :
      return it(t.stringValue, e.stringValue);

    case 6
    /* BlobValue */
    :
      return function (t, e) {
        var n = te(t),
            s = te(e);
        return n.compareTo(s);
      }(t.bytesValue, e.bytesValue);

    case 7
    /* RefValue */
    :
      return function (t, e) {
        var n = t.split("/"),
            s = e.split("/");

        for (var _t13 = 0; _t13 < n.length && _t13 < s.length; _t13++) {
          var _e8 = it(n[_t13], s[_t13]);

          if (0 !== _e8) return _e8;
        }

        return it(n.length, s.length);
      }(t.referenceValue, e.referenceValue);

    case 8
    /* GeoPointValue */
    :
      return function (t, e) {
        var n = it(Zt(t.latitude), Zt(e.latitude));
        if (0 !== n) return n;
        return it(Zt(t.longitude), Zt(e.longitude));
      }(t.geoPointValue, e.geoPointValue);

    case 9
    /* ArrayValue */
    :
      return function (t, e) {
        var n = t.values || [],
            s = e.values || [];

        for (var _t14 = 0; _t14 < n.length && _t14 < s.length; ++_t14) {
          var _e9 = _e(n[_t14], s[_t14]);

          if (_e9) return _e9;
        }

        return it(n.length, s.length);
      }(t.arrayValue, e.arrayValue);

    case 10
    /* ObjectValue */
    :
      return function (t, e) {
        if (t === ae.mapValue && e === ae.mapValue) return 0;
        if (t === ae.mapValue) return 1;
        if (e === ae.mapValue) return -1;
        var n = t.fields || {},
            s = Object.keys(n),
            i = e.fields || {},
            r = Object.keys(i); // Even though MapValues are likely sorted correctly based on their insertion
        // order (e.g. when received from the backend), local modifications can bring
        // elements out of order. We need to re-sort the elements to ensure that
        // canonical IDs are independent of insertion order.

        s.sort(), r.sort();

        for (var _t15 = 0; _t15 < s.length && _t15 < r.length; ++_t15) {
          var _e10 = it(s[_t15], r[_t15]);

          if (0 !== _e10) return _e10;

          var o = _e(n[s[_t15]], i[r[_t15]]);

          if (0 !== o) return o;
        }

        return it(s.length, r.length);
      }
      /**
      * Generates the canonical ID for the provided field value (as used in Target
      * serialization).
      */
      (t.mapValue, e.mapValue);

    default:
      throw L();
  }
}

function we(t, e) {
  if ("string" == typeof t && "string" == typeof e && t.length === e.length) return it(t, e);
  var n = Xt(t),
      s = Xt(e),
      i = it(n.seconds, s.seconds);
  return 0 !== i ? i : it(n.nanos, s.nanos);
}

function me(t) {
  return ge(t);
}

function ge(t) {
  return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function (t) {
    var e = Xt(t);
    return "time(".concat(e.seconds, ",").concat(e.nanos, ")");
  }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? te(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, dt.fromName(n).toString()) : "geoPointValue" in t ? "geo(".concat((e = t.geoPointValue).latitude, ",").concat(e.longitude, ")") : "arrayValue" in t ? function (t) {
    var e = "[",
        n = !0;

    var _iterator5 = _createForOfIteratorHelper(t.values || []),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var s = _step5.value;
        n ? n = !1 : e += ",", e += ge(s);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return e + "]";
  }
  /** Returns a reference value for the provided database and key. */
  (t.arrayValue) : "mapValue" in t ? function (t) {
    // Iteration order in JavaScript is not guaranteed. To ensure that we generate
    // matching canonical IDs for identical maps, we need to sort the keys.
    var e = Object.keys(t.fields || {}).sort();
    var n = "{",
        s = !0;

    var _iterator6 = _createForOfIteratorHelper(e),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var i = _step6.value;
        s ? s = !1 : n += ",", n += "".concat(i, ":").concat(ge(t.fields[i]));
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    return n + "}";
  }(t.mapValue) : L();
  var e, n;
}

function ye(t, e) {
  return {
    referenceValue: "projects/".concat(t.projectId, "/databases/").concat(t.database, "/documents/").concat(e.path.canonicalString())
  };
}
/** Returns true if `value` is an IntegerValue . */


function pe(t) {
  return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */

/** Returns true if `value` is an ArrayValue. */


function Ie(t) {
  return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */


function Te(t) {
  return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */


function Ee(t) {
  return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */


function Ae(t) {
  return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */


function Re(t) {
  if (t.geoPointValue) return {
    geoPointValue: Object.assign({}, t.geoPointValue)
  };
  if (t.timestampValue && "object" == typeof t.timestampValue) return {
    timestampValue: Object.assign({}, t.timestampValue)
  };

  if (t.mapValue) {
    var e = {
      mapValue: {
        fields: {}
      }
    };
    return Lt(t.mapValue.fields, function (t, n) {
      return e.mapValue.fields[t] = Re(n);
    }), e;
  }

  if (t.arrayValue) {
    var _e11 = {
      arrayValue: {
        values: []
      }
    };

    for (var n = 0; n < (t.arrayValue.values || []).length; ++n) {
      _e11.arrayValue.values[n] = Re(t.arrayValue.values[n]);
    }

    return _e11;
  }

  return Object.assign({}, t);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */


function be(t) {
  return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */


function Pe(t) {
  return "nullValue" in t ? he : "booleanValue" in t ? {
    booleanValue: !1
  } : "integerValue" in t || "doubleValue" in t ? {
    doubleValue: NaN
  } : "timestampValue" in t ? {
    timestampValue: {
      seconds: Number.MIN_SAFE_INTEGER
    }
  } : "stringValue" in t ? {
    stringValue: ""
  } : "bytesValue" in t ? {
    bytesValue: ""
  } : "referenceValue" in t ? ye(re.empty(), dt.empty()) : "geoPointValue" in t ? {
    geoPointValue: {
      latitude: -90,
      longitude: -180
    }
  } : "arrayValue" in t ? {
    arrayValue: {}
  } : "mapValue" in t ? {
    mapValue: {}
  } : L();
}
/** Returns the largest value for the given value type (exclusive). */


function ve(t) {
  return "nullValue" in t ? {
    booleanValue: !1
  } : "booleanValue" in t ? {
    doubleValue: NaN
  } : "integerValue" in t || "doubleValue" in t ? {
    timestampValue: {
      seconds: Number.MIN_SAFE_INTEGER
    }
  } : "timestampValue" in t ? {
    stringValue: ""
  } : "stringValue" in t ? {
    bytesValue: ""
  } : "bytesValue" in t ? ye(re.empty(), dt.empty()) : "referenceValue" in t ? {
    geoPointValue: {
      latitude: -90,
      longitude: -180
    }
  } : "geoPointValue" in t ? {
    arrayValue: {}
  } : "arrayValue" in t ? {
    mapValue: {}
  } : "mapValue" in t ? ae : L();
}

function Ve(t, e) {
  var n = _e(t.value, e.value);

  return 0 !== n ? n : t.inclusive && !e.inclusive ? -1 : !t.inclusive && e.inclusive ? 1 : 0;
}

function Se(t, e) {
  var n = _e(t.value, e.value);

  return 0 !== n ? n : t.inclusive && !e.inclusive ? 1 : !t.inclusive && e.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */


var De = /*#__PURE__*/function () {
  function De(t) {
    _classCallCheck(this, De);

    this.value = t;
  }

  _createClass(De, [{
    key: "field",
    value:
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */
    function field(t) {
      if (t.isEmpty()) return this.value;
      {
        var e = this.value;

        for (var n = 0; n < t.length - 1; ++n) {
          if (e = (e.mapValue.fields || {})[t.get(n)], !Ae(e)) return null;
        }

        return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
      }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */

  }, {
    key: "set",
    value: function set(t, e) {
      this.getFieldsMap(t.popLast())[t.lastSegment()] = Re(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */

  }, {
    key: "setAll",
    value: function setAll(t) {
      var _this23 = this;

      var e = ft.emptyPath(),
          n = {},
          s = [];
      t.forEach(function (t, i) {
        if (!e.isImmediateParentOf(i)) {
          // Insert the accumulated changes at this parent location
          var _t16 = _this23.getFieldsMap(e);

          _this23.applyChanges(_t16, n, s), n = {}, s = [], e = i.popLast();
        }

        t ? n[i.lastSegment()] = Re(t) : s.push(i.lastSegment());
      });
      var i = this.getFieldsMap(e);
      this.applyChanges(i, n, s);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */

  }, {
    key: "delete",
    value: function _delete(t) {
      var e = this.field(t.popLast());
      Ae(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return fe(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */

  }, {
    key: "getFieldsMap",
    value: function getFieldsMap(t) {
      var e = this.value;
      e.mapValue.fields || (e.mapValue = {
        fields: {}
      });

      for (var n = 0; n < t.length; ++n) {
        var s = e.mapValue.fields[t.get(n)];
        Ae(s) && s.mapValue.fields || (s = {
          mapValue: {
            fields: {}
          }
        }, e.mapValue.fields[t.get(n)] = s), e = s;
      }

      return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */

  }, {
    key: "applyChanges",
    value: function applyChanges(t, e, n) {
      Lt(e, function (e, n) {
        return t[e] = n;
      });

      var _iterator7 = _createForOfIteratorHelper(n),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _e12 = _step7.value;
          delete t[_e12];
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new De(Re(this.value));
    }
  }], [{
    key: "empty",
    value: function empty() {
      return new De({
        mapValue: {}
      });
    }
  }]);

  return De;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */


function Ce(t) {
  var e = [];
  return Lt(t.fields, function (t, n) {
    var s = new ft([t]);

    if (Ae(n)) {
      var _t17 = Ce(n.mapValue).fields;
      if (0 === _t17.length) // Preserve the empty map by adding it to the FieldMask.
        e.push(s);else {
        // For nested and non-empty ObjectValues, add the FieldPath of the
        // leaf nodes.
        var _iterator8 = _createForOfIteratorHelper(_t17),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _n4 = _step8.value;
            e.push(s.child(_n4));
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
      // nodes.
      e.push(s);
  }), new zt(e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */


var xe = /*#__PURE__*/function () {
  function xe(t, e, n, s, i, r) {
    _classCallCheck(this, xe);

    this.key = t, this.documentType = e, this.version = n, this.readTime = s, this.data = i, this.documentState = r;
  }
  /**
   * Creates a document with no known version or data, but which can serve as
   * base document for mutations.
   */


  _createClass(xe, [{
    key: "convertToFoundDocument",
    value:
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */
    function convertToFoundDocument(t, e) {
      return this.version = t, this.documentType = 1
      /* FOUND_DOCUMENT */
      , this.data = e, this.documentState = 0
      /* SYNCED */
      , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */

  }, {
    key: "convertToNoDocument",
    value: function convertToNoDocument(t) {
      return this.version = t, this.documentType = 2
      /* NO_DOCUMENT */
      , this.data = De.empty(), this.documentState = 0
      /* SYNCED */
      , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */

  }, {
    key: "convertToUnknownDocument",
    value: function convertToUnknownDocument(t) {
      return this.version = t, this.documentType = 3
      /* UNKNOWN_DOCUMENT */
      , this.data = De.empty(), this.documentState = 2
      /* HAS_COMMITTED_MUTATIONS */
      , this;
    }
  }, {
    key: "setHasCommittedMutations",
    value: function setHasCommittedMutations() {
      return this.documentState = 2
      /* HAS_COMMITTED_MUTATIONS */
      , this;
    }
  }, {
    key: "setHasLocalMutations",
    value: function setHasLocalMutations() {
      return this.documentState = 1
      /* HAS_LOCAL_MUTATIONS */
      , this.version = ct.min(), this;
    }
  }, {
    key: "setReadTime",
    value: function setReadTime(t) {
      return this.readTime = t, this;
    }
  }, {
    key: "hasLocalMutations",
    get: function get() {
      return 1
      /* HAS_LOCAL_MUTATIONS */
      === this.documentState;
    }
  }, {
    key: "hasCommittedMutations",
    get: function get() {
      return 2
      /* HAS_COMMITTED_MUTATIONS */
      === this.documentState;
    }
  }, {
    key: "hasPendingWrites",
    get: function get() {
      return this.hasLocalMutations || this.hasCommittedMutations;
    }
  }, {
    key: "isValidDocument",
    value: function isValidDocument() {
      return 0
      /* INVALID */
      !== this.documentType;
    }
  }, {
    key: "isFoundDocument",
    value: function isFoundDocument() {
      return 1
      /* FOUND_DOCUMENT */
      === this.documentType;
    }
  }, {
    key: "isNoDocument",
    value: function isNoDocument() {
      return 2
      /* NO_DOCUMENT */
      === this.documentType;
    }
  }, {
    key: "isUnknownDocument",
    value: function isUnknownDocument() {
      return 3
      /* UNKNOWN_DOCUMENT */
      === this.documentType;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t instanceof xe && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
  }, {
    key: "mutableCopy",
    value: function mutableCopy() {
      return new xe(this.key, this.documentType, this.version, this.readTime, this.data.clone(), this.documentState);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Document(".concat(this.key, ", ").concat(this.version, ", ").concat(JSON.stringify(this.data.value), ", {documentType: ").concat(this.documentType, "}), {documentState: ").concat(this.documentState, "})");
    }
  }], [{
    key: "newInvalidDocument",
    value: function newInvalidDocument(t) {
      return new xe(t, 0
      /* INVALID */
      , ct.min(), ct.min(), De.empty(), 0
      /* SYNCED */
      );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */

  }, {
    key: "newFoundDocument",
    value: function newFoundDocument(t, e, n) {
      return new xe(t, 1
      /* FOUND_DOCUMENT */
      , e, ct.min(), n, 0
      /* SYNCED */
      );
    }
    /** Creates a new document that is known to not exist at the given version. */

  }, {
    key: "newNoDocument",
    value: function newNoDocument(t, e) {
      return new xe(t, 2
      /* NO_DOCUMENT */
      , e, ct.min(), De.empty(), 0
      /* SYNCED */
      );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */

  }, {
    key: "newUnknownDocument",
    value: function newUnknownDocument(t, e) {
      return new xe(t, 3
      /* UNKNOWN_DOCUMENT */
      , e, ct.min(), De.empty(), 2
      /* HAS_COMMITTED_MUTATIONS */
      );
    }
  }]);

  return xe;
}();
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Visible for testing


var Ne = /*#__PURE__*/_createClass(function Ne(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

  _classCallCheck(this, Ne);

  this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = s, this.limit = i, this.startAt = r, this.endAt = o, this.ut = null;
});
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */


function ke(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return new Ne(t, e, n, s, i, r, o);
}

function Oe(t) {
  var e = K(t);

  if (null === e.ut) {
    var _t18 = e.path.canonicalString();

    null !== e.collectionGroup && (_t18 += "|cg:" + e.collectionGroup), _t18 += "|f:", _t18 += e.filters.map(function (t) {
      return (e = t).field.canonicalString() + e.op.toString() + me(e.value);
      var e;
    }).join(","), _t18 += "|ob:", _t18 += e.orderBy.map(function (t) {
      return function (t) {
        // TODO(b/29183165): Make this collision robust.
        return t.field.canonicalString() + t.dir;
      }(t);
    }).join(","), oe(e.limit) || (_t18 += "|l:", _t18 += e.limit), e.startAt && (_t18 += "|lb:", _t18 += e.startAt.inclusive ? "b:" : "a:", _t18 += e.startAt.position.map(function (t) {
      return me(t);
    }).join(",")), e.endAt && (_t18 += "|ub:", _t18 += e.endAt.inclusive ? "a:" : "b:", _t18 += e.endAt.position.map(function (t) {
      return me(t);
    }).join(",")), e.ut = _t18;
  }

  return e.ut;
}

function Me(t) {
  var e = t.path.canonicalString();
  return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += ", filters: [".concat(t.filters.map(function (t) {
    return "".concat((e = t).field.canonicalString(), " ").concat(e.op, " ").concat(me(e.value));
    /** Returns a debug description for `filter`. */

    var e;
    /** Filter that matches on key fields (i.e. '__name__'). */
  }).join(", "), "]")), oe(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += ", orderBy: [".concat(t.orderBy.map(function (t) {
    return function (t) {
      return "".concat(t.field.canonicalString(), " (").concat(t.dir, ")");
    }(t);
  }).join(", "), "]")), t.startAt && (e += ", startAt: ", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map(function (t) {
    return me(t);
  }).join(",")), t.endAt && (e += ", endAt: ", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map(function (t) {
    return me(t);
  }).join(",")), "Target(".concat(e, ")");
}

function Fe(t, e) {
  if (t.limit !== e.limit) return !1;
  if (t.orderBy.length !== e.orderBy.length) return !1;

  for (var _n5 = 0; _n5 < t.orderBy.length; _n5++) {
    if (!Ze(t.orderBy[_n5], e.orderBy[_n5])) return !1;
  }

  if (t.filters.length !== e.filters.length) return !1;

  for (var i = 0; i < t.filters.length; i++) {
    if (n = t.filters[i], s = e.filters[i], n.op !== s.op || !n.field.isEqual(s.field) || !fe(n.value, s.value)) return !1;
  }

  var n, s;
  return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!en(t.startAt, e.startAt) && en(t.endAt, e.endAt);
}

function $e(t) {
  return dt.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/** Returns the field filters that target the given field path. */


function Be(t, e) {
  return t.filters.filter(function (t) {
    return t instanceof qe && t.field.isEqual(e);
  });
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */

/**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */


function Le(t, e, n) {
  var s = he,
      i = !0; // Process all filters to find a value for the current field segment

  var _iterator9 = _createForOfIteratorHelper(Be(t, e)),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var _n6 = _step9.value;

      var _t20 = he,
          _e13 = !0;

      switch (_n6.op) {
        case "<"
        /* LESS_THAN */
        :
        case "<="
        /* LESS_THAN_OR_EQUAL */
        :
          _t20 = Pe(_n6.value);
          break;

        case "=="
        /* EQUAL */
        :
        case "in"
        /* IN */
        :
        case ">="
        /* GREATER_THAN_OR_EQUAL */
        :
          _t20 = _n6.value;
          break;

        case ">"
        /* GREATER_THAN */
        :
          _t20 = _n6.value, _e13 = !1;
          break;

        case "!="
        /* NOT_EQUAL */
        :
        case "not-in"
        /* NOT_IN */
        :
          _t20 = he;
        // Remaining filters cannot be used as lower bounds.
      }

      Ve({
        value: s,
        inclusive: i
      }, {
        value: _t20,
        inclusive: _e13
      }) < 0 && (s = _t20, i = _e13);
    } // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.

  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  if (null !== n) for (var r = 0; r < t.orderBy.length; ++r) {
    if (t.orderBy[r].field.isEqual(e)) {
      var _t19 = n.position[r];
      Ve({
        value: s,
        inclusive: i
      }, {
        value: _t19,
        inclusive: n.inclusive
      }) < 0 && (s = _t19, i = n.inclusive);
      break;
    }
  }
  return {
    value: s,
    inclusive: i
  };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */


function Ue(t, e, n) {
  var s = ae,
      i = !0; // Process all filters to find a value for the current field segment

  var _iterator10 = _createForOfIteratorHelper(Be(t, e)),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var _n7 = _step10.value;

      var _t22 = ae,
          _e14 = !0;

      switch (_n7.op) {
        case ">="
        /* GREATER_THAN_OR_EQUAL */
        :
        case ">"
        /* GREATER_THAN */
        :
          _t22 = ve(_n7.value), _e14 = !1;
          break;

        case "=="
        /* EQUAL */
        :
        case "in"
        /* IN */
        :
        case "<="
        /* LESS_THAN_OR_EQUAL */
        :
          _t22 = _n7.value;
          break;

        case "<"
        /* LESS_THAN */
        :
          _t22 = _n7.value, _e14 = !1;
          break;

        case "!="
        /* NOT_EQUAL */
        :
        case "not-in"
        /* NOT_IN */
        :
          _t22 = ae;
        // Remaining filters cannot be used as upper bounds.
      }

      Se({
        value: s,
        inclusive: i
      }, {
        value: _t22,
        inclusive: _e14
      }) > 0 && (s = _t22, i = _e14);
    } // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.

  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  if (null !== n) for (var r = 0; r < t.orderBy.length; ++r) {
    if (t.orderBy[r].field.isEqual(e)) {
      var _t21 = n.position[r];
      Se({
        value: s,
        inclusive: i
      }, {
        value: _t21,
        inclusive: n.inclusive
      }) > 0 && (s = _t21, i = n.inclusive);
      break;
    }
  }
  return {
    value: s,
    inclusive: i
  };
}
/** Returns the number of segments of a perfect index for this target. */


var qe = /*#__PURE__*/function (_ref3) {
  _inherits(qe, _ref3);

  var _super5 = _createSuper(qe);

  function qe(t, e, n) {
    var _this24;

    _classCallCheck(this, qe);

    _this24 = _super5.call(this), _this24.field = t, _this24.op = e, _this24.value = n;
    return _this24;
  }
  /**
   * Creates a filter based on the provided arguments.
   */


  _createClass(qe, [{
    key: "matches",
    value: function matches(t) {
      var e = t.data.field(this.field); // Types do not have to match in NOT_EQUAL filters.

      return "!="
      /* NOT_EQUAL */
      === this.op ? null !== e && this.at(_e(e, this.value)) : null !== e && le(this.value) === le(e) && this.at(_e(e, this.value)); // Only compare types with matching backend order (such as double and int).
    }
  }, {
    key: "at",
    value: function at(t) {
      switch (this.op) {
        case "<"
        /* LESS_THAN */
        :
          return t < 0;

        case "<="
        /* LESS_THAN_OR_EQUAL */
        :
          return t <= 0;

        case "=="
        /* EQUAL */
        :
          return 0 === t;

        case "!="
        /* NOT_EQUAL */
        :
          return 0 !== t;

        case ">"
        /* GREATER_THAN */
        :
          return t > 0;

        case ">="
        /* GREATER_THAN_OR_EQUAL */
        :
          return t >= 0;

        default:
          return L();
      }
    }
  }, {
    key: "ht",
    value: function ht() {
      return ["<"
      /* LESS_THAN */
      , "<="
      /* LESS_THAN_OR_EQUAL */
      , ">"
      /* GREATER_THAN */
      , ">="
      /* GREATER_THAN_OR_EQUAL */
      , "!="
      /* NOT_EQUAL */
      , "not-in"
      /* NOT_IN */
      ].indexOf(this.op) >= 0;
    }
  }], [{
    key: "create",
    value: function create(t, e, n) {
      return t.isKeyField() ? "in"
      /* IN */
      === e || "not-in"
      /* NOT_IN */
      === e ? this.ct(t, e, n) : new Ke(t, e, n) : "array-contains"
      /* ARRAY_CONTAINS */
      === e ? new We(t, n) : "in"
      /* IN */
      === e ? new ze(t, n) : "not-in"
      /* NOT_IN */
      === e ? new He(t, n) : "array-contains-any"
      /* ARRAY_CONTAINS_ANY */
      === e ? new Je(t, n) : new qe(t, e, n);
    }
  }, {
    key: "ct",
    value: function ct(t, e, n) {
      return "in"
      /* IN */
      === e ? new Ge(t, n) : new Qe(t, n);
    }
  }]);

  return qe;
}( /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }

  return _createClass(_class2);
}());

var Ke = /*#__PURE__*/function (_qe) {
  _inherits(Ke, _qe);

  var _super6 = _createSuper(Ke);

  function Ke(t, e, n) {
    var _this25;

    _classCallCheck(this, Ke);

    _this25 = _super6.call(this, t, e, n), _this25.key = dt.fromName(n.referenceValue);
    return _this25;
  }

  _createClass(Ke, [{
    key: "matches",
    value: function matches(t) {
      var e = dt.comparator(t.key, this.key);
      return this.at(e);
    }
  }]);

  return Ke;
}(qe);
/** Filter that matches on key fields within an array. */


var Ge = /*#__PURE__*/function (_qe2) {
  _inherits(Ge, _qe2);

  var _super7 = _createSuper(Ge);

  function Ge(t, e) {
    var _this26;

    _classCallCheck(this, Ge);

    _this26 = _super7.call(this, t, "in"
    /* IN */
    , e), _this26.keys = je("in"
    /* IN */
    , e);
    return _this26;
  }

  _createClass(Ge, [{
    key: "matches",
    value: function matches(t) {
      return this.keys.some(function (e) {
        return e.isEqual(t.key);
      });
    }
  }]);

  return Ge;
}(qe);
/** Filter that matches on key fields not present within an array. */


var Qe = /*#__PURE__*/function (_qe3) {
  _inherits(Qe, _qe3);

  var _super8 = _createSuper(Qe);

  function Qe(t, e) {
    var _this27;

    _classCallCheck(this, Qe);

    _this27 = _super8.call(this, t, "not-in"
    /* NOT_IN */
    , e), _this27.keys = je("not-in"
    /* NOT_IN */
    , e);
    return _this27;
  }

  _createClass(Qe, [{
    key: "matches",
    value: function matches(t) {
      return !this.keys.some(function (e) {
        return e.isEqual(t.key);
      });
    }
  }]);

  return Qe;
}(qe);

function je(t, e) {
  var n;
  return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map(function (t) {
    return dt.fromName(t.referenceValue);
  });
}
/** A Filter that implements the array-contains operator. */


var We = /*#__PURE__*/function (_qe4) {
  _inherits(We, _qe4);

  var _super9 = _createSuper(We);

  function We(t, e) {
    _classCallCheck(this, We);

    return _super9.call(this, t, "array-contains"
    /* ARRAY_CONTAINS */
    , e);
  }

  _createClass(We, [{
    key: "matches",
    value: function matches(t) {
      var e = t.data.field(this.field);
      return Ie(e) && de(e.arrayValue, this.value);
    }
  }]);

  return We;
}(qe);
/** A Filter that implements the IN operator. */


var ze = /*#__PURE__*/function (_qe5) {
  _inherits(ze, _qe5);

  var _super10 = _createSuper(ze);

  function ze(t, e) {
    _classCallCheck(this, ze);

    return _super10.call(this, t, "in"
    /* IN */
    , e);
  }

  _createClass(ze, [{
    key: "matches",
    value: function matches(t) {
      var e = t.data.field(this.field);
      return null !== e && de(this.value.arrayValue, e);
    }
  }]);

  return ze;
}(qe);
/** A Filter that implements the not-in operator. */


var He = /*#__PURE__*/function (_qe6) {
  _inherits(He, _qe6);

  var _super11 = _createSuper(He);

  function He(t, e) {
    _classCallCheck(this, He);

    return _super11.call(this, t, "not-in"
    /* NOT_IN */
    , e);
  }

  _createClass(He, [{
    key: "matches",
    value: function matches(t) {
      if (de(this.value.arrayValue, {
        nullValue: "NULL_VALUE"
      })) return !1;
      var e = t.data.field(this.field);
      return null !== e && !de(this.value.arrayValue, e);
    }
  }]);

  return He;
}(qe);
/** A Filter that implements the array-contains-any operator. */


var Je = /*#__PURE__*/function (_qe7) {
  _inherits(Je, _qe7);

  var _super12 = _createSuper(Je);

  function Je(t, e) {
    _classCallCheck(this, Je);

    return _super12.call(this, t, "array-contains-any"
    /* ARRAY_CONTAINS_ANY */
    , e);
  }

  _createClass(Je, [{
    key: "matches",
    value: function matches(t) {
      var _this28 = this;

      var e = t.data.field(this.field);
      return !(!Ie(e) || !e.arrayValue.values) && e.arrayValue.values.some(function (t) {
        return de(_this28.value.arrayValue, t);
      });
    }
  }]);

  return Je;
}(qe);
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */


var Ye = /*#__PURE__*/_createClass(function Ye(t, e) {
  _classCallCheck(this, Ye);

  this.position = t, this.inclusive = e;
});
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */


var Xe = /*#__PURE__*/_createClass(function Xe(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";

  _classCallCheck(this, Xe);

  this.field = t, this.dir = e;
});

function Ze(t, e) {
  return t.dir === e.dir && t.field.isEqual(e.field);
}

function tn(t, e, n) {
  var s = 0;

  for (var i = 0; i < t.position.length; i++) {
    var r = e[i],
        o = t.position[i];
    if (r.field.isKeyField()) s = dt.comparator(dt.fromName(o.referenceValue), n.key);else {
      s = _e(o, n.data.field(r.field));
    }
    if ("desc"
    /* DESCENDING */
    === r.dir && (s *= -1), 0 !== s) break;
  }

  return s;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */


function en(t, e) {
  if (null === t) return null === e;
  if (null === e) return !1;
  if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;

  for (var n = 0; n < t.position.length; n++) {
    if (!fe(t.position[n], e.position[n])) return !1;
  }

  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */


var nn = /*#__PURE__*/_createClass(
/**
 * Initializes a Query with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 */
function nn(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "F";
  var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var u = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

  _classCallCheck(this, nn);

  this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = s, this.limit = i, this.limitType = r, this.startAt = o, this.endAt = u, this.lt = null, // The corresponding `Target` of this `Query` instance.
  this.ft = null, this.startAt, this.endAt;
});
/** Creates a new Query instance with the options provided. */


function sn(t, e, n, s, i, r, o, u) {
  return new nn(t, e, n, s, i, r, o, u);
}
/** Creates a new Query for a query that matches all documents at `path` */


function rn(t) {
  return new nn(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */

/**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */


function on(t) {
  return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
}

function un(t) {
  return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}

function cn(t) {
  var _iterator11 = _createForOfIteratorHelper(t.filters),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var e = _step11.value;
      if (e.ht()) return e.field;
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return null;
}
/**
 * Checks if any of the provided Operators are included in the query and
 * returns the first one that is, or null if none are.
 */

/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */


function an(t) {
  return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */


function hn(t) {
  var e = K(t);

  if (null === e.lt) {
    e.lt = [];

    var _t23 = cn(e),
        n = un(e);

    if (null !== _t23 && null === n) // In order to implicitly add key ordering, we must also add the
      // inequality filter field for it to be a valid query.
      // Note that the default inequality field and key ordering is ascending.
      _t23.isKeyField() || e.lt.push(new Xe(_t23)), e.lt.push(new Xe(ft.keyField(), "asc"
      /* ASCENDING */
      ));else {
      var _t24 = !1;

      var _iterator12 = _createForOfIteratorHelper(e.explicitOrderBy),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _n8 = _step12.value;
          e.lt.push(_n8), _n8.field.isKeyField() && (_t24 = !0);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      if (!_t24) {
        // The order of the implicit key ordering always matches the last
        // explicit order by
        var _t25 = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc"
        /* ASCENDING */
        ;

        e.lt.push(new Xe(ft.keyField(), _t25));
      }
    }
  }

  return e.lt;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */


function ln(t) {
  var e = K(t);
  if (!e.ft) if ("F"
  /* First */
  === e.limitType) e.ft = ke(e.path, e.collectionGroup, hn(e), e.filters, e.limit, e.startAt, e.endAt);else {
    // Flip the orderBy directions since we want the last results
    var _t26 = [];

    var _iterator13 = _createForOfIteratorHelper(hn(e)),
        _step13;

    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var _n9 = _step13.value;

        var _e15 = "desc"
        /* DESCENDING */
        === _n9.dir ? "asc"
        /* ASCENDING */
        : "desc"
        /* DESCENDING */
        ;

        _t26.push(new Xe(_n9.field, _e15));
      } // We need to swap the cursors to match the now-flipped query ordering.

    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }

    var n = e.endAt ? new Ye(e.endAt.position, e.endAt.inclusive) : null,
        s = e.startAt ? new Ye(e.startAt.position, e.startAt.inclusive) : null; // Now return as a LimitType.First query.

    e.ft = ke(e.path, e.collectionGroup, _t26, e.filters, e.limit, n, s);
  }
  return e.ft;
}

function fn(t, e, n) {
  return new nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}

function dn(t, e) {
  return Fe(ln(t), ln(e)) && t.limitType === e.limitType;
} // TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.


function _n(t) {
  return "".concat(Oe(ln(t)), "|lt:").concat(t.limitType);
}

function wn(t) {
  return "Query(target=".concat(Me(ln(t)), "; limitType=").concat(t.limitType, ")");
}
/** Returns whether `doc` matches the constraints of `query`. */


function mn(t, e) {
  return e.isFoundDocument() && function (t, e) {
    var n = e.key.path;
    return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : dt.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
  }
  /**
  * A document must have a value for every ordering clause in order to show up
  * in the results.
  */
  (t, e) && function (t, e) {
    var _iterator14 = _createForOfIteratorHelper(t.explicitOrderBy),
        _step14;

    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) // order by key always matches
      {
        var n = _step14.value;
        if (!n.field.isKeyField() && null === e.data.field(n.field)) return !1;
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }

    return !0;
  }(t, e) && function (t, e) {
    var _iterator15 = _createForOfIteratorHelper(t.filters),
        _step15;

    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var n = _step15.value;
        if (!n.matches(e)) return !1;
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }

    return !0;
  }
  /** Makes sure a document is within the bounds, if provided. */
  (t, e) && function (t, e) {
    if (t.startAt && !
    /**
    * Returns true if a document sorts before a bound using the provided sort
    * order.
    */
    function (t, e, n) {
      var s = tn(t, e, n);
      return t.inclusive ? s <= 0 : s < 0;
    }(t.startAt, hn(t), e)) return !1;
    if (t.endAt && !function (t, e, n) {
      var s = tn(t, e, n);
      return t.inclusive ? s >= 0 : s > 0;
    }(t.endAt, hn(t), e)) return !1;
    return !0;
  }
  /**
  * Returns the collection group that this query targets.
  *
  * PORTING NOTE: This is only used in the Web SDK to facilitate multi-tab
  * synchronization for query results.
  */
  (t, e);
}

function gn(t) {
  return t.collectionGroup || (t.path.length % 2 == 1 ? t.path.lastSegment() : t.path.get(t.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */


function yn(t) {
  return function (e, n) {
    var s = !1;

    var _iterator16 = _createForOfIteratorHelper(hn(t)),
        _step16;

    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var i = _step16.value;

        var _t27 = pn(i, e, n);

        if (0 !== _t27) return _t27;
        s = s || i.field.isKeyField();
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }

    return 0;
  };
}

function pn(t, e, n) {
  var s = t.field.isKeyField() ? dt.comparator(e.key, n.key) : function (t, e, n) {
    var s = e.data.field(t),
        i = n.data.field(t);
    return null !== s && null !== i ? _e(s, i) : L();
  }(t.field, e, n);

  switch (t.dir) {
    case "asc"
    /* ASCENDING */
    :
      return s;

    case "desc"
    /* DESCENDING */
    :
      return -1 * s;

    default:
      return L();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */


function In(t, e) {
  if (t.dt) {
    if (isNaN(e)) return {
      doubleValue: "NaN"
    };
    if (e === 1 / 0) return {
      doubleValue: "Infinity"
    };
    if (e === -1 / 0) return {
      doubleValue: "-Infinity"
    };
  }

  return {
    doubleValue: ue(e) ? "-0" : e
  };
}
/**
 * Returns an IntegerValue for `value`.
 */


function Tn(t) {
  return {
    integerValue: "" + t
  };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */


function En(t, e) {
  return ce(e) ? Tn(e) : In(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Used to represent a field transform on a mutation. */


var An = /*#__PURE__*/_createClass(function An() {
  _classCallCheck(this, An);

  // Make sure that the structural type of `TransformOperation` is unique.
  // See https://github.com/microsoft/TypeScript/issues/5451
  this._ = void 0;
});
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */


function Rn(t, e, n) {
  return t instanceof vn ? function (t, e) {
    var n = {
      fields: {
        __type__: {
          stringValue: "server_timestamp"
        },
        __local_write_time__: {
          timestampValue: {
            seconds: t.seconds,
            nanos: t.nanoseconds
          }
        }
      }
    };
    return e && (n.fields.__previous_value__ = e), {
      mapValue: n
    };
  }(n, e) : t instanceof Vn ? Sn(t, e) : t instanceof Dn ? Cn(t, e) : function (t, e) {
    // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
    // precision and resolves overflows by reducing precision, we do not
    // manually cap overflows at 2^63.
    var n = Pn(t, e),
        s = Nn(n) + Nn(t._t);
    return pe(n) && pe(t._t) ? Tn(s) : In(t.wt, s);
  }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */


function bn(t, e, n) {
  // The server just sends null as the transform result for array operations,
  // so we have to calculate a result the same as we do for local
  // applications.
  return t instanceof Vn ? Sn(t, e) : t instanceof Dn ? Cn(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */


function Pn(t, e) {
  return t instanceof xn ? pe(n = e) || function (t) {
    return !!t && "doubleValue" in t;
  }
  /** Returns true if `value` is either an IntegerValue or a DoubleValue. */
  (n) ? e : {
    integerValue: 0
  } : null;
  var n;
}
/** Transforms a value into a server-generated timestamp. */


var vn = /*#__PURE__*/function (_An) {
  _inherits(vn, _An);

  var _super13 = _createSuper(vn);

  function vn() {
    _classCallCheck(this, vn);

    return _super13.apply(this, arguments);
  }

  return _createClass(vn);
}(An);
/** Transforms an array value via a union operation. */


var Vn = /*#__PURE__*/function (_An2) {
  _inherits(Vn, _An2);

  var _super14 = _createSuper(Vn);

  function Vn(t) {
    var _this29;

    _classCallCheck(this, Vn);

    _this29 = _super14.call(this), _this29.elements = t;
    return _this29;
  }

  return _createClass(Vn);
}(An);

function Sn(t, e) {
  var n = kn(e);

  var _iterator17 = _createForOfIteratorHelper(t.elements),
      _step17;

  try {
    var _loop3 = function _loop3() {
      var e = _step17.value;
      n.some(function (t) {
        return fe(t, e);
      }) || n.push(e);
    };

    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }

  return {
    arrayValue: {
      values: n
    }
  };
}
/** Transforms an array value via a remove operation. */


var Dn = /*#__PURE__*/function (_An3) {
  _inherits(Dn, _An3);

  var _super15 = _createSuper(Dn);

  function Dn(t) {
    var _this30;

    _classCallCheck(this, Dn);

    _this30 = _super15.call(this), _this30.elements = t;
    return _this30;
  }

  return _createClass(Dn);
}(An);

function Cn(t, e) {
  var n = kn(e);

  var _iterator18 = _createForOfIteratorHelper(t.elements),
      _step18;

  try {
    var _loop4 = function _loop4() {
      var e = _step18.value;
      n = n.filter(function (t) {
        return !fe(t, e);
      });
    };

    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      _loop4();
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }

  return {
    arrayValue: {
      values: n
    }
  };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */


var xn = /*#__PURE__*/function (_An4) {
  _inherits(xn, _An4);

  var _super16 = _createSuper(xn);

  function xn(t, e) {
    var _this31;

    _classCallCheck(this, xn);

    _this31 = _super16.call(this), _this31.wt = t, _this31._t = e;
    return _this31;
  }

  return _createClass(xn);
}(An);

function Nn(t) {
  return Zt(t.integerValue || t.doubleValue);
}

function kn(t) {
  return Ie(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** A field path and the TransformOperation to perform upon it. */


var On = /*#__PURE__*/_createClass(function On(t, e) {
  _classCallCheck(this, On);

  this.field = t, this.transform = e;
});

function Mn(t, e) {
  return t.field.isEqual(e.field) && function (t, e) {
    return t instanceof Vn && e instanceof Vn || t instanceof Dn && e instanceof Dn ? rt(t.elements, e.elements, fe) : t instanceof xn && e instanceof xn ? fe(t._t, e._t) : t instanceof vn && e instanceof vn;
  }(t.transform, e.transform);
}
/** The result of successfully applying a mutation to the backend. */


var Fn = /*#__PURE__*/_createClass(function Fn(
/**
 * The version at which the mutation was committed:
 *
 * - For most operations, this is the updateTime in the WriteResult.
 * - For deletes, the commitTime of the WriteResponse (because deletes are
 *   not stored and have no updateTime).
 *
 * Note that these versions can be different: No-op writes will not change
 * the updateTime even though the commitTime advances.
 */
t,
/**
 * The resulting fields returned from the backend after a mutation
 * containing field transforms has been committed. Contains one FieldValue
 * for each FieldTransform that was in the mutation.
 *
 * Will be empty if the mutation did not contain any field transforms.
 */
e) {
  _classCallCheck(this, Fn);

  this.version = t, this.transformResults = e;
});
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */


var $n = /*#__PURE__*/function () {
  function $n(t, e) {
    _classCallCheck(this, $n);

    this.updateTime = t, this.exists = e;
  }
  /** Creates a new empty Precondition. */


  _createClass($n, [{
    key: "isNone",
    get:
    /** Returns whether this Precondition is empty. */
    function get() {
      return void 0 === this.updateTime && void 0 === this.exists;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
  }], [{
    key: "none",
    value: function none() {
      return new $n();
    }
    /** Creates a new Precondition with an exists flag. */

  }, {
    key: "exists",
    value: function exists(t) {
      return new $n(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */

  }, {
    key: "updateTime",
    value: function updateTime(t) {
      return new $n(t);
    }
  }]);

  return $n;
}();
/** Returns true if the preconditions is valid for the given document. */


function Bn(t, e) {
  return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */


var Ln = /*#__PURE__*/_createClass(function Ln() {
  _classCallCheck(this, Ln);
});
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */


function Un(t, e) {
  if (!t.hasLocalMutations || e && 0 === e.fields.length) return null; // mask is null when sets or deletes are applied to the current document.

  if (null === e) return t.isNoDocument() ? new Yn(t.key, $n.none()) : new jn(t.key, t.data, $n.none());
  {
    var n = t.data,
        s = De.empty();
    var i = new Qt(ft.comparator);

    var _iterator19 = _createForOfIteratorHelper(e.fields),
        _step19;

    try {
      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
        var _t28 = _step19.value;

        if (!i.has(_t28)) {
          var _e16 = n.field(_t28); // If we are deleting a nested field, we take the immediate parent as
          // the mask used to construct the resulting mutation.
          // Justification: Nested fields can create parent fields implicitly. If
          // only a leaf entry is deleted in later mutations, the parent field
          // should still remain, but we may have lost this information.
          // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
          // This leaves the final result (foo, {}). Despite the fact that `doc`
          // has the correct result, `foo` is not in `mask`, and the resulting
          // mutation would miss `foo`.


          null === _e16 && _t28.length > 1 && (_t28 = _t28.popLast(), _e16 = n.field(_t28)), null === _e16 ? s.delete(_t28) : s.set(_t28, _e16), i = i.add(_t28);
        }
      }
    } catch (err) {
      _iterator19.e(err);
    } finally {
      _iterator19.f();
    }

    return new Wn(t.key, s, new zt(i.toArray()), $n.none());
  }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */


function qn(t, e, n) {
  t instanceof jn ? function (t, e, n) {
    // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
    // remote document the server has accepted the mutation so the precondition
    // must have held.
    var s = t.value.clone(),
        i = Hn(t.fieldTransforms, e, n.transformResults);
    s.setAll(i), e.convertToFoundDocument(n.version, s).setHasCommittedMutations();
  }(t, e, n) : t instanceof Wn ? function (t, e, n) {
    if (!Bn(t.precondition, e)) // Since the mutation was not rejected, we know that the precondition
      // matched on the backend. We therefore must not have the expected version
      // of the document in our cache and convert to an UnknownDocument with a
      // known updateTime.
      return void e.convertToUnknownDocument(n.version);
    var s = Hn(t.fieldTransforms, e, n.transformResults),
        i = e.data;
    i.setAll(zn(t)), i.setAll(s), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
  }(t, e, n) : function (t, e, n) {
    // Unlike applyToLocalView, if we're applying a mutation to a remote
    // document the server has accepted the mutation so the precondition must
    // have held.
    e.convertToNoDocument(n.version).setHasCommittedMutations();
  }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */


function Kn(t, e, n, s) {
  return t instanceof jn ? function (t, e, n, s) {
    if (!Bn(t.precondition, e)) // The mutation failed to apply (e.g. a document ID created with add()
      // caused a name collision).
      return n;
    var i = t.value.clone(),
        r = Jn(t.fieldTransforms, s, e);
    return i.setAll(r), e.convertToFoundDocument(e.version, i).setHasLocalMutations(), null; // SetMutation overwrites all fields.
  }
  /**
  * A mutation that modifies fields of the document at the given key with the
  * given values. The values are applied through a field mask:
  *
  *  * When a field is in both the mask and the values, the corresponding field
  *    is updated.
  *  * When a field is in neither the mask nor the values, the corresponding
  *    field is unmodified.
  *  * When a field is in the mask but not in the values, the corresponding field
  *    is deleted.
  *  * When a field is not in the mask but is in the values, the values map is
  *    ignored.
  */
  (t, e, n, s) : t instanceof Wn ? function (t, e, n, s) {
    if (!Bn(t.precondition, e)) return n;
    var i = Jn(t.fieldTransforms, s, e),
        r = e.data;
    if (r.setAll(zn(t)), r.setAll(i), e.convertToFoundDocument(e.version, r).setHasLocalMutations(), null === n) return null;
    return n.unionWith(t.fieldMask.fields).unionWith(t.fieldTransforms.map(function (t) {
      return t.field;
    }));
  }
  /**
  * Returns a FieldPath/Value map with the content of the PatchMutation.
  */
  (t, e, n, s) : function (t, e, n) {
    if (Bn(t.precondition, e)) return e.convertToNoDocument(e.version).setHasLocalMutations(), null;
    return n;
  }
  /**
  * A mutation that verifies the existence of the document at the given key with
  * the provided precondition.
  *
  * The `verify` operation is only used in Transactions, and this class serves
  * primarily to facilitate serialization into protos.
  */
  (t, e, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */


function Gn(t, e) {
  var n = null;

  var _iterator20 = _createForOfIteratorHelper(t.fieldTransforms),
      _step20;

  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var s = _step20.value;

      var _t29 = e.data.field(s.field),
          i = Pn(s.transform, _t29 || null);

      null != i && (null === n && (n = De.empty()), n.set(s.field, i));
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }

  return n || null;
}

function Qn(t, e) {
  return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function (t, e) {
    return void 0 === t && void 0 === e || !(!t || !e) && rt(t, e, function (t, e) {
      return Mn(t, e);
    });
  }(t.fieldTransforms, e.fieldTransforms) && (0
  /* Set */
  === t.type ? t.value.isEqual(e.value) : 1
  /* Patch */
  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */


var jn = /*#__PURE__*/function (_Ln) {
  _inherits(jn, _Ln);

  var _super17 = _createSuper(jn);

  function jn(t, e, n) {
    var _this32;

    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, jn);

    _this32 = _super17.call(this), _this32.key = t, _this32.value = e, _this32.precondition = n, _this32.fieldTransforms = s, _this32.type = 0
    /* Set */
    ;
    return _this32;
  }

  _createClass(jn, [{
    key: "getFieldMask",
    value: function getFieldMask() {
      return null;
    }
  }]);

  return jn;
}(Ln);

var Wn = /*#__PURE__*/function (_Ln2) {
  _inherits(Wn, _Ln2);

  var _super18 = _createSuper(Wn);

  function Wn(t, e, n, s) {
    var _this33;

    var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    _classCallCheck(this, Wn);

    _this33 = _super18.call(this), _this33.key = t, _this33.data = e, _this33.fieldMask = n, _this33.precondition = s, _this33.fieldTransforms = i, _this33.type = 1
    /* Patch */
    ;
    return _this33;
  }

  _createClass(Wn, [{
    key: "getFieldMask",
    value: function getFieldMask() {
      return this.fieldMask;
    }
  }]);

  return Wn;
}(Ln);

function zn(t) {
  var e = new Map();
  return t.fieldMask.fields.forEach(function (n) {
    if (!n.isEmpty()) {
      var s = t.data.field(n);
      e.set(n, s);
    }
  }), e;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */


function Hn(t, e, n) {
  var s = new Map();
  U(t.length === n.length);

  for (var i = 0; i < n.length; i++) {
    var r = t[i],
        o = r.transform,
        u = e.data.field(r.field);
    s.set(r.field, bn(o, u, n[i]));
  }

  return s;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */


function Jn(t, e, n) {
  var s = new Map();

  var _iterator21 = _createForOfIteratorHelper(t),
      _step21;

  try {
    for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
      var i = _step21.value;
      var _t30 = i.transform,
          r = n.data.field(i.field);
      s.set(i.field, Rn(_t30, r, e));
    }
  } catch (err) {
    _iterator21.e(err);
  } finally {
    _iterator21.f();
  }

  return s;
}
/** A mutation that deletes the document at the given key. */


var Yn = /*#__PURE__*/function (_Ln3) {
  _inherits(Yn, _Ln3);

  var _super19 = _createSuper(Yn);

  function Yn(t, e) {
    var _this34;

    _classCallCheck(this, Yn);

    _this34 = _super19.call(this), _this34.key = t, _this34.precondition = e, _this34.type = 2
    /* Delete */
    , _this34.fieldTransforms = [];
    return _this34;
  }

  _createClass(Yn, [{
    key: "getFieldMask",
    value: function getFieldMask() {
      return null;
    }
  }]);

  return Yn;
}(Ln);

var Xn = /*#__PURE__*/function (_Ln4) {
  _inherits(Xn, _Ln4);

  var _super20 = _createSuper(Xn);

  function Xn(t, e) {
    var _this35;

    _classCallCheck(this, Xn);

    _this35 = _super20.call(this), _this35.key = t, _this35.precondition = e, _this35.type = 3
    /* Verify */
    , _this35.fieldTransforms = [];
    return _this35;
  }

  _createClass(Xn, [{
    key: "getFieldMask",
    value: function getFieldMask() {
      return null;
    }
  }]);

  return Xn;
}(Ln);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Zn = /*#__PURE__*/_createClass( // TODO(b/33078163): just use simplest form of existence filter for now
function Zn(t) {
  _classCallCheck(this, Zn);

  this.count = t;
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */


var ts, es;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */

function ns(t) {
  switch (t) {
    default:
      return L();

    case G.CANCELLED:
    case G.UNKNOWN:
    case G.DEADLINE_EXCEEDED:
    case G.RESOURCE_EXHAUSTED:
    case G.INTERNAL:
    case G.UNAVAILABLE: // Unauthenticated means something went wrong with our token and we need
    // to retry with new credentials which will happen automatically.

    case G.UNAUTHENTICATED:
      return !1;

    case G.INVALID_ARGUMENT:
    case G.NOT_FOUND:
    case G.ALREADY_EXISTS:
    case G.PERMISSION_DENIED:
    case G.FAILED_PRECONDITION: // Aborted might be retried in some scenarios, but that is dependant on
    // the context and should handled individually by the calling code.
    // See https://cloud.google.com/apis/design/errors.

    case G.ABORTED:
    case G.OUT_OF_RANGE:
    case G.UNIMPLEMENTED:
    case G.DATA_LOSS:
      return !0;
  }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */

/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */


function ss(t) {
  if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return F("GRPC error has no .code"), G.UNKNOWN;

  switch (t) {
    case ts.OK:
      return G.OK;

    case ts.CANCELLED:
      return G.CANCELLED;

    case ts.UNKNOWN:
      return G.UNKNOWN;

    case ts.DEADLINE_EXCEEDED:
      return G.DEADLINE_EXCEEDED;

    case ts.RESOURCE_EXHAUSTED:
      return G.RESOURCE_EXHAUSTED;

    case ts.INTERNAL:
      return G.INTERNAL;

    case ts.UNAVAILABLE:
      return G.UNAVAILABLE;

    case ts.UNAUTHENTICATED:
      return G.UNAUTHENTICATED;

    case ts.INVALID_ARGUMENT:
      return G.INVALID_ARGUMENT;

    case ts.NOT_FOUND:
      return G.NOT_FOUND;

    case ts.ALREADY_EXISTS:
      return G.ALREADY_EXISTS;

    case ts.PERMISSION_DENIED:
      return G.PERMISSION_DENIED;

    case ts.FAILED_PRECONDITION:
      return G.FAILED_PRECONDITION;

    case ts.ABORTED:
      return G.ABORTED;

    case ts.OUT_OF_RANGE:
      return G.OUT_OF_RANGE;

    case ts.UNIMPLEMENTED:
      return G.UNIMPLEMENTED;

    case ts.DATA_LOSS:
      return G.DATA_LOSS;

    default:
      return L();
  }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */


(es = ts || (ts = {}))[es.OK = 0] = "OK", es[es.CANCELLED = 1] = "CANCELLED", es[es.UNKNOWN = 2] = "UNKNOWN", es[es.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", es[es.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", es[es.NOT_FOUND = 5] = "NOT_FOUND", es[es.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", es[es.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", es[es.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", es[es.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", es[es.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", es[es.ABORTED = 10] = "ABORTED", es[es.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", es[es.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", es[es.INTERNAL = 13] = "INTERNAL", es[es.UNAVAILABLE = 14] = "UNAVAILABLE", es[es.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */

var is = /*#__PURE__*/function () {
  function is(t, e) {
    _classCallCheck(this, is);

    this.mapKeyFn = t, this.equalsFn = e,
    /**
     * The inner map for a key/value pair. Due to the possibility of collisions we
     * keep a list of entries that we do a linear search through to find an actual
     * match. Note that collisions should be rare, so we still expect near
     * constant time lookups in practice.
     */
    this.inner = {},
    /** The number of entries stored in the map */
    this.innerSize = 0;
  }
  /** Get a value for this key, or undefined if it does not exist. */


  _createClass(is, [{
    key: "get",
    value: function get(t) {
      var e = this.mapKeyFn(t),
          n = this.inner[e];

      if (void 0 !== n) {
        var _iterator22 = _createForOfIteratorHelper(n),
            _step22;

        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var _step22$value = _slicedToArray(_step22.value, 2),
                _e17 = _step22$value[0],
                s = _step22$value[1];

            if (this.equalsFn(_e17, t)) return s;
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
      }
    }
  }, {
    key: "has",
    value: function has(t) {
      return void 0 !== this.get(t);
    }
    /** Put this key and value in the map. */

  }, {
    key: "set",
    value: function set(t, e) {
      var n = this.mapKeyFn(t),
          s = this.inner[n];
      if (void 0 === s) return this.inner[n] = [[t, e]], void this.innerSize++;

      for (var _n10 = 0; _n10 < s.length; _n10++) {
        if (this.equalsFn(s[_n10][0], t)) // This is updating an existing entry and does not increase `innerSize`.
          return void (s[_n10] = [t, e]);
      }

      s.push([t, e]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */

  }, {
    key: "delete",
    value: function _delete(t) {
      var e = this.mapKeyFn(t),
          n = this.inner[e];
      if (void 0 === n) return !1;

      for (var s = 0; s < n.length; s++) {
        if (this.equalsFn(n[s][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(s, 1), this.innerSize--, !0;
      }

      return !1;
    }
  }, {
    key: "forEach",
    value: function forEach(t) {
      Lt(this.inner, function (e, n) {
        var _iterator23 = _createForOfIteratorHelper(n),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _step23$value = _slicedToArray(_step23.value, 2),
                _e18 = _step23$value[0],
                s = _step23$value[1];

            t(_e18, s);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return Ut(this.inner);
    }
  }, {
    key: "size",
    value: function size() {
      return this.innerSize;
    }
  }]);

  return is;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var rs = new qt(dt.comparator);

function os() {
  return rs;
}

var us = new qt(dt.comparator);

function cs() {
  var e = us;

  for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    t[_key5] = arguments[_key5];
  }

  for (var _i3 = 0, _t31 = t; _i3 < _t31.length; _i3++) {
    var n = _t31[_i3];
    e = e.insert(n.key, n);
  }

  return e;
}

function as(t) {
  var e = us;
  return t.forEach(function (t, n) {
    return e = e.insert(t, n.overlayedDocument);
  }), e;
}

function hs() {
  return fs();
}

function ls() {
  return fs();
}

function fs() {
  return new is(function (t) {
    return t.toString();
  }, function (t, e) {
    return t.isEqual(e);
  });
}

var ds = new qt(dt.comparator);

var _s = new Qt(dt.comparator);

function ws() {
  var e = _s;

  for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    t[_key6] = arguments[_key6];
  }

  for (var _i4 = 0, _t32 = t; _i4 < _t32.length; _i4++) {
    var n = _t32[_i4];
    e = e.add(n);
  }

  return e;
}

var ms = new Qt(it);

function gs() {
  return ms;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */


var ys = /*#__PURE__*/function () {
  function ys(
  /**
   * The snapshot version this event brings us up to, or MIN if not set.
   */
  t,
  /**
   * A map from target to changes to the target. See TargetChange.
   */
  e,
  /**
   * A set of targets that is known to be inconsistent. Listens for these
   * targets should be re-established without resume tokens.
   */
  n,
  /**
   * A set of which documents have changed or been deleted, along with the
   * doc's new values (if not deleted).
   */
  s,
  /**
   * A set of which document updates are due only to limbo resolution targets.
   */
  i) {
    _classCallCheck(this, ys);

    this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = s, this.resolvedLimboDocuments = i;
  }
  /**
   * HACK: Views require RemoteEvents in order to determine whether the view is
   * CURRENT, but secondary tabs don't receive remote events. So this method is
   * used to create a synthesized RemoteEvent that can be used to apply a
   * CURRENT status change to a View, for queries executed in a different tab.
   */
  // PORTING NOTE: Multi-tab only


  _createClass(ys, null, [{
    key: "createSynthesizedRemoteEventForCurrentChange",
    value: function createSynthesizedRemoteEventForCurrentChange(t, e) {
      var n = new Map();
      return n.set(t, ps.createSynthesizedTargetChangeForCurrentChange(t, e)), new ys(ct.min(), n, gs(), os(), ws());
    }
  }]);

  return ys;
}();
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */


var ps = /*#__PURE__*/function () {
  function ps(
  /**
   * An opaque, server-assigned token that allows watching a query to be resumed
   * after disconnecting without retransmitting all the data that matches the
   * query. The resume token essentially identifies a point in time from which
   * the server should resume sending results.
   */
  t,
  /**
   * The "current" (synced) status of this target. Note that "current"
   * has special meaning in the RPC protocol that implies that a target is
   * both up-to-date and consistent with the rest of the watch stream.
   */
  e,
  /**
   * The set of documents that were newly assigned to this target as part of
   * this remote event.
   */
  n,
  /**
   * The set of documents that were already assigned to this target but received
   * an update during this remote event.
   */
  s,
  /**
   * The set of documents that were removed from this target as part of this
   * remote event.
   */
  i) {
    _classCallCheck(this, ps);

    this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = s, this.removedDocuments = i;
  }
  /**
   * This method is used to create a synthesized TargetChanges that can be used to
   * apply a CURRENT status change to a View (for queries executed in a different
   * tab) or for new queries (to raise snapshots with correct CURRENT status).
   */


  _createClass(ps, null, [{
    key: "createSynthesizedTargetChangeForCurrentChange",
    value: function createSynthesizedTargetChangeForCurrentChange(t, e) {
      return new ps(Jt.EMPTY_BYTE_STRING, e, ws(), ws(), ws());
    }
  }]);

  return ps;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */


var Is = /*#__PURE__*/_createClass(function Is(
/** The new document applies to all of these targets. */
t,
/** The new document is removed from all of these targets. */
e,
/** The key of the document for this change. */
n,
/**
 * The new document or NoDocument if it was deleted. Is null if the
 * document went out of view without the server sending a new document.
 */
s) {
  _classCallCheck(this, Is);

  this.gt = t, this.removedTargetIds = e, this.key = n, this.yt = s;
});

var Ts = /*#__PURE__*/_createClass(function Ts(t, e) {
  _classCallCheck(this, Ts);

  this.targetId = t, this.It = e;
});

var Es = /*#__PURE__*/_createClass(function Es(
/** What kind of change occurred to the watch target. */
t,
/** The target IDs that were added/removed/set. */
e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Jt.EMPTY_BYTE_STRING;
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck(this, Es);

  this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = s;
});
/** Tracks the internal state of a Watch target. */


var As = /*#__PURE__*/function () {
  function As() {
    _classCallCheck(this, As);

    /**
     * The number of pending responses (adds or removes) that we are waiting on.
     * We only consider targets active that have no pending responses.
     */
    this.Tt = 0,
    /**
     * Keeps track of the document changes since the last raised snapshot.
     *
     * These changes are continuously updated as we receive document updates and
     * always reflect the current set of changes against the last issued snapshot.
     */
    this.Et = Ps(),
    /** See public getters for explanations of these fields. */
    this.At = Jt.EMPTY_BYTE_STRING, this.Rt = !1,
    /**
     * Whether this target state should be included in the next snapshot. We
     * initialize to true so that newly-added targets are included in the next
     * RemoteEvent.
     */
    this.bt = !0;
  }
  /**
   * Whether this target has been marked 'current'.
   *
   * 'Current' has special meaning in the RPC protocol: It implies that the
   * Watch backend has sent us all changes up to the point at which the target
   * was added and that the target is consistent with the rest of the watch
   * stream.
   */


  _createClass(As, [{
    key: "current",
    get: function get() {
      return this.Rt;
    }
    /** The last resume token sent to us for this target. */

  }, {
    key: "resumeToken",
    get: function get() {
      return this.At;
    }
    /** Whether this target has pending target adds or target removes. */

  }, {
    key: "Pt",
    get: function get() {
      return 0 !== this.Tt;
    }
    /** Whether we have modified any state that should trigger a snapshot. */

  }, {
    key: "vt",
    get: function get() {
      return this.bt;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */

  }, {
    key: "Vt",
    value: function Vt(t) {
      t.approximateByteSize() > 0 && (this.bt = !0, this.At = t);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */

  }, {
    key: "St",
    value: function St() {
      var t = ws(),
          e = ws(),
          n = ws();
      return this.Et.forEach(function (s, i) {
        switch (i) {
          case 0
          /* Added */
          :
            t = t.add(s);
            break;

          case 2
          /* Modified */
          :
            e = e.add(s);
            break;

          case 1
          /* Removed */
          :
            n = n.add(s);
            break;

          default:
            L();
        }
      }), new ps(this.At, this.Rt, t, e, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */

  }, {
    key: "Dt",
    value: function Dt() {
      this.bt = !1, this.Et = Ps();
    }
  }, {
    key: "Ct",
    value: function Ct(t, e) {
      this.bt = !0, this.Et = this.Et.insert(t, e);
    }
  }, {
    key: "xt",
    value: function xt(t) {
      this.bt = !0, this.Et = this.Et.remove(t);
    }
  }, {
    key: "Nt",
    value: function Nt() {
      this.Tt += 1;
    }
  }, {
    key: "kt",
    value: function kt() {
      this.Tt -= 1;
    }
  }, {
    key: "Ot",
    value: function Ot() {
      this.bt = !0, this.Rt = !0;
    }
  }]);

  return As;
}();
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */


var Rs = /*#__PURE__*/function () {
  function Rs(t) {
    _classCallCheck(this, Rs);

    this.Mt = t,
    /** The internal state of all tracked targets. */
    this.Ft = new Map(),
    /** Keeps track of the documents to update since the last raised snapshot. */
    this.$t = os(),
    /** A mapping of document keys to their set of target IDs. */
    this.Bt = bs(),
    /**
     * A list of targets with existence filter mismatches. These targets are
     * known to be inconsistent and their listens needs to be re-established by
     * RemoteStore.
     */
    this.Lt = new Qt(it);
  }
  /**
   * Processes and adds the DocumentWatchChange to the current set of changes.
   */


  _createClass(Rs, [{
    key: "Ut",
    value: function Ut(t) {
      var _iterator24 = _createForOfIteratorHelper(t.gt),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var e = _step24.value;
          t.yt && t.yt.isFoundDocument() ? this.qt(e, t.yt) : this.Kt(e, t.key, t.yt);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      var _iterator25 = _createForOfIteratorHelper(t.removedTargetIds),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _e19 = _step25.value;
          this.Kt(_e19, t.key, t.yt);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */

  }, {
    key: "Gt",
    value: function Gt(t) {
      var _this36 = this;

      this.forEachTarget(t, function (e) {
        var n = _this36.Qt(e);

        switch (t.state) {
          case 0
          /* NoChange */
          :
            _this36.jt(e) && n.Vt(t.resumeToken);
            break;

          case 1
          /* Added */
          :
            // We need to decrement the number of pending acks needed from watch
            // for this targetId.
            n.kt(), n.Pt || // We have a freshly added target, so we need to reset any state
            // that we had previously. This can happen e.g. when remove and add
            // back a target for existence filter mismatches.
            n.Dt(), n.Vt(t.resumeToken);
            break;

          case 2
          /* Removed */
          :
            // We need to keep track of removed targets to we can post-filter and
            // remove any target changes.
            // We need to decrement the number of pending acks needed from watch
            // for this targetId.
            n.kt(), n.Pt || _this36.removeTarget(e);
            break;

          case 3
          /* Current */
          :
            _this36.jt(e) && (n.Ot(), n.Vt(t.resumeToken));
            break;

          case 4
          /* Reset */
          :
            _this36.jt(e) && ( // Reset the target and synthesizes removes for all existing
            // documents. The backend will re-add any documents that still
            // match the target before it sends the next global snapshot.
            _this36.Wt(e), n.Vt(t.resumeToken));
            break;

          default:
            L();
        }
      });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */

  }, {
    key: "forEachTarget",
    value: function forEachTarget(t, e) {
      var _this37 = this;

      t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Ft.forEach(function (t, n) {
        _this37.jt(n) && e(n);
      });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */

  }, {
    key: "zt",
    value: function zt(t) {
      var e = t.targetId,
          n = t.It.count,
          s = this.Ht(e);

      if (s) {
        var _t33 = s.target;
        if ($e(_t33)) {
          if (0 === n) {
            // The existence filter told us the document does not exist. We deduce
            // that this document does not exist and apply a deleted document to
            // our updates. Without applying this deleted document there might be
            // another query that will raise this document as part of a snapshot
            // until it is resolved, essentially exposing inconsistency between
            // queries.
            var _n11 = new dt(_t33.path);

            this.Kt(e, _n11, xe.newNoDocument(_n11, ct.min()));
          } else U(1 === n);
        } else {
          this.Jt(e) !== n && ( // Existence filter mismatch: We reset the mapping and raise a new
          // snapshot with `isFromCache:true`.
          this.Wt(e), this.Lt = this.Lt.add(e));
        }
      }
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */

  }, {
    key: "Yt",
    value: function Yt(t) {
      var _this38 = this;

      var e = new Map();
      this.Ft.forEach(function (n, s) {
        var i = _this38.Ht(s);

        if (i) {
          if (n.current && $e(i.target)) {
            // Document queries for document that don't exist can produce an empty
            // result set. To update our local cache, we synthesize a document
            // delete if we have not previously received the document. This
            // resolves the limbo state of the document, removing it from
            // limboDocumentRefs.
            // TODO(dimond): Ideally we would have an explicit lookup target
            // instead resulting in an explicit delete message and we could
            // remove this special logic.
            var _e20 = new dt(i.target.path);

            null !== _this38.$t.get(_e20) || _this38.Xt(s, _e20) || _this38.Kt(s, _e20, xe.newNoDocument(_e20, t));
          }

          n.vt && (e.set(s, n.St()), n.Dt());
        }
      });
      var n = ws(); // We extract the set of limbo-only document updates as the GC logic
      // special-cases documents that do not appear in the target cache.
      // TODO(gsoltis): Expand on this comment once GC is available in the JS
      // client.

      this.Bt.forEach(function (t, e) {
        var s = !0;
        e.forEachWhile(function (t) {
          var e = _this38.Ht(t);

          return !e || 2
          /* LimboResolution */
          === e.purpose || (s = !1, !1);
        }), s && (n = n.add(t));
      }), this.$t.forEach(function (e, n) {
        return n.setReadTime(t);
      });
      var s = new ys(t, e, this.Lt, this.$t, n);
      return this.$t = os(), this.Bt = bs(), this.Lt = new Qt(it), s;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.

  }, {
    key: "qt",
    value: function qt(t, e) {
      if (!this.jt(t)) return;
      var n = this.Xt(t, e.key) ? 2
      /* Modified */
      : 0
      /* Added */
      ;
      this.Qt(t).Ct(e.key, n), this.$t = this.$t.insert(e.key, e), this.Bt = this.Bt.insert(e.key, this.Zt(e.key).add(t));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.

  }, {
    key: "Kt",
    value: function Kt(t, e, n) {
      if (!this.jt(t)) return;
      var s = this.Qt(t);
      this.Xt(t, e) ? s.Ct(e, 1
      /* Removed */
      ) : // The document may have entered and left the target before we raised a
      // snapshot, so we can just ignore the change.
      s.xt(e), this.Bt = this.Bt.insert(e, this.Zt(e).delete(t)), n && (this.$t = this.$t.insert(e, n));
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(t) {
      this.Ft.delete(t);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */

  }, {
    key: "Jt",
    value: function Jt(t) {
      var e = this.Qt(t).St();
      return this.Mt.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */

  }, {
    key: "Nt",
    value: function Nt(t) {
      this.Qt(t).Nt();
    }
  }, {
    key: "Qt",
    value: function Qt(t) {
      var e = this.Ft.get(t);
      return e || (e = new As(), this.Ft.set(t, e)), e;
    }
  }, {
    key: "Zt",
    value: function Zt(t) {
      var e = this.Bt.get(t);
      return e || (e = new Qt(it), this.Bt = this.Bt.insert(t, e)), e;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */

  }, {
    key: "jt",
    value: function jt(t) {
      var e = null !== this.Ht(t);
      return e || M("WatchChangeAggregator", "Detected inactive target", t), e;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */

  }, {
    key: "Ht",
    value: function Ht(t) {
      var e = this.Ft.get(t);
      return e && e.Pt ? null : this.Mt.te(t);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */

  }, {
    key: "Wt",
    value: function Wt(t) {
      var _this39 = this;

      this.Ft.set(t, new As());
      this.Mt.getRemoteKeysForTarget(t).forEach(function (e) {
        _this39.Kt(t, e,
        /*updatedDocument=*/
        null);
      });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */

  }, {
    key: "Xt",
    value: function Xt(t, e) {
      return this.Mt.getRemoteKeysForTarget(t).has(e);
    }
  }]);

  return Rs;
}();

function bs() {
  return new qt(dt.comparator);
}

function Ps() {
  return new qt(dt.comparator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var vs = function () {
  var t = {
    asc: "ASCENDING",
    desc: "DESCENDING"
  };
  return t;
}(),
    Vs = function () {
  var t = {
    "<": "LESS_THAN",
    "<=": "LESS_THAN_OR_EQUAL",
    ">": "GREATER_THAN",
    ">=": "GREATER_THAN_OR_EQUAL",
    "==": "EQUAL",
    "!=": "NOT_EQUAL",
    "array-contains": "ARRAY_CONTAINS",
    in: "IN",
    "not-in": "NOT_IN",
    "array-contains-any": "ARRAY_CONTAINS_ANY"
  };
  return t;
}();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */


var Ss = /*#__PURE__*/_createClass(function Ss(t, e) {
  _classCallCheck(this, Ss);

  this.databaseId = t, this.dt = e;
});
/**
 * Returns a value for a Date that's appropriate to put into a proto.
 */


function Ds(t, e) {
  if (t.dt) {
    return "".concat(new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", ""), ".").concat(("000000000" + e.nanoseconds).slice(-9), "Z");
  }

  return {
    seconds: "" + e.seconds,
    nanos: e.nanoseconds
  };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */


function Cs(t, e) {
  return t.dt ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */


function xs(t, e) {
  return Ds(t, e.toTimestamp());
}

function Ns(t) {
  return U(!!t), ct.fromTimestamp(function (t) {
    var e = Xt(t);
    return new ut(e.seconds, e.nanos);
  }(t));
}

function ks(t, e) {
  return function (t) {
    return new ht(["projects", t.projectId, "databases", t.database]);
  }(t).child("documents").child(e).canonicalString();
}

function Os(t) {
  var e = ht.fromString(t);
  return U(ui(e)), e;
}

function Ms(t, e) {
  return ks(t.databaseId, e.path);
}

function Fs(t, e) {
  var n = Os(e);
  if (n.get(1) !== t.databaseId.projectId) throw new Q(G.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
  if (n.get(3) !== t.databaseId.database) throw new Q(G.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
  return new dt(Us(n));
}

function $s(t, e) {
  return ks(t.databaseId, e);
}

function Bs(t) {
  var e = Os(t); // In v1beta1 queries for collections at the root did not have a trailing
  // "/documents". In v1 all resource paths contain "/documents". Preserve the
  // ability to read the v1beta1 form for compatibility with queries persisted
  // in the local target cache.

  return 4 === e.length ? ht.emptyPath() : Us(e);
}

function Ls(t) {
  return new ht(["projects", t.databaseId.projectId, "databases", t.databaseId.database]).canonicalString();
}

function Us(t) {
  return U(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */


function qs(t, e, n) {
  return {
    name: Ms(t, e),
    fields: n.value.mapValue.fields
  };
}

function Ks(t, e, n) {
  var s = Fs(t, e.name),
      i = Ns(e.updateTime),
      r = new De({
    mapValue: {
      fields: e.fields
    }
  }),
      o = xe.newFoundDocument(s, i, r);
  return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}

function Gs(t, e) {
  return "found" in e ? function (t, e) {
    U(!!e.found), e.found.name, e.found.updateTime;
    var n = Fs(t, e.found.name),
        s = Ns(e.found.updateTime),
        i = new De({
      mapValue: {
        fields: e.found.fields
      }
    });
    return xe.newFoundDocument(n, s, i);
  }(t, e) : "missing" in e ? function (t, e) {
    U(!!e.missing), U(!!e.readTime);
    var n = Fs(t, e.missing),
        s = Ns(e.readTime);
    return xe.newNoDocument(n, s);
  }(t, e) : L();
}

function Qs(t, e) {
  var n;

  if ("targetChange" in e) {
    e.targetChange; // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
    // if unset

    var s = function (t) {
      return "NO_CHANGE" === t ? 0
      /* NoChange */
      : "ADD" === t ? 1
      /* Added */
      : "REMOVE" === t ? 2
      /* Removed */
      : "CURRENT" === t ? 3
      /* Current */
      : "RESET" === t ? 4
      /* Reset */
      : L();
    }(e.targetChange.targetChangeType || "NO_CHANGE"),
        i = e.targetChange.targetIds || [],
        r = function (t, e) {
      return t.dt ? (U(void 0 === e || "string" == typeof e), Jt.fromBase64String(e || "")) : (U(void 0 === e || e instanceof Uint8Array), Jt.fromUint8Array(e || new Uint8Array()));
    }(t, e.targetChange.resumeToken),
        o = e.targetChange.cause,
        u = o && function (t) {
      var e = void 0 === t.code ? G.UNKNOWN : ss(t.code);
      return new Q(e, t.message || "");
    }
    /**
    * Returns a value for a number (or null) that's appropriate to put into
    * a google.protobuf.Int32Value proto.
    * DO NOT USE THIS FOR ANYTHING ELSE.
    * This method cheats. It's typed as returning "number" because that's what
    * our generated proto interfaces say Int32Value must be. But GRPC actually
    * expects a { value: <number> } struct.
    */
    (o);

    n = new Es(s, i, r, u || null);
  } else if ("documentChange" in e) {
    e.documentChange;
    var _s2 = e.documentChange;
    _s2.document, _s2.document.name, _s2.document.updateTime;

    var _i5 = Fs(t, _s2.document.name),
        _r2 = Ns(_s2.document.updateTime),
        _o2 = new De({
      mapValue: {
        fields: _s2.document.fields
      }
    }),
        _u2 = xe.newFoundDocument(_i5, _r2, _o2),
        c = _s2.targetIds || [],
        a = _s2.removedTargetIds || [];

    n = new Is(c, a, _u2.key, _u2);
  } else if ("documentDelete" in e) {
    e.documentDelete;
    var _s3 = e.documentDelete;
    _s3.document;

    var _i6 = Fs(t, _s3.document),
        _r3 = _s3.readTime ? Ns(_s3.readTime) : ct.min(),
        _o3 = xe.newNoDocument(_i6, _r3),
        _u3 = _s3.removedTargetIds || [];

    n = new Is([], _u3, _o3.key, _o3);
  } else if ("documentRemove" in e) {
    e.documentRemove;
    var _s4 = e.documentRemove;
    _s4.document;

    var _i7 = Fs(t, _s4.document),
        _r4 = _s4.removedTargetIds || [];

    n = new Is([], _r4, _i7, null);
  } else {
    if (!("filter" in e)) return L();
    {
      e.filter;
      var _t34 = e.filter;
      _t34.targetId;

      var _s5 = _t34.count || 0,
          _i8 = new Zn(_s5),
          _r5 = _t34.targetId;

      n = new Ts(_r5, _i8);
    }
  }

  return n;
}

function js(t, e) {
  var n;
  if (e instanceof jn) n = {
    update: qs(t, e.key, e.value)
  };else if (e instanceof Yn) n = {
    delete: Ms(t, e.key)
  };else if (e instanceof Wn) n = {
    update: qs(t, e.key, e.data),
    updateMask: oi(e.fieldMask)
  };else {
    if (!(e instanceof Xn)) return L();
    n = {
      verify: Ms(t, e.key)
    };
  }
  return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map(function (t) {
    return function (t, e) {
      var n = e.transform;
      if (n instanceof vn) return {
        fieldPath: e.field.canonicalString(),
        setToServerValue: "REQUEST_TIME"
      };
      if (n instanceof Vn) return {
        fieldPath: e.field.canonicalString(),
        appendMissingElements: {
          values: n.elements
        }
      };
      if (n instanceof Dn) return {
        fieldPath: e.field.canonicalString(),
        removeAllFromArray: {
          values: n.elements
        }
      };
      if (n instanceof xn) return {
        fieldPath: e.field.canonicalString(),
        increment: n._t
      };
      throw L();
    }(0, t);
  })), e.precondition.isNone || (n.currentDocument = function (t, e) {
    return void 0 !== e.updateTime ? {
      updateTime: xs(t, e.updateTime)
    } : void 0 !== e.exists ? {
      exists: e.exists
    } : L();
  }(t, e.precondition)), n;
}

function Ws(t, e) {
  var n = e.currentDocument ? function (t) {
    return void 0 !== t.updateTime ? $n.updateTime(Ns(t.updateTime)) : void 0 !== t.exists ? $n.exists(t.exists) : $n.none();
  }(e.currentDocument) : $n.none(),
      s = e.updateTransforms ? e.updateTransforms.map(function (e) {
    return function (t, e) {
      var n = null;
      if ("setToServerValue" in e) U("REQUEST_TIME" === e.setToServerValue), n = new vn();else if ("appendMissingElements" in e) {
        var _t35 = e.appendMissingElements.values || [];

        n = new Vn(_t35);
      } else if ("removeAllFromArray" in e) {
        var _t36 = e.removeAllFromArray.values || [];

        n = new Dn(_t36);
      } else "increment" in e ? n = new xn(t, e.increment) : L();
      var s = ft.fromServerFormat(e.fieldPath);
      return new On(s, n);
    }(t, e);
  }) : [];

  if (e.update) {
    e.update.name;
    var i = Fs(t, e.update.name),
        r = new De({
      mapValue: {
        fields: e.update.fields
      }
    });

    if (e.updateMask) {
      var _t37 = function (t) {
        var e = t.fieldPaths || [];
        return new zt(e.map(function (t) {
          return ft.fromServerFormat(t);
        }));
      }(e.updateMask);

      return new Wn(i, r, _t37, n, s);
    }

    return new jn(i, r, n, s);
  }

  if (e.delete) {
    var _s6 = Fs(t, e.delete);

    return new Yn(_s6, n);
  }

  if (e.verify) {
    var _s7 = Fs(t, e.verify);

    return new Xn(_s7, n);
  }

  return L();
}

function zs(t, e) {
  return t && t.length > 0 ? (U(void 0 !== e), t.map(function (t) {
    return function (t, e) {
      // NOTE: Deletes don't have an updateTime.
      var n = t.updateTime ? Ns(t.updateTime) : Ns(e);
      return n.isEqual(ct.min()) && ( // The Firestore Emulator currently returns an update time of 0 for
      // deletes of non-existing documents (rather than null). This breaks the
      // test "get deleted doc while offline with source=cache" as NoDocuments
      // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
      // TODO(#2149): Remove this when Emulator is fixed
      n = Ns(e)), new Fn(n, t.transformResults || []);
    }(t, e);
  })) : [];
}

function Hs(t, e) {
  return {
    documents: [$s(t, e.path)]
  };
}

function Js(t, e) {
  // Dissect the path into parent, collectionId, and optional key filter.
  var n = {
    structuredQuery: {}
  },
      s = e.path;
  null !== e.collectionGroup ? (n.parent = $s(t, s), n.structuredQuery.from = [{
    collectionId: e.collectionGroup,
    allDescendants: !0
  }]) : (n.parent = $s(t, s.popLast()), n.structuredQuery.from = [{
    collectionId: s.lastSegment()
  }]);

  var i = function (t) {
    if (0 === t.length) return;
    var e = t.map(function (t) {
      return (// visible for testing
        function (t) {
          if ("=="
          /* EQUAL */
          === t.op) {
            if (Ee(t.value)) return {
              unaryFilter: {
                field: ni(t.field),
                op: "IS_NAN"
              }
            };
            if (Te(t.value)) return {
              unaryFilter: {
                field: ni(t.field),
                op: "IS_NULL"
              }
            };
          } else if ("!="
          /* NOT_EQUAL */
          === t.op) {
            if (Ee(t.value)) return {
              unaryFilter: {
                field: ni(t.field),
                op: "IS_NOT_NAN"
              }
            };
            if (Te(t.value)) return {
              unaryFilter: {
                field: ni(t.field),
                op: "IS_NOT_NULL"
              }
            };
          }

          return {
            fieldFilter: {
              field: ni(t.field),
              op: ei(t.op),
              value: t.value
            }
          };
        }(t)
      );
    });
    if (1 === e.length) return e[0];
    return {
      compositeFilter: {
        op: "AND",
        filters: e
      }
    };
  }(e.filters);

  i && (n.structuredQuery.where = i);

  var r = function (t) {
    if (0 === t.length) return;
    return t.map(function (t) {
      return (// visible for testing
        function (t) {
          return {
            field: ni(t.field),
            direction: ti(t.dir)
          };
        }(t)
      );
    });
  }(e.orderBy);

  r && (n.structuredQuery.orderBy = r);

  var o = function (t, e) {
    return t.dt || oe(e) ? e : {
      value: e
    };
  }
  /**
  * Returns a number (or null) from a google.protobuf.Int32Value proto.
  */
  (t, e.limit);

  var u;
  return null !== o && (n.structuredQuery.limit = o), e.startAt && (n.structuredQuery.startAt = {
    before: (u = e.startAt).inclusive,
    values: u.position
  }), e.endAt && (n.structuredQuery.endAt = function (t) {
    return {
      before: !t.inclusive,
      values: t.position
    };
  }(e.endAt)), n;
}

function Ys(t) {
  var e = Bs(t.parent);
  var n = t.structuredQuery,
      s = n.from ? n.from.length : 0;
  var i = null;

  if (s > 0) {
    U(1 === s);
    var _t38 = n.from[0];
    _t38.allDescendants ? i = _t38.collectionId : e = e.child(_t38.collectionId);
  }

  var r = [];
  n.where && (r = Zs(n.where));
  var o = [];
  n.orderBy && (o = n.orderBy.map(function (t) {
    return function (t) {
      return new Xe(si(t.field), // visible for testing
      function (t) {
        switch (t) {
          case "ASCENDING":
            return "asc"
            /* ASCENDING */
            ;

          case "DESCENDING":
            return "desc"
            /* DESCENDING */
            ;

          default:
            return;
        }
      } // visible for testing
      (t.direction));
    }(t);
  }));
  var u = null;
  n.limit && (u = function (t) {
    var e;
    return e = "object" == typeof t ? t.value : t, oe(e) ? null : e;
  }(n.limit));
  var c = null;
  n.startAt && (c = function (t) {
    var e = !!t.before,
        n = t.values || [];
    return new Ye(n, e);
  }(n.startAt));
  var a = null;
  return n.endAt && (a = function (t) {
    var e = !t.before,
        n = t.values || [];
    return new Ye(n, e);
  } // visible for testing
  (n.endAt)), sn(e, i, o, r, u, "F"
  /* First */
  , c, a);
}

function Xs(t, e) {
  var n = function (t, e) {
    switch (e) {
      case 0
      /* Listen */
      :
        return null;

      case 1
      /* ExistenceFilterMismatch */
      :
        return "existence-filter-mismatch";

      case 2
      /* LimboResolution */
      :
        return "limbo-document";

      default:
        return L();
    }
  }(0, e.purpose);

  return null == n ? null : {
    "goog-listen-tags": n
  };
}

function Zs(t) {
  return t ? void 0 !== t.unaryFilter ? [ri(t)] : void 0 !== t.fieldFilter ? [ii(t)] : void 0 !== t.compositeFilter ? t.compositeFilter.filters.map(function (t) {
    return Zs(t);
  }).reduce(function (t, e) {
    return t.concat(e);
  }) : L() : [];
}

function ti(t) {
  return vs[t];
}

function ei(t) {
  return Vs[t];
}

function ni(t) {
  return {
    fieldPath: t.canonicalString()
  };
}

function si(t) {
  return ft.fromServerFormat(t.fieldPath);
}

function ii(t) {
  return qe.create(si(t.fieldFilter.field), function (t) {
    switch (t) {
      case "EQUAL":
        return "=="
        /* EQUAL */
        ;

      case "NOT_EQUAL":
        return "!="
        /* NOT_EQUAL */
        ;

      case "GREATER_THAN":
        return ">"
        /* GREATER_THAN */
        ;

      case "GREATER_THAN_OR_EQUAL":
        return ">="
        /* GREATER_THAN_OR_EQUAL */
        ;

      case "LESS_THAN":
        return "<"
        /* LESS_THAN */
        ;

      case "LESS_THAN_OR_EQUAL":
        return "<="
        /* LESS_THAN_OR_EQUAL */
        ;

      case "ARRAY_CONTAINS":
        return "array-contains"
        /* ARRAY_CONTAINS */
        ;

      case "IN":
        return "in"
        /* IN */
        ;

      case "NOT_IN":
        return "not-in"
        /* NOT_IN */
        ;

      case "ARRAY_CONTAINS_ANY":
        return "array-contains-any"
        /* ARRAY_CONTAINS_ANY */
        ;

      default:
        return L();
    }
  }(t.fieldFilter.op), t.fieldFilter.value);
}

function ri(t) {
  switch (t.unaryFilter.op) {
    case "IS_NAN":
      var e = si(t.unaryFilter.field);
      return qe.create(e, "=="
      /* EQUAL */
      , {
        doubleValue: NaN
      });

    case "IS_NULL":
      var n = si(t.unaryFilter.field);
      return qe.create(n, "=="
      /* EQUAL */
      , {
        nullValue: "NULL_VALUE"
      });

    case "IS_NOT_NAN":
      var s = si(t.unaryFilter.field);
      return qe.create(s, "!="
      /* NOT_EQUAL */
      , {
        doubleValue: NaN
      });

    case "IS_NOT_NULL":
      var i = si(t.unaryFilter.field);
      return qe.create(i, "!="
      /* NOT_EQUAL */
      , {
        nullValue: "NULL_VALUE"
      });

    default:
      return L();
  }
}

function oi(t) {
  var e = [];
  return t.fields.forEach(function (t) {
    return e.push(t.canonicalString());
  }), {
    fieldPaths: e
  };
}

function ui(t) {
  // Resource names have at least 4 components (project ID, database ID)
  return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */


function ci(t) {
  var e = "";

  for (var n = 0; n < t.length; n++) {
    e.length > 0 && (e = hi(e)), e = ai(t.get(n), e);
  }

  return hi(e);
}
/** Encodes a single segment of a resource path into the given result */


function ai(t, e) {
  var n = e;
  var s = t.length;

  for (var _e21 = 0; _e21 < s; _e21++) {
    var _s8 = t.charAt(_e21);

    switch (_s8) {
      case "\0":
        n += "";
        break;

      case "":
        n += "";
        break;

      default:
        n += _s8;
    }
  }

  return n;
}
/** Encodes a path separator into the given result */


function hi(t) {
  return t + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */


function li(t) {
  // Event the empty path must encode as a path of at least length 2. A path
  // with exactly 2 must be the empty path.
  var e = t.length;
  if (U(e >= 2), 2 === e) return U("" === t.charAt(0) && "" === t.charAt(1)), ht.emptyPath(); // Escape characters cannot exist past the second-to-last position in the
  // source value.

  var n = e - 2,
      s = [];
  var i = "";

  for (var r = 0; r < e;) {
    // The last two characters of a valid encoded path must be a separator, so
    // there must be an end to this segment.
    var _e22 = t.indexOf("", r);

    (_e22 < 0 || _e22 > n) && L();

    switch (t.charAt(_e22 + 1)) {
      case "":
        var _n12 = t.substring(r, _e22);

        var o = void 0;
        0 === i.length ? // Avoid copying for the common case of a segment that excludes \0
        // and \001
        o = _n12 : (i += _n12, o = i, i = ""), s.push(o);
        break;

      case "":
        i += t.substring(r, _e22), i += "\0";
        break;

      case "":
        // The escape character can be used in the output to encode itself.
        i += t.substring(r, _e22 + 1);
        break;

      default:
        L();
    }

    r = _e22 + 2;
  }

  return new ht(s);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var fi = ["userId", "batchId"];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */

/**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */

function di(t, e) {
  return [t, ci(e)];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */


function _i(t, e, n) {
  return [t, ci(e), n];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */


var wi = {},
    mi = ["prefixPath", "collectionGroup", "readTime", "documentId"],
    gi = ["prefixPath", "collectionGroup", "documentId"],
    yi = ["collectionGroup", "readTime", "prefixPath", "documentId"],
    pi = ["canonicalId", "targetId"],
    Ii = ["targetId", "path"],
    Ti = ["path", "targetId"],
    Ei = ["collectionId", "parent"],
    Ai = ["indexId", "uid"],
    Ri = ["uid", "sequenceNumber"],
    bi = ["indexId", "uid", "arrayValue", "directionalValue", "orderedDocumentKey", "documentKey"],
    Pi = ["indexId", "uid", "orderedDocumentKey"],
    vi = ["userId", "collectionPath", "documentId"],
    Vi = ["userId", "collectionPath", "largestBatchId"],
    Si = ["userId", "collectionGroup", "largestBatchId"],
    Di = ["mutationQueues", "mutations", "documentMutations", "remoteDocuments", "targets", "owner", "targetGlobal", "targetDocuments"].concat(["clientMetadata"]).concat(["remoteDocumentGlobal"]).concat(["collectionParents"]).concat(["bundles", "namedQueries"]),
    Ci = [].concat(_toConsumableArray(Di), ["documentOverlays"]),
    xi = ["mutationQueues", "mutations", "documentMutations", "remoteDocumentsV14", "targets", "owner", "targetGlobal", "targetDocuments", "clientMetadata", "remoteDocumentGlobal", "collectionParents", "bundles", "namedQueries", "documentOverlays"],
    Ni = xi,
    ki = [].concat(Ni, ["indexConfiguration", "indexState", "indexEntries"]);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Oi = /*#__PURE__*/function (_Rt) {
  _inherits(Oi, _Rt);

  var _super21 = _createSuper(Oi);

  function Oi(t, e) {
    var _this40;

    _classCallCheck(this, Oi);

    _this40 = _super21.call(this), _this40.ee = t, _this40.currentSequenceNumber = e;
    return _this40;
  }

  return _createClass(Oi);
}(Rt);

function Mi(t, e) {
  var n = K(t);
  return Vt.N(n.ee, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A batch of mutations that will be sent as one unit to the backend.
 */


var Fi = /*#__PURE__*/function () {
  /**
   * @param batchId - The unique ID of this mutation batch.
   * @param localWriteTime - The original write time of this mutation.
   * @param baseMutations - Mutations that are used to populate the base
   * values when this mutation is applied locally. This can be used to locally
   * overwrite values that are persisted in the remote document cache. Base
   * mutations are never sent to the backend.
   * @param mutations - The user-provided mutations in this mutation batch.
   * User-provided mutations are applied both locally and remotely on the
   * backend.
   */
  function Fi(t, e, n, s) {
    _classCallCheck(this, Fi);

    this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = s;
  }
  /**
   * Applies all the mutations in this MutationBatch to the specified document
   * to compute the state of the remote document
   *
   * @param document - The document to apply mutations to.
   * @param batchResult - The result of applying the MutationBatch to the
   * backend.
   */


  _createClass(Fi, [{
    key: "applyToRemoteDocument",
    value: function applyToRemoteDocument(t, e) {
      var n = e.mutationResults;

      for (var _e23 = 0; _e23 < this.mutations.length; _e23++) {
        var s = this.mutations[_e23];

        if (s.key.isEqual(t.key)) {
          qn(s, t, n[_e23]);
        }
      }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */

  }, {
    key: "applyToLocalView",
    value: function applyToLocalView(t, e) {
      // First, apply the base state. This allows us to apply non-idempotent
      // transform against a consistent set of values.
      var _iterator26 = _createForOfIteratorHelper(this.baseMutations),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var n = _step26.value;
          n.key.isEqual(t.key) && (e = Kn(n, t, e, this.localWriteTime));
        } // Second, apply all user-provided mutations.

      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      var _iterator27 = _createForOfIteratorHelper(this.mutations),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var _n13 = _step27.value;
          _n13.key.isEqual(t.key) && (e = Kn(_n13, t, e, this.localWriteTime));
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }

      return e;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */

  }, {
    key: "applyToLocalDocumentSet",
    value: function applyToLocalDocumentSet(t, e) {
      var _this41 = this;

      // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
      // directly (as done in `applyToLocalView()`), we can reduce the complexity
      // to O(n).
      var n = ls();
      return this.mutations.forEach(function (s) {
        var i = t.get(s.key),
            r = i.overlayedDocument; // TODO(mutabledocuments): This method should take a MutableDocumentMap
        // and we should remove this cast.

        var o = _this41.applyToLocalView(r, i.mutatedFields); // Set mutatedFields to null if the document is only from local mutations.
        // This creates a Set or Delete mutation, instead of trying to create a
        // patch mutation as the overlay.


        o = e.has(s.key) ? null : o;
        var u = Un(r, o);
        null !== u && n.set(s.key, u), r.isValidDocument() || r.convertToNoDocument(ct.min());
      }), n;
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.mutations.reduce(function (t, e) {
        return t.add(e.key);
      }, ws());
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this.batchId === t.batchId && rt(this.mutations, t.mutations, function (t, e) {
        return Qn(t, e);
      }) && rt(this.baseMutations, t.baseMutations, function (t, e) {
        return Qn(t, e);
      });
    }
  }]);

  return Fi;
}();
/** The result of applying a mutation batch to the backend. */


var $i = /*#__PURE__*/function () {
  function $i(t, e, n,
  /**
   * A pre-computed mapping from each mutated document to the resulting
   * version.
   */
  s) {
    _classCallCheck(this, $i);

    this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = s;
  }
  /**
   * Creates a new MutationBatchResult for the given batch and results. There
   * must be one result for each mutation in the batch. This static factory
   * caches a document=&gt;version mapping (docVersions).
   */


  _createClass($i, null, [{
    key: "from",
    value: function from(t, e, n) {
      U(t.mutations.length === n.length);
      var s = ds;
      var i = t.mutations;

      for (var _t39 = 0; _t39 < i.length; _t39++) {
        s = s.insert(i[_t39].key, n[_t39].version);
      }

      return new $i(t, e, n, s);
    }
  }]);

  return $i;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */


var Bi = /*#__PURE__*/function () {
  function Bi(t, e) {
    _classCallCheck(this, Bi);

    this.largestBatchId = t, this.mutation = e;
  }

  _createClass(Bi, [{
    key: "getKey",
    value: function getKey() {
      return this.mutation.key;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return null !== t && this.mutation === t.mutation;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Overlay{\n      largestBatchId: ".concat(this.largestBatchId, ",\n      mutation: ").concat(this.mutation.toString(), "\n    }");
    }
  }]);

  return Bi;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An immutable set of metadata that the local store tracks for each target.
 */


var Li = /*#__PURE__*/function () {
  function Li(
  /** The target being listened to. */
  t,
  /**
   * The target ID to which the target corresponds; Assigned by the
   * LocalStore for user listens and by the SyncEngine for limbo watches.
   */
  e,
  /** The purpose of the target. */
  n,
  /**
   * The sequence number of the last transaction during which this target data
   * was modified.
   */
  s) {
    var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ct.min();
    var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ct.min();
    var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Jt.EMPTY_BYTE_STRING;

    _classCallCheck(this, Li);

    this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = s, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = r, this.resumeToken = o;
  }
  /** Creates a new target data instance with an updated sequence number. */


  _createClass(Li, [{
    key: "withSequenceNumber",
    value: function withSequenceNumber(t) {
      return new Li(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */

  }, {
    key: "withResumeToken",
    value: function withResumeToken(t, e) {
      return new Li(this.target, this.targetId, this.purpose, this.sequenceNumber, e, this.lastLimboFreeSnapshotVersion, t);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */

  }, {
    key: "withLastLimboFreeSnapshotVersion",
    value: function withLastLimboFreeSnapshotVersion(t) {
      return new Li(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken);
    }
  }]);

  return Li;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Serializer for values stored in the LocalStore. */


var Ui = /*#__PURE__*/_createClass(function Ui(t) {
  _classCallCheck(this, Ui);

  this.ne = t;
});
/** Decodes a remote document from storage locally to a Document. */


function qi(t, e) {
  var n;
  if (e.document) n = Ks(t.ne, e.document, !!e.hasCommittedMutations);else if (e.noDocument) {
    var _t40 = dt.fromSegments(e.noDocument.path),
        s = ji(e.noDocument.readTime);

    n = xe.newNoDocument(_t40, s), e.hasCommittedMutations && n.setHasCommittedMutations();
  } else {
    if (!e.unknownDocument) return L();
    {
      var _t41 = dt.fromSegments(e.unknownDocument.path),
          _s9 = ji(e.unknownDocument.version);

      n = xe.newUnknownDocument(_t41, _s9);
    }
  }
  return e.readTime && n.setReadTime(function (t) {
    var e = new ut(t[0], t[1]);
    return ct.fromTimestamp(e);
  }(e.readTime)), n;
}
/** Encodes a document for storage locally. */


function Ki(t, e) {
  var n = e.key,
      s = {
    prefixPath: n.getCollectionPath().popLast().toArray(),
    collectionGroup: n.collectionGroup,
    documentId: n.path.lastSegment(),
    readTime: Gi(e.readTime),
    hasCommittedMutations: e.hasCommittedMutations
  };
  if (e.isFoundDocument()) s.document = function (t, e) {
    return {
      name: Ms(t, e.key),
      fields: e.data.value.mapValue.fields,
      updateTime: Ds(t, e.version.toTimestamp())
    };
  }(t.ne, e);else if (e.isNoDocument()) s.noDocument = {
    path: n.path.toArray(),
    readTime: Qi(e.version)
  };else {
    if (!e.isUnknownDocument()) return L();
    s.unknownDocument = {
      path: n.path.toArray(),
      version: Qi(e.version)
    };
  }
  return s;
}

function Gi(t) {
  var e = t.toTimestamp();
  return [e.seconds, e.nanoseconds];
}

function Qi(t) {
  var e = t.toTimestamp();
  return {
    seconds: e.seconds,
    nanoseconds: e.nanoseconds
  };
}

function ji(t) {
  var e = new ut(t.seconds, t.nanoseconds);
  return ct.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */

/** Decodes a DbMutationBatch into a MutationBatch */


function Wi(t, e) {
  var n = (e.baseMutations || []).map(function (e) {
    return Ws(t.ne, e);
  }); // Squash old transform mutations into existing patch or set mutations.
  // The replacement of representing `transforms` with `update_transforms`
  // on the SDK means that old `transform` mutations stored in IndexedDB need
  // to be updated to `update_transforms`.
  // TODO(b/174608374): Remove this code once we perform a schema migration.

  for (var _t42 = 0; _t42 < e.mutations.length - 1; ++_t42) {
    var _n14 = e.mutations[_t42];

    if (_t42 + 1 < e.mutations.length && void 0 !== e.mutations[_t42 + 1].transform) {
      var _s10 = e.mutations[_t42 + 1];
      _n14.updateTransforms = _s10.transform.fieldTransforms, e.mutations.splice(_t42 + 1, 1), ++_t42;
    }
  }

  var s = e.mutations.map(function (e) {
    return Ws(t.ne, e);
  }),
      i = ut.fromMillis(e.localWriteTimeMs);
  return new Fi(e.batchId, i, n, s);
}
/** Decodes a DbTarget into TargetData */


function zi(t) {
  var e = ji(t.readTime),
      n = void 0 !== t.lastLimboFreeSnapshotVersion ? ji(t.lastLimboFreeSnapshotVersion) : ct.min();
  var s;
  var i;
  return void 0 !== t.query.documents ? (U(1 === (i = t.query).documents.length), s = ln(rn(Bs(i.documents[0])))) : s = function (t) {
    return ln(Ys(t));
  }(t.query), new Li(s, t.targetId, 0
  /* Listen */
  , t.lastListenSequenceNumber, e, n, Jt.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */


function Hi(t, e) {
  var n = Qi(e.snapshotVersion),
      s = Qi(e.lastLimboFreeSnapshotVersion);
  var i;
  i = $e(e.target) ? Hs(t.ne, e.target) : Js(t.ne, e.target); // We can't store the resumeToken as a ByteString in IndexedDb, so we
  // convert it to a base64 string for storage.

  var r = e.resumeToken.toBase64(); // lastListenSequenceNumber is always 0 until we do real GC.

  return {
    targetId: e.targetId,
    canonicalId: Oe(e.target),
    readTime: n,
    resumeToken: r,
    lastListenSequenceNumber: e.sequenceNumber,
    lastLimboFreeSnapshotVersion: s,
    query: i
  };
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */

/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */


function Ji(t) {
  var e = Ys({
    parent: t.parent,
    structuredQuery: t.structuredQuery
  });
  return "LAST" === t.limitType ? fn(e, e.limit, "L"
  /* Last */
  ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */

/** Encodes a DbDocumentOverlay object to an Overlay model object. */


function Yi(t, e) {
  return new Bi(e.largestBatchId, Ws(t.ne, e.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */

/**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */


function Xi(t, e) {
  var n = e.path.lastSegment();
  return [t, ci(e.path.popLast()), n];
}

function Zi(t, e, n, s) {
  return {
    indexId: t,
    uid: e.uid || "",
    sequenceNumber: n,
    readTime: Qi(s.readTime),
    documentKey: ci(s.documentKey.path),
    largestBatchId: s.largestBatchId
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var tr = /*#__PURE__*/function () {
  function tr() {
    _classCallCheck(this, tr);
  }

  _createClass(tr, [{
    key: "getBundleMetadata",
    value: function getBundleMetadata(t, e) {
      return er(t).get(e).next(function (t) {
        if (t) return {
          id: (e = t).bundleId,
          createTime: ji(e.createTime),
          version: e.version
        };
        /** Encodes a DbBundle to a BundleMetadata object. */

        var e;
        /** Encodes a BundleMetadata to a DbBundle. */
      });
    }
  }, {
    key: "saveBundleMetadata",
    value: function saveBundleMetadata(t, e) {
      return er(t).put({
        bundleId: (n = e).id,
        createTime: Qi(Ns(n.createTime)),
        version: n.version
      });
      var n;
      /** Encodes a DbNamedQuery to a NamedQuery. */
    }
  }, {
    key: "getNamedQuery",
    value: function getNamedQuery(t, e) {
      return nr(t).get(e).next(function (t) {
        if (t) return {
          name: (e = t).name,
          query: Ji(e.bundledQuery),
          readTime: ji(e.readTime)
        };
        var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */
      });
    }
  }, {
    key: "saveNamedQuery",
    value: function saveNamedQuery(t, e) {
      return nr(t).put(function (t) {
        return {
          name: t.name,
          readTime: Qi(Ns(t.readTime)),
          bundledQuery: t.bundledQuery
        };
      }(e));
    }
  }]);

  return tr;
}();
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */


function er(t) {
  return Mi(t, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */


function nr(t) {
  return Mi(t, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */


var sr = /*#__PURE__*/function () {
  /**
   * @param serializer - The document serializer.
   * @param userId - The userId for which we are accessing overlays.
   */
  function sr(t, e) {
    _classCallCheck(this, sr);

    this.wt = t, this.userId = e;
  }

  _createClass(sr, [{
    key: "getOverlay",
    value: function getOverlay(t, e) {
      var _this42 = this;

      return ir(t).get(Xi(this.userId, e)).next(function (t) {
        return t ? Yi(_this42.wt, t) : null;
      });
    }
  }, {
    key: "getOverlays",
    value: function getOverlays(t, e) {
      var _this43 = this;

      var n = hs();
      return Pt.forEach(e, function (e) {
        return _this43.getOverlay(t, e).next(function (t) {
          null !== t && n.set(e, t);
        });
      }).next(function () {
        return n;
      });
    }
  }, {
    key: "saveOverlays",
    value: function saveOverlays(t, e, n) {
      var _this44 = this;

      var s = [];
      return n.forEach(function (n, i) {
        var r = new Bi(e, i);
        s.push(_this44.ie(t, r));
      }), Pt.waitFor(s);
    }
  }, {
    key: "removeOverlaysForBatchId",
    value: function removeOverlaysForBatchId(t, e, n) {
      var _this45 = this;

      var s = new Set(); // Get the set of unique collection paths.

      e.forEach(function (t) {
        return s.add(ci(t.getCollectionPath()));
      });
      var i = [];
      return s.forEach(function (e) {
        var s = IDBKeyRange.bound([_this45.userId, e, n], [_this45.userId, e, n + 1],
        /*lowerOpen=*/
        !1,
        /*upperOpen=*/
        !0);
        i.push(ir(t).W("collectionPathOverlayIndex", s));
      }), Pt.waitFor(i);
    }
  }, {
    key: "getOverlaysForCollection",
    value: function getOverlaysForCollection(t, e, n) {
      var _this46 = this;

      var s = hs(),
          i = ci(e),
          r = IDBKeyRange.bound([this.userId, i, n], [this.userId, i, Number.POSITIVE_INFINITY],
      /*lowerOpen=*/
      !0);
      return ir(t).K("collectionPathOverlayIndex", r).next(function (t) {
        var _iterator28 = _createForOfIteratorHelper(t),
            _step28;

        try {
          for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
            var _e24 = _step28.value;

            var _t43 = Yi(_this46.wt, _e24);

            s.set(_t43.getKey(), _t43);
          }
        } catch (err) {
          _iterator28.e(err);
        } finally {
          _iterator28.f();
        }

        return s;
      });
    }
  }, {
    key: "getOverlaysForCollectionGroup",
    value: function getOverlaysForCollectionGroup(t, e, n, s) {
      var _this47 = this;

      var i = hs();
      var r; // We want batch IDs larger than `sinceBatchId`, and so the lower bound
      // is not inclusive.

      var o = IDBKeyRange.bound([this.userId, e, n], [this.userId, e, Number.POSITIVE_INFINITY],
      /*lowerOpen=*/
      !0);
      return ir(t).J({
        index: "collectionGroupOverlayIndex",
        range: o
      }, function (t, e, n) {
        // We do not want to return partial batch overlays, even if the size
        // of the result set exceeds the given `count` argument. Therefore, we
        // continue to aggregate results even after the result size exceeds
        // `count` if there are more overlays from the `currentBatchId`.
        var o = Yi(_this47.wt, e);
        i.size() < s || o.largestBatchId === r ? (i.set(o.getKey(), o), r = o.largestBatchId) : n.done();
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "ie",
    value: function ie(t, e) {
      return ir(t).put(function (t, e, n) {
        var _Xi = Xi(e, n.mutation.key),
            _Xi2 = _slicedToArray(_Xi, 3),
            s = _Xi2[0],
            i = _Xi2[1],
            r = _Xi2[2];

        return {
          userId: e,
          collectionPath: i,
          documentId: r,
          collectionGroup: n.mutation.key.getCollectionGroup(),
          largestBatchId: n.largestBatchId,
          overlayMutation: js(t.ne, n.mutation)
        };
      }(this.wt, this.userId, e));
    }
  }], [{
    key: "se",
    value: function se(t, e) {
      var n = e.uid || "";
      return new sr(t, n);
    }
  }]);

  return sr;
}();
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */


function ir(t) {
  return Mi(t, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.

/** Firestore index value writer.  */


var rr = /*#__PURE__*/function () {
  function rr() {
    _classCallCheck(this, rr);
  } // The write methods below short-circuit writing terminators for values
  // containing a (terminating) truncated value.
  // As an example, consider the resulting encoding for:
  // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
  // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
  // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)

  /** Writes an index value.  */


  _createClass(rr, [{
    key: "re",
    value: function re(t, e) {
      this.oe(t, e), // Write separator to split index values
      // (see go/firestore-storage-format#encodings).
      e.ue();
    }
  }, {
    key: "oe",
    value: function oe(t, e) {
      if ("nullValue" in t) this.ce(e, 5);else if ("booleanValue" in t) this.ce(e, 10), e.ae(t.booleanValue ? 1 : 0);else if ("integerValue" in t) this.ce(e, 15), e.ae(Zt(t.integerValue));else if ("doubleValue" in t) {
        var n = Zt(t.doubleValue);
        isNaN(n) ? this.ce(e, 13) : (this.ce(e, 15), ue(n) ? // -0.0, 0 and 0.0 are all considered the same
        e.ae(0) : e.ae(n));
      } else if ("timestampValue" in t) {
        var _n15 = t.timestampValue;
        this.ce(e, 20), "string" == typeof _n15 ? e.he(_n15) : (e.he("".concat(_n15.seconds || "")), e.ae(_n15.nanos || 0));
      } else if ("stringValue" in t) this.le(t.stringValue, e), this.fe(e);else if ("bytesValue" in t) this.ce(e, 30), e.de(te(t.bytesValue)), this.fe(e);else if ("referenceValue" in t) this._e(t.referenceValue, e);else if ("geoPointValue" in t) {
        var _n16 = t.geoPointValue;
        this.ce(e, 45), e.ae(_n16.latitude || 0), e.ae(_n16.longitude || 0);
      } else "mapValue" in t ? be(t) ? this.ce(e, Number.MAX_SAFE_INTEGER) : (this.we(t.mapValue, e), this.fe(e)) : "arrayValue" in t ? (this.me(t.arrayValue, e), this.fe(e)) : L();
    }
  }, {
    key: "le",
    value: function le(t, e) {
      this.ce(e, 25), this.ge(t, e);
    }
  }, {
    key: "ge",
    value: function ge(t, e) {
      e.he(t);
    }
  }, {
    key: "we",
    value: function we(t, e) {
      var n = t.fields || {};
      this.ce(e, 55);

      for (var _i9 = 0, _Object$keys = Object.keys(n); _i9 < _Object$keys.length; _i9++) {
        var _t44 = _Object$keys[_i9];
        this.le(_t44, e), this.oe(n[_t44], e);
      }
    }
  }, {
    key: "me",
    value: function me(t, e) {
      var n = t.values || [];
      this.ce(e, 50);

      var _iterator29 = _createForOfIteratorHelper(n),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var _t45 = _step29.value;
          this.oe(_t45, e);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "_e",
    value: function _e(t, e) {
      var _this48 = this;

      this.ce(e, 37);
      dt.fromName(t).path.forEach(function (t) {
        _this48.ce(e, 60), _this48.ge(t, e);
      });
    }
  }, {
    key: "ce",
    value: function ce(t, e) {
      t.ae(e);
    }
  }, {
    key: "fe",
    value: function fe(t) {
      // While the SDK does not implement truncation, the truncation marker is
      // used to terminate all variable length values (which are strings, bytes,
      // references, arrays and maps).
      t.ae(2);
    }
  }]);

  return rr;
}();

rr.ye = new rr();
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */

function or(t) {
  if (0 === t) return 8;
  var e = 0;
  return t >> 4 == 0 && ( // Test if the first four bits are zero.
  e += 4, t <<= 4), t >> 6 == 0 && ( // Test if the first two (or next two) bits are zero.
  e += 2, t <<= 2), t >> 7 == 0 && ( // Test if the remaining bit is zero.
  e += 1), e;
}
/** Counts the number of leading zeros in the given byte array. */

/**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */


function ur(t) {
  // This is just the number of bytes for the unsigned representation of the number.
  var e = 64 - function (t) {
    var e = 0;

    for (var n = 0; n < 8; ++n) {
      var s = or(255 & t[n]);
      if (e += s, 8 !== s) break;
    }

    return e;
  }(t);

  return Math.ceil(e / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */


var cr = /*#__PURE__*/function () {
  function cr() {
    _classCallCheck(this, cr);

    this.buffer = new Uint8Array(1024), this.position = 0;
  }

  _createClass(cr, [{
    key: "pe",
    value: function pe(t) {
      var e = t[Symbol.iterator]();
      var n = e.next();

      for (; !n.done;) {
        this.Ie(n.value), n = e.next();
      }

      this.Te();
    }
  }, {
    key: "Ee",
    value: function Ee(t) {
      var e = t[Symbol.iterator]();
      var n = e.next();

      for (; !n.done;) {
        this.Ae(n.value), n = e.next();
      }

      this.Re();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */

  }, {
    key: "be",
    value: function be(t) {
      var _iterator30 = _createForOfIteratorHelper(t),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var e = _step30.value;

          var _t46 = e.charCodeAt(0);

          if (_t46 < 128) this.Ie(_t46);else if (_t46 < 2048) this.Ie(960 | _t46 >>> 6), this.Ie(128 | 63 & _t46);else if (e < "\uD800" || "\uDBFF" < e) this.Ie(480 | _t46 >>> 12), this.Ie(128 | 63 & _t46 >>> 6), this.Ie(128 | 63 & _t46);else {
            var _t47 = e.codePointAt(0);

            this.Ie(240 | _t47 >>> 18), this.Ie(128 | 63 & _t47 >>> 12), this.Ie(128 | 63 & _t47 >>> 6), this.Ie(128 | 63 & _t47);
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }

      this.Te();
    }
    /** Writes utf8 bytes into this byte sequence, descending */

  }, {
    key: "Pe",
    value: function Pe(t) {
      var _iterator31 = _createForOfIteratorHelper(t),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var e = _step31.value;

          var _t48 = e.charCodeAt(0);

          if (_t48 < 128) this.Ae(_t48);else if (_t48 < 2048) this.Ae(960 | _t48 >>> 6), this.Ae(128 | 63 & _t48);else if (e < "\uD800" || "\uDBFF" < e) this.Ae(480 | _t48 >>> 12), this.Ae(128 | 63 & _t48 >>> 6), this.Ae(128 | 63 & _t48);else {
            var _t49 = e.codePointAt(0);

            this.Ae(240 | _t49 >>> 18), this.Ae(128 | 63 & _t49 >>> 12), this.Ae(128 | 63 & _t49 >>> 6), this.Ae(128 | 63 & _t49);
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }

      this.Re();
    }
  }, {
    key: "ve",
    value: function ve(t) {
      // Values are encoded with a single byte length prefix, followed by the
      // actual value in big-endian format with leading 0 bytes dropped.
      var e = this.Ve(t),
          n = ur(e);
      this.Se(1 + n), this.buffer[this.position++] = 255 & n; // Write the length

      for (var _t50 = e.length - n; _t50 < e.length; ++_t50) {
        this.buffer[this.position++] = 255 & e[_t50];
      }
    }
  }, {
    key: "De",
    value: function De(t) {
      // Values are encoded with a single byte length prefix, followed by the
      // inverted value in big-endian format with leading 0 bytes dropped.
      var e = this.Ve(t),
          n = ur(e);
      this.Se(1 + n), this.buffer[this.position++] = ~(255 & n); // Write the length

      for (var _t51 = e.length - n; _t51 < e.length; ++_t51) {
        this.buffer[this.position++] = ~(255 & e[_t51]);
      }
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */

  }, {
    key: "Ce",
    value: function Ce() {
      this.xe(255), this.xe(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */

  }, {
    key: "Ne",
    value: function Ne() {
      this.ke(255), this.ke(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */

  }, {
    key: "reset",
    value: function reset() {
      this.position = 0;
    }
  }, {
    key: "seed",
    value: function seed(t) {
      this.Se(t.length), this.buffer.set(t, this.position), this.position += t.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */

  }, {
    key: "Oe",
    value: function Oe() {
      return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */

  }, {
    key: "Ve",
    value: function Ve(t) {
      var e =
      /** Converts a JavaScript number to a byte array (using big endian encoding). */
      function (t) {
        var e = new DataView(new ArrayBuffer(8));
        return e.setFloat64(0, t,
        /* littleEndian= */
        !1), new Uint8Array(e.buffer);
      }(t),
          n = 0 != (128 & e[0]); // Check if the first bit is set. We use a bit mask since value[0] is
      // encoded as a number from 0 to 255.
      // Revert the two complement to get natural ordering


      e[0] ^= n ? 255 : 128;

      for (var _t52 = 1; _t52 < e.length; ++_t52) {
        e[_t52] ^= n ? 255 : 0;
      }

      return e;
    }
    /** Writes a single byte ascending to the buffer. */

  }, {
    key: "Ie",
    value: function Ie(t) {
      var e = 255 & t;
      0 === e ? (this.xe(0), this.xe(255)) : 255 === e ? (this.xe(255), this.xe(0)) : this.xe(e);
    }
    /** Writes a single byte descending to the buffer.  */

  }, {
    key: "Ae",
    value: function Ae(t) {
      var e = 255 & t;
      0 === e ? (this.ke(0), this.ke(255)) : 255 === e ? (this.ke(255), this.ke(0)) : this.ke(t);
    }
  }, {
    key: "Te",
    value: function Te() {
      this.xe(0), this.xe(1);
    }
  }, {
    key: "Re",
    value: function Re() {
      this.ke(0), this.ke(1);
    }
  }, {
    key: "xe",
    value: function xe(t) {
      this.Se(1), this.buffer[this.position++] = t;
    }
  }, {
    key: "ke",
    value: function ke(t) {
      this.Se(1), this.buffer[this.position++] = ~t;
    }
  }, {
    key: "Se",
    value: function Se(t) {
      var e = t + this.position;
      if (e <= this.buffer.length) return; // Try doubling.

      var n = 2 * this.buffer.length; // Still not big enough? Just allocate the right size.

      n < e && (n = e); // Create the new buffer.

      var s = new Uint8Array(n);
      s.set(this.buffer), // copy old data
      this.buffer = s;
    }
  }]);

  return cr;
}();

var ar = /*#__PURE__*/function () {
  function ar(t) {
    _classCallCheck(this, ar);

    this.Me = t;
  }

  _createClass(ar, [{
    key: "de",
    value: function de(t) {
      this.Me.pe(t);
    }
  }, {
    key: "he",
    value: function he(t) {
      this.Me.be(t);
    }
  }, {
    key: "ae",
    value: function ae(t) {
      this.Me.ve(t);
    }
  }, {
    key: "ue",
    value: function ue() {
      this.Me.Ce();
    }
  }]);

  return ar;
}();

var hr = /*#__PURE__*/function () {
  function hr(t) {
    _classCallCheck(this, hr);

    this.Me = t;
  }

  _createClass(hr, [{
    key: "de",
    value: function de(t) {
      this.Me.Ee(t);
    }
  }, {
    key: "he",
    value: function he(t) {
      this.Me.Pe(t);
    }
  }, {
    key: "ae",
    value: function ae(t) {
      this.Me.De(t);
    }
  }, {
    key: "ue",
    value: function ue() {
      this.Me.Ne();
    }
  }]);

  return hr;
}();
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */


var lr = /*#__PURE__*/function () {
  function lr() {
    _classCallCheck(this, lr);

    this.Me = new cr(), this.Fe = new ar(this.Me), this.$e = new hr(this.Me);
  }

  _createClass(lr, [{
    key: "seed",
    value: function seed(t) {
      this.Me.seed(t);
    }
  }, {
    key: "Be",
    value: function Be(t) {
      return 0
      /* ASCENDING */
      === t ? this.Fe : this.$e;
    }
  }, {
    key: "Oe",
    value: function Oe() {
      return this.Me.Oe();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.Me.reset();
    }
  }]);

  return lr;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Represents an index entry saved by the SDK in persisted storage. */


var fr = /*#__PURE__*/function () {
  function fr(t, e, n, s) {
    _classCallCheck(this, fr);

    this.indexId = t, this.documentKey = e, this.arrayValue = n, this.directionalValue = s;
  }
  /**
   * Returns an IndexEntry entry that sorts immediately after the current
   * directional value.
   */


  _createClass(fr, [{
    key: "Le",
    value: function Le() {
      var t = this.directionalValue.length,
          e = 0 === t || 255 === this.directionalValue[t - 1] ? t + 1 : t,
          n = new Uint8Array(e);
      return n.set(this.directionalValue, 0), e !== t ? n.set([0], this.directionalValue.length) : ++n[n.length - 1], new fr(this.indexId, this.documentKey, this.arrayValue, n);
    }
  }]);

  return fr;
}();

function dr(t, e) {
  var n = t.indexId - e.indexId;
  return 0 !== n ? n : (n = _r(t.arrayValue, e.arrayValue), 0 !== n ? n : (n = _r(t.directionalValue, e.directionalValue), 0 !== n ? n : dt.comparator(t.documentKey, e.documentKey)));
}

function _r(t, e) {
  for (var n = 0; n < t.length && n < e.length; ++n) {
    var s = t[n] - e[n];
    if (0 !== s) return s;
  }

  return t.length - e.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */


var wr = /*#__PURE__*/function () {
  function wr(t) {
    _classCallCheck(this, wr);

    this.collectionId = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment(), this.Ue = t.orderBy, this.qe = [];

    var _iterator32 = _createForOfIteratorHelper(t.filters),
        _step32;

    try {
      for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
        var e = _step32.value;
        var _t53 = e;
        _t53.ht() ? this.Ke = _t53 : this.qe.push(_t53);
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
  }
  /**
   * Returns whether the index can be used to serve the TargetIndexMatcher's
   * target.
   *
   * An index is considered capable of serving the target when:
   * - The target uses all index segments for its filters and orderBy clauses.
   *   The target can have additional filter and orderBy clauses, but not
   *   fewer.
   * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
   *   have a corresponding `CONTAINS` segment.
   * - All directional index segments can be mapped to the target as a series of
   *   equality filters, a single inequality filter and a series of orderBy
   *   clauses.
   * - The segments that represent the equality filters may appear out of order.
   * - The optional segment for the inequality filter must appear after all
   *   equality segments.
   * - The segments that represent that orderBy clause of the target must appear
   *   in order after all equality and inequality segments. Single orderBy
   *   clauses cannot be skipped, but a continuous orderBy suffix may be
   *   omitted.
   */


  _createClass(wr, [{
    key: "Ge",
    value: function Ge(t) {
      // If there is an array element, find a matching filter.
      var e = wt(t);
      if (void 0 !== e && !this.Qe(e)) return !1;
      var n = mt(t);
      var s = 0,
          i = 0; // Process all equalities first. Equalities can appear out of order.

      for (; s < n.length && this.Qe(n[s]); ++s) {
        ;
      } // If we already have processed all segments, all segments are used to serve
      // the equality filters and we do not need to map any segments to the
      // target's inequality and orderBy clauses.


      if (s === n.length) return !0; // If there is an inequality filter, the next segment must match both the
      // filter and the first orderBy clause.

      if (void 0 !== this.Ke) {
        var _t54 = n[s];
        if (!this.je(this.Ke, _t54) || !this.We(this.Ue[i++], _t54)) return !1;
        ++s;
      } // All remaining segments need to represent the prefix of the target's
      // orderBy.


      for (; s < n.length; ++s) {
        var _t55 = n[s];
        if (i >= this.Ue.length || !this.We(this.Ue[i++], _t55)) return !1;
      }

      return !0;
    }
  }, {
    key: "Qe",
    value: function Qe(t) {
      var _iterator33 = _createForOfIteratorHelper(this.qe),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var e = _step33.value;
          if (this.je(e, t)) return !0;
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }

      return !1;
    }
  }, {
    key: "je",
    value: function je(t, e) {
      if (void 0 === t || !t.field.isEqual(e.fieldPath)) return !1;
      var n = "array-contains"
      /* ARRAY_CONTAINS */
      === t.op || "array-contains-any"
      /* ARRAY_CONTAINS_ANY */
      === t.op;
      return 2
      /* CONTAINS */
      === e.kind === n;
    }
  }, {
    key: "We",
    value: function We(t, e) {
      return !!t.field.isEqual(e.fieldPath) && (0
      /* ASCENDING */
      === e.kind && "asc"
      /* ASCENDING */
      === t.dir || 1
      /* DESCENDING */
      === e.kind && "desc"
      /* DESCENDING */
      === t.dir);
    }
  }]);

  return wr;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An in-memory implementation of IndexManager.
 */


var mr = /*#__PURE__*/function () {
  function mr() {
    _classCallCheck(this, mr);

    this.ze = new gr();
  }

  _createClass(mr, [{
    key: "addToCollectionParentIndex",
    value: function addToCollectionParentIndex(t, e) {
      return this.ze.add(e), Pt.resolve();
    }
  }, {
    key: "getCollectionParents",
    value: function getCollectionParents(t, e) {
      return Pt.resolve(this.ze.getEntries(e));
    }
  }, {
    key: "addFieldIndex",
    value: function addFieldIndex(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve();
    }
  }, {
    key: "deleteFieldIndex",
    value: function deleteFieldIndex(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve();
    }
  }, {
    key: "getDocumentsMatchingTarget",
    value: function getDocumentsMatchingTarget(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve(null);
    }
  }, {
    key: "getIndexType",
    value: function getIndexType(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve(0
      /* NONE */
      );
    }
  }, {
    key: "getFieldIndexes",
    value: function getFieldIndexes(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve([]);
    }
  }, {
    key: "getNextCollectionGroupToUpdate",
    value: function getNextCollectionGroupToUpdate(t) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve(null);
    }
  }, {
    key: "getMinOffset",
    value: function getMinOffset(t, e) {
      return Pt.resolve(Tt.min());
    }
  }, {
    key: "getMinOffsetFromCollectionGroup",
    value: function getMinOffsetFromCollectionGroup(t, e) {
      return Pt.resolve(Tt.min());
    }
  }, {
    key: "updateCollectionGroup",
    value: function updateCollectionGroup(t, e, n) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve();
    }
  }, {
    key: "updateIndexEntries",
    value: function updateIndexEntries(t, e) {
      // Field indices are not supported with memory persistence.
      return Pt.resolve();
    }
  }]);

  return mr;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */


var gr = /*#__PURE__*/function () {
  function gr() {
    _classCallCheck(this, gr);

    this.index = {};
  } // Returns false if the entry already existed.


  _createClass(gr, [{
    key: "add",
    value: function add(t) {
      var e = t.lastSegment(),
          n = t.popLast(),
          s = this.index[e] || new Qt(ht.comparator),
          i = !s.has(n);
      return this.index[e] = s.add(n), i;
    }
  }, {
    key: "has",
    value: function has(t) {
      var e = t.lastSegment(),
          n = t.popLast(),
          s = this.index[e];
      return s && s.has(n);
    }
  }, {
    key: "getEntries",
    value: function getEntries(t) {
      return (this.index[t] || new Qt(ht.comparator)).toArray();
    }
  }]);

  return gr;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var yr = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */

var pr = /*#__PURE__*/function () {
  function pr(t, e) {
    _classCallCheck(this, pr);

    this.user = t, this.databaseId = e,
    /**
     * An in-memory copy of the index entries we've already written since the SDK
     * launched. Used to avoid re-writing the same entry repeatedly.
     *
     * This is *NOT* a complete cache of what's in persistence and so can never be
     * used to satisfy reads.
     */
    this.He = new gr(),
    /**
     * Maps from a target to its equivalent list of sub-targets. Each sub-target
     * contains only one term from the target's disjunctive normal form (DNF).
     */
    this.Je = new is(function (t) {
      return Oe(t);
    }, function (t, e) {
      return Fe(t, e);
    }), this.uid = t.uid || "";
  }
  /**
   * Adds a new entry to the collection parent index.
   *
   * Repeated calls for the same collectionPath should be avoided within a
   * transaction as IndexedDbIndexManager only caches writes once a transaction
   * has been committed.
   */


  _createClass(pr, [{
    key: "addToCollectionParentIndex",
    value: function addToCollectionParentIndex(t, e) {
      var _this49 = this;

      if (!this.He.has(e)) {
        var n = e.lastSegment(),
            s = e.popLast();
        t.addOnCommittedListener(function () {
          // Add the collection to the in memory cache only if the transaction was
          // successfully committed.
          _this49.He.add(e);
        });
        var i = {
          collectionId: n,
          parent: ci(s)
        };
        return Ir(t).put(i);
      }

      return Pt.resolve();
    }
  }, {
    key: "getCollectionParents",
    value: function getCollectionParents(t, e) {
      var n = [],
          s = IDBKeyRange.bound([e, ""], [ot(e), ""],
      /*lowerOpen=*/
      !1,
      /*upperOpen=*/
      !0);
      return Ir(t).K(s).next(function (t) {
        var _iterator34 = _createForOfIteratorHelper(t),
            _step34;

        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _s11 = _step34.value;
            // This collectionId guard shouldn't be necessary (and isn't as long
            // as we're running in a real browser), but there's a bug in
            // indexeddbshim that breaks our range in our tests running in node:
            // https://github.com/axemclion/IndexedDBShim/issues/334
            if (_s11.collectionId !== e) break;
            n.push(li(_s11.parent));
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }

        return n;
      });
    }
  }, {
    key: "addFieldIndex",
    value: function addFieldIndex(t, e) {
      var _this50 = this;

      // TODO(indexing): Verify that the auto-incrementing index ID works in
      // Safari & Firefox.
      var n = Er(t),
          s = function (t) {
        return {
          indexId: t.indexId,
          collectionGroup: t.collectionGroup,
          fields: t.fields.map(function (t) {
            return [t.fieldPath.canonicalString(), t.kind];
          })
        };
      }(e);

      delete s.indexId; // `indexId` is auto-populated by IndexedDb

      var i = n.add(s);

      if (e.indexState) {
        var _n17 = Ar(t);

        return i.next(function (t) {
          _n17.put(Zi(t, _this50.user, e.indexState.sequenceNumber, e.indexState.offset));
        });
      }

      return i.next();
    }
  }, {
    key: "deleteFieldIndex",
    value: function deleteFieldIndex(t, e) {
      var n = Er(t),
          s = Ar(t),
          i = Tr(t);
      return n.delete(e.indexId).next(function () {
        return s.delete(IDBKeyRange.bound([e.indexId], [e.indexId + 1],
        /*lowerOpen=*/
        !1,
        /*upperOpen=*/
        !0));
      }).next(function () {
        return i.delete(IDBKeyRange.bound([e.indexId], [e.indexId + 1],
        /*lowerOpen=*/
        !1,
        /*upperOpen=*/
        !0));
      });
    }
  }, {
    key: "getDocumentsMatchingTarget",
    value: function getDocumentsMatchingTarget(t, e) {
      var _this51 = this;

      var n = Tr(t);
      var s = !0;
      var i = new Map();
      return Pt.forEach(this.Ye(e), function (e) {
        return _this51.Xe(t, e).next(function (t) {
          s && (s = !!t), i.set(e, t);
        });
      }).next(function () {
        if (s) {
          var _t56 = ws();

          var _s12 = [];
          return Pt.forEach(i, function (i, r) {
            /** Returns a debug representation of the field index */
            var o;
            M("IndexedDbIndexManager", "Using index ".concat((o = i, "id=".concat(o.indexId, "|cg=").concat(o.collectionGroup, "|f=").concat(o.fields.map(function (t) {
              return "".concat(t.fieldPath, ":").concat(t.kind);
            }).join(","))), " to execute ").concat(Oe(e)));

            var u = function (t, e) {
              var n = wt(e);
              if (void 0 === n) return null;

              var _iterator35 = _createForOfIteratorHelper(Be(t, n.fieldPath)),
                  _step35;

              try {
                for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                  var _e25 = _step35.value;

                  switch (_e25.op) {
                    case "array-contains-any"
                    /* ARRAY_CONTAINS_ANY */
                    :
                      return _e25.value.arrayValue.values || [];

                    case "array-contains"
                    /* ARRAY_CONTAINS */
                    :
                      return [_e25.value];
                    // Remaining filters are not array filters.
                  }
                }
              } catch (err) {
                _iterator35.e(err);
              } finally {
                _iterator35.f();
              }

              return null;
            }
            /**
            * Returns the list of values that are used in != or NOT_IN filters. Returns
            * `null` if there are no such filters.
            */
            (r, i),
                c = function (t, e) {
              var n = new Map();

              var _iterator36 = _createForOfIteratorHelper(mt(e)),
                  _step36;

              try {
                for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                  var _s13 = _step36.value;

                  var _iterator37 = _createForOfIteratorHelper(Be(t, _s13.fieldPath)),
                      _step37;

                  try {
                    for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                      var _e26 = _step37.value;

                      switch (_e26.op) {
                        case "=="
                        /* EQUAL */
                        :
                        case "in"
                        /* IN */
                        :
                          // Encode equality prefix, which is encoded in the index value before
                          // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                          // `value != 'ab'`).
                          n.set(_s13.fieldPath.canonicalString(), _e26.value);
                          break;

                        case "not-in"
                        /* NOT_IN */
                        :
                        case "!="
                        /* NOT_EQUAL */
                        :
                          // NotIn/NotEqual is always a suffix. There cannot be any remaining
                          // segments and hence we can return early here.
                          return n.set(_s13.fieldPath.canonicalString(), _e26.value), Array.from(n.values());
                        // Remaining filters cannot be used as notIn bounds.
                      }
                    }
                  } catch (err) {
                    _iterator37.e(err);
                  } finally {
                    _iterator37.f();
                  }
                }
              } catch (err) {
                _iterator36.e(err);
              } finally {
                _iterator36.f();
              }

              return null;
            }
            /**
            * Returns a lower bound of field values that can be used as a starting point to
            * scan the index defined by `fieldIndex`. Returns `MIN_VALUE` if no lower bound
            * exists.
            */
            (r, i),
                a = function (t, e) {
              var n = [];
              var s = !0; // For each segment, retrieve a lower bound if there is a suitable filter or
              // startAt.

              var _iterator38 = _createForOfIteratorHelper(mt(e)),
                  _step38;

              try {
                for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                  var _i10 = _step38.value;

                  var _e27 = 0
                  /* ASCENDING */
                  === _i10.kind ? Le(t, _i10.fieldPath, t.startAt) : Ue(t, _i10.fieldPath, t.startAt);

                  n.push(_e27.value), s && (s = _e27.inclusive);
                }
              } catch (err) {
                _iterator38.e(err);
              } finally {
                _iterator38.f();
              }

              return new Ye(n, s);
            }
            /**
            * Returns an upper bound of field values that can be used as an ending point
            * when scanning the index defined by `fieldIndex`. Returns `MAX_VALUE` if no
            * upper bound exists.
            */
            (r, i),
                h = function (t, e) {
              var n = [];
              var s = !0; // For each segment, retrieve an upper bound if there is a suitable filter or
              // endAt.

              var _iterator39 = _createForOfIteratorHelper(mt(e)),
                  _step39;

              try {
                for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                  var _i11 = _step39.value;

                  var _e28 = 0
                  /* ASCENDING */
                  === _i11.kind ? Ue(t, _i11.fieldPath, t.endAt) : Le(t, _i11.fieldPath, t.endAt);

                  n.push(_e28.value), s && (s = _e28.inclusive);
                }
              } catch (err) {
                _iterator39.e(err);
              } finally {
                _iterator39.f();
              }

              return new Ye(n, s);
            }(r, i),
                l = _this51.Ze(i, r, a),
                f = _this51.Ze(i, r, h),
                d = _this51.tn(i, r, c),
                _ = _this51.en(i.indexId, u, l, a.inclusive, f, h.inclusive, d);

            return Pt.forEach(_, function (i) {
              return n.j(i, e.limit).next(function (e) {
                e.forEach(function (e) {
                  var n = dt.fromSegments(e.documentKey);
                  _t56.has(n) || (_t56 = _t56.add(n), _s12.push(n));
                });
              });
            });
          }).next(function () {
            return _s12;
          });
        }

        return Pt.resolve(null);
      });
    }
  }, {
    key: "Ye",
    value: function Ye(t) {
      var e = this.Je.get(t);
      return e || ( // TODO(orquery): Implement DNF transform
      e = [t], this.Je.set(t, e), e);
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */

  }, {
    key: "en",
    value: function en(t, e, n, s, i, r, o) {
      var _this52 = this;

      // The number of total index scans we union together. This is similar to a
      // distributed normal form, but adapted for array values. We create a single
      // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
      // combined with the values from the query bounds.
      var u = (null != e ? e.length : 1) * Math.max(n.length, i.length),
          c = u / (null != e ? e.length : 1),
          a = [];

      var _loop5 = function _loop5(h) {
        var u = e ? _this52.nn(e[h / c]) : yr,
            l = _this52.sn(t, u, n[h % c], s),
            f = _this52.rn(t, u, i[h % c], r),
            d = o.map(function (e) {
          return _this52.sn(t, u, e,
          /* inclusive= */
          !0);
        });

        a.push.apply(a, _toConsumableArray(_this52.createRange(l, f, d)));
      };

      for (var h = 0; h < u; ++h) {
        _loop5(h);
      }

      return a;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */

  }, {
    key: "sn",
    value: function sn(t, e, n, s) {
      var i = new fr(t, dt.empty(), e, n);
      return s ? i : i.Le();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */

  }, {
    key: "rn",
    value: function rn(t, e, n, s) {
      var i = new fr(t, dt.empty(), e, n);
      return s ? i.Le() : i;
    }
  }, {
    key: "Xe",
    value: function Xe(t, e) {
      var n = new wr(e),
          s = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment();
      return this.getFieldIndexes(t, s).next(function (t) {
        // Return the index with the most number of segments.
        var e = null;

        var _iterator40 = _createForOfIteratorHelper(t),
            _step40;

        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var _s14 = _step40.value;
            n.Ge(_s14) && (!e || _s14.fields.length > e.fields.length) && (e = _s14);
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }

        return e;
      });
    }
  }, {
    key: "getIndexType",
    value: function getIndexType(t, e) {
      var _this53 = this;

      var n = 2
      /* FULL */
      ;
      return Pt.forEach(this.Ye(e), function (e) {
        return _this53.Xe(t, e).next(function (t) {
          t ? 0
          /* NONE */
          !== n && t.fields.length < function (t) {
            var e = new Qt(ft.comparator),
                n = !1;

            var _iterator41 = _createForOfIteratorHelper(t.filters),
                _step41;

            try {
              for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                var s = _step41.value;
                // TODO(orquery): Use the flattened filters here
                var _t57 = s; // __name__ is not an explicit segment of any index, so we don't need to
                // count it.

                _t57.field.isKeyField() || ( // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                // though these are on the same field, they should be counted as two
                // separate segments in an index.
                "array-contains"
                /* ARRAY_CONTAINS */
                === _t57.op || "array-contains-any"
                /* ARRAY_CONTAINS_ANY */
                === _t57.op ? n = !0 : e = e.add(_t57.field));
              }
            } catch (err) {
              _iterator41.e(err);
            } finally {
              _iterator41.f();
            }

            var _iterator42 = _createForOfIteratorHelper(t.orderBy),
                _step42;

            try {
              for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) // __name__ is not an explicit segment of any index, so we don't need to
              // count it.
              {
                var _n18 = _step42.value;
                _n18.field.isKeyField() || (e = e.add(_n18.field));
              }
            } catch (err) {
              _iterator42.e(err);
            } finally {
              _iterator42.f();
            }

            return e.size + (n ? 1 : 0);
          }(e) && (n = 1
          /* PARTIAL */
          ) : n = 0
          /* NONE */
          ;
        });
      }).next(function () {
        return n;
      });
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */

  }, {
    key: "on",
    value: function on(t, e) {
      var n = new lr();

      var _iterator43 = _createForOfIteratorHelper(mt(t)),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var s = _step43.value;

          var _t58 = e.data.field(s.fieldPath);

          if (null == _t58) return null;
          var i = n.Be(s.kind);
          rr.ye.re(_t58, i);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }

      return n.Oe();
    }
    /** Encodes a single value to the ascending index format. */

  }, {
    key: "nn",
    value: function nn(t) {
      var e = new lr();
      return rr.ye.re(t, e.Be(0
      /* ASCENDING */
      )), e.Oe();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */

  }, {
    key: "un",
    value: function un(t, e) {
      var n = new lr();
      return rr.ye.re(ye(this.databaseId, e), n.Be(function (t) {
        var e = mt(t);
        return 0 === e.length ? 0
        /* ASCENDING */
        : e[e.length - 1].kind;
      }(t))), n.Oe();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */

  }, {
    key: "tn",
    value: function tn(t, e, n) {
      if (null === n) return [];
      var s = [];
      s.push(new lr());
      var i = 0;

      var _iterator44 = _createForOfIteratorHelper(mt(t)),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var r = _step44.value;
          var _t59 = n[i++];

          var _iterator45 = _createForOfIteratorHelper(s),
              _step45;

          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _n19 = _step45.value;
              if (this.cn(e, r.fieldPath) && Ie(_t59)) s = this.an(s, r, _t59);else {
                var _e29 = _n19.Be(r.kind);

                rr.ye.re(_t59, _e29);
              }
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }

      return this.hn(s);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */

  }, {
    key: "Ze",
    value: function Ze(t, e, n) {
      return this.tn(t, e, n.position);
    }
    /** Returns the byte representation for the provided encoders. */

  }, {
    key: "hn",
    value: function hn(t) {
      var e = [];

      for (var n = 0; n < t.length; ++n) {
        e[n] = t[n].Oe();
      }

      return e;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */

  }, {
    key: "an",
    value: function an(t, e, n) {
      var s = _toConsumableArray(t),
          i = [];

      var _iterator46 = _createForOfIteratorHelper(n.arrayValue.values || []),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var _t60 = _step46.value;

          var _iterator47 = _createForOfIteratorHelper(s),
              _step47;

          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var _n20 = _step47.value;

              var _s15 = new lr();

              _s15.seed(_n20.Oe()), rr.ye.re(_t60, _s15.Be(e.kind)), i.push(_s15);
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }

      return i;
    }
  }, {
    key: "cn",
    value: function cn(t, e) {
      return !!t.filters.find(function (t) {
        return t instanceof qe && t.field.isEqual(e) && ("in"
        /* IN */
        === t.op || "not-in"
        /* NOT_IN */
        === t.op);
      });
    }
  }, {
    key: "getFieldIndexes",
    value: function getFieldIndexes(t, e) {
      var _this54 = this;

      var n = Er(t),
          s = Ar(t);
      return (e ? n.K("collectionGroupIndex", IDBKeyRange.bound(e, e)) : n.K()).next(function (t) {
        var e = [];
        return Pt.forEach(t, function (t) {
          return s.get([t.indexId, _this54.uid]).next(function (n) {
            e.push(function (t, e) {
              var n = e ? new yt(e.sequenceNumber, new Tt(ji(e.readTime), new dt(li(e.documentKey)), e.largestBatchId)) : yt.empty(),
                  s = t.fields.map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    t = _ref5[0],
                    e = _ref5[1];

                return new gt(ft.fromServerFormat(t), e);
              });
              return new _t(t.indexId, t.collectionGroup, s, n);
            }(t, n));
          });
        }).next(function () {
          return e;
        });
      });
    }
  }, {
    key: "getNextCollectionGroupToUpdate",
    value: function getNextCollectionGroupToUpdate(t) {
      return this.getFieldIndexes(t).next(function (t) {
        return 0 === t.length ? null : (t.sort(function (t, e) {
          var n = t.indexState.sequenceNumber - e.indexState.sequenceNumber;
          return 0 !== n ? n : it(t.collectionGroup, e.collectionGroup);
        }), t[0].collectionGroup);
      });
    }
  }, {
    key: "updateCollectionGroup",
    value: function updateCollectionGroup(t, e, n) {
      var _this55 = this;

      var s = Er(t),
          i = Ar(t);
      return this.ln(t).next(function (t) {
        return s.K("collectionGroupIndex", IDBKeyRange.bound(e, e)).next(function (e) {
          return Pt.forEach(e, function (e) {
            return i.put(Zi(e.indexId, _this55.user, t, n));
          });
        });
      });
    }
  }, {
    key: "updateIndexEntries",
    value: function updateIndexEntries(t, e) {
      var _this56 = this;

      // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
      // it could be used across different IndexedDB transactions. As any cached
      // data might be invalidated by other multi-tab clients, we can only trust
      // data within a single IndexedDB transaction. We therefore add a cache
      // here.
      var n = new Map();
      return Pt.forEach(e, function (e, s) {
        var i = n.get(e.collectionGroup);
        return (i ? Pt.resolve(i) : _this56.getFieldIndexes(t, e.collectionGroup)).next(function (i) {
          return n.set(e.collectionGroup, i), Pt.forEach(i, function (n) {
            return _this56.fn(t, e, n).next(function (e) {
              var i = _this56.dn(s, n);

              return e.isEqual(i) ? Pt.resolve() : _this56._n(t, s, n, e, i);
            });
          });
        });
      });
    }
  }, {
    key: "wn",
    value: function wn(t, e, n, s) {
      return Tr(t).put({
        indexId: s.indexId,
        uid: this.uid,
        arrayValue: s.arrayValue,
        directionalValue: s.directionalValue,
        orderedDocumentKey: this.un(n, e.key),
        documentKey: e.key.path.toArray()
      });
    }
  }, {
    key: "mn",
    value: function mn(t, e, n, s) {
      return Tr(t).delete([s.indexId, this.uid, s.arrayValue, s.directionalValue, this.un(n, e.key), e.key.path.toArray()]);
    }
  }, {
    key: "fn",
    value: function fn(t, e, n) {
      var s = Tr(t);
      var i = new Qt(dr);
      return s.J({
        index: "documentKeyIndex",
        range: IDBKeyRange.only([n.indexId, this.uid, this.un(n, e)])
      }, function (t, s) {
        i = i.add(new fr(n.indexId, e, s.arrayValue, s.directionalValue));
      }).next(function () {
        return i;
      });
    }
    /** Creates the index entries for the given document. */

  }, {
    key: "dn",
    value: function dn(t, e) {
      var n = new Qt(dr);
      var s = this.on(e, t);
      if (null == s) return n;
      var i = wt(e);

      if (null != i) {
        var r = t.data.field(i.fieldPath);

        if (Ie(r)) {
          var _iterator48 = _createForOfIteratorHelper(r.arrayValue.values || []),
              _step48;

          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _i12 = _step48.value;
              n = n.add(new fr(e.indexId, t.key, this.nn(_i12), s));
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
        }
      } else n = n.add(new fr(e.indexId, t.key, yr, s));

      return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */

  }, {
    key: "_n",
    value: function _n(t, e, n, s, i) {
      var _this57 = this;

      M("IndexedDbIndexManager", "Updating index entries for document '%s'", e.key);
      var r = [];
      return function (t, e, n, s, i) {
        var r = t.getIterator(),
            o = e.getIterator();
        var u = Wt(r),
            c = Wt(o); // Walk through the two sets at the same time, using the ordering defined by
        // `comparator`.

        for (; u || c;) {
          var _t61 = !1,
              _e30 = !1;

          if (u && c) {
            var _s16 = n(u, c);

            _s16 < 0 ? // The element was removed if the next element in our ordered
            // walkthrough is only in `before`.
            _e30 = !0 : _s16 > 0 && ( // The element was added if the next element in our ordered walkthrough
            // is only in `after`.
            _t61 = !0);
          } else null != u ? _e30 = !0 : _t61 = !0;

          _t61 ? (s(c), c = Wt(o)) : _e30 ? (i(u), u = Wt(r)) : (u = Wt(r), c = Wt(o));
        }
      }(s, i, dr,
      /* onAdd= */
      function (s) {
        r.push(_this57.wn(t, e, n, s));
      },
      /* onRemove= */
      function (s) {
        r.push(_this57.mn(t, e, n, s));
      }), Pt.waitFor(r);
    }
  }, {
    key: "ln",
    value: function ln(t) {
      var e = 1;
      return Ar(t).J({
        index: "sequenceNumberIndex",
        reverse: !0,
        range: IDBKeyRange.upperBound([this.uid, Number.MAX_SAFE_INTEGER])
      }, function (t, n, s) {
        s.done(), e = n.sequenceNumber + 1;
      }).next(function () {
        return e;
      });
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */

  }, {
    key: "createRange",
    value: function createRange(t, e, n) {
      // The notIn values need to be sorted and unique so that we can return a
      // sorted set of non-overlapping ranges.
      n = n.sort(function (t, e) {
        return dr(t, e);
      }).filter(function (t, e, n) {
        return !e || 0 !== dr(t, n[e - 1]);
      });
      var s = [];
      s.push(t);

      var _iterator49 = _createForOfIteratorHelper(n),
          _step49;

      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var _i13 = _step49.value;

          var _n21 = dr(_i13, t),
              r = dr(_i13, e);

          if (0 === _n21) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            s[0] = t.Le();else if (_n21 > 0 && r < 0) // `notInValue` is in the middle of the range
            s.push(_i13), s.push(_i13.Le());else if (r > 0) // `notInValue` (and all following values) are out of the range
            break;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }

      s.push(e);
      var i = [];

      for (var _t62 = 0; _t62 < s.length; _t62 += 2) {
        i.push(IDBKeyRange.bound([s[_t62].indexId, this.uid, s[_t62].arrayValue, s[_t62].directionalValue, yr, []], [s[_t62 + 1].indexId, this.uid, s[_t62 + 1].arrayValue, s[_t62 + 1].directionalValue, yr, []]));
      }

      return i;
    }
  }, {
    key: "getMinOffsetFromCollectionGroup",
    value: function getMinOffsetFromCollectionGroup(t, e) {
      return this.getFieldIndexes(t, e).next(Rr);
    }
  }, {
    key: "getMinOffset",
    value: function getMinOffset(t, e) {
      var _this58 = this;

      return Pt.mapArray(this.Ye(e), function (e) {
        return _this58.Xe(t, e).next(function (t) {
          return t || L();
        });
      }).next(Rr);
    }
  }]);

  return pr;
}();
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */


function Ir(t) {
  return Mi(t, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */


function Tr(t) {
  return Mi(t, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */


function Er(t) {
  return Mi(t, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */


function Ar(t) {
  return Mi(t, "indexState");
}

function Rr(t) {
  U(0 !== t.length);
  var e = t[0].indexState.offset,
      n = e.largestBatchId;

  for (var s = 1; s < t.length; s++) {
    var i = t[s].indexState.offset;
    Et(i, e) < 0 && (e = i), n < i.largestBatchId && (n = i.largestBatchId);
  }

  return new Tt(e.readTime, e.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var br = {
  didRun: !1,
  sequenceNumbersCollected: 0,
  targetsRemoved: 0,
  documentsRemoved: 0
};

var Pr = /*#__PURE__*/function () {
  function Pr( // When we attempt to collect, we will only do so if the cache size is greater than this
  // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
  t, // The percentage of sequence numbers that we will attempt to collect
  e, // A cap on the total number of sequence numbers that will be collected. This prevents
  // us from collecting a huge number of sequence numbers if the cache has grown very large.
  n) {
    _classCallCheck(this, Pr);

    this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
  }

  _createClass(Pr, null, [{
    key: "withCacheSize",
    value: function withCacheSize(t) {
      return new Pr(t, Pr.DEFAULT_COLLECTION_PERCENTILE, Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
  }]);

  return Pr;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */


function vr(t, e, n) {
  var s = t.store("mutations"),
      i = t.store("documentMutations"),
      r = [],
      o = IDBKeyRange.only(n.batchId);
  var u = 0;
  var c = s.J({
    range: o
  }, function (t, e, n) {
    return u++, n.delete();
  });
  r.push(c.next(function () {
    U(1 === u);
  }));
  var a = [];

  var _iterator50 = _createForOfIteratorHelper(n.mutations),
      _step50;

  try {
    for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
      var _t63 = _step50.value;

      var _s17 = _i(e, _t63.key.path, n.batchId);

      r.push(i.delete(_s17)), a.push(_t63.key);
    }
  } catch (err) {
    _iterator50.e(err);
  } finally {
    _iterator50.f();
  }

  return Pt.waitFor(r).next(function () {
    return a;
  });
}
/**
 * Returns an approximate size for the given document.
 */


function Vr(t) {
  if (!t) return 0;
  var e;
  if (t.document) e = t.document;else if (t.unknownDocument) e = t.unknownDocument;else {
    if (!t.noDocument) throw L();
    e = t.noDocument;
  }
  return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** A mutation queue for a specific user, backed by IndexedDB. */


Pr.DEFAULT_COLLECTION_PERCENTILE = 10, Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, Pr.DEFAULT = new Pr(41943040, Pr.DEFAULT_COLLECTION_PERCENTILE, Pr.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), Pr.DISABLED = new Pr(-1, 0, 0);

var Sr = /*#__PURE__*/function () {
  function Sr(
  /**
   * The normalized userId (e.g. null UID => "" userId) used to store /
   * retrieve mutations.
   */
  t, e, n, s) {
    _classCallCheck(this, Sr);

    this.userId = t, this.wt = e, this.indexManager = n, this.referenceDelegate = s,
    /**
     * Caches the document keys for pending mutation batches. If the mutation
     * has been removed from IndexedDb, the cached value may continue to
     * be used to retrieve the batch's document keys. To remove a cached value
     * locally, `removeCachedMutationKeys()` should be invoked either directly
     * or through `removeMutationBatches()`.
     *
     * With multi-tab, when the primary client acknowledges or rejects a mutation,
     * this cache is used by secondary clients to invalidate the local
     * view of the documents that were previously affected by the mutation.
     */
    // PORTING NOTE: Multi-tab only.
    this.gn = {};
  }
  /**
   * Creates a new mutation queue for the given user.
   * @param user - The user for which to create a mutation queue.
   * @param serializer - The serializer to use when persisting to IndexedDb.
   */


  _createClass(Sr, [{
    key: "checkEmpty",
    value: function checkEmpty(t) {
      var e = !0;
      var n = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
      return Cr(t).J({
        index: "userMutationsIndex",
        range: n
      }, function (t, n, s) {
        e = !1, s.done();
      }).next(function () {
        return e;
      });
    }
  }, {
    key: "addMutationBatch",
    value: function addMutationBatch(t, e, n, s) {
      var _this59 = this;

      var i = xr(t),
          r = Cr(t); // The IndexedDb implementation in Chrome (and Firefox) does not handle
      // compound indices that include auto-generated keys correctly. To ensure
      // that the index entry is added correctly in all browsers, we perform two
      // writes: The first write is used to retrieve the next auto-generated Batch
      // ID, and the second write populates the index and stores the actual
      // mutation batch.
      // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
      // We write an empty object to obtain key
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      return r.add({}).next(function (o) {
        U("number" == typeof o);

        var u = new Fi(o, e, n, s),
            c = function (t, e, n) {
          var s = n.baseMutations.map(function (e) {
            return js(t.ne, e);
          }),
              i = n.mutations.map(function (e) {
            return js(t.ne, e);
          });
          return {
            userId: e,
            batchId: n.batchId,
            localWriteTimeMs: n.localWriteTime.toMillis(),
            baseMutations: s,
            mutations: i
          };
        }(_this59.wt, _this59.userId, u),
            a = [];

        var h = new Qt(function (t, e) {
          return it(t.canonicalString(), e.canonicalString());
        });

        var _iterator51 = _createForOfIteratorHelper(s),
            _step51;

        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var _t64 = _step51.value;

            var _e31 = _i(_this59.userId, _t64.key.path, o);

            h = h.add(_t64.key.path.popLast()), a.push(r.put(c)), a.push(i.put(_e31, wi));
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }

        return h.forEach(function (e) {
          a.push(_this59.indexManager.addToCollectionParentIndex(t, e));
        }), t.addOnCommittedListener(function () {
          _this59.gn[o] = u.keys();
        }), Pt.waitFor(a).next(function () {
          return u;
        });
      });
    }
  }, {
    key: "lookupMutationBatch",
    value: function lookupMutationBatch(t, e) {
      var _this60 = this;

      return Cr(t).get(e).next(function (t) {
        return t ? (U(t.userId === _this60.userId), Wi(_this60.wt, t)) : null;
      });
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */
    // PORTING NOTE: Multi-tab only.

  }, {
    key: "yn",
    value: function yn(t, e) {
      var _this61 = this;

      return this.gn[e] ? Pt.resolve(this.gn[e]) : this.lookupMutationBatch(t, e).next(function (t) {
        if (t) {
          var n = t.keys();
          return _this61.gn[e] = n, n;
        }

        return null;
      });
    }
  }, {
    key: "getNextMutationBatchAfterBatchId",
    value: function getNextMutationBatchAfterBatchId(t, e) {
      var _this62 = this;

      var n = e + 1,
          s = IDBKeyRange.lowerBound([this.userId, n]);
      var i = null;
      return Cr(t).J({
        index: "userMutationsIndex",
        range: s
      }, function (t, e, s) {
        e.userId === _this62.userId && (U(e.batchId >= n), i = Wi(_this62.wt, e)), s.done();
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "getHighestUnacknowledgedBatchId",
    value: function getHighestUnacknowledgedBatchId(t) {
      var e = IDBKeyRange.upperBound([this.userId, Number.POSITIVE_INFINITY]);
      var n = -1;
      return Cr(t).J({
        index: "userMutationsIndex",
        range: e,
        reverse: !0
      }, function (t, e, s) {
        n = e.batchId, s.done();
      }).next(function () {
        return n;
      });
    }
  }, {
    key: "getAllMutationBatches",
    value: function getAllMutationBatches(t) {
      var _this63 = this;

      var e = IDBKeyRange.bound([this.userId, -1], [this.userId, Number.POSITIVE_INFINITY]);
      return Cr(t).K("userMutationsIndex", e).next(function (t) {
        return t.map(function (t) {
          return Wi(_this63.wt, t);
        });
      });
    }
  }, {
    key: "getAllMutationBatchesAffectingDocumentKey",
    value: function getAllMutationBatchesAffectingDocumentKey(t, e) {
      var _this64 = this;

      // Scan the document-mutation index starting with a prefix starting with
      // the given documentKey.
      var n = di(this.userId, e.path),
          s = IDBKeyRange.lowerBound(n),
          i = [];
      return xr(t).J({
        range: s
      }, function (n, s, r) {
        var _n22 = _slicedToArray(n, 3),
            o = _n22[0],
            u = _n22[1],
            c = _n22[2],
            a = li(u); // Only consider rows matching exactly the specific key of
        // interest. Note that because we order by path first, and we
        // order terminators before path separators, we'll encounter all
        // the index rows for documentKey contiguously. In particular, all
        // the rows for documentKey will occur before any rows for
        // documents nested in a subcollection beneath documentKey so we
        // can stop as soon as we hit any such row.


        if (o === _this64.userId && e.path.isEqual(a)) // Look up the mutation batch in the store.
          return Cr(t).get(c).next(function (t) {
            if (!t) throw L();
            U(t.userId === _this64.userId), i.push(Wi(_this64.wt, t));
          });
        r.done();
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "getAllMutationBatchesAffectingDocumentKeys",
    value: function getAllMutationBatchesAffectingDocumentKeys(t, e) {
      var _this65 = this;

      var n = new Qt(it);
      var s = [];
      return e.forEach(function (e) {
        var i = di(_this65.userId, e.path),
            r = IDBKeyRange.lowerBound(i),
            o = xr(t).J({
          range: r
        }, function (t, s, i) {
          var _t65 = _slicedToArray(t, 3),
              r = _t65[0],
              o = _t65[1],
              u = _t65[2],
              c = li(o); // Only consider rows matching exactly the specific key of
          // interest. Note that because we order by path first, and we
          // order terminators before path separators, we'll encounter all
          // the index rows for documentKey contiguously. In particular, all
          // the rows for documentKey will occur before any rows for
          // documents nested in a subcollection beneath documentKey so we
          // can stop as soon as we hit any such row.


          r === _this65.userId && e.path.isEqual(c) ? n = n.add(u) : i.done();
        });
        s.push(o);
      }), Pt.waitFor(s).next(function () {
        return _this65.pn(t, n);
      });
    }
  }, {
    key: "getAllMutationBatchesAffectingQuery",
    value: function getAllMutationBatchesAffectingQuery(t, e) {
      var _this66 = this;

      var n = e.path,
          s = n.length + 1,
          i = di(this.userId, n),
          r = IDBKeyRange.lowerBound(i); // Collect up unique batchIDs encountered during a scan of the index. Use a
      // SortedSet to accumulate batch IDs so they can be traversed in order in a
      // scan of the main table.

      var o = new Qt(it);
      return xr(t).J({
        range: r
      }, function (t, e, i) {
        var _t66 = _slicedToArray(t, 3),
            r = _t66[0],
            u = _t66[1],
            c = _t66[2],
            a = li(u);

        r === _this66.userId && n.isPrefixOf(a) ? // Rows with document keys more than one segment longer than the
        // query path can't be matches. For example, a query on 'rooms'
        // can't match the document /rooms/abc/messages/xyx.
        // TODO(mcg): we'll need a different scanner when we implement
        // ancestor queries.
        a.length === s && (o = o.add(c)) : i.done();
      }).next(function () {
        return _this66.pn(t, o);
      });
    }
  }, {
    key: "pn",
    value: function pn(t, e) {
      var _this67 = this;

      var n = [],
          s = []; // TODO(rockwood): Implement this using iterate.

      return e.forEach(function (e) {
        s.push(Cr(t).get(e).next(function (t) {
          if (null === t) throw L();
          U(t.userId === _this67.userId), n.push(Wi(_this67.wt, t));
        }));
      }), Pt.waitFor(s).next(function () {
        return n;
      });
    }
  }, {
    key: "removeMutationBatch",
    value: function removeMutationBatch(t, e) {
      var _this68 = this;

      return vr(t.ee, this.userId, e).next(function (n) {
        return t.addOnCommittedListener(function () {
          _this68.In(e.batchId);
        }), Pt.forEach(n, function (e) {
          return _this68.referenceDelegate.markPotentiallyOrphaned(t, e);
        });
      });
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */
    // PORTING NOTE: Multi-tab only

  }, {
    key: "In",
    value: function In(t) {
      delete this.gn[t];
    }
  }, {
    key: "performConsistencyCheck",
    value: function performConsistencyCheck(t) {
      var _this69 = this;

      return this.checkEmpty(t).next(function (e) {
        if (!e) return Pt.resolve(); // Verify that there are no entries in the documentMutations index if
        // the queue is empty.

        var n = IDBKeyRange.lowerBound([_this69.userId]);
        var s = [];
        return xr(t).J({
          range: n
        }, function (t, e, n) {
          if (t[0] === _this69.userId) {
            var _e32 = li(t[1]);

            s.push(_e32);
          } else n.done();
        }).next(function () {
          U(0 === s.length);
        });
      });
    }
  }, {
    key: "containsKey",
    value: function containsKey(t, e) {
      return Dr(t, this.userId, e);
    } // PORTING NOTE: Multi-tab only (state is held in memory in other clients).

    /** Returns the mutation queue's metadata from IndexedDb. */

  }, {
    key: "Tn",
    value: function Tn(t) {
      var _this70 = this;

      return Nr(t).get(this.userId).next(function (t) {
        return t || {
          userId: _this70.userId,
          lastAcknowledgedBatchId: -1,
          lastStreamToken: ""
        };
      });
    }
  }], [{
    key: "se",
    value: function se(t, e, n, s) {
      // TODO(mcg): Figure out what constraints there are on userIDs
      // In particular, are there any reserved characters? are empty ids allowed?
      // For the moment store these together in the same mutations table assuming
      // that empty userIDs aren't allowed.
      U("" !== t.uid);
      var i = t.isAuthenticated() ? t.uid : "";
      return new Sr(i, e, n, s);
    }
  }]);

  return Sr;
}();
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */


function Dr(t, e, n) {
  var s = di(e, n.path),
      i = s[1],
      r = IDBKeyRange.lowerBound(s);
  var o = !1;
  return xr(t).J({
    range: r,
    H: !0
  }, function (t, n, s) {
    var _t67 = _slicedToArray(t, 3),
        r = _t67[0],
        u = _t67[1],

    /*batchID*/
    c = _t67[2];

    r === e && u === i && (o = !0), s.done();
  }).next(function () {
    return o;
  });
}
/** Returns true if any mutation queue contains the given document. */

/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */


function Cr(t) {
  return Mi(t, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */


function xr(t) {
  return Mi(t, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */


function Nr(t) {
  return Mi(t, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Offset to ensure non-overlapping target ids. */

/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */


var kr = /*#__PURE__*/function () {
  function kr(t) {
    _classCallCheck(this, kr);

    this.En = t;
  }

  _createClass(kr, [{
    key: "next",
    value: function next() {
      return this.En += 2, this.En;
    }
  }], [{
    key: "An",
    value: function An() {
      // The target cache generator must return '2' in its first call to `next()`
      // as there is no differentiation in the protocol layer between an unset
      // number and the number '0'. If we were to sent a target with target ID
      // '0', the backend would consider it unset and replace it with its own ID.
      return new kr(0);
    }
  }, {
    key: "Rn",
    value: function Rn() {
      // Sync engine assigns target IDs for limbo document detection.
      return new kr(-1);
    }
  }]);

  return kr;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Or = /*#__PURE__*/function () {
  function Or(t, e) {
    _classCallCheck(this, Or);

    this.referenceDelegate = t, this.wt = e;
  } // PORTING NOTE: We don't cache global metadata for the target cache, since
  // some of it (in particular `highestTargetId`) can be modified by secondary
  // tabs. We could perhaps be more granular (and e.g. still cache
  // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
  // to IndexedDb whenever we need to read metadata. We can revisit if it turns
  // out to have a meaningful performance impact.


  _createClass(Or, [{
    key: "allocateTargetId",
    value: function allocateTargetId(t) {
      var _this71 = this;

      return this.bn(t).next(function (e) {
        var n = new kr(e.highestTargetId);
        return e.highestTargetId = n.next(), _this71.Pn(t, e).next(function () {
          return e.highestTargetId;
        });
      });
    }
  }, {
    key: "getLastRemoteSnapshotVersion",
    value: function getLastRemoteSnapshotVersion(t) {
      return this.bn(t).next(function (t) {
        return ct.fromTimestamp(new ut(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds));
      });
    }
  }, {
    key: "getHighestSequenceNumber",
    value: function getHighestSequenceNumber(t) {
      return this.bn(t).next(function (t) {
        return t.highestListenSequenceNumber;
      });
    }
  }, {
    key: "setTargetsMetadata",
    value: function setTargetsMetadata(t, e, n) {
      var _this72 = this;

      return this.bn(t).next(function (s) {
        return s.highestListenSequenceNumber = e, n && (s.lastRemoteSnapshotVersion = n.toTimestamp()), e > s.highestListenSequenceNumber && (s.highestListenSequenceNumber = e), _this72.Pn(t, s);
      });
    }
  }, {
    key: "addTargetData",
    value: function addTargetData(t, e) {
      var _this73 = this;

      return this.vn(t, e).next(function () {
        return _this73.bn(t).next(function (n) {
          return n.targetCount += 1, _this73.Vn(e, n), _this73.Pn(t, n);
        });
      });
    }
  }, {
    key: "updateTargetData",
    value: function updateTargetData(t, e) {
      return this.vn(t, e);
    }
  }, {
    key: "removeTargetData",
    value: function removeTargetData(t, e) {
      var _this74 = this;

      return this.removeMatchingKeysForTargetId(t, e.targetId).next(function () {
        return Mr(t).delete(e.targetId);
      }).next(function () {
        return _this74.bn(t);
      }).next(function (e) {
        return U(e.targetCount > 0), e.targetCount -= 1, _this74.Pn(t, e);
      });
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */

  }, {
    key: "removeTargets",
    value: function removeTargets(t, e, n) {
      var _this75 = this;

      var s = 0;
      var i = [];
      return Mr(t).J(function (r, o) {
        var u = zi(o);
        u.sequenceNumber <= e && null === n.get(u.targetId) && (s++, i.push(_this75.removeTargetData(t, u)));
      }).next(function () {
        return Pt.waitFor(i);
      }).next(function () {
        return s;
      });
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */

  }, {
    key: "forEachTarget",
    value: function forEachTarget(t, e) {
      return Mr(t).J(function (t, n) {
        var s = zi(n);
        e(s);
      });
    }
  }, {
    key: "bn",
    value: function bn(t) {
      return Fr(t).get("targetGlobalKey").next(function (t) {
        return U(null !== t), t;
      });
    }
  }, {
    key: "Pn",
    value: function Pn(t, e) {
      return Fr(t).put("targetGlobalKey", e);
    }
  }, {
    key: "vn",
    value: function vn(t, e) {
      return Mr(t).put(Hi(this.wt, e));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */

  }, {
    key: "Vn",
    value: function Vn(t, e) {
      var n = !1;
      return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }
  }, {
    key: "getTargetCount",
    value: function getTargetCount(t) {
      return this.bn(t).next(function (t) {
        return t.targetCount;
      });
    }
  }, {
    key: "getTargetData",
    value: function getTargetData(t, e) {
      // Iterating by the canonicalId may yield more than one result because
      // canonicalId values are not required to be unique per target. This query
      // depends on the queryTargets index to be efficient.
      var n = Oe(e),
          s = IDBKeyRange.bound([n, Number.NEGATIVE_INFINITY], [n, Number.POSITIVE_INFINITY]);
      var i = null;
      return Mr(t).J({
        range: s,
        index: "queryTargetsIndex"
      }, function (t, n, s) {
        var r = zi(n); // After finding a potential match, check that the target is
        // actually equal to the requested target.

        Fe(e, r.target) && (i = r, s.done());
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "addMatchingKeys",
    value: function addMatchingKeys(t, e, n) {
      var _this76 = this;

      // PORTING NOTE: The reverse index (documentsTargets) is maintained by
      // IndexedDb.
      var s = [],
          i = $r(t);
      return e.forEach(function (e) {
        var r = ci(e.path);
        s.push(i.put({
          targetId: n,
          path: r
        })), s.push(_this76.referenceDelegate.addReference(t, n, e));
      }), Pt.waitFor(s);
    }
  }, {
    key: "removeMatchingKeys",
    value: function removeMatchingKeys(t, e, n) {
      var _this77 = this;

      // PORTING NOTE: The reverse index (documentsTargets) is maintained by
      // IndexedDb.
      var s = $r(t);
      return Pt.forEach(e, function (e) {
        var i = ci(e.path);
        return Pt.waitFor([s.delete([n, i]), _this77.referenceDelegate.removeReference(t, n, e)]);
      });
    }
  }, {
    key: "removeMatchingKeysForTargetId",
    value: function removeMatchingKeysForTargetId(t, e) {
      var n = $r(t),
          s = IDBKeyRange.bound([e], [e + 1],
      /*lowerOpen=*/
      !1,
      /*upperOpen=*/
      !0);
      return n.delete(s);
    }
  }, {
    key: "getMatchingKeysForTargetId",
    value: function getMatchingKeysForTargetId(t, e) {
      var n = IDBKeyRange.bound([e], [e + 1],
      /*lowerOpen=*/
      !1,
      /*upperOpen=*/
      !0),
          s = $r(t);
      var i = ws();
      return s.J({
        range: n,
        H: !0
      }, function (t, e, n) {
        var s = li(t[1]),
            r = new dt(s);
        i = i.add(r);
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "containsKey",
    value: function containsKey(t, e) {
      var n = ci(e.path),
          s = IDBKeyRange.bound([n], [ot(n)],
      /*lowerOpen=*/
      !1,
      /*upperOpen=*/
      !0);
      var i = 0;
      return $r(t).J({
        index: "documentTargetsIndex",
        H: !0,
        range: s
      }, function (_ref6, n, s) {
        var _ref7 = _slicedToArray(_ref6, 2),
            t = _ref7[0],
            e = _ref7[1];

        // Having a sentinel row for a document does not count as containing that document;
        // For the target cache, containing the document means the document is part of some
        // target.
        0 !== t && (i++, s.done());
      }).next(function () {
        return i > 0;
      });
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */
    // PORTING NOTE: Multi-tab only.

  }, {
    key: "te",
    value: function te(t, e) {
      return Mr(t).get(e).next(function (t) {
        return t ? zi(t) : null;
      });
    }
  }]);

  return Or;
}();
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */


function Mr(t) {
  return Mi(t, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */


function Fr(t) {
  return Mi(t, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */


function $r(t) {
  return Mi(t, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Br(_ref8, _ref9) {
  var _ref10 = _slicedToArray(_ref8, 2),
      t = _ref10[0],
      e = _ref10[1];

  var _ref11 = _slicedToArray(_ref9, 2),
      n = _ref11[0],
      s = _ref11[1];

  var i = it(t, n);
  return 0 === i ? it(e, s) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */


var Lr = /*#__PURE__*/function () {
  function Lr(t) {
    _classCallCheck(this, Lr);

    this.Sn = t, this.buffer = new Qt(Br), this.Dn = 0;
  }

  _createClass(Lr, [{
    key: "Cn",
    value: function Cn() {
      return ++this.Dn;
    }
  }, {
    key: "xn",
    value: function xn(t) {
      var e = [t, this.Cn()];
      if (this.buffer.size < this.Sn) this.buffer = this.buffer.add(e);else {
        var _t68 = this.buffer.last();

        Br(e, _t68) < 0 && (this.buffer = this.buffer.delete(_t68).add(e));
      }
    }
  }, {
    key: "maxValue",
    get: function get() {
      // Guaranteed to be non-empty. If we decide we are not collecting any
      // sequence numbers, nthSequenceNumber below short-circuits. If we have
      // decided that we are collecting n sequence numbers, it's because n is some
      // percentage of the existing sequence numbers. That means we should never
      // be in a situation where we are collecting sequence numbers but don't
      // actually have any.
      return this.buffer.last()[0];
    }
  }]);

  return Lr;
}();
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */


var Ur = /*#__PURE__*/function () {
  function Ur(t, e, n) {
    _classCallCheck(this, Ur);

    this.garbageCollector = t, this.asyncQueue = e, this.localStore = n, this.Nn = null;
  }

  _createClass(Ur, [{
    key: "start",
    value: function start() {
      -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.kn(6e4);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.Nn && (this.Nn.cancel(), this.Nn = null);
    }
  }, {
    key: "started",
    get: function get() {
      return null !== this.Nn;
    }
  }, {
    key: "kn",
    value: function kn(t) {
      var _this78 = this;

      M("LruGarbageCollector", "Garbage collection scheduled in ".concat(t, "ms")), this.Nn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection"
      /* LruGarbageCollection */
      , t, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this78.Nn = null;
                _context7.prev = 1;
                _context7.next = 4;
                return _this78.localStore.collectGarbage(_this78.garbageCollector);

              case 4:
                _context7.next = 14;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](1);

                if (!Ct(_context7.t0)) {
                  _context7.next = 12;
                  break;
                }

                M("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", _context7.t0);
                _context7.next = 14;
                break;

              case 12:
                _context7.next = 14;
                return bt(_context7.t0);

              case 14:
                _context7.next = 16;
                return _this78.kn(3e5);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 6]]);
      })));
    }
  }]);

  return Ur;
}();
/** Implements the steps for LRU garbage collection. */


var qr = /*#__PURE__*/function () {
  function qr(t, e) {
    _classCallCheck(this, qr);

    this.On = t, this.params = e;
  }

  _createClass(qr, [{
    key: "calculateTargetCount",
    value: function calculateTargetCount(t, e) {
      return this.On.Mn(t).next(function (t) {
        return Math.floor(e / 100 * t);
      });
    }
  }, {
    key: "nthSequenceNumber",
    value: function nthSequenceNumber(t, e) {
      var _this79 = this;

      if (0 === e) return Pt.resolve($t.ot);
      var n = new Lr(e);
      return this.On.forEachTarget(t, function (t) {
        return n.xn(t.sequenceNumber);
      }).next(function () {
        return _this79.On.Fn(t, function (t) {
          return n.xn(t);
        });
      }).next(function () {
        return n.maxValue;
      });
    }
  }, {
    key: "removeTargets",
    value: function removeTargets(t, e, n) {
      return this.On.removeTargets(t, e, n);
    }
  }, {
    key: "removeOrphanedDocuments",
    value: function removeOrphanedDocuments(t, e) {
      return this.On.removeOrphanedDocuments(t, e);
    }
  }, {
    key: "collect",
    value: function collect(t, e) {
      var _this80 = this;

      return -1 === this.params.cacheSizeCollectionThreshold ? (M("LruGarbageCollector", "Garbage collection skipped; disabled"), Pt.resolve(br)) : this.getCacheSize(t).next(function (n) {
        return n < _this80.params.cacheSizeCollectionThreshold ? (M("LruGarbageCollector", "Garbage collection skipped; Cache size ".concat(n, " is lower than threshold ").concat(_this80.params.cacheSizeCollectionThreshold)), br) : _this80.$n(t, e);
      });
    }
  }, {
    key: "getCacheSize",
    value: function getCacheSize(t) {
      return this.On.getCacheSize(t);
    }
  }, {
    key: "$n",
    value: function $n(t, e) {
      var _this81 = this;

      var n, s, i, r, o, c, a;
      var h = Date.now();
      return this.calculateTargetCount(t, this.params.percentileToCollect).next(function (e) {
        return (// Cap at the configured max
          e > _this81.params.maximumSequenceNumbersToCollect ? (M("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of ".concat(_this81.params.maximumSequenceNumbersToCollect, " from ").concat(e)), s = _this81.params.maximumSequenceNumbersToCollect) : s = e, r = Date.now(), _this81.nthSequenceNumber(t, s)
        );
      }).next(function (s) {
        return n = s, o = Date.now(), _this81.removeTargets(t, n, e);
      }).next(function (e) {
        return i = e, c = Date.now(), _this81.removeOrphanedDocuments(t, n);
      }).next(function (t) {
        if (a = Date.now(), k() <= LogLevel.DEBUG) {
          M("LruGarbageCollector", "LRU Garbage Collection\n\tCounted targets in ".concat(r - h, "ms\n\tDetermined least recently used ").concat(s, " in ") + (o - r) + "ms\n" + "\tRemoved ".concat(i, " targets in ") + (c - o) + "ms\n" + "\tRemoved ".concat(t, " documents in ") + (a - c) + "ms\n" + "Total Duration: ".concat(a - h, "ms"));
        }

        return Pt.resolve({
          didRun: !0,
          sequenceNumbersCollected: s,
          targetsRemoved: i,
          documentsRemoved: t
        });
      });
    }
  }]);

  return qr;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Provides LRU functionality for IndexedDB persistence. */


var Kr = /*#__PURE__*/function () {
  function Kr(t, e) {
    _classCallCheck(this, Kr);

    this.db = t, this.garbageCollector = function (t, e) {
      return new qr(t, e);
    }(this, e);
  }

  _createClass(Kr, [{
    key: "Mn",
    value: function Mn(t) {
      var e = this.Bn(t);
      return this.db.getTargetCache().getTargetCount(t).next(function (t) {
        return e.next(function (e) {
          return t + e;
        });
      });
    }
  }, {
    key: "Bn",
    value: function Bn(t) {
      var e = 0;
      return this.Fn(t, function (t) {
        e++;
      }).next(function () {
        return e;
      });
    }
  }, {
    key: "forEachTarget",
    value: function forEachTarget(t, e) {
      return this.db.getTargetCache().forEachTarget(t, e);
    }
  }, {
    key: "Fn",
    value: function Fn(t, e) {
      return this.Ln(t, function (t, n) {
        return e(n);
      });
    }
  }, {
    key: "addReference",
    value: function addReference(t, e, n) {
      return Gr(t, n);
    }
  }, {
    key: "removeReference",
    value: function removeReference(t, e, n) {
      return Gr(t, n);
    }
  }, {
    key: "removeTargets",
    value: function removeTargets(t, e, n) {
      return this.db.getTargetCache().removeTargets(t, e, n);
    }
  }, {
    key: "markPotentiallyOrphaned",
    value: function markPotentiallyOrphaned(t, e) {
      return Gr(t, e);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */

  }, {
    key: "Un",
    value: function Un(t, e) {
      return function (t, e) {
        var n = !1;
        return Nr(t).Y(function (s) {
          return Dr(t, s, e).next(function (t) {
            return t && (n = !0), Pt.resolve(!t);
          });
        }).next(function () {
          return n;
        });
      }(t, e);
    }
  }, {
    key: "removeOrphanedDocuments",
    value: function removeOrphanedDocuments(t, e) {
      var _this82 = this;

      var n = this.db.getRemoteDocumentCache().newChangeBuffer(),
          s = [];
      var i = 0;
      return this.Ln(t, function (r, o) {
        if (o <= e) {
          var _e33 = _this82.Un(t, r).next(function (e) {
            if (!e) // Our size accounting requires us to read all documents before
              // removing them.
              return i++, n.getEntry(t, r).next(function () {
                return n.removeEntry(r, ct.min()), $r(t).delete([0, ci(r.path)]);
              });
          });

          s.push(_e33);
        }
      }).next(function () {
        return Pt.waitFor(s);
      }).next(function () {
        return n.apply(t);
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(t, e) {
      var n = e.withSequenceNumber(t.currentSequenceNumber);
      return this.db.getTargetCache().updateTargetData(t, n);
    }
  }, {
    key: "updateLimboDocument",
    value: function updateLimboDocument(t, e) {
      return Gr(t, e);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */

  }, {
    key: "Ln",
    value: function Ln(t, e) {
      var n = $r(t);
      var s,
          i = $t.ot;
      return n.J({
        index: "documentTargetsIndex"
      }, function (_ref13, _ref14) {
        var _ref15 = _slicedToArray(_ref13, 2),
            t = _ref15[0],
            n = _ref15[1];

        var r = _ref14.path,
            o = _ref14.sequenceNumber;
        0 === t ? ( // if nextToReport is valid, report it, this is a new key so the
        // last one must not be a member of any targets.
        i !== $t.ot && e(new dt(li(s)), i), // set nextToReport to be this sequence number. It's the next one we
        // might report, if we don't find any targets for this document.
        // Note that the sequence number must be defined when the targetId
        // is 0.
        i = o, s = r) : // set nextToReport to be invalid, we know we don't need to report
        // this one since we found a target for it.
        i = $t.ot;
      }).next(function () {
        // Since we report sequence numbers after getting to the next key, we
        // need to check if the last key we iterated over was an orphaned
        // document and report it.
        i !== $t.ot && e(new dt(li(s)), i);
      });
    }
  }, {
    key: "getCacheSize",
    value: function getCacheSize(t) {
      return this.db.getRemoteDocumentCache().getSize(t);
    }
  }]);

  return Kr;
}();

function Gr(t, e) {
  return $r(t).put(
  /**
  * @returns A value suitable for writing a sentinel row in the target-document
  * store.
  */
  function (t, e) {
    return {
      targetId: 0,
      path: ci(t.path),
      sequenceNumber: e
    };
  }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */


var Qr = /*#__PURE__*/function () {
  function Qr() {
    _classCallCheck(this, Qr);

    // A mapping of document key to the new cache entry that should be written.
    this.changes = new is(function (t) {
      return t.toString();
    }, function (t, e) {
      return t.isEqual(e);
    }), this.changesApplied = !1;
  }
  /**
   * Buffers a `RemoteDocumentCache.addEntry()` call.
   *
   * You can only modify documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */


  _createClass(Qr, [{
    key: "addEntry",
    value: function addEntry(t) {
      this.assertNotApplied(), this.changes.set(t.key, t);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */

  }, {
    key: "removeEntry",
    value: function removeEntry(t, e) {
      this.assertNotApplied(), this.changes.set(t, xe.newInvalidDocument(t).setReadTime(e));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */

  }, {
    key: "getEntry",
    value: function getEntry(t, e) {
      this.assertNotApplied();
      var n = this.changes.get(e);
      return void 0 !== n ? Pt.resolve(n) : this.getFromCache(t, e);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */

  }, {
    key: "getEntries",
    value: function getEntries(t, e) {
      return this.getAllFromCache(t, e);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */

  }, {
    key: "apply",
    value: function apply(t) {
      return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }
    /** Helper to assert this.changes is not null  */

  }, {
    key: "assertNotApplied",
    value: function assertNotApplied() {}
  }]);

  return Qr;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */


var jr = /*#__PURE__*/function () {
  function jr(t) {
    _classCallCheck(this, jr);

    this.wt = t;
  }

  _createClass(jr, [{
    key: "setIndexManager",
    value: function setIndexManager(t) {
      this.indexManager = t;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */

  }, {
    key: "addEntry",
    value: function addEntry(t, e, n) {
      return Jr(t).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */

  }, {
    key: "removeEntry",
    value: function removeEntry(t, e, n) {
      return Jr(t).delete(
      /**
      * Returns a key that can be used for document lookups via the primary key of
      * the DbRemoteDocument object store.
      */
      function (t, e) {
        var n = t.path.toArray();
        return [
        /* prefix path */
        n.slice(0, n.length - 2),
        /* collection id */
        n[n.length - 2], Gi(e),
        /* document id */
        n[n.length - 1]];
      }
      /**
      * Returns a key that can be used for document lookups on the
      * `DbRemoteDocumentDocumentCollectionGroupIndex` index.
      */
      (e, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */

  }, {
    key: "updateMetadata",
    value: function updateMetadata(t, e) {
      var _this83 = this;

      return this.getMetadata(t).next(function (n) {
        return n.byteSize += e, _this83.qn(t, n);
      });
    }
  }, {
    key: "getEntry",
    value: function getEntry(t, e) {
      var _this84 = this;

      var n = xe.newInvalidDocument(e);
      return Jr(t).J({
        index: "documentKeyIndex",
        range: IDBKeyRange.only(Yr(e))
      }, function (t, s) {
        n = _this84.Kn(e, s);
      }).next(function () {
        return n;
      });
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */

  }, {
    key: "Gn",
    value: function Gn(t, e) {
      var _this85 = this;

      var n = {
        size: 0,
        document: xe.newInvalidDocument(e)
      };
      return Jr(t).J({
        index: "documentKeyIndex",
        range: IDBKeyRange.only(Yr(e))
      }, function (t, s) {
        n = {
          document: _this85.Kn(e, s),
          size: Vr(s)
        };
      }).next(function () {
        return n;
      });
    }
  }, {
    key: "getEntries",
    value: function getEntries(t, e) {
      var _this86 = this;

      var n = os();
      return this.Qn(t, e, function (t, e) {
        var s = _this86.Kn(t, e);

        n = n.insert(t, s);
      }).next(function () {
        return n;
      });
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */

  }, {
    key: "jn",
    value: function jn(t, e) {
      var _this87 = this;

      var n = os(),
          s = new qt(dt.comparator);
      return this.Qn(t, e, function (t, e) {
        var i = _this87.Kn(t, e);

        n = n.insert(t, i), s = s.insert(t, Vr(e));
      }).next(function () {
        return {
          documents: n,
          Wn: s
        };
      });
    }
  }, {
    key: "Qn",
    value: function Qn(t, e, n) {
      if (e.isEmpty()) return Pt.resolve();
      var s = new Qt(Zr);
      e.forEach(function (t) {
        return s = s.add(t);
      });
      var i = IDBKeyRange.bound(Yr(s.first()), Yr(s.last())),
          r = s.getIterator();
      var o = r.getNext();
      return Jr(t).J({
        index: "documentKeyIndex",
        range: i
      }, function (t, e, s) {
        var i = dt.fromSegments([].concat(_toConsumableArray(e.prefixPath), [e.collectionGroup, e.documentId])); // Go through keys not found in cache.

        for (; o && Zr(o, i) < 0;) {
          n(o, null), o = r.getNext();
        }

        o && o.isEqual(i) && ( // Key found in cache.
        n(o, e), o = r.hasNext() ? r.getNext() : null), // Skip to the next key (if there is one).
        o ? s.q(Yr(o)) : s.done();
      }).next(function () {
        // The rest of the keys are not in the cache. One case where `iterate`
        // above won't go through them is when the cache is empty.
        for (; o;) {
          n(o, null), o = r.hasNext() ? r.getNext() : null;
        }
      });
    }
  }, {
    key: "getAllFromCollection",
    value: function getAllFromCollection(t, e, n) {
      var _this88 = this;

      var s = [e.popLast().toArray(), e.lastSegment(), Gi(n.readTime), n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()],
          i = [e.popLast().toArray(), e.lastSegment(), [Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER], ""];
      return Jr(t).K(IDBKeyRange.bound(s, i, !0)).next(function (t) {
        var e = os();

        var _iterator52 = _createForOfIteratorHelper(t),
            _step52;

        try {
          for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
            var _n23 = _step52.value;

            var _t69 = _this88.Kn(dt.fromSegments(_n23.prefixPath.concat(_n23.collectionGroup, _n23.documentId)), _n23);

            e = e.insert(_t69.key, _t69);
          }
        } catch (err) {
          _iterator52.e(err);
        } finally {
          _iterator52.f();
        }

        return e;
      });
    }
  }, {
    key: "getAllFromCollectionGroup",
    value: function getAllFromCollectionGroup(t, e, n, s) {
      var _this89 = this;

      var i = os();
      var r = Xr(e, n),
          o = Xr(e, Tt.max());
      return Jr(t).J({
        index: "collectionGroupIndex",
        range: IDBKeyRange.bound(r, o, !0)
      }, function (t, e, n) {
        var r = _this89.Kn(dt.fromSegments(e.prefixPath.concat(e.collectionGroup, e.documentId)), e);

        i = i.insert(r.key, r), i.size === s && n.done();
      }).next(function () {
        return i;
      });
    }
  }, {
    key: "newChangeBuffer",
    value: function newChangeBuffer(t) {
      return new zr(this, !!t && t.trackRemovals);
    }
  }, {
    key: "getSize",
    value: function getSize(t) {
      return this.getMetadata(t).next(function (t) {
        return t.byteSize;
      });
    }
  }, {
    key: "getMetadata",
    value: function getMetadata(t) {
      return Hr(t).get("remoteDocumentGlobalKey").next(function (t) {
        return U(!!t), t;
      });
    }
  }, {
    key: "qn",
    value: function qn(t, e) {
      return Hr(t).put("remoteDocumentGlobalKey", e);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */

  }, {
    key: "Kn",
    value: function Kn(t, e) {
      if (e) {
        var _t70 = qi(this.wt, e); // Whether the document is a sentinel removal and should only be used in the
        // `getNewDocumentChanges()`


        if (!(_t70.isNoDocument() && _t70.version.isEqual(ct.min()))) return _t70;
      }

      return xe.newInvalidDocument(t);
    }
  }]);

  return jr;
}();
/** Creates a new IndexedDbRemoteDocumentCache. */


function Wr(t) {
  return new jr(t);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */


var zr = /*#__PURE__*/function (_Qr) {
  _inherits(zr, _Qr);

  var _super22 = _createSuper(zr);

  /**
   * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
   * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
   * `getNewDocumentChanges()`.
   */
  function zr(t, e) {
    var _this90;

    _classCallCheck(this, zr);

    _this90 = _super22.call(this), _this90.zn = t, _this90.trackRemovals = e, // A map of document sizes and read times prior to applying the changes in
    // this buffer.
    _this90.Hn = new is(function (t) {
      return t.toString();
    }, function (t, e) {
      return t.isEqual(e);
    });
    return _this90;
  }

  _createClass(zr, [{
    key: "applyChanges",
    value: function applyChanges(t) {
      var _this91 = this;

      var e = [];
      var n = 0,
          s = new Qt(function (t, e) {
        return it(t.canonicalString(), e.canonicalString());
      });
      return this.changes.forEach(function (i, r) {
        var o = _this91.Hn.get(i);

        if (e.push(_this91.zn.removeEntry(t, i, o.readTime)), r.isValidDocument()) {
          var u = Ki(_this91.zn.wt, r);
          s = s.add(i.path.popLast());
          var c = Vr(u);
          n += c - o.size, e.push(_this91.zn.addEntry(t, i, u));
        } else if (n -= o.size, _this91.trackRemovals) {
          // In order to track removals, we store a "sentinel delete" in the
          // RemoteDocumentCache. This entry is represented by a NoDocument
          // with a version of 0 and ignored by `maybeDecodeDocument()` but
          // preserved in `getNewDocumentChanges()`.
          var _n24 = Ki(_this91.zn.wt, r.convertToNoDocument(ct.min()));

          e.push(_this91.zn.addEntry(t, i, _n24));
        }
      }), s.forEach(function (n) {
        e.push(_this91.zn.indexManager.addToCollectionParentIndex(t, n));
      }), e.push(this.zn.updateMetadata(t, n)), Pt.waitFor(e);
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(t, e) {
      var _this92 = this;

      // Record the size of everything we load from the cache so we can compute a delta later.
      return this.zn.Gn(t, e).next(function (t) {
        return _this92.Hn.set(e, {
          size: t.size,
          readTime: t.document.readTime
        }), t.document;
      });
    }
  }, {
    key: "getAllFromCache",
    value: function getAllFromCache(t, e) {
      var _this93 = this;

      // Record the size of everything we load from the cache so we can compute
      // a delta later.
      return this.zn.jn(t, e).next(function (_ref16) {
        var t = _ref16.documents,
            e = _ref16.Wn;
        return (// Note: `getAllFromCache` returns two maps instead of a single map from
          // keys to `DocumentSizeEntry`s. This is to allow returning the
          // `MutableDocumentMap` directly, without a conversion.
          e.forEach(function (e, n) {
            _this93.Hn.set(e, {
              size: n,
              readTime: t.get(e).readTime
            });
          }), t
        );
      });
    }
  }]);

  return zr;
}(Qr);

function Hr(t) {
  return Mi(t, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */


function Jr(t) {
  return Mi(t, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */


function Yr(t) {
  var e = t.path.toArray();
  return [
  /* prefix path */
  e.slice(0, e.length - 2),
  /* collection id */
  e[e.length - 2],
  /* document id */
  e[e.length - 1]];
}

function Xr(t, e) {
  var n = e.documentKey.path.toArray();
  return [
  /* collection id */
  t, Gi(e.readTime),
  /* prefix path */
  n.slice(0, n.length - 2),
  /* document id */
  n.length > 0 ? n[n.length - 1] : ""];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */


function Zr(t, e) {
  var n = t.path.toArray(),
      s = e.path.toArray(); // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74

  var i = 0;

  for (var _t71 = 0; _t71 < n.length - 2 && _t71 < s.length - 2; ++_t71) {
    if (i = it(n[_t71], s[_t71]), i) return i;
  }

  return i = it(n.length, s.length), i || (i = it(n[n.length - 2], s[s.length - 2]), i || it(n[n.length - 1], s[s.length - 1]));
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */


var to = /*#__PURE__*/_createClass(function to(t,
/**
 * The fields that are locally mutated by patch mutations. If the overlayed
 * document is from set or delete mutations, this returns null.
 */
e) {
  _classCallCheck(this, to);

  this.overlayedDocument = t, this.mutatedFields = e;
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */


var eo = /*#__PURE__*/function () {
  function eo(t, e, n, s) {
    _classCallCheck(this, eo);

    this.remoteDocumentCache = t, this.mutationQueue = e, this.documentOverlayCache = n, this.indexManager = s;
  }
  /**
   * Get the local view of the document identified by `key`.
   *
   * @returns Local view of the document or null if we don't have any cached
   * state for it.
   */


  _createClass(eo, [{
    key: "getDocument",
    value: function getDocument(t, e) {
      var _this94 = this;

      var n = null;
      return this.documentOverlayCache.getOverlay(t, e).next(function (s) {
        return n = s, _this94.getBaseDocument(t, e, n);
      }).next(function (t) {
        return null !== n && Kn(n.mutation, t, zt.empty(), ut.now()), t;
      });
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */

  }, {
    key: "getDocuments",
    value: function getDocuments(t, e) {
      var _this95 = this;

      return this.remoteDocumentCache.getEntries(t, e).next(function (e) {
        return _this95.getLocalViewOfDocuments(t, e, ws()).next(function () {
          return e;
        });
      });
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */

  }, {
    key: "getLocalViewOfDocuments",
    value: function getLocalViewOfDocuments(t, e) {
      var _this96 = this;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ws();
      var s = hs();
      return this.populateOverlays(t, s, e).next(function () {
        return _this96.computeViews(t, e, s, n).next(function (t) {
          var e = cs();
          return t.forEach(function (t, n) {
            e = e.insert(t, n.overlayedDocument);
          }), e;
        });
      });
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */

  }, {
    key: "getOverlayedDocuments",
    value: function getOverlayedDocuments(t, e) {
      var _this97 = this;

      var n = hs();
      return this.populateOverlays(t, n, e).next(function () {
        return _this97.computeViews(t, e, n, ws());
      });
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */

  }, {
    key: "populateOverlays",
    value: function populateOverlays(t, e, n) {
      var s = [];
      return n.forEach(function (t) {
        e.has(t) || s.push(t);
      }), this.documentOverlayCache.getOverlays(t, s).next(function (t) {
        t.forEach(function (t, n) {
          e.set(t, n);
        });
      });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */

  }, {
    key: "computeViews",
    value: function computeViews(t, e, n, s) {
      var i = os();
      var r = fs(),
          o = fs();
      return e.forEach(function (t, e) {
        var o = n.get(e.key); // Recalculate an overlay if the document's existence state changed due to
        // a remote event *and* the overlay is a PatchMutation. This is because
        // document existence state can change if some patch mutation's
        // preconditions are met.
        // NOTE: we recalculate when `overlay` is undefined as well, because there
        // might be a patch mutation whose precondition does not match before the
        // change (hence overlay is undefined), but would now match.

        s.has(e.key) && (void 0 === o || o.mutation instanceof Wn) ? i = i.insert(e.key, e) : void 0 !== o && (r.set(e.key, o.mutation.getFieldMask()), Kn(o.mutation, e, o.mutation.getFieldMask(), ut.now()));
      }), this.recalculateAndSaveOverlays(t, i).next(function (t) {
        return t.forEach(function (t, e) {
          return r.set(t, e);
        }), e.forEach(function (t, e) {
          var n;
          return o.set(t, new to(e, null !== (n = r.get(t)) && void 0 !== n ? n : null));
        }), o;
      });
    }
  }, {
    key: "recalculateAndSaveOverlays",
    value: function recalculateAndSaveOverlays(t, e) {
      var _this98 = this;

      var n = fs(); // A reverse lookup map from batch id to the documents within that batch.

      var s = new qt(function (t, e) {
        return t - e;
      }),
          i = ws();
      return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, e).next(function (t) {
        var _iterator53 = _createForOfIteratorHelper(t),
            _step53;

        try {
          var _loop6 = function _loop6() {
            var i = _step53.value;
            i.keys().forEach(function (t) {
              var r = e.get(t);
              if (null === r) return;
              var o = n.get(t) || zt.empty();
              o = i.applyToLocalView(r, o), n.set(t, o);
              var u = (s.get(i.batchId) || ws()).add(t);
              s = s.insert(i.batchId, u);
            });
          };

          for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
            _loop6();
          }
        } catch (err) {
          _iterator53.e(err);
        } finally {
          _iterator53.f();
        }
      }).next(function () {
        var r = [],
            o = s.getReverseIterator(); // Iterate in descending order of batch IDs, and skip documents that are
        // already saved.

        var _loop7 = function _loop7() {
          var s = o.getNext(),
              u = s.key,
              c = s.value,
              a = ls();
          c.forEach(function (t) {
            if (!i.has(t)) {
              var _s18 = Un(e.get(t), n.get(t));

              null !== _s18 && a.set(t, _s18), i = i.add(t);
            }
          }), r.push(_this98.documentOverlayCache.saveOverlays(t, u, a));
        };

        for (; o.hasNext();) {
          _loop7();
        }

        return Pt.waitFor(r);
      }).next(function () {
        return n;
      });
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */

  }, {
    key: "recalculateAndSaveOverlaysForDocumentKeys",
    value: function recalculateAndSaveOverlaysForDocumentKeys(t, e) {
      var _this99 = this;

      return this.remoteDocumentCache.getEntries(t, e).next(function (e) {
        return _this99.recalculateAndSaveOverlays(t, e);
      });
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */

  }, {
    key: "getDocumentsMatchingQuery",
    value: function getDocumentsMatchingQuery(t, e, n) {
      /**
      * Returns whether the query matches a single document by path (rather than a
      * collection).
      */
      return function (t) {
        return dt.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
      }(e) ? this.getDocumentsMatchingDocumentQuery(t, e.path) : an(e) ? this.getDocumentsMatchingCollectionGroupQuery(t, e, n) : this.getDocumentsMatchingCollectionQuery(t, e, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */

  }, {
    key: "getNextDocuments",
    value: function getNextDocuments(t, e, n, s) {
      var _this100 = this;

      return this.remoteDocumentCache.getAllFromCollectionGroup(t, e, n, s).next(function (i) {
        var r = s - i.size > 0 ? _this100.documentOverlayCache.getOverlaysForCollectionGroup(t, e, n.largestBatchId, s - i.size) : Pt.resolve(hs()); // The callsite will use the largest batch ID together with the latest read time to create
        // a new index offset. Since we only process batch IDs if all remote documents have been read,
        // no overlay will increase the overall read time. This is why we only need to special case
        // the batch id.

        var o = -1,
            u = i;
        return r.next(function (e) {
          return Pt.forEach(e, function (e, n) {
            return o < n.largestBatchId && (o = n.largestBatchId), i.get(e) ? Pt.resolve() : _this100.getBaseDocument(t, e, n).next(function (t) {
              u = u.insert(e, t);
            });
          }).next(function () {
            return _this100.populateOverlays(t, e, i);
          }).next(function () {
            return _this100.computeViews(t, u, e, ws());
          }).next(function (t) {
            return {
              batchId: o,
              changes: as(t)
            };
          });
        });
      });
    }
  }, {
    key: "getDocumentsMatchingDocumentQuery",
    value: function getDocumentsMatchingDocumentQuery(t, e) {
      // Just do a simple document lookup.
      return this.getDocument(t, new dt(e)).next(function (t) {
        var e = cs();
        return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
      });
    }
  }, {
    key: "getDocumentsMatchingCollectionGroupQuery",
    value: function getDocumentsMatchingCollectionGroupQuery(t, e, n) {
      var _this101 = this;

      var s = e.collectionGroup;
      var i = cs();
      return this.indexManager.getCollectionParents(t, s).next(function (r) {
        return Pt.forEach(r, function (r) {
          var o = function (t, e) {
            return new nn(e,
            /*collectionGroup=*/
            null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
          }(e, r.child(s));

          return _this101.getDocumentsMatchingCollectionQuery(t, o, n).next(function (t) {
            t.forEach(function (t, e) {
              i = i.insert(t, e);
            });
          });
        }).next(function () {
          return i;
        });
      });
    }
  }, {
    key: "getDocumentsMatchingCollectionQuery",
    value: function getDocumentsMatchingCollectionQuery(t, e, n) {
      var _this102 = this;

      // Query the remote documents and overlay mutations.
      var s;
      return this.remoteDocumentCache.getAllFromCollection(t, e.path, n).next(function (i) {
        return s = i, _this102.documentOverlayCache.getOverlaysForCollection(t, e.path, n.largestBatchId);
      }).next(function (t) {
        // As documents might match the query because of their overlay we need to
        // include documents for all overlays in the initial document set.
        t.forEach(function (t, e) {
          var n = e.getKey();
          null === s.get(n) && (s = s.insert(n, xe.newInvalidDocument(n)));
        }); // Apply the overlays and match against the query.

        var n = cs();
        return s.forEach(function (s, i) {
          var r = t.get(s);
          void 0 !== r && Kn(r.mutation, i, zt.empty(), ut.now()), // Finally, insert the documents that still match the query
          mn(e, i) && (n = n.insert(s, i));
        }), n;
      });
    }
    /** Returns a base document that can be used to apply `overlay`. */

  }, {
    key: "getBaseDocument",
    value: function getBaseDocument(t, e, n) {
      return null === n || 1
      /* Patch */
      === n.mutation.type ? this.remoteDocumentCache.getEntry(t, e) : Pt.resolve(xe.newInvalidDocument(e));
    }
  }]);

  return eo;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var no = /*#__PURE__*/function () {
  function no(t) {
    _classCallCheck(this, no);

    this.wt = t, this.Jn = new Map(), this.Yn = new Map();
  }

  _createClass(no, [{
    key: "getBundleMetadata",
    value: function getBundleMetadata(t, e) {
      return Pt.resolve(this.Jn.get(e));
    }
  }, {
    key: "saveBundleMetadata",
    value: function saveBundleMetadata(t, e) {
      /** Decodes a BundleMetadata proto into a BundleMetadata object. */
      var n;
      return this.Jn.set(e.id, {
        id: (n = e).id,
        version: n.version,
        createTime: Ns(n.createTime)
      }), Pt.resolve();
    }
  }, {
    key: "getNamedQuery",
    value: function getNamedQuery(t, e) {
      return Pt.resolve(this.Yn.get(e));
    }
  }, {
    key: "saveNamedQuery",
    value: function saveNamedQuery(t, e) {
      return this.Yn.set(e.name, function (t) {
        return {
          name: t.name,
          query: Ji(t.bundledQuery),
          readTime: Ns(t.readTime)
        };
      }(e)), Pt.resolve();
    }
  }]);

  return no;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An in-memory implementation of DocumentOverlayCache.
 */


var so = /*#__PURE__*/function () {
  function so() {
    _classCallCheck(this, so);

    // A map sorted by DocumentKey, whose value is a pair of the largest batch id
    // for the overlay and the overlay itself.
    this.overlays = new qt(dt.comparator), this.Xn = new Map();
  }

  _createClass(so, [{
    key: "getOverlay",
    value: function getOverlay(t, e) {
      return Pt.resolve(this.overlays.get(e));
    }
  }, {
    key: "getOverlays",
    value: function getOverlays(t, e) {
      var _this103 = this;

      var n = hs();
      return Pt.forEach(e, function (e) {
        return _this103.getOverlay(t, e).next(function (t) {
          null !== t && n.set(e, t);
        });
      }).next(function () {
        return n;
      });
    }
  }, {
    key: "saveOverlays",
    value: function saveOverlays(t, e, n) {
      var _this104 = this;

      return n.forEach(function (n, s) {
        _this104.ie(t, e, s);
      }), Pt.resolve();
    }
  }, {
    key: "removeOverlaysForBatchId",
    value: function removeOverlaysForBatchId(t, e, n) {
      var _this105 = this;

      var s = this.Xn.get(n);
      return void 0 !== s && (s.forEach(function (t) {
        return _this105.overlays = _this105.overlays.remove(t);
      }), this.Xn.delete(n)), Pt.resolve();
    }
  }, {
    key: "getOverlaysForCollection",
    value: function getOverlaysForCollection(t, e, n) {
      var s = hs(),
          i = e.length + 1,
          r = new dt(e.child("")),
          o = this.overlays.getIteratorFrom(r);

      for (; o.hasNext();) {
        var _t72 = o.getNext().value,
            _r6 = _t72.getKey();

        if (!e.isPrefixOf(_r6.path)) break; // Documents from sub-collections

        _r6.path.length === i && _t72.largestBatchId > n && s.set(_t72.getKey(), _t72);
      }

      return Pt.resolve(s);
    }
  }, {
    key: "getOverlaysForCollectionGroup",
    value: function getOverlaysForCollectionGroup(t, e, n, s) {
      var i = new qt(function (t, e) {
        return t - e;
      });
      var r = this.overlays.getIterator();

      for (; r.hasNext();) {
        var _t73 = r.getNext().value;

        if (_t73.getKey().getCollectionGroup() === e && _t73.largestBatchId > n) {
          var _e34 = i.get(_t73.largestBatchId);

          null === _e34 && (_e34 = hs(), i = i.insert(_t73.largestBatchId, _e34)), _e34.set(_t73.getKey(), _t73);
        }
      }

      var o = hs(),
          u = i.getIterator();

      for (; u.hasNext();) {
        if (u.getNext().value.forEach(function (t, e) {
          return o.set(t, e);
        }), o.size() >= s) break;
      }

      return Pt.resolve(o);
    }
  }, {
    key: "ie",
    value: function ie(t, e, n) {
      // Remove the association of the overlay to its batch id.
      var s = this.overlays.get(n.key);

      if (null !== s) {
        var _t74 = this.Xn.get(s.largestBatchId).delete(n.key);

        this.Xn.set(s.largestBatchId, _t74);
      }

      this.overlays = this.overlays.insert(n.key, new Bi(e, n)); // Create the association of this overlay to the given largestBatchId.

      var i = this.Xn.get(e);
      void 0 === i && (i = ws(), this.Xn.set(e, i)), this.Xn.set(e, i.add(n.key));
    }
  }]);

  return so;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */


var io = /*#__PURE__*/function () {
  function io() {
    _classCallCheck(this, io);

    // A set of outstanding references to a document sorted by key.
    this.Zn = new Qt(ro.ts), // A set of outstanding references to a document sorted by target id.
    this.es = new Qt(ro.ns);
  }
  /** Returns true if the reference set contains no references. */


  _createClass(io, [{
    key: "isEmpty",
    value: function isEmpty() {
      return this.Zn.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */

  }, {
    key: "addReference",
    value: function addReference(t, e) {
      var n = new ro(t, e);
      this.Zn = this.Zn.add(n), this.es = this.es.add(n);
    }
    /** Add references to the given document keys for the given ID. */

  }, {
    key: "ss",
    value: function ss(t, e) {
      var _this106 = this;

      t.forEach(function (t) {
        return _this106.addReference(t, e);
      });
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */

  }, {
    key: "removeReference",
    value: function removeReference(t, e) {
      this.rs(new ro(t, e));
    }
  }, {
    key: "os",
    value: function os(t, e) {
      var _this107 = this;

      t.forEach(function (t) {
        return _this107.removeReference(t, e);
      });
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */

  }, {
    key: "us",
    value: function us(t) {
      var _this108 = this;

      var e = new dt(new ht([])),
          n = new ro(e, t),
          s = new ro(e, t + 1),
          i = [];
      return this.es.forEachInRange([n, s], function (t) {
        _this108.rs(t), i.push(t.key);
      }), i;
    }
  }, {
    key: "cs",
    value: function cs() {
      var _this109 = this;

      this.Zn.forEach(function (t) {
        return _this109.rs(t);
      });
    }
  }, {
    key: "rs",
    value: function rs(t) {
      this.Zn = this.Zn.delete(t), this.es = this.es.delete(t);
    }
  }, {
    key: "hs",
    value: function hs(t) {
      var e = new dt(new ht([])),
          n = new ro(e, t),
          s = new ro(e, t + 1);
      var i = ws();
      return this.es.forEachInRange([n, s], function (t) {
        i = i.add(t.key);
      }), i;
    }
  }, {
    key: "containsKey",
    value: function containsKey(t) {
      var e = new ro(t, 0),
          n = this.Zn.firstAfterOrEqual(e);
      return null !== n && t.isEqual(n.key);
    }
  }]);

  return io;
}();

var ro = /*#__PURE__*/function () {
  function ro(t, e) {
    _classCallCheck(this, ro);

    this.key = t, this.ls = e;
  }
  /** Compare by key then by ID */


  _createClass(ro, null, [{
    key: "ts",
    value: function ts(t, e) {
      return dt.comparator(t.key, e.key) || it(t.ls, e.ls);
    }
    /** Compare by ID then by key */

  }, {
    key: "ns",
    value: function ns(t, e) {
      return it(t.ls, e.ls) || dt.comparator(t.key, e.key);
    }
  }]);

  return ro;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var oo = /*#__PURE__*/function () {
  function oo(t, e) {
    _classCallCheck(this, oo);

    this.indexManager = t, this.referenceDelegate = e,
    /**
     * The set of all mutations that have been sent but not yet been applied to
     * the backend.
     */
    this.mutationQueue = [],
    /** Next value to use when assigning sequential IDs to each mutation batch. */
    this.fs = 1,
    /** An ordered mapping between documents and the mutations batch IDs. */
    this.ds = new Qt(ro.ts);
  }

  _createClass(oo, [{
    key: "checkEmpty",
    value: function checkEmpty(t) {
      return Pt.resolve(0 === this.mutationQueue.length);
    }
  }, {
    key: "addMutationBatch",
    value: function addMutationBatch(t, e, n, s) {
      var i = this.fs;
      this.fs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
      var r = new Fi(i, e, n, s);
      this.mutationQueue.push(r); // Track references by document key and index collection parents.

      var _iterator54 = _createForOfIteratorHelper(s),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var _e35 = _step54.value;
          this.ds = this.ds.add(new ro(_e35.key, i)), this.indexManager.addToCollectionParentIndex(t, _e35.key.path.popLast());
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }

      return Pt.resolve(r);
    }
  }, {
    key: "lookupMutationBatch",
    value: function lookupMutationBatch(t, e) {
      return Pt.resolve(this._s(e));
    }
  }, {
    key: "getNextMutationBatchAfterBatchId",
    value: function getNextMutationBatchAfterBatchId(t, e) {
      var n = e + 1,
          s = this.ws(n),
          i = s < 0 ? 0 : s; // The requested batchId may still be out of range so normalize it to the
      // start of the queue.

      return Pt.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
  }, {
    key: "getHighestUnacknowledgedBatchId",
    value: function getHighestUnacknowledgedBatchId() {
      return Pt.resolve(0 === this.mutationQueue.length ? -1 : this.fs - 1);
    }
  }, {
    key: "getAllMutationBatches",
    value: function getAllMutationBatches(t) {
      return Pt.resolve(this.mutationQueue.slice());
    }
  }, {
    key: "getAllMutationBatchesAffectingDocumentKey",
    value: function getAllMutationBatchesAffectingDocumentKey(t, e) {
      var _this110 = this;

      var n = new ro(e, 0),
          s = new ro(e, Number.POSITIVE_INFINITY),
          i = [];
      return this.ds.forEachInRange([n, s], function (t) {
        var e = _this110._s(t.ls);

        i.push(e);
      }), Pt.resolve(i);
    }
  }, {
    key: "getAllMutationBatchesAffectingDocumentKeys",
    value: function getAllMutationBatchesAffectingDocumentKeys(t, e) {
      var _this111 = this;

      var n = new Qt(it);
      return e.forEach(function (t) {
        var e = new ro(t, 0),
            s = new ro(t, Number.POSITIVE_INFINITY);

        _this111.ds.forEachInRange([e, s], function (t) {
          n = n.add(t.ls);
        });
      }), Pt.resolve(this.gs(n));
    }
  }, {
    key: "getAllMutationBatchesAffectingQuery",
    value: function getAllMutationBatchesAffectingQuery(t, e) {
      // Use the query path as a prefix for testing if a document matches the
      // query.
      var n = e.path,
          s = n.length + 1; // Construct a document reference for actually scanning the index. Unlike
      // the prefix the document key in this reference must have an even number of
      // segments. The empty segment can be used a suffix of the query path
      // because it precedes all other segments in an ordered traversal.

      var i = n;
      dt.isDocumentKey(i) || (i = i.child(""));
      var r = new ro(new dt(i), 0); // Find unique batchIDs referenced by all documents potentially matching the
      // query.

      var o = new Qt(it);
      return this.ds.forEachWhile(function (t) {
        var e = t.key.path;
        return !!n.isPrefixOf(e) && ( // Rows with document keys more than one segment longer than the query
        // path can't be matches. For example, a query on 'rooms' can't match
        // the document /rooms/abc/messages/xyx.
        // TODO(mcg): we'll need a different scanner when we implement
        // ancestor queries.
        e.length === s && (o = o.add(t.ls)), !0);
      }, r), Pt.resolve(this.gs(o));
    }
  }, {
    key: "gs",
    value: function gs(t) {
      var _this112 = this;

      // Construct an array of matching batches, sorted by batchID to ensure that
      // multiple mutations affecting the same document key are applied in order.
      var e = [];
      return t.forEach(function (t) {
        var n = _this112._s(t);

        null !== n && e.push(n);
      }), e;
    }
  }, {
    key: "removeMutationBatch",
    value: function removeMutationBatch(t, e) {
      var _this113 = this;

      U(0 === this.ys(e.batchId, "removed")), this.mutationQueue.shift();
      var n = this.ds;
      return Pt.forEach(e.mutations, function (s) {
        var i = new ro(s.key, e.batchId);
        return n = n.delete(i), _this113.referenceDelegate.markPotentiallyOrphaned(t, s.key);
      }).next(function () {
        _this113.ds = n;
      });
    }
  }, {
    key: "In",
    value: function In(t) {// No-op since the memory mutation queue does not maintain a separate cache.
    }
  }, {
    key: "containsKey",
    value: function containsKey(t, e) {
      var n = new ro(e, 0),
          s = this.ds.firstAfterOrEqual(n);
      return Pt.resolve(e.isEqual(s && s.key));
    }
  }, {
    key: "performConsistencyCheck",
    value: function performConsistencyCheck(t) {
      return this.mutationQueue.length, Pt.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */

  }, {
    key: "ys",
    value: function ys(t, e) {
      return this.ws(t);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */

  }, {
    key: "ws",
    value: function ws(t) {
      if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0; // Examine the front of the queue to figure out the difference between the
      // batchId and indexes in the array. Note that since the queue is ordered
      // by batchId, if the first batch has a larger batchId then the requested
      // batchId doesn't exist in the queue.

      return t - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */

  }, {
    key: "_s",
    value: function _s(t) {
      var e = this.ws(t);
      if (e < 0 || e >= this.mutationQueue.length) return null;
      return this.mutationQueue[e];
    }
  }]);

  return oo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */


var uo = /*#__PURE__*/function () {
  /**
   * @param sizer - Used to assess the size of a document. For eager GC, this is
   * expected to just return 0 to avoid unnecessarily doing the work of
   * calculating the size.
   */
  function uo(t) {
    _classCallCheck(this, uo);

    this.ps = t,
    /** Underlying cache of documents and their read times. */
    this.docs = new qt(dt.comparator),
    /** Size of all cached documents. */
    this.size = 0;
  }

  _createClass(uo, [{
    key: "setIndexManager",
    value: function setIndexManager(t) {
      this.indexManager = t;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */

  }, {
    key: "addEntry",
    value: function addEntry(t, e) {
      var n = e.key,
          s = this.docs.get(n),
          i = s ? s.size : 0,
          r = this.ps(e);
      return this.docs = this.docs.insert(n, {
        document: e.mutableCopy(),
        size: r
      }), this.size += r - i, this.indexManager.addToCollectionParentIndex(t, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */

  }, {
    key: "removeEntry",
    value: function removeEntry(t) {
      var e = this.docs.get(t);
      e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }
  }, {
    key: "getEntry",
    value: function getEntry(t, e) {
      var n = this.docs.get(e);
      return Pt.resolve(n ? n.document.mutableCopy() : xe.newInvalidDocument(e));
    }
  }, {
    key: "getEntries",
    value: function getEntries(t, e) {
      var _this114 = this;

      var n = os();
      return e.forEach(function (t) {
        var e = _this114.docs.get(t);

        n = n.insert(t, e ? e.document.mutableCopy() : xe.newInvalidDocument(t));
      }), Pt.resolve(n);
    }
  }, {
    key: "getAllFromCollection",
    value: function getAllFromCollection(t, e, n) {
      var s = os(); // Documents are ordered by key, so we can use a prefix scan to narrow down
      // the documents we need to match the query against.

      var i = new dt(e.child("")),
          r = this.docs.getIteratorFrom(i);

      for (; r.hasNext();) {
        var _r$getNext = r.getNext(),
            _t75 = _r$getNext.key,
            _i14 = _r$getNext.value.document;

        if (!e.isPrefixOf(_t75.path)) break;
        _t75.path.length > e.length + 1 || Et(It(_i14), n) <= 0 || (s = s.insert(_i14.key, _i14.mutableCopy()));
      }

      return Pt.resolve(s);
    }
  }, {
    key: "getAllFromCollectionGroup",
    value: function getAllFromCollectionGroup(t, e, n, s) {
      // This method should only be called from the IndexBackfiller if persistence
      // is enabled.
      L();
    }
  }, {
    key: "Is",
    value: function Is(t, e) {
      return Pt.forEach(this.docs, function (t) {
        return e(t);
      });
    }
  }, {
    key: "newChangeBuffer",
    value: function newChangeBuffer(t) {
      // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
      // a separate changelog and does not need special handling for removals.
      return new co(this);
    }
  }, {
    key: "getSize",
    value: function getSize(t) {
      return Pt.resolve(this.size);
    }
  }]);

  return uo;
}();
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */

/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */


var co = /*#__PURE__*/function (_Qr2) {
  _inherits(co, _Qr2);

  var _super23 = _createSuper(co);

  function co(t) {
    var _this115;

    _classCallCheck(this, co);

    _this115 = _super23.call(this), _this115.zn = t;
    return _this115;
  }

  _createClass(co, [{
    key: "applyChanges",
    value: function applyChanges(t) {
      var _this116 = this;

      var e = [];
      return this.changes.forEach(function (n, s) {
        s.isValidDocument() ? e.push(_this116.zn.addEntry(t, s)) : _this116.zn.removeEntry(n);
      }), Pt.waitFor(e);
    }
  }, {
    key: "getFromCache",
    value: function getFromCache(t, e) {
      return this.zn.getEntry(t, e);
    }
  }, {
    key: "getAllFromCache",
    value: function getAllFromCache(t, e) {
      return this.zn.getEntries(t, e);
    }
  }]);

  return co;
}(Qr);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ao = /*#__PURE__*/function () {
  function ao(t) {
    _classCallCheck(this, ao);

    this.persistence = t,
    /**
     * Maps a target to the data about that target
     */
    this.Ts = new is(function (t) {
      return Oe(t);
    }, Fe),
    /** The last received snapshot version. */
    this.lastRemoteSnapshotVersion = ct.min(),
    /** The highest numbered target ID encountered. */
    this.highestTargetId = 0,
    /** The highest sequence number encountered. */
    this.Es = 0,
    /**
     * A ordered bidirectional mapping between documents and the remote target
     * IDs.
     */
    this.As = new io(), this.targetCount = 0, this.Rs = kr.An();
  }

  _createClass(ao, [{
    key: "forEachTarget",
    value: function forEachTarget(t, e) {
      return this.Ts.forEach(function (t, n) {
        return e(n);
      }), Pt.resolve();
    }
  }, {
    key: "getLastRemoteSnapshotVersion",
    value: function getLastRemoteSnapshotVersion(t) {
      return Pt.resolve(this.lastRemoteSnapshotVersion);
    }
  }, {
    key: "getHighestSequenceNumber",
    value: function getHighestSequenceNumber(t) {
      return Pt.resolve(this.Es);
    }
  }, {
    key: "allocateTargetId",
    value: function allocateTargetId(t) {
      return this.highestTargetId = this.Rs.next(), Pt.resolve(this.highestTargetId);
    }
  }, {
    key: "setTargetsMetadata",
    value: function setTargetsMetadata(t, e, n) {
      return n && (this.lastRemoteSnapshotVersion = n), e > this.Es && (this.Es = e), Pt.resolve();
    }
  }, {
    key: "vn",
    value: function vn(t) {
      this.Ts.set(t.target, t);
      var e = t.targetId;
      e > this.highestTargetId && (this.Rs = new kr(e), this.highestTargetId = e), t.sequenceNumber > this.Es && (this.Es = t.sequenceNumber);
    }
  }, {
    key: "addTargetData",
    value: function addTargetData(t, e) {
      return this.vn(e), this.targetCount += 1, Pt.resolve();
    }
  }, {
    key: "updateTargetData",
    value: function updateTargetData(t, e) {
      return this.vn(e), Pt.resolve();
    }
  }, {
    key: "removeTargetData",
    value: function removeTargetData(t, e) {
      return this.Ts.delete(e.target), this.As.us(e.targetId), this.targetCount -= 1, Pt.resolve();
    }
  }, {
    key: "removeTargets",
    value: function removeTargets(t, e, n) {
      var _this117 = this;

      var s = 0;
      var i = [];
      return this.Ts.forEach(function (r, o) {
        o.sequenceNumber <= e && null === n.get(o.targetId) && (_this117.Ts.delete(r), i.push(_this117.removeMatchingKeysForTargetId(t, o.targetId)), s++);
      }), Pt.waitFor(i).next(function () {
        return s;
      });
    }
  }, {
    key: "getTargetCount",
    value: function getTargetCount(t) {
      return Pt.resolve(this.targetCount);
    }
  }, {
    key: "getTargetData",
    value: function getTargetData(t, e) {
      var n = this.Ts.get(e) || null;
      return Pt.resolve(n);
    }
  }, {
    key: "addMatchingKeys",
    value: function addMatchingKeys(t, e, n) {
      return this.As.ss(e, n), Pt.resolve();
    }
  }, {
    key: "removeMatchingKeys",
    value: function removeMatchingKeys(t, e, n) {
      this.As.os(e, n);
      var s = this.persistence.referenceDelegate,
          i = [];
      return s && e.forEach(function (e) {
        i.push(s.markPotentiallyOrphaned(t, e));
      }), Pt.waitFor(i);
    }
  }, {
    key: "removeMatchingKeysForTargetId",
    value: function removeMatchingKeysForTargetId(t, e) {
      return this.As.us(e), Pt.resolve();
    }
  }, {
    key: "getMatchingKeysForTargetId",
    value: function getMatchingKeysForTargetId(t, e) {
      var n = this.As.hs(e);
      return Pt.resolve(n);
    }
  }, {
    key: "containsKey",
    value: function containsKey(t, e) {
      return Pt.resolve(this.As.containsKey(e));
    }
  }]);

  return ao;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */


var ho = /*#__PURE__*/function () {
  /**
   * The constructor accepts a factory for creating a reference delegate. This
   * allows both the delegate and this instance to have strong references to
   * each other without having nullable fields that would then need to be
   * checked or asserted on every access.
   */
  function ho(t, e) {
    var _this118 = this;

    _classCallCheck(this, ho);

    this.bs = {}, this.overlays = {}, this.Ps = new $t(0), this.vs = !1, this.vs = !0, this.referenceDelegate = t(this), this.Vs = new ao(this);
    this.indexManager = new mr(), this.remoteDocumentCache = function (t) {
      return new uo(t);
    }(function (t) {
      return _this118.referenceDelegate.Ss(t);
    }), this.wt = new Ui(e), this.Ds = new no(this.wt);
  }

  _createClass(ho, [{
    key: "start",
    value: function start() {
      return Promise.resolve();
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      // No durable state to ensure is closed on shutdown.
      return this.vs = !1, Promise.resolve();
    }
  }, {
    key: "started",
    get: function get() {
      return this.vs;
    }
  }, {
    key: "setDatabaseDeletedListener",
    value: function setDatabaseDeletedListener() {// No op.
    }
  }, {
    key: "setNetworkEnabled",
    value: function setNetworkEnabled() {// No op.
    }
  }, {
    key: "getIndexManager",
    value: function getIndexManager(t) {
      // We do not currently support indices for memory persistence, so we can
      // return the same shared instance of the memory index manager.
      return this.indexManager;
    }
  }, {
    key: "getDocumentOverlayCache",
    value: function getDocumentOverlayCache(t) {
      var e = this.overlays[t.toKey()];
      return e || (e = new so(), this.overlays[t.toKey()] = e), e;
    }
  }, {
    key: "getMutationQueue",
    value: function getMutationQueue(t, e) {
      var n = this.bs[t.toKey()];
      return n || (n = new oo(e, this.referenceDelegate), this.bs[t.toKey()] = n), n;
    }
  }, {
    key: "getTargetCache",
    value: function getTargetCache() {
      return this.Vs;
    }
  }, {
    key: "getRemoteDocumentCache",
    value: function getRemoteDocumentCache() {
      return this.remoteDocumentCache;
    }
  }, {
    key: "getBundleCache",
    value: function getBundleCache() {
      return this.Ds;
    }
  }, {
    key: "runTransaction",
    value: function runTransaction(t, e, n) {
      var _this119 = this;

      M("MemoryPersistence", "Starting transaction:", t);
      var s = new lo(this.Ps.next());
      return this.referenceDelegate.Cs(), n(s).next(function (t) {
        return _this119.referenceDelegate.xs(s).next(function () {
          return t;
        });
      }).toPromise().then(function (t) {
        return s.raiseOnCommittedEvent(), t;
      });
    }
  }, {
    key: "Ns",
    value: function Ns(t, e) {
      return Pt.or(Object.values(this.bs).map(function (n) {
        return function () {
          return n.containsKey(t, e);
        };
      }));
    }
  }]);

  return ho;
}();
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */


var lo = /*#__PURE__*/function (_Rt2) {
  _inherits(lo, _Rt2);

  var _super24 = _createSuper(lo);

  function lo(t) {
    var _this120;

    _classCallCheck(this, lo);

    _this120 = _super24.call(this), _this120.currentSequenceNumber = t;
    return _this120;
  }

  return _createClass(lo);
}(Rt);

var fo = /*#__PURE__*/function () {
  function fo(t) {
    _classCallCheck(this, fo);

    this.persistence = t,
    /** Tracks all documents that are active in Query views. */
    this.ks = new io(),
    /** The list of documents that are potentially GCed after each transaction. */
    this.Os = null;
  }

  _createClass(fo, [{
    key: "Fs",
    get: function get() {
      if (this.Os) return this.Os;
      throw L();
    }
  }, {
    key: "addReference",
    value: function addReference(t, e, n) {
      return this.ks.addReference(n, e), this.Fs.delete(n.toString()), Pt.resolve();
    }
  }, {
    key: "removeReference",
    value: function removeReference(t, e, n) {
      return this.ks.removeReference(n, e), this.Fs.add(n.toString()), Pt.resolve();
    }
  }, {
    key: "markPotentiallyOrphaned",
    value: function markPotentiallyOrphaned(t, e) {
      return this.Fs.add(e.toString()), Pt.resolve();
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(t, e) {
      var _this121 = this;

      this.ks.us(e.targetId).forEach(function (t) {
        return _this121.Fs.add(t.toString());
      });
      var n = this.persistence.getTargetCache();
      return n.getMatchingKeysForTargetId(t, e.targetId).next(function (t) {
        t.forEach(function (t) {
          return _this121.Fs.add(t.toString());
        });
      }).next(function () {
        return n.removeTargetData(t, e);
      });
    }
  }, {
    key: "Cs",
    value: function Cs() {
      this.Os = new Set();
    }
  }, {
    key: "xs",
    value: function xs(t) {
      var _this122 = this;

      // Remove newly orphaned documents.
      var e = this.persistence.getRemoteDocumentCache().newChangeBuffer();
      return Pt.forEach(this.Fs, function (n) {
        var s = dt.fromPath(n);
        return _this122.$s(t, s).next(function (t) {
          t || e.removeEntry(s, ct.min());
        });
      }).next(function () {
        return _this122.Os = null, e.apply(t);
      });
    }
  }, {
    key: "updateLimboDocument",
    value: function updateLimboDocument(t, e) {
      var _this123 = this;

      return this.$s(t, e).next(function (t) {
        t ? _this123.Fs.delete(e.toString()) : _this123.Fs.add(e.toString());
      });
    }
  }, {
    key: "Ss",
    value: function Ss(t) {
      // For eager GC, we don't care about the document size, there are no size thresholds.
      return 0;
    }
  }, {
    key: "$s",
    value: function $s(t, e) {
      var _this124 = this;

      return Pt.or([function () {
        return Pt.resolve(_this124.ks.containsKey(e));
      }, function () {
        return _this124.persistence.getTargetCache().containsKey(t, e);
      }, function () {
        return _this124.persistence.Ns(t, e);
      }]);
    }
  }], [{
    key: "Ms",
    value: function Ms(t) {
      return new fo(t);
    }
  }]);

  return fo;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Performs database creation and schema upgrades. */


var _o = /*#__PURE__*/function () {
  function _o(t) {
    _classCallCheck(this, _o);

    this.wt = t;
  }
  /**
   * Performs database creation and schema upgrades.
   *
   * Note that in production, this method is only ever used to upgrade the schema
   * to SCHEMA_VERSION. Different values of toVersion are only used for testing
   * and local feature development.
   */


  _createClass(_o, [{
    key: "O",
    value: function O(t, e, n, s) {
      var _this125 = this;

      var i = new vt("createOrUpgrade", e);
      n < 1 && s >= 1 && (function (t) {
        t.createObjectStore("owner");
      }(t), function (t) {
        t.createObjectStore("mutationQueues", {
          keyPath: "userId"
        });
        t.createObjectStore("mutations", {
          keyPath: "batchId",
          autoIncrement: !0
        }).createIndex("userMutationsIndex", fi, {
          unique: !0
        }), t.createObjectStore("documentMutations");
      }
      /**
      * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
      * and rewrites all data.
      */
      (t), wo(t), function (t) {
        t.createObjectStore("remoteDocuments");
      }(t)); // Migration 2 to populate the targetGlobal object no longer needed since
      // migration 3 unconditionally clears it.

      var r = Pt.resolve();
      return n < 3 && s >= 3 && ( // Brand new clients don't need to drop and recreate--only clients that
      // potentially have corrupt data.
      0 !== n && (!function (t) {
        t.deleteObjectStore("targetDocuments"), t.deleteObjectStore("targets"), t.deleteObjectStore("targetGlobal");
      }(t), wo(t)), r = r.next(function () {
        return (
          /**
          * Creates the target global singleton row.
          *
          * @param txn - The version upgrade transaction for indexeddb
          */
          function (t) {
            var e = t.store("targetGlobal"),
                n = {
              highestTargetId: 0,
              highestListenSequenceNumber: 0,
              lastRemoteSnapshotVersion: ct.min().toTimestamp(),
              targetCount: 0
            };
            return e.put("targetGlobalKey", n);
          }(i)
        );
      })), n < 4 && s >= 4 && (0 !== n && ( // Schema version 3 uses auto-generated keys to generate globally unique
      // mutation batch IDs (this was previously ensured internally by the
      // client). To migrate to the new schema, we have to read all mutations
      // and write them back out. We preserve the existing batch IDs to guarantee
      // consistency with other object stores. Any further mutation batch IDs will
      // be auto-generated.
      r = r.next(function () {
        return function (t, e) {
          return e.store("mutations").K().next(function (n) {
            t.deleteObjectStore("mutations");
            t.createObjectStore("mutations", {
              keyPath: "batchId",
              autoIncrement: !0
            }).createIndex("userMutationsIndex", fi, {
              unique: !0
            });
            var s = e.store("mutations"),
                i = n.map(function (t) {
              return s.put(t);
            });
            return Pt.waitFor(i);
          });
        }(t, i);
      })), r = r.next(function () {
        !function (t) {
          t.createObjectStore("clientMetadata", {
            keyPath: "clientId"
          });
        }(t);
      })), n < 5 && s >= 5 && (r = r.next(function () {
        return _this125.Bs(i);
      })), n < 6 && s >= 6 && (r = r.next(function () {
        return function (t) {
          t.createObjectStore("remoteDocumentGlobal");
        }(t), _this125.Ls(i);
      })), n < 7 && s >= 7 && (r = r.next(function () {
        return _this125.Us(i);
      })), n < 8 && s >= 8 && (r = r.next(function () {
        return _this125.qs(t, i);
      })), n < 9 && s >= 9 && (r = r.next(function () {
        // Multi-Tab used to manage its own changelog, but this has been moved
        // to the DbRemoteDocument object store itself. Since the previous change
        // log only contained transient data, we can drop its object store.
        !function (t) {
          t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
        }(t); // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
      })), n < 10 && s >= 10 && (r = r.next(function () {
        return _this125.Ks(i);
      })), n < 11 && s >= 11 && (r = r.next(function () {
        !function (t) {
          t.createObjectStore("bundles", {
            keyPath: "bundleId"
          });
        }(t), function (t) {
          t.createObjectStore("namedQueries", {
            keyPath: "name"
          });
        }(t);
      })), n < 12 && s >= 12 && (r = r.next(function () {
        !function (t) {
          var e = t.createObjectStore("documentOverlays", {
            keyPath: vi
          });
          e.createIndex("collectionPathOverlayIndex", Vi, {
            unique: !1
          }), e.createIndex("collectionGroupOverlayIndex", Si, {
            unique: !1
          });
        }(t);
      })), n < 13 && s >= 13 && (r = r.next(function () {
        return function (t) {
          var e = t.createObjectStore("remoteDocumentsV14", {
            keyPath: mi
          });
          e.createIndex("documentKeyIndex", gi), e.createIndex("collectionGroupIndex", yi);
        }(t);
      }).next(function () {
        return _this125.Gs(t, i);
      }).next(function () {
        return t.deleteObjectStore("remoteDocuments");
      })), n < 14 && s >= 14 && (r = r.next(function () {
        return _this125.Qs(t, i);
      })), n < 15 && s >= 15 && (r = r.next(function () {
        return function (t) {
          t.createObjectStore("indexConfiguration", {
            keyPath: "indexId",
            autoIncrement: !0
          }).createIndex("collectionGroupIndex", "collectionGroup", {
            unique: !1
          });
          t.createObjectStore("indexState", {
            keyPath: Ai
          }).createIndex("sequenceNumberIndex", Ri, {
            unique: !1
          });
          t.createObjectStore("indexEntries", {
            keyPath: bi
          }).createIndex("documentKeyIndex", Pi, {
            unique: !1
          });
        }(t);
      })), r;
    }
  }, {
    key: "Ls",
    value: function Ls(t) {
      var e = 0;
      return t.store("remoteDocuments").J(function (t, n) {
        e += Vr(n);
      }).next(function () {
        var n = {
          byteSize: e
        };
        return t.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
      });
    }
  }, {
    key: "Bs",
    value: function Bs(t) {
      var _this126 = this;

      var e = t.store("mutationQueues"),
          n = t.store("mutations");
      return e.K().next(function (e) {
        return Pt.forEach(e, function (e) {
          var s = IDBKeyRange.bound([e.userId, -1], [e.userId, e.lastAcknowledgedBatchId]);
          return n.K("userMutationsIndex", s).next(function (n) {
            return Pt.forEach(n, function (n) {
              U(n.userId === e.userId);
              var s = Wi(_this126.wt, n);
              return vr(t, e.userId, s).next(function () {});
            });
          });
        });
      });
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */

  }, {
    key: "Us",
    value: function Us(t) {
      var e = t.store("targetDocuments"),
          n = t.store("remoteDocuments");
      return t.store("targetGlobal").get("targetGlobalKey").next(function (t) {
        var s = [];
        return n.J(function (n, i) {
          var r = new ht(n),
              o = function (t) {
            return [0, ci(t)];
          }(r);

          s.push(e.get(o).next(function (n) {
            return n ? Pt.resolve() : function (n) {
              return e.put({
                targetId: 0,
                path: ci(n),
                sequenceNumber: t.highestListenSequenceNumber
              });
            }(r);
          }));
        }).next(function () {
          return Pt.waitFor(s);
        });
      });
    }
  }, {
    key: "qs",
    value: function qs(t, e) {
      // Create the index.
      t.createObjectStore("collectionParents", {
        keyPath: Ei
      });

      var n = e.store("collectionParents"),
          s = new gr(),
          i = function i(t) {
        if (s.add(t)) {
          var _e36 = t.lastSegment(),
              _s19 = t.popLast();

          return n.put({
            collectionId: _e36,
            parent: ci(_s19)
          });
        }
      }; // Helper to add an index entry iff we haven't already written it.
      // Index existing remote documents.


      return e.store("remoteDocuments").J({
        H: !0
      }, function (t, e) {
        var n = new ht(t);
        return i(n.popLast());
      }).next(function () {
        return e.store("documentMutations").J({
          H: !0
        }, function (_ref17, s) {
          var _ref18 = _slicedToArray(_ref17, 3),
              t = _ref18[0],
              e = _ref18[1],
              n = _ref18[2];

          var r = li(e);
          return i(r.popLast());
        });
      });
    }
  }, {
    key: "Ks",
    value: function Ks(t) {
      var _this127 = this;

      var e = t.store("targets");
      return e.J(function (t, n) {
        var s = zi(n),
            i = Hi(_this127.wt, s);
        return e.put(i);
      });
    }
  }, {
    key: "Gs",
    value: function Gs(t, e) {
      var n = e.store("remoteDocuments"),
          s = [];
      return n.J(function (t, n) {
        var i = e.store("remoteDocumentsV14"),
            r = (o = n, o.document ? new dt(ht.fromString(o.document.name).popFirst(5)) : o.noDocument ? dt.fromSegments(o.noDocument.path) : o.unknownDocument ? dt.fromSegments(o.unknownDocument.path) : L()).path.toArray();
        var o;
        /**
        * @license
        * Copyright 2017 Google LLC
        *
        * Licensed under the Apache License, Version 2.0 (the "License");
        * you may not use this file except in compliance with the License.
        * You may obtain a copy of the License at
        *
        *   http://www.apache.org/licenses/LICENSE-2.0
        *
        * Unless required by applicable law or agreed to in writing, software
        * distributed under the License is distributed on an "AS IS" BASIS,
        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        * See the License for the specific language governing permissions and
        * limitations under the License.
        */

        var u = {
          prefixPath: r.slice(0, r.length - 2),
          collectionGroup: r[r.length - 2],
          documentId: r[r.length - 1],
          readTime: n.readTime || [0, 0],
          unknownDocument: n.unknownDocument,
          noDocument: n.noDocument,
          document: n.document,
          hasCommittedMutations: !!n.hasCommittedMutations
        };
        s.push(i.put(u));
      }).next(function () {
        return Pt.waitFor(s);
      });
    }
  }, {
    key: "Qs",
    value: function Qs(t, e) {
      var _this128 = this;

      var n = e.store("mutations"),
          s = Wr(this.wt),
          i = new ho(fo.Ms, this.wt.ne);
      return n.K().next(function (t) {
        var n = new Map();
        return t.forEach(function (t) {
          var e;
          var s = null !== (e = n.get(t.userId)) && void 0 !== e ? e : ws();
          Wi(_this128.wt, t).keys().forEach(function (t) {
            return s = s.add(t);
          }), n.set(t.userId, s);
        }), Pt.forEach(n, function (t, n) {
          var r = new C(n),
              o = sr.se(_this128.wt, r),
              u = i.getIndexManager(r),
              c = Sr.se(r, _this128.wt, u, i.referenceDelegate);
          return new eo(s, c, o, u).recalculateAndSaveOverlaysForDocumentKeys(new Oi(e, $t.ot), t).next();
        });
      });
    }
  }]);

  return _o;
}();

function wo(t) {
  t.createObjectStore("targetDocuments", {
    keyPath: Ii
  }).createIndex("documentTargetsIndex", Ti, {
    unique: !0
  }); // NOTE: This is unique only because the TargetId is the suffix.

  t.createObjectStore("targets", {
    keyPath: "targetId"
  }).createIndex("queryTargetsIndex", pi, {
    unique: !0
  }), t.createObjectStore("targetGlobal");
}

var mo = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */

/**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */

var go = /*#__PURE__*/function () {
  function go(
  /**
   * Whether to synchronize the in-memory state of multiple tabs and share
   * access to local persistence.
   */
  t, e, n, s, i, r, o, u, c,
  /**
   * If set to true, forcefully obtains database access. Existing tabs will
   * no longer be able to access IndexedDB.
   */
  a) {
    var h = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 14;

    _classCallCheck(this, go);

    if (this.allowTabSynchronization = t, this.persistenceKey = e, this.clientId = n, this.js = i, this.window = r, this.document = o, this.Ws = c, this.zs = a, this.Hs = h, this.Ps = null, this.vs = !1, this.isPrimary = !1, this.networkEnabled = !0,
    /** Our window.unload handler, if registered. */
    this.Js = null, this.inForeground = !1,
    /** Our 'visibilitychange' listener if registered. */
    this.Ys = null,
    /** The client metadata refresh task. */
    this.Xs = null,
    /** The last time we garbage collected the client metadata object store. */
    this.Zs = Number.NEGATIVE_INFINITY,
    /** A listener to notify on primary state changes. */
    this.ti = function (t) {
      return Promise.resolve();
    }, !go.V()) throw new Q(G.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
    this.referenceDelegate = new Kr(this, s), this.ei = e + "main", this.wt = new Ui(u), this.ni = new Vt(this.ei, this.Hs, new _o(this.wt)), this.Vs = new Or(this.referenceDelegate, this.wt), this.remoteDocumentCache = Wr(this.wt), this.Ds = new tr(), this.window && this.window.localStorage ? this.si = this.window.localStorage : (this.si = null, !1 === a && F("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
  }
  /**
   * Attempt to start IndexedDb persistence.
   *
   * @returns Whether persistence was enabled.
   */


  _createClass(go, [{
    key: "start",
    value: function start() {
      var _this129 = this;

      // NOTE: This is expected to fail sometimes (in the case of another tab
      // already having the persistence lock), so it's the first thing we should
      // do.
      return this.ii().then(function () {
        if (!_this129.isPrimary && !_this129.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
          // obtain the primary lease.
          throw new Q(G.FAILED_PRECONDITION, mo);
        return _this129.ri(), _this129.oi(), _this129.ui(), _this129.runTransaction("getHighestListenSequenceNumber", "readonly", function (t) {
          return _this129.Vs.getHighestSequenceNumber(t);
        });
      }).then(function (t) {
        _this129.Ps = new $t(t, _this129.Ws);
      }).then(function () {
        _this129.vs = !0;
      }).catch(function (t) {
        return _this129.ni && _this129.ni.close(), Promise.reject(t);
      });
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */

  }, {
    key: "ci",
    value: function ci(t) {
      var _this130 = this;

      return this.ti = /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!_this130.started) {
                    _context8.next = 2;
                    break;
                  }

                  return _context8.abrupt("return", t(e));

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref19.apply(this, arguments);
        };
      }(), t(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */

  }, {
    key: "setDatabaseDeletedListener",
    value: function setDatabaseDeletedListener(t) {
      this.ni.F( /*#__PURE__*/function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.t0 = null === e.newVersion;

                  if (!_context9.t0) {
                    _context9.next = 4;
                    break;
                  }

                  _context9.next = 4;
                  return t();

                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x8) {
          return _ref20.apply(this, arguments);
        };
      }());
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */

  }, {
    key: "setNetworkEnabled",
    value: function setNetworkEnabled(t) {
      var _this131 = this;

      this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
      // lease update will be propagated via `primaryStateListener`.
      this.js.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.t0 = _this131.started;

                if (!_context10.t0) {
                  _context10.next = 4;
                  break;
                }

                _context10.next = 4;
                return _this131.ii();

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */

  }, {
    key: "ii",
    value: function ii() {
      var _this132 = this;

      return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function (t) {
        return po(t).put({
          clientId: _this132.clientId,
          updateTimeMs: Date.now(),
          networkEnabled: _this132.networkEnabled,
          inForeground: _this132.inForeground
        }).next(function () {
          if (_this132.isPrimary) return _this132.ai(t).next(function (t) {
            t || (_this132.isPrimary = !1, _this132.js.enqueueRetryable(function () {
              return _this132.ti(!1);
            }));
          });
        }).next(function () {
          return _this132.hi(t);
        }).next(function (e) {
          return _this132.isPrimary && !e ? _this132.li(t).next(function () {
            return !1;
          }) : !!e && _this132.fi(t).next(function () {
            return !0;
          });
        });
      }).catch(function (t) {
        if (Ct(t)) // Proceed with the existing state. Any subsequent access to
          // IndexedDB will verify the lease.
          return M("IndexedDbPersistence", "Failed to extend owner lease: ", t), _this132.isPrimary;
        if (!_this132.allowTabSynchronization) throw t;
        return M("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t),
        /* isPrimary= */
        !1;
      }).then(function (t) {
        _this132.isPrimary !== t && _this132.js.enqueueRetryable(function () {
          return _this132.ti(t);
        }), _this132.isPrimary = t;
      });
    }
  }, {
    key: "ai",
    value: function ai(t) {
      var _this133 = this;

      return yo(t).get("owner").next(function (t) {
        return Pt.resolve(_this133.di(t));
      });
    }
  }, {
    key: "_i",
    value: function _i(t) {
      return po(t).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */

  }, {
    key: "wi",
    value: function () {
      var _wi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this134 = this;

        var t, _iterator55, _step55, e;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(this.isPrimary && !this.mi(this.Zs, 18e5))) {
                  _context11.next = 6;
                  break;
                }

                this.Zs = Date.now();
                _context11.next = 4;
                return this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function (t) {
                  var e = Mi(t, "clientMetadata");
                  return e.K().next(function (t) {
                    var n = _this134.gi(t, 18e5),
                        s = t.filter(function (t) {
                      return -1 === n.indexOf(t);
                    }); // Delete metadata for clients that are no longer considered active.


                    return Pt.forEach(s, function (t) {
                      return e.delete(t.clientId);
                    }).next(function () {
                      return s;
                    });
                  });
                }).catch(function () {
                  return [];
                });

              case 4:
                t = _context11.sent;

                // Delete potential leftover entries that may continue to mark the
                // inactive clients as zombied in LocalStorage.
                // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                // the client atomically, but we can't. So we opt to delete the IndexedDb
                // entries first to avoid potentially reviving a zombied client.
                if (this.si) {
                  _iterator55 = _createForOfIteratorHelper(t);

                  try {
                    for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                      e = _step55.value;
                      this.si.removeItem(this.yi(e.clientId));
                    }
                  } catch (err) {
                    _iterator55.e(err);
                  } finally {
                    _iterator55.f();
                  }
                }

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function wi() {
        return _wi.apply(this, arguments);
      }

      return wi;
    }()
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */

  }, {
    key: "ui",
    value: function ui() {
      var _this135 = this;

      this.Xs = this.js.enqueueAfterDelay("client_metadata_refresh"
      /* ClientMetadataRefresh */
      , 4e3, function () {
        return _this135.ii().then(function () {
          return _this135.wi();
        }).then(function () {
          return _this135.ui();
        });
      });
    }
    /** Checks whether `client` is the local client. */

  }, {
    key: "di",
    value: function di(t) {
      return !!t && t.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */

  }, {
    key: "hi",
    value: function hi(t) {
      var _this136 = this;

      if (this.zs) return Pt.resolve(!0);
      return yo(t).get("owner").next(function (e) {
        // A client is eligible for the primary lease if:
        // - its network is enabled and the client's tab is in the foreground.
        // - its network is enabled and no other client's tab is in the
        //   foreground.
        // - every clients network is disabled and the client's tab is in the
        //   foreground.
        // - every clients network is disabled and no other client's tab is in
        //   the foreground.
        // - the `forceOwningTab` setting was passed in.
        if (null !== e && _this136.mi(e.leaseTimestampMs, 5e3) && !_this136.pi(e.ownerId)) {
          if (_this136.di(e) && _this136.networkEnabled) return !0;

          if (!_this136.di(e)) {
            if (!e.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
              // not opted into multi-tab synchronization. If this happens at
              // client startup, we reject the Promise returned by
              // `enablePersistence()` and the user can continue to use Firestore
              // with in-memory persistence.
              // If this fails during a lease refresh, we will instead block the
              // AsyncQueue from executing further operations. Note that this is
              // acceptable since mixing & matching different `synchronizeTabs`
              // settings is not supported.
              // TODO(b/114226234): Remove this check when `synchronizeTabs` can
              // no longer be turned off.
              throw new Q(G.FAILED_PRECONDITION, mo);
            return !1;
          }
        }

        return !(!_this136.networkEnabled || !_this136.inForeground) || po(t).K().next(function (t) {
          return void 0 === _this136.gi(t, 5e3).find(function (t) {
            if (_this136.clientId !== t.clientId) {
              var _e37 = !_this136.networkEnabled && t.networkEnabled,
                  n = !_this136.inForeground && t.inForeground,
                  s = _this136.networkEnabled === t.networkEnabled;

              if (_e37 || n && s) return !0;
            }

            return !1;
          });
        });
      }).next(function (t) {
        return _this136.isPrimary !== t && M("IndexedDbPersistence", "Client ".concat(t ? "is" : "is not", " eligible for a primary lease.")), t;
      });
    }
  }, {
    key: "shutdown",
    value: function () {
      var _shutdown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this137 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.vs = !1;
                this.Ii();
                this.Xs && (this.Xs.cancel(), this.Xs = null);
                this.Ti();
                this.Ei();
                _context12.next = 7;
                return this.ni.runTransaction("shutdown", "readwrite", ["owner", "clientMetadata"], function (t) {
                  var e = new Oi(t, $t.ot);
                  return _this137.li(e).next(function () {
                    return _this137._i(e);
                  });
                });

              case 7:
                this.ni.close();
                // Remove the entry marking the client as zombied from LocalStorage since
                // we successfully deleted its metadata from IndexedDb.
                this.Ai();

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function shutdown() {
        return _shutdown.apply(this, arguments);
      }

      return shutdown;
    }()
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */

  }, {
    key: "gi",
    value: function gi(t, e) {
      var _this138 = this;

      return t.filter(function (t) {
        return _this138.mi(t.updateTimeMs, e) && !_this138.pi(t.clientId);
      });
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */

  }, {
    key: "Ri",
    value: function Ri() {
      var _this139 = this;

      return this.runTransaction("getActiveClients", "readonly", function (t) {
        return po(t).K().next(function (t) {
          return _this139.gi(t, 18e5).map(function (t) {
            return t.clientId;
          });
        });
      });
    }
  }, {
    key: "started",
    get: function get() {
      return this.vs;
    }
  }, {
    key: "getMutationQueue",
    value: function getMutationQueue(t, e) {
      return Sr.se(t, this.wt, e, this.referenceDelegate);
    }
  }, {
    key: "getTargetCache",
    value: function getTargetCache() {
      return this.Vs;
    }
  }, {
    key: "getRemoteDocumentCache",
    value: function getRemoteDocumentCache() {
      return this.remoteDocumentCache;
    }
  }, {
    key: "getIndexManager",
    value: function getIndexManager(t) {
      return new pr(t, this.wt.ne.databaseId);
    }
  }, {
    key: "getDocumentOverlayCache",
    value: function getDocumentOverlayCache(t) {
      return sr.se(this.wt, t);
    }
  }, {
    key: "getBundleCache",
    value: function getBundleCache() {
      return this.Ds;
    }
  }, {
    key: "runTransaction",
    value: function runTransaction(t, e, n) {
      var _this140 = this;

      M("IndexedDbPersistence", "Starting transaction:", t);
      var s = "readonly" === e ? "readonly" : "readwrite",
          i = 15 === (r = this.Hs) ? ki : 14 === r ? Ni : 13 === r ? xi : 12 === r ? Ci : 11 === r ? Di : void L();
      /** Returns the object stores for the provided schema. */

      var r;
      var o; // Do all transactions as readwrite against all object stores, since we
      // are the only reader/writer.

      return this.ni.runTransaction(t, s, i, function (s) {
        return o = new Oi(s, _this140.Ps ? _this140.Ps.next() : $t.ot), "readwrite-primary" === e ? _this140.ai(o).next(function (t) {
          return !!t || _this140.hi(o);
        }).next(function (e) {
          if (!e) throw F("Failed to obtain primary lease for action '".concat(t, "'.")), _this140.isPrimary = !1, _this140.js.enqueueRetryable(function () {
            return _this140.ti(!1);
          }), new Q(G.FAILED_PRECONDITION, At);
          return n(o);
        }).next(function (t) {
          return _this140.fi(o).next(function () {
            return t;
          });
        }) : _this140.bi(o).next(function () {
          return n(o);
        });
      }).then(function (t) {
        return o.raiseOnCommittedEvent(), t;
      });
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.

  }, {
    key: "bi",
    value: function bi(t) {
      var _this141 = this;

      return yo(t).get("owner").next(function (t) {
        if (null !== t && _this141.mi(t.leaseTimestampMs, 5e3) && !_this141.pi(t.ownerId) && !_this141.di(t) && !(_this141.zs || _this141.allowTabSynchronization && t.allowTabSynchronization)) throw new Q(G.FAILED_PRECONDITION, mo);
      });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */

  }, {
    key: "fi",
    value: function fi(t) {
      var e = {
        ownerId: this.clientId,
        allowTabSynchronization: this.allowTabSynchronization,
        leaseTimestampMs: Date.now()
      };
      return yo(t).put("owner", e);
    }
  }, {
    key: "li",
    value:
    /** Checks the primary lease and removes it if we are the current primary. */
    function li(t) {
      var _this142 = this;

      var e = yo(t);
      return e.get("owner").next(function (t) {
        return _this142.di(t) ? (M("IndexedDbPersistence", "Releasing primary lease."), e.delete("owner")) : Pt.resolve();
      });
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */

  }, {
    key: "mi",
    value: function mi(t, e) {
      var n = Date.now();
      return !(t < n - e) && (!(t > n) || (F("Detected an update time that is in the future: ".concat(t, " > ").concat(n)), !1));
    }
  }, {
    key: "ri",
    value: function ri() {
      var _this143 = this;

      null !== this.document && "function" == typeof this.document.addEventListener && (this.Ys = function () {
        _this143.js.enqueueAndForget(function () {
          return _this143.inForeground = "visible" === _this143.document.visibilityState, _this143.ii();
        });
      }, this.document.addEventListener("visibilitychange", this.Ys), this.inForeground = "visible" === this.document.visibilityState);
    }
  }, {
    key: "Ti",
    value: function Ti() {
      this.Ys && (this.document.removeEventListener("visibilitychange", this.Ys), this.Ys = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */

  }, {
    key: "oi",
    value: function oi() {
      var _this144 = this;

      var t;
      "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.Js = function () {
        // Note: In theory, this should be scheduled on the AsyncQueue since it
        // accesses internal state. We execute this code directly during shutdown
        // to make sure it gets a chance to run.
        _this144.Ii(), isSafari() && navigator.appVersion.match(/Version\/1[45]/) && // On Safari 14 and 15, we do not run any cleanup actions as it might
        // trigger a bug that prevents Safari from re-opening IndexedDB during
        // the next page load.
        // See https://bugs.webkit.org/show_bug.cgi?id=226547
        _this144.js.enterRestrictedMode(
        /* purgeExistingTasks= */
        !0), _this144.js.enqueueAndForget(function () {
          return _this144.shutdown();
        });
      }, this.window.addEventListener("pagehide", this.Js));
    }
  }, {
    key: "Ei",
    value: function Ei() {
      this.Js && (this.window.removeEventListener("pagehide", this.Js), this.Js = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */

  }, {
    key: "pi",
    value: function pi(t) {
      var e;

      try {
        var n = null !== (null === (e = this.si) || void 0 === e ? void 0 : e.getItem(this.yi(t)));
        return M("IndexedDbPersistence", "Client '".concat(t, "' ").concat(n ? "is" : "is not", " zombied in LocalStorage")), n;
      } catch (t) {
        // Gracefully handle if LocalStorage isn't working.
        return F("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
      }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */

  }, {
    key: "Ii",
    value: function Ii() {
      if (this.si) try {
        this.si.setItem(this.yi(this.clientId), String(Date.now()));
      } catch (t) {
        // Gracefully handle if LocalStorage isn't available / working.
        F("Failed to set zombie client id.", t);
      }
    }
    /** Removes the zombied client entry if it exists. */

  }, {
    key: "Ai",
    value: function Ai() {
      if (this.si) try {
        this.si.removeItem(this.yi(this.clientId));
      } catch (t) {// Ignore
      }
    }
  }, {
    key: "yi",
    value: function yi(t) {
      return "firestore_zombie_".concat(this.persistenceKey, "_").concat(t);
    }
  }], [{
    key: "V",
    value: function V() {
      return Vt.V();
    }
  }]);

  return go;
}();
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */


function yo(t) {
  return Mi(t, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */


function po(t) {
  return Mi(t, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */


function Io(t, e) {
  // Use two different prefix formats:
  //   * firestore / persistenceKey / projectID . databaseID / ...
  //   * firestore / persistenceKey / projectID / ...
  // projectIDs are DNS-compatible names and cannot contain dots
  // so there's no danger of collisions.
  var n = t.projectId;
  return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */


var To = /*#__PURE__*/function () {
  function To(t, e, n, s) {
    _classCallCheck(this, To);

    this.targetId = t, this.fromCache = e, this.Pi = n, this.vi = s;
  }

  _createClass(To, null, [{
    key: "Vi",
    value: function Vi(t, e) {
      var n = ws(),
          s = ws();

      var _iterator56 = _createForOfIteratorHelper(e.docChanges),
          _step56;

      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var _t76 = _step56.value;

          switch (_t76.type) {
            case 0
            /* Added */
            :
              n = n.add(_t76.doc.key);
              break;

            case 1
            /* Removed */
            :
              s = s.add(_t76.doc.key);
            // do nothing
          }
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }

      return new To(t, e.fromCache, n, s);
    }
  }]);

  return To;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */


var Eo = /*#__PURE__*/function () {
  function Eo() {
    _classCallCheck(this, Eo);

    this.Si = !1;
  }
  /** Sets the document view to query against. */


  _createClass(Eo, [{
    key: "initialize",
    value: function initialize(t, e) {
      this.Di = t, this.indexManager = e, this.Si = !0;
    }
    /** Returns all local documents matching the specified query. */

  }, {
    key: "getDocumentsMatchingQuery",
    value: function getDocumentsMatchingQuery(t, e, n, s) {
      var _this145 = this;

      return this.Ci(t, e).next(function (i) {
        return i || _this145.xi(t, e, s, n);
      }).next(function (n) {
        return n || _this145.Ni(t, e);
      });
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */

  }, {
    key: "Ci",
    value: function Ci(t, e) {
      return Pt.resolve(null);
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */

  }, {
    key: "xi",
    value: function xi(t, e, n, s) {
      var _this146 = this;

      return on(e) || s.isEqual(ct.min()) ? this.Ni(t, e) : this.Di.getDocuments(t, n).next(function (i) {
        var r = _this146.ki(e, i);

        return _this146.Oi(e, r, n, s) ? _this146.Ni(t, e) : (k() <= LogLevel.DEBUG && M("QueryEngine", "Re-using previous result from %s to execute query: %s", s.toString(), wn(e)), _this146.Mi(t, r, e, pt(s, -1)));
      }); // Queries that have never seen a snapshot without limbo free documents
      // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */

  }, {
    key: "ki",
    value: function ki(t, e) {
      // Sort the documents and re-apply the query filter since previously
      // matching documents do not necessarily still match the query.
      var n = new Qt(yn(t));
      return e.forEach(function (e, s) {
        mn(t, s) && (n = n.add(s));
      }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */

  }, {
    key: "Oi",
    value: function Oi(t, e, n, s) {
      if (null === t.limit) // Queries without limits do not need to be refilled.
        return !1;
      if (n.size !== e.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0; // Limit queries are not eligible for index-free query execution if there is
      // a potential that an older document from cache now sorts before a document
      // that was previously part of the limit. This, however, can only happen if
      // the document at the edge of the limit goes out of limit.
      // If a document that is not the limit boundary sorts differently,
      // the boundary of the limit itself did not change and documents from cache
      // will continue to be "rejected" by this boundary. Therefore, we can ignore
      // any modifications that don't affect the last document.

      var i = "F"
      /* First */
      === t.limitType ? e.last() : e.first();
      return !!i && (i.hasPendingWrites || i.version.compareTo(s) > 0);
    }
  }, {
    key: "Ni",
    value: function Ni(t, e) {
      return k() <= LogLevel.DEBUG && M("QueryEngine", "Using full collection scan to execute query:", wn(e)), this.Di.getDocumentsMatchingQuery(t, e, Tt.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */

  }, {
    key: "Mi",
    value: function Mi(t, e, n, s) {
      // Retrieve all results for documents that were updated since the offset.
      return this.Di.getDocumentsMatchingQuery(t, n, s).next(function (t) {
        return (// Merge with existing results
          e.forEach(function (e) {
            t = t.insert(e.key, e);
          }), t
        );
      });
    }
  }]);

  return Eo;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */


var Ao = /*#__PURE__*/function () {
  function Ao(
  /** Manages our in-memory or durable persistence. */
  t, e, n, s) {
    _classCallCheck(this, Ao);

    this.persistence = t, this.Fi = e, this.wt = s,
    /**
     * Maps a targetID to data about its target.
     *
     * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
     * of `applyRemoteEvent()` idempotent.
     */
    this.$i = new qt(it),
    /** Maps a target to its targetID. */
    // TODO(wuandy): Evaluate if TargetId can be part of Target.
    this.Bi = new is(function (t) {
      return Oe(t);
    }, Fe),
    /**
     * A per collection group index of the last read time processed by
     * `getNewDocumentChanges()`.
     *
     * PORTING NOTE: This is only used for multi-tab synchronization.
     */
    this.Li = new Map(), this.Ui = t.getRemoteDocumentCache(), this.Vs = t.getTargetCache(), this.Ds = t.getBundleCache(), this.qi(n);
  }

  _createClass(Ao, [{
    key: "qi",
    value: function qi(t) {
      // TODO(indexing): Add spec tests that test these components change after a
      // user change
      this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new eo(this.Ui, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Ui.setIndexManager(this.indexManager), this.Fi.initialize(this.localDocuments, this.indexManager);
    }
  }, {
    key: "collectGarbage",
    value: function collectGarbage(t) {
      var _this147 = this;

      return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function (e) {
        return t.collect(e, _this147.$i);
      });
    }
  }]);

  return Ao;
}();

function Ro(
/** Manages our in-memory or durable persistence. */
t, e, n, s) {
  return new Ao(t, e, n, s);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */
// PORTING NOTE: Android and iOS only return the documents affected by the
// change.


function bo(_x9, _x10) {
  return _bo.apply(this, arguments);
}
/* Accepts locally generated Mutations and commit them to storage. */

/**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */


function _bo() {
  _bo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(t, e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            n = K(t);
            _context73.next = 3;
            return n.persistence.runTransaction("Handle user change", "readonly", function (t) {
              // Swap out the mutation queue, grabbing the pending mutation batches
              // before and after.
              var s;
              return n.mutationQueue.getAllMutationBatches(t).next(function (i) {
                return s = i, n.qi(e), n.mutationQueue.getAllMutationBatches(t);
              }).next(function (e) {
                var i = [],
                    r = []; // Union the old/new changed keys.

                var o = ws();

                var _iterator82 = _createForOfIteratorHelper(s),
                    _step82;

                try {
                  for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
                    var _t116 = _step82.value;
                    i.push(_t116.batchId);

                    var _iterator84 = _createForOfIteratorHelper(_t116.mutations),
                        _step84;

                    try {
                      for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
                        var _e54 = _step84.value;
                        o = o.add(_e54.key);
                      }
                    } catch (err) {
                      _iterator84.e(err);
                    } finally {
                      _iterator84.f();
                    }
                  }
                } catch (err) {
                  _iterator82.e(err);
                } finally {
                  _iterator82.f();
                }

                var _iterator83 = _createForOfIteratorHelper(e),
                    _step83;

                try {
                  for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
                    var _t117 = _step83.value;
                    r.push(_t117.batchId);

                    var _iterator85 = _createForOfIteratorHelper(_t117.mutations),
                        _step85;

                    try {
                      for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                        var _e55 = _step85.value;
                        o = o.add(_e55.key);
                      }
                    } catch (err) {
                      _iterator85.e(err);
                    } finally {
                      _iterator85.f();
                    }
                  } // Return the set of all (potentially) changed documents and the list
                  // of mutation batch IDs that were affected by change.

                } catch (err) {
                  _iterator83.e(err);
                } finally {
                  _iterator83.f();
                }

                return n.localDocuments.getDocuments(t, o).next(function (t) {
                  return {
                    Ki: t,
                    removedBatchIds: i,
                    addedBatchIds: r
                  };
                });
              });
            });

          case 3:
            return _context73.abrupt("return", _context73.sent);

          case 4:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73);
  }));
  return _bo.apply(this, arguments);
}

function Po(t, e) {
  var n = K(t);
  return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function (t) {
    var s = e.batch.keys(),
        i = n.Ui.newChangeBuffer({
      trackRemovals: !0
    });
    return function (t, e, n, s) {
      var i = n.batch,
          r = i.keys();
      var o = Pt.resolve();
      return r.forEach(function (t) {
        o = o.next(function () {
          return s.getEntry(e, t);
        }).next(function (e) {
          var r = n.docVersions.get(t);
          U(null !== r), e.version.compareTo(r) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && ( // We use the commitVersion as the readTime rather than the
          // document's updateTime since the updateTime is not advanced
          // for updates that do not modify the underlying document.
          e.setReadTime(n.commitVersion), s.addEntry(e)));
        });
      }), o.next(function () {
        return t.mutationQueue.removeMutationBatch(e, i);
      });
    }
    /** Returns the local view of the documents affected by a mutation batch. */
    // PORTING NOTE: Multi-Tab only.
    (n, t, e, i).next(function () {
      return i.apply(t);
    }).next(function () {
      return n.mutationQueue.performConsistencyCheck(t);
    }).next(function () {
      return n.documentOverlayCache.removeOverlaysForBatchId(t, s, e.batch.batchId);
    }).next(function () {
      return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function (t) {
        var e = ws();

        for (var _n25 = 0; _n25 < t.mutationResults.length; ++_n25) {
          t.mutationResults[_n25].transformResults.length > 0 && (e = e.add(t.batch.mutations[_n25].key));
        }

        return e;
      }
      /**
      * Removes mutations from the MutationQueue for the specified batch;
      * LocalDocuments will be recalculated.
      *
      * @returns The resulting modified documents.
      */
      (e));
    }).next(function () {
      return n.localDocuments.getDocuments(t, s);
    });
  });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */


function vo(t) {
  var e = K(t);
  return e.persistence.runTransaction("Get last remote snapshot version", "readonly", function (t) {
    return e.Vs.getLastRemoteSnapshotVersion(t);
  });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */


function Vo(t, e) {
  var n = K(t),
      s = e.snapshotVersion;
  var i = n.$i;
  return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function (t) {
    var r = n.Ui.newChangeBuffer({
      trackRemovals: !0
    }); // Reset newTargetDataByTargetMap in case this transaction gets re-run.

    i = n.$i;
    var o = [];
    e.targetChanges.forEach(function (r, u) {
      var c = i.get(u);
      if (!c) return; // Only update the remote keys if the target is still active. This
      // ensures that we can persist the updated target data along with
      // the updated assignment.

      o.push(n.Vs.removeMatchingKeys(t, r.removedDocuments, u).next(function () {
        return n.Vs.addMatchingKeys(t, r.addedDocuments, u);
      }));
      var a = c.withSequenceNumber(t.currentSequenceNumber);
      e.targetMismatches.has(u) ? a = a.withResumeToken(Jt.EMPTY_BYTE_STRING, ct.min()).withLastLimboFreeSnapshotVersion(ct.min()) : r.resumeToken.approximateByteSize() > 0 && (a = a.withResumeToken(r.resumeToken, s)), i = i.insert(u, a), // Update the target data if there are target changes (or if
      // sufficient time has passed since the last update).

      /**
      * Returns true if the newTargetData should be persisted during an update of
      * an active target. TargetData should always be persisted when a target is
      * being released and should not call this function.
      *
      * While the target is active, TargetData updates can be omitted when nothing
      * about the target has changed except metadata like the resume token or
      * snapshot version. Occasionally it's worth the extra write to prevent these
      * values from getting too stale after a crash, but this doesn't have to be
      * too frequent.
      */
      function (t, e, n) {
        // Always persist target data if we don't already have a resume token.
        if (0 === t.resumeToken.approximateByteSize()) return !0; // Don't allow resume token changes to be buffered indefinitely. This
        // allows us to be reasonably up-to-date after a crash and avoids needing
        // to loop over all active queries on shutdown. Especially in the browser
        // we may not get time to do anything interesting while the current tab is
        // closing.

        if (e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8) return !0; // Otherwise if the only thing that has changed about a target is its resume
        // token it's not worth persisting. Note that the RemoteStore keeps an
        // in-memory view of the currently active targets which includes the current
        // resume token, so stream failure or user changes will still use an
        // up-to-date resume token regardless of what we do here.

        return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
      }
      /**
      * Notifies local store of the changed views to locally pin documents.
      */
      (c, a, r) && o.push(n.Vs.updateTargetData(t, a));
    });
    var u = os(),
        c = ws(); // HACK: The only reason we allow a null snapshot version is so that we
    // can synthesize remote events when we get permission denied errors while
    // trying to resolve the state of a locally cached document that is in
    // limbo.

    if (e.documentUpdates.forEach(function (s) {
      e.resolvedLimboDocuments.has(s) && o.push(n.persistence.referenceDelegate.updateLimboDocument(t, s));
    }), // Each loop iteration only affects its "own" doc, so it's safe to get all
    // the remote documents in advance in a single call.
    o.push(So(t, r, e.documentUpdates).next(function (t) {
      u = t.Gi, c = t.Qi;
    })), !s.isEqual(ct.min())) {
      var _e38 = n.Vs.getLastRemoteSnapshotVersion(t).next(function (e) {
        return n.Vs.setTargetsMetadata(t, t.currentSequenceNumber, s);
      });

      o.push(_e38);
    }

    return Pt.waitFor(o).next(function () {
      return r.apply(t);
    }).next(function () {
      return n.localDocuments.getLocalViewOfDocuments(t, u, c);
    }).next(function () {
      return u;
    });
  }).then(function (t) {
    return n.$i = i, t;
  });
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */


function So(t, e, n) {
  var s = ws(),
      i = ws();
  return n.forEach(function (t) {
    return s = s.add(t);
  }), e.getEntries(t, s).next(function (t) {
    var s = os();
    return n.forEach(function (n, r) {
      var o = t.get(n); // Check if see if there is a existence state change for this document.

      r.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
      // to ensure that rejected limbo resolutions (which fabricate
      // NoDocuments with SnapshotVersion.min()) never add documents to
      // cache.
      r.isNoDocument() && r.version.isEqual(ct.min()) ? ( // NoDocuments with SnapshotVersion.min() are used in manufactured
      // events. We remove these documents from cache since we lost
      // access.
      e.removeEntry(n, r.readTime), s = s.insert(n, r)) : !o.isValidDocument() || r.version.compareTo(o.version) > 0 || 0 === r.version.compareTo(o.version) && o.hasPendingWrites ? (e.addEntry(r), s = s.insert(n, r)) : M("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", r.version);
    }), {
      Gi: s,
      Qi: i
    };
  });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */


function Do(t, e) {
  var n = K(t);
  return n.persistence.runTransaction("Get next mutation batch", "readonly", function (t) {
    return void 0 === e && (e = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(t, e);
  });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */

/**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */


function Co(t, e) {
  var n = K(t);
  return n.persistence.runTransaction("Allocate target", "readwrite", function (t) {
    var s;
    return n.Vs.getTargetData(t, e).next(function (i) {
      return i ? ( // This target has been listened to previously, so reuse the
      // previous targetID.
      // TODO(mcg): freshen last accessed date?
      s = i, Pt.resolve(s)) : n.Vs.allocateTargetId(t).next(function (i) {
        return s = new Li(e, i, 0
        /* Listen */
        , t.currentSequenceNumber), n.Vs.addTargetData(t, s).next(function () {
          return s;
        });
      });
    });
  }).then(function (t) {
    // If Multi-Tab is enabled, the existing target data may be newer than
    // the in-memory data
    var s = n.$i.get(t.targetId);
    return (null === s || t.snapshotVersion.compareTo(s.snapshotVersion) > 0) && (n.$i = n.$i.insert(t.targetId, t), n.Bi.set(e, t.targetId)), t;
  });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */
// Visible for testing.

/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */
// PORTING NOTE: `keepPersistedTargetData` is multi-tab only.


function xo(_x11, _x12, _x13) {
  return _xo.apply(this, arguments);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */


function _xo() {
  _xo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(t, e, n) {
    var s, i, r;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            s = K(t), i = s.$i.get(e), r = n ? "readwrite" : "readwrite-primary";
            _context74.prev = 1;
            _context74.t0 = n;

            if (_context74.t0) {
              _context74.next = 6;
              break;
            }

            _context74.next = 6;
            return s.persistence.runTransaction("Release target", r, function (t) {
              return s.persistence.referenceDelegate.removeTarget(t, i);
            });

          case 6:
            _context74.next = 13;
            break;

          case 8:
            _context74.prev = 8;
            _context74.t1 = _context74["catch"](1);

            if (Ct(_context74.t1)) {
              _context74.next = 12;
              break;
            }

            throw _context74.t1;

          case 12:
            // All `releaseTarget` does is record the final metadata state for the
            // target, but we've been recording this periodically during target
            // activity. If we lose this write this could cause a very slight
            // difference in the order of target deletion during GC, but we
            // don't define exact LRU semantics so this is acceptable.
            M("LocalStore", "Failed to update sequence numbers for target ".concat(e, ": ").concat(_context74.t1));

          case 13:
            s.$i = s.$i.remove(e), s.Bi.delete(i.target);

          case 14:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74, null, [[1, 8]]);
  }));
  return _xo.apply(this, arguments);
}

function No(t, e, n) {
  var s = K(t);
  var i = ct.min(),
      r = ws();
  return s.persistence.runTransaction("Execute query", "readonly", function (t) {
    return function (t, e, n) {
      var s = K(t),
          i = s.Bi.get(n);
      return void 0 !== i ? Pt.resolve(s.$i.get(i)) : s.Vs.getTargetData(e, n);
    }(s, t, ln(e)).next(function (e) {
      if (e) return i = e.lastLimboFreeSnapshotVersion, s.Vs.getMatchingKeysForTargetId(t, e.targetId).next(function (t) {
        r = t;
      });
    }).next(function () {
      return s.Fi.getDocumentsMatchingQuery(t, e, n ? i : ct.min(), n ? r : ws());
    }).next(function (t) {
      return Mo(s, gn(e), t), {
        documents: t,
        ji: r
      };
    });
  });
} // PORTING NOTE: Multi-Tab only.


function ko(t, e) {
  var n = K(t),
      s = K(n.Vs),
      i = n.$i.get(e);
  return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", function (t) {
    return s.te(t, e).next(function (t) {
      return t ? t.target : null;
    });
  });
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */
// PORTING NOTE: Multi-Tab only.


function Oo(t, e) {
  var n = K(t),
      s = n.Li.get(e) || ct.min(); // Get the current maximum read time for the collection. This should always
  // exist, but to reduce the chance for regressions we default to
  // SnapshotVersion.Min()
  // TODO(indexing): Consider removing the default value.

  return n.persistence.runTransaction("Get new document changes", "readonly", function (t) {
    return n.Ui.getAllFromCollectionGroup(t, e, pt(s, -1),
    /* limit= */
    Number.MAX_SAFE_INTEGER);
  }).then(function (t) {
    return Mo(n, e, t), t;
  });
}
/** Sets the collection group's maximum read time from the given documents. */
// PORTING NOTE: Multi-Tab only.


function Mo(t, e, n) {
  var s = ct.min();
  n.forEach(function (t, e) {
    e.readTime.compareTo(s) > 0 && (s = e.readTime);
  }), t.Li.set(e, s);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */

/**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */


function Fo(_x14, _x15, _x16, _x17) {
  return _Fo.apply(this, arguments);
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */

/**
 * Saves the given `NamedQuery` to local persistence.
 */


function _Fo() {
  _Fo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(t, e, n, s) {
    var i, r, o, _iterator86, _step86, _t118, _n42, _s33, u, c;

    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            i = K(t);
            r = ws(), o = os();
            _iterator86 = _createForOfIteratorHelper(n);

            try {
              for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
                _t118 = _step86.value;
                _n42 = e.Wi(_t118.metadata.name);
                _t118.document && (r = r.add(_n42));
                _s33 = e.zi(_t118);
                _s33.setReadTime(e.Hi(_t118.metadata.readTime)), o = o.insert(_n42, _s33);
              }
            } catch (err) {
              _iterator86.e(err);
            } finally {
              _iterator86.f();
            }

            u = i.Ui.newChangeBuffer({
              trackRemovals: !0
            });
            _context75.next = 7;
            return Co(i, function (t) {
              // It is OK that the path used for the query is not valid, because this will
              // not be read and queried.
              return ln(rn(ht.fromString("__bundle__/docs/".concat(t))));
            }(s));

          case 7:
            c = _context75.sent;
            return _context75.abrupt("return", i.persistence.runTransaction("Apply bundle documents", "readwrite", function (t) {
              return So(t, u, o).next(function (e) {
                return u.apply(t), e;
              }).next(function (e) {
                return i.Vs.removeMatchingKeysForTargetId(t, c.targetId).next(function () {
                  return i.Vs.addMatchingKeys(t, r, c.targetId);
                }).next(function () {
                  return i.localDocuments.getLocalViewOfDocuments(t, e.Gi, e.Qi);
                }).next(function () {
                  return e.Gi;
                });
              });
            }));

          case 9:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75);
  }));
  return _Fo.apply(this, arguments);
}

function $o(_x18, _x19) {
  return _$o.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>

/** Assembles the key for a client state in WebStorage */


function _$o() {
  _$o = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(t, e) {
    var n,
        s,
        i,
        _args76 = arguments;
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            n = _args76.length > 2 && _args76[2] !== undefined ? _args76[2] : ws();
            _context76.next = 3;
            return Co(t, ln(Ji(e.bundledQuery)));

          case 3:
            s = _context76.sent;
            i = K(t);
            return _context76.abrupt("return", i.persistence.runTransaction("Save named query", "readwrite", function (t) {
              var r = Ns(e.readTime); // Simply save the query itself if it is older than what the SDK already
              // has.

              if (s.snapshotVersion.compareTo(r) >= 0) return i.Ds.saveNamedQuery(t, e); // Update existing target data because the query from the bundle is newer.

              var o = s.withResumeToken(Jt.EMPTY_BYTE_STRING, r);
              return i.$i = i.$i.insert(o.targetId, o), i.Vs.updateTargetData(t, o).next(function () {
                return i.Vs.removeMatchingKeysForTargetId(t, s.targetId);
              }).next(function () {
                return i.Vs.addMatchingKeys(t, n, s.targetId);
              }).next(function () {
                return i.Ds.saveNamedQuery(t, e);
              });
            }));

          case 6:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee76);
  }));
  return _$o.apply(this, arguments);
}

function Bo(t, e) {
  return "firestore_clients_".concat(t, "_").concat(e);
} // The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.

/** Assembles the key for a mutation batch in WebStorage */


function Lo(t, e, n) {
  var s = "firestore_mutations_".concat(t, "_").concat(n);
  return e.isAuthenticated() && (s += "_".concat(e.uid)), s;
} // The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>

/** Assembles the key for a query state in WebStorage */


function Uo(t, e) {
  return "firestore_targets_".concat(t, "_").concat(e);
} // The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>

/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing


var qo = /*#__PURE__*/function () {
  function qo(t, e, n, s) {
    _classCallCheck(this, qo);

    this.user = t, this.batchId = e, this.state = n, this.error = s;
  }
  /**
   * Parses a MutationMetadata from its JSON representation in WebStorage.
   * Logs a warning and returns null if the format of the data is not valid.
   */


  _createClass(qo, [{
    key: "Yi",
    value: function Yi() {
      var t = {
        state: this.state,
        updateTimeMs: Date.now()
      };
      return this.error && (t.error = {
        code: this.error.code,
        message: this.error.message
      }), JSON.stringify(t);
    }
  }], [{
    key: "Ji",
    value: function Ji(t, e, n) {
      var s = JSON.parse(n);
      var i,
          r = "object" == typeof s && -1 !== ["pending", "acknowledged", "rejected"].indexOf(s.state) && (void 0 === s.error || "object" == typeof s.error);
      return r && s.error && (r = "string" == typeof s.error.message && "string" == typeof s.error.code, r && (i = new Q(s.error.code, s.error.message))), r ? new qo(t, e, s.state, i) : (F("SharedClientState", "Failed to parse mutation state for ID '".concat(e, "': ").concat(n)), null);
    }
  }]);

  return qo;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing


var Ko = /*#__PURE__*/function () {
  function Ko(t, e, n) {
    _classCallCheck(this, Ko);

    this.targetId = t, this.state = e, this.error = n;
  }
  /**
   * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
   * Logs a warning and returns null if the format of the data is not valid.
   */


  _createClass(Ko, [{
    key: "Yi",
    value: function Yi() {
      var t = {
        state: this.state,
        updateTimeMs: Date.now()
      };
      return this.error && (t.error = {
        code: this.error.code,
        message: this.error.message
      }), JSON.stringify(t);
    }
  }], [{
    key: "Ji",
    value: function Ji(t, e) {
      var n = JSON.parse(e);
      var s,
          i = "object" == typeof n && -1 !== ["not-current", "current", "rejected"].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
      return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (s = new Q(n.error.code, n.error.message))), i ? new Ko(t, n.state, s) : (F("SharedClientState", "Failed to parse target state for ID '".concat(t, "': ").concat(e)), null);
    }
  }]);

  return Ko;
}();
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */


var Go = /*#__PURE__*/function () {
  function Go(t, e) {
    _classCallCheck(this, Go);

    this.clientId = t, this.activeTargetIds = e;
  }
  /**
   * Parses a RemoteClientState from the JSON representation in WebStorage.
   * Logs a warning and returns null if the format of the data is not valid.
   */


  _createClass(Go, null, [{
    key: "Ji",
    value: function Ji(t, e) {
      var n = JSON.parse(e);
      var s = "object" == typeof n && n.activeTargetIds instanceof Array,
          i = gs();

      for (var _t77 = 0; s && _t77 < n.activeTargetIds.length; ++_t77) {
        s = ce(n.activeTargetIds[_t77]), i = i.add(n.activeTargetIds[_t77]);
      }

      return s ? new Go(t, i) : (F("SharedClientState", "Failed to parse client data for instance '".concat(t, "': ").concat(e)), null);
    }
  }]);

  return Go;
}();
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */


var Qo = /*#__PURE__*/function () {
  function Qo(t, e) {
    _classCallCheck(this, Qo);

    this.clientId = t, this.onlineState = e;
  }
  /**
   * Parses a SharedOnlineState from its JSON representation in WebStorage.
   * Logs a warning and returns null if the format of the data is not valid.
   */


  _createClass(Qo, null, [{
    key: "Ji",
    value: function Ji(t) {
      var e = JSON.parse(t);
      return "object" == typeof e && -1 !== ["Unknown", "Online", "Offline"].indexOf(e.onlineState) && "string" == typeof e.clientId ? new Qo(e.clientId, e.onlineState) : (F("SharedClientState", "Failed to parse online state: ".concat(t)), null);
    }
  }]);

  return Qo;
}();
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.


var jo = /*#__PURE__*/function () {
  function jo() {
    _classCallCheck(this, jo);

    this.activeTargetIds = gs();
  }

  _createClass(jo, [{
    key: "Xi",
    value: function Xi(t) {
      this.activeTargetIds = this.activeTargetIds.add(t);
    }
  }, {
    key: "Zi",
    value: function Zi(t) {
      this.activeTargetIds = this.activeTargetIds.delete(t);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */

  }, {
    key: "Yi",
    value: function Yi() {
      var t = {
        activeTargetIds: this.activeTargetIds.toArray(),
        updateTimeMs: Date.now()
      };
      return JSON.stringify(t);
    }
  }]);

  return jo;
}();
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */


var Wo = /*#__PURE__*/function () {
  function Wo(t, e, n, s, i) {
    _classCallCheck(this, Wo);

    this.window = t, this.js = e, this.persistenceKey = n, this.tr = s, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.er = this.nr.bind(this), this.sr = new qt(it), this.started = !1,
    /**
     * Captures WebStorage events that occur before `start()` is called. These
     * events are replayed once `WebStorageSharedClientState` is started.
     */
    this.ir = []; // Escape the special characters mentioned here:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions

    var r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    this.storage = this.window.localStorage, this.currentUser = i, this.rr = Bo(this.persistenceKey, this.tr), this.ur =
    /** Assembles the key for the current sequence number. */
    function (t) {
      return "firestore_sequence_number_".concat(t);
    }
    /**
    * @license
    * Copyright 2018 Google LLC
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *   http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    (this.persistenceKey), this.sr = this.sr.insert(this.tr, new jo()), this.cr = new RegExp("^firestore_clients_".concat(r, "_([^_]*)$")), this.ar = new RegExp("^firestore_mutations_".concat(r, "_(\\d+)(?:_(.*))?$")), this.hr = new RegExp("^firestore_targets_".concat(r, "_(\\d+)$")), this.lr =
    /** Assembles the key for the online state of the primary tab. */
    function (t) {
      return "firestore_online_state_".concat(t);
    } // The WebStorage prefix that plays as a event to indicate the remote documents
    // might have changed due to some secondary tabs loading a bundle.
    // format of the key is:
    //     firestore_bundle_loaded_v2_<persistenceKey>
    // The version ending with "v2" stores the list of modified collection groups.
    (this.persistenceKey), this.dr = function (t) {
      return "firestore_bundle_loaded_v2_".concat(t);
    } // The WebStorage key prefix for the key that stores the last sequence number allocated. The key
    // looks like 'firestore_sequence_number_<persistence_prefix>'.
    (this.persistenceKey), // Rather than adding the storage observer during start(), we add the
    // storage observer during initialization. This ensures that we collect
    // events before other components populate their initial state (during their
    // respective start() calls). Otherwise, we might for example miss a
    // mutation that is added after LocalStore's start() processed the existing
    // mutations but before we observe WebStorage events.
    this.window.addEventListener("storage", this.er);
  }
  /** Returns 'true' if WebStorage is available in the current environment. */


  _createClass(Wo, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _this148 = this;

        var t, _iterator57, _step57, _e39, _t79, n, e, _t78, _iterator58, _step58, _t80;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.syncEngine.Ri();

              case 2:
                t = _context13.sent;
                _iterator57 = _createForOfIteratorHelper(t);
                _context13.prev = 4;

                _iterator57.s();

              case 6:
                if ((_step57 = _iterator57.n()).done) {
                  _context13.next = 14;
                  break;
                }

                _e39 = _step57.value;

                if (!(_e39 === this.tr)) {
                  _context13.next = 10;
                  break;
                }

                return _context13.abrupt("continue", 12);

              case 10:
                _t79 = this.getItem(Bo(this.persistenceKey, _e39));

                if (_t79) {
                  n = Go.Ji(_e39, _t79);
                  n && (this.sr = this.sr.insert(n.clientId, n));
                }

              case 12:
                _context13.next = 6;
                break;

              case 14:
                _context13.next = 19;
                break;

              case 16:
                _context13.prev = 16;
                _context13.t0 = _context13["catch"](4);

                _iterator57.e(_context13.t0);

              case 19:
                _context13.prev = 19;

                _iterator57.f();

                return _context13.finish(19);

              case 22:
                this._r(); // Check if there is an existing online state and call the callback handler
                // if applicable.


                e = this.storage.getItem(this.lr);

                if (e) {
                  _t78 = this.wr(e);
                  _t78 && this.mr(_t78);
                }

                _iterator58 = _createForOfIteratorHelper(this.ir);

                try {
                  for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                    _t80 = _step58.value;
                    this.nr(_t80);
                  }
                } catch (err) {
                  _iterator58.e(err);
                } finally {
                  _iterator58.f();
                }

                this.ir = [], // Register a window unload hook to remove the client metadata entry from
                // WebStorage even if `shutdown()` was not called.
                this.window.addEventListener("pagehide", function () {
                  return _this148.shutdown();
                }), this.started = !0;

              case 28:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[4, 16, 19, 22]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "writeSequenceNumber",
    value: function writeSequenceNumber(t) {
      this.setItem(this.ur, JSON.stringify(t));
    }
  }, {
    key: "getAllActiveQueryTargets",
    value: function getAllActiveQueryTargets() {
      return this.gr(this.sr);
    }
  }, {
    key: "isActiveQueryTarget",
    value: function isActiveQueryTarget(t) {
      var e = !1;
      return this.sr.forEach(function (n, s) {
        s.activeTargetIds.has(t) && (e = !0);
      }), e;
    }
  }, {
    key: "addPendingMutation",
    value: function addPendingMutation(t) {
      this.yr(t, "pending");
    }
  }, {
    key: "updateMutationState",
    value: function updateMutationState(t, e, n) {
      this.yr(t, e, n), // Once a final mutation result is observed by other clients, they no longer
      // access the mutation's metadata entry. Since WebStorage replays events
      // in order, it is safe to delete the entry right after updating it.
      this.pr(t);
    }
  }, {
    key: "addLocalQueryTarget",
    value: function addLocalQueryTarget(t) {
      var e = "not-current"; // Lookup an existing query state if the target ID was already registered
      // by another tab

      if (this.isActiveQueryTarget(t)) {
        var n = this.storage.getItem(Uo(this.persistenceKey, t));

        if (n) {
          var s = Ko.Ji(t, n);
          s && (e = s.state);
        }
      }

      return this.Ir.Xi(t), this._r(), e;
    }
  }, {
    key: "removeLocalQueryTarget",
    value: function removeLocalQueryTarget(t) {
      this.Ir.Zi(t), this._r();
    }
  }, {
    key: "isLocalQueryTarget",
    value: function isLocalQueryTarget(t) {
      return this.Ir.activeTargetIds.has(t);
    }
  }, {
    key: "clearQueryState",
    value: function clearQueryState(t) {
      this.removeItem(Uo(this.persistenceKey, t));
    }
  }, {
    key: "updateQueryState",
    value: function updateQueryState(t, e, n) {
      this.Tr(t, e, n);
    }
  }, {
    key: "handleUserChange",
    value: function handleUserChange(t, e, n) {
      var _this149 = this;

      e.forEach(function (t) {
        _this149.pr(t);
      }), this.currentUser = t, n.forEach(function (t) {
        _this149.addPendingMutation(t);
      });
    }
  }, {
    key: "setOnlineState",
    value: function setOnlineState(t) {
      this.Er(t);
    }
  }, {
    key: "notifyBundleLoaded",
    value: function notifyBundleLoaded(t) {
      this.Ar(t);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this.started && (this.window.removeEventListener("storage", this.er), this.removeItem(this.rr), this.started = !1);
    }
  }, {
    key: "getItem",
    value: function getItem(t) {
      var e = this.storage.getItem(t);
      return M("SharedClientState", "READ", t, e), e;
    }
  }, {
    key: "setItem",
    value: function setItem(t, e) {
      M("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }
  }, {
    key: "removeItem",
    value: function removeItem(t) {
      M("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }
  }, {
    key: "nr",
    value: function nr(t) {
      var _this150 = this;

      // Note: The function is typed to take Event to be interface-compatible with
      // `Window.addEventListener`.
      var e = t;

      if (e.storageArea === this.storage) {
        if (M("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.rr) return void F("Received WebStorage notification for local change. Another client might have garbage-collected our state");
        this.js.enqueueRetryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
          var _t81, _t82, _t83, _t84, _t85, _t86, _t87;

          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!_this150.started) {
                    _context14.next = 43;
                    break;
                  }

                  if (!(null !== e.key)) {
                    _context14.next = 41;
                    break;
                  }

                  if (!_this150.cr.test(e.key)) {
                    _context14.next = 11;
                    break;
                  }

                  if (!(null == e.newValue)) {
                    _context14.next = 6;
                    break;
                  }

                  _t81 = _this150.Rr(e.key);
                  return _context14.abrupt("return", _this150.br(_t81, null));

                case 6:
                  _t82 = _this150.Pr(e.key, e.newValue);

                  if (!_t82) {
                    _context14.next = 9;
                    break;
                  }

                  return _context14.abrupt("return", _this150.br(_t82.clientId, _t82));

                case 9:
                  _context14.next = 41;
                  break;

                case 11:
                  if (!_this150.ar.test(e.key)) {
                    _context14.next = 18;
                    break;
                  }

                  if (!(null !== e.newValue)) {
                    _context14.next = 16;
                    break;
                  }

                  _t83 = _this150.vr(e.key, e.newValue);

                  if (!_t83) {
                    _context14.next = 16;
                    break;
                  }

                  return _context14.abrupt("return", _this150.Vr(_t83));

                case 16:
                  _context14.next = 41;
                  break;

                case 18:
                  if (!_this150.hr.test(e.key)) {
                    _context14.next = 25;
                    break;
                  }

                  if (!(null !== e.newValue)) {
                    _context14.next = 23;
                    break;
                  }

                  _t84 = _this150.Sr(e.key, e.newValue);

                  if (!_t84) {
                    _context14.next = 23;
                    break;
                  }

                  return _context14.abrupt("return", _this150.Dr(_t84));

                case 23:
                  _context14.next = 41;
                  break;

                case 25:
                  if (!(e.key === _this150.lr)) {
                    _context14.next = 32;
                    break;
                  }

                  if (!(null !== e.newValue)) {
                    _context14.next = 30;
                    break;
                  }

                  _t85 = _this150.wr(e.newValue);

                  if (!_t85) {
                    _context14.next = 30;
                    break;
                  }

                  return _context14.abrupt("return", _this150.mr(_t85));

                case 30:
                  _context14.next = 41;
                  break;

                case 32:
                  if (!(e.key === _this150.ur)) {
                    _context14.next = 37;
                    break;
                  }

                  _t86 = function (t) {
                    var e = $t.ot;
                    if (null != t) try {
                      var n = JSON.parse(t);
                      U("number" == typeof n), e = n;
                    } catch (t) {
                      F("SharedClientState", "Failed to read sequence number from WebStorage", t);
                    }
                    return e;
                  }
                  /**
                  * `MemorySharedClientState` is a simple implementation of SharedClientState for
                  * clients using memory persistence. The state in this class remains fully
                  * isolated and no synchronization is performed.
                  */
                  (e.newValue);

                  _t86 !== $t.ot && _this150.sequenceNumberHandler(_t86);
                  _context14.next = 41;
                  break;

                case 37:
                  if (!(e.key === _this150.dr)) {
                    _context14.next = 41;
                    break;
                  }

                  _t87 = _this150.Cr(e.newValue);
                  _context14.next = 41;
                  return Promise.all(_t87.map(function (t) {
                    return _this150.syncEngine.Nr(t);
                  }));

                case 41:
                  _context14.next = 44;
                  break;

                case 43:
                  _this150.ir.push(e);

                case 44:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14);
        })));
      }
    }
  }, {
    key: "Ir",
    get: function get() {
      return this.sr.get(this.tr);
    }
  }, {
    key: "_r",
    value: function _r() {
      this.setItem(this.rr, this.Ir.Yi());
    }
  }, {
    key: "yr",
    value: function yr(t, e, n) {
      var s = new qo(this.currentUser, t, e, n),
          i = Lo(this.persistenceKey, this.currentUser, t);
      this.setItem(i, s.Yi());
    }
  }, {
    key: "pr",
    value: function pr(t) {
      var e = Lo(this.persistenceKey, this.currentUser, t);
      this.removeItem(e);
    }
  }, {
    key: "Er",
    value: function Er(t) {
      var e = {
        clientId: this.tr,
        onlineState: t
      };
      this.storage.setItem(this.lr, JSON.stringify(e));
    }
  }, {
    key: "Tr",
    value: function Tr(t, e, n) {
      var s = Uo(this.persistenceKey, t),
          i = new Ko(t, e, n);
      this.setItem(s, i.Yi());
    }
  }, {
    key: "Ar",
    value: function Ar(t) {
      var e = JSON.stringify(Array.from(t));
      this.setItem(this.dr, e);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */

  }, {
    key: "Rr",
    value: function Rr(t) {
      var e = this.cr.exec(t);
      return e ? e[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */

  }, {
    key: "Pr",
    value: function Pr(t, e) {
      var n = this.Rr(t);
      return Go.Ji(n, e);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */

  }, {
    key: "vr",
    value: function vr(t, e) {
      var n = this.ar.exec(t),
          s = Number(n[1]),
          i = void 0 !== n[2] ? n[2] : null;
      return qo.Ji(new C(i), s, e);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */

  }, {
    key: "Sr",
    value: function Sr(t, e) {
      var n = this.hr.exec(t),
          s = Number(n[1]);
      return Ko.Ji(s, e);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */

  }, {
    key: "wr",
    value: function wr(t) {
      return Qo.Ji(t);
    }
  }, {
    key: "Cr",
    value: function Cr(t) {
      return JSON.parse(t);
    }
  }, {
    key: "Vr",
    value: function () {
      var _Vr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(t.user.uid === this.currentUser.uid)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return", this.syncEngine.kr(t.batchId, t.state, t.error));

              case 2:
                M("SharedClientState", "Ignoring mutation for non-active user ".concat(t.user.uid));

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function Vr(_x20) {
        return _Vr.apply(this, arguments);
      }

      return Vr;
    }()
  }, {
    key: "Dr",
    value: function Dr(t) {
      return this.syncEngine.Or(t.targetId, t.state, t.error);
    }
  }, {
    key: "br",
    value: function br(t, e) {
      var _this151 = this;

      var n = e ? this.sr.insert(t, e) : this.sr.remove(t),
          s = this.gr(this.sr),
          i = this.gr(n),
          r = [],
          o = [];
      return i.forEach(function (t) {
        s.has(t) || r.push(t);
      }), s.forEach(function (t) {
        i.has(t) || o.push(t);
      }), this.syncEngine.Mr(r, o).then(function () {
        _this151.sr = n;
      });
    }
  }, {
    key: "mr",
    value: function mr(t) {
      // We check whether the client that wrote this online state is still active
      // by comparing its client ID to the list of clients kept active in
      // IndexedDb. If a client does not update their IndexedDb client state
      // within 5 seconds, it is considered inactive and we don't emit an online
      // state event.
      this.sr.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }
  }, {
    key: "gr",
    value: function gr(t) {
      var e = gs();
      return t.forEach(function (t, n) {
        e = e.unionWith(n.activeTargetIds);
      }), e;
    }
  }], [{
    key: "V",
    value: function V(t) {
      return !(!t || !t.localStorage);
    }
  }]);

  return Wo;
}();

var zo = /*#__PURE__*/function () {
  function zo() {
    _classCallCheck(this, zo);

    this.Fr = new jo(), this.$r = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
  }

  _createClass(zo, [{
    key: "addPendingMutation",
    value: function addPendingMutation(t) {// No op.
    }
  }, {
    key: "updateMutationState",
    value: function updateMutationState(t, e, n) {// No op.
    }
  }, {
    key: "addLocalQueryTarget",
    value: function addLocalQueryTarget(t) {
      return this.Fr.Xi(t), this.$r[t] || "not-current";
    }
  }, {
    key: "updateQueryState",
    value: function updateQueryState(t, e, n) {
      this.$r[t] = e;
    }
  }, {
    key: "removeLocalQueryTarget",
    value: function removeLocalQueryTarget(t) {
      this.Fr.Zi(t);
    }
  }, {
    key: "isLocalQueryTarget",
    value: function isLocalQueryTarget(t) {
      return this.Fr.activeTargetIds.has(t);
    }
  }, {
    key: "clearQueryState",
    value: function clearQueryState(t) {
      delete this.$r[t];
    }
  }, {
    key: "getAllActiveQueryTargets",
    value: function getAllActiveQueryTargets() {
      return this.Fr.activeTargetIds;
    }
  }, {
    key: "isActiveQueryTarget",
    value: function isActiveQueryTarget(t) {
      return this.Fr.activeTargetIds.has(t);
    }
  }, {
    key: "start",
    value: function start() {
      return this.Fr = new jo(), Promise.resolve();
    }
  }, {
    key: "handleUserChange",
    value: function handleUserChange(t, e, n) {// No op.
    }
  }, {
    key: "setOnlineState",
    value: function setOnlineState(t) {// No op.
    }
  }, {
    key: "shutdown",
    value: function shutdown() {}
  }, {
    key: "writeSequenceNumber",
    value: function writeSequenceNumber(t) {}
  }, {
    key: "notifyBundleLoaded",
    value: function notifyBundleLoaded(t) {// No op.
    }
  }]);

  return zo;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ho = /*#__PURE__*/function () {
  function Ho() {
    _classCallCheck(this, Ho);
  }

  _createClass(Ho, [{
    key: "Br",
    value: function Br(t) {// No-op.
    }
  }, {
    key: "shutdown",
    value: function shutdown() {// No-op.
    }
  }]);

  return Ho;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()

/* eslint-disable no-restricted-globals */

/**
 * Browser implementation of ConnectivityMonitor.
 */


var Jo = /*#__PURE__*/function () {
  function Jo() {
    var _this152 = this;

    _classCallCheck(this, Jo);

    this.Lr = function () {
      return _this152.Ur();
    }, this.qr = function () {
      return _this152.Kr();
    }, this.Gr = [], this.Qr();
  }

  _createClass(Jo, [{
    key: "Br",
    value: function Br(t) {
      this.Gr.push(t);
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      window.removeEventListener("online", this.Lr), window.removeEventListener("offline", this.qr);
    }
  }, {
    key: "Qr",
    value: function Qr() {
      window.addEventListener("online", this.Lr), window.addEventListener("offline", this.qr);
    }
  }, {
    key: "Ur",
    value: function Ur() {
      M("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");

      var _iterator59 = _createForOfIteratorHelper(this.Gr),
          _step59;

      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var t = _step59.value;
          t(0
          /* AVAILABLE */
          );
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
    }
  }, {
    key: "Kr",
    value: function Kr() {
      M("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");

      var _iterator60 = _createForOfIteratorHelper(this.Gr),
          _step60;

      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var t = _step60.value;
          t(1
          /* UNAVAILABLE */
          );
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
    } // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.

    /** Checks that all used attributes of window are available. */

  }], [{
    key: "V",
    value: function V() {
      return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
  }]);

  return Jo;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Yo = {
  BatchGetDocuments: "batchGet",
  Commit: "commit",
  RunQuery: "runQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */

var Xo = /*#__PURE__*/function () {
  function Xo(t) {
    _classCallCheck(this, Xo);

    this.jr = t.jr, this.Wr = t.Wr;
  }

  _createClass(Xo, [{
    key: "zr",
    value: function zr(t) {
      this.Hr = t;
    }
  }, {
    key: "Jr",
    value: function Jr(t) {
      this.Yr = t;
    }
  }, {
    key: "onMessage",
    value: function onMessage(t) {
      this.Xr = t;
    }
  }, {
    key: "close",
    value: function close() {
      this.Wr();
    }
  }, {
    key: "send",
    value: function send(t) {
      this.jr(t);
    }
  }, {
    key: "Zr",
    value: function Zr() {
      this.Hr();
    }
  }, {
    key: "eo",
    value: function eo(t) {
      this.Yr(t);
    }
  }, {
    key: "no",
    value: function no(t) {
      this.Xr(t);
    }
  }]);

  return Xo;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Zo = /*#__PURE__*/function (_ref23) {
  _inherits(Zo, _ref23);

  var _super25 = _createSuper(Zo);

  function Zo(t) {
    var _this153;

    _classCallCheck(this, Zo);

    _this153 = _super25.call(this, t), _this153.forceLongPolling = t.forceLongPolling, _this153.autoDetectLongPolling = t.autoDetectLongPolling, _this153.useFetchStreams = t.useFetchStreams;
    return _this153;
  }

  _createClass(Zo, [{
    key: "co",
    value: function co(t, e, n, s) {
      return new Promise(function (i, r) {
        var o = new XhrIo();
        o.listenOnce(EventType.COMPLETE, function () {
          try {
            switch (o.getLastErrorCode()) {
              case ErrorCode.NO_ERROR:
                var _e40 = o.getResponseJson();

                M("Connection", "XHR received:", JSON.stringify(_e40)), i(_e40);
                break;

              case ErrorCode.TIMEOUT:
                M("Connection", 'RPC "' + t + '" timed out'), r(new Q(G.DEADLINE_EXCEEDED, "Request time out"));
                break;

              case ErrorCode.HTTP_ERROR:
                var _n26 = o.getStatus();

                if (M("Connection", 'RPC "' + t + '" failed with status:', _n26, "response text:", o.getResponseText()), _n26 > 0) {
                  var _t88 = o.getResponseJson().error;

                  if (_t88 && _t88.status && _t88.message) {
                    var _e41 = function (t) {
                      var e = t.toLowerCase().replace(/_/g, "-");
                      return Object.values(G).indexOf(e) >= 0 ? e : G.UNKNOWN;
                    }(_t88.status);

                    r(new Q(_e41, _t88.message));
                  } else r(new Q(G.UNKNOWN, "Server responded with status " + o.getStatus()));
                } else // If we received an HTTP_ERROR but there's no status code,
                  // it's most probably a connection issue
                  r(new Q(G.UNAVAILABLE, "Connection failed."));

                break;

              default:
                L();
            }
          } finally {
            M("Connection", 'RPC "' + t + '" completed.');
          }
        });
        var u = JSON.stringify(s);
        o.send(e, "POST", u, n, 15);
      });
    }
  }, {
    key: "ho",
    value: function ho(t, e, n) {
      var s = [this.so, "/", "google.firestore.v1.Firestore", "/", t, "/channel"],
          i = createWebChannelTransport(),
          r = getStatEventTarget(),
          o = {
        // Required for backend stickiness, routing behavior is based on this
        // parameter.
        httpSessionIdParam: "gsessionid",
        initMessageHeaders: {},
        messageUrlParams: {
          // This param is used to improve routing and project isolation by the
          // backend and must be included in every request.
          database: "projects/".concat(this.databaseId.projectId, "/databases/").concat(this.databaseId.database)
        },
        sendRawJson: !0,
        supportsCrossDomainXhr: !0,
        internalChannelParams: {
          // Override the default timeout (randomized between 10-20 seconds) since
          // a large write batch on a slow internet connection may take a long
          // time to send to the backend. Rather than have WebChannel impose a
          // tight timeout which could lead to infinite timeouts and retries, we
          // set it very large (5-10 minutes) and rely on the browser's builtin
          // timeouts to kick in if the request isn't working.
          forwardChannelRequestTimeoutMs: 6e5
        },
        forceLongPolling: this.forceLongPolling,
        detectBufferingProxy: this.autoDetectLongPolling
      };
      this.useFetchStreams && (o.xmlHttpFactory = new FetchXmlHttpFactory({})), this.uo(o.initMessageHeaders, e, n), // Sending the custom headers we just added to request.initMessageHeaders
      // (Authorization, etc.) will trigger the browser to make a CORS preflight
      // request because the XHR will no longer meet the criteria for a "simple"
      // CORS request:
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
      // Therefore to avoid the CORS preflight request (an extra network
      // roundtrip), we use the httpHeadersOverwriteParam option to specify that
      // the headers should instead be encoded into a special "$httpHeaders" query
      // parameter, which is recognized by the webchannel backend. This is
      // formally defined here:
      // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
      // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
      // doesn't have an Origin header. So we have to exclude a few browser environments that are
      // known to (sometimes) not include an Origin. See
      // https://github.com/firebase/firebase-js-sdk/issues/1491.
      isMobileCordova() || isReactNative() || isElectron() || isIE() || isUWP() || isBrowserExtension() || (o.httpHeadersOverwriteParam = "$httpHeaders");
      var u = s.join("");
      M("Connection", "Creating WebChannel: " + u, o);
      var c = i.createWebChannel(u, o); // WebChannel supports sending the first message with the handshake - saving
      // a network round trip. However, it will have to call send in the same
      // JS event loop as open. In order to enforce this, we delay actually
      // opening the WebChannel until send is called. Whether we have called
      // open is tracked with this variable.

      var a = !1,
          h = !1; // A flag to determine whether the stream was closed (by us or through an
      // error/close event) to avoid delivering multiple close events or sending
      // on a closed stream

      var l = new Xo({
        jr: function jr(t) {
          h ? M("Connection", "Not sending because WebChannel is closed:", t) : (a || (M("Connection", "Opening WebChannel transport."), c.open(), a = !0), M("Connection", "WebChannel sending:", t), c.send(t));
        },
        Wr: function Wr() {
          return c.close();
        }
      }),
          y = function y(t, e, n) {
        // TODO(dimond): closure typing seems broken because WebChannel does
        // not implement goog.events.Listenable
        t.listen(e, function (t) {
          try {
            n(t);
          } catch (t) {
            setTimeout(function () {
              throw t;
            }, 0);
          }
        });
      }; // Closure events are guarded and exceptions are swallowed, so catch any
      // exception and rethrow using a setTimeout so they become visible again.
      // Note that eventually this function could go away if we are confident
      // enough the code is exception free.


      return y(c, WebChannel.EventType.OPEN, function () {
        h || M("Connection", "WebChannel transport opened.");
      }), y(c, WebChannel.EventType.CLOSE, function () {
        h || (h = !0, M("Connection", "WebChannel transport closed"), l.eo());
      }), y(c, WebChannel.EventType.ERROR, function (t) {
        h || (h = !0, $("Connection", "WebChannel transport errored:", t), l.eo(new Q(G.UNAVAILABLE, "The operation could not be completed")));
      }), y(c, WebChannel.EventType.MESSAGE, function (t) {
        var e;

        if (!h) {
          var _n27 = t.data[0];
          U(!!_n27); // TODO(b/35143891): There is a bug in One Platform that caused errors
          // (and only errors) to be wrapped in an extra array. To be forward
          // compatible with the bug we need to check either condition. The latter
          // can be removed once the fix has been rolled out.
          // Use any because msgData.error is not typed.

          var _s20 = _n27,
              _i15 = _s20.error || (null === (e = _s20[0]) || void 0 === e ? void 0 : e.error);

          if (_i15) {
            M("Connection", "WebChannel received error:", _i15); // error.status will be a string like 'OK' or 'NOT_FOUND'.

            var _t89 = _i15.status;

            var _e42 =
            /**
            * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
            *
            * @returns The Code equivalent to the given status string or undefined if
            *     there is no match.
            */
            function (t) {
              // lookup by string
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              var e = ts[t];
              if (void 0 !== e) return ss(e);
            }(_t89),
                _n28 = _i15.message;

            void 0 === _e42 && (_e42 = G.INTERNAL, _n28 = "Unknown error status: " + _t89 + " with message " + _i15.message), // Mark closed so no further events are propagated
            h = !0, l.eo(new Q(_e42, _n28)), c.close();
          } else M("Connection", "WebChannel received:", _n27), l.no(_n27);
        }
      }), y(r, Event.STAT_EVENT, function (t) {
        t.stat === Stat.PROXY ? M("Connection", "Detected buffering proxy") : t.stat === Stat.NOPROXY && M("Connection", "Detected no buffering proxy");
      }), setTimeout(function () {
        // Technically we could/should wait for the WebChannel opened event,
        // but because we want to send the first message with the WebChannel
        // handshake we pretend the channel opened here (asynchronously), and
        // then delay the actual open until the first message is sent.
        l.Zr();
      }, 0), l;
    }
  }]);

  return Zo;
}(
/*#__PURE__*/

/**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */
function () {
  function _class3(t) {
    _classCallCheck(this, _class3);

    this.databaseInfo = t, this.databaseId = t.databaseId;
    var e = t.ssl ? "https" : "http";
    this.so = e + "://" + t.host, this.io = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
  }

  _createClass(_class3, [{
    key: "ro",
    value: function ro(t, e, n, s, i) {
      var r = this.oo(t, e);
      M("RestConnection", "Sending: ", r, n);
      var o = {};
      return this.uo(o, s, i), this.co(t, r, o, n).then(function (t) {
        return M("RestConnection", "Received: ", t), t;
      }, function (e) {
        throw $("RestConnection", "".concat(t, " failed with error: "), e, "url: ", r, "request:", n), e;
      });
    }
  }, {
    key: "ao",
    value: function ao(t, e, n, s, i) {
      // The REST API automatically aggregates all of the streamed results, so we
      // can just use the normal invoke() method.
      return this.ro(t, e, n, s, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */

  }, {
    key: "uo",
    value: function uo(t, e, n) {
      t["X-Goog-Api-Client"] = "gl-js/ fire/" + x, // Content-Type: text/plain will avoid preflight requests which might
      // mess with CORS and redirects by proxies. If we add custom headers
      // we will need to change this code to potentially use the $httpOverwrite
      // parameter supported by ESF to avoid triggering preflight requests.
      t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach(function (e, n) {
        return t[n] = e;
      }), n && n.headers.forEach(function (e, n) {
        return t[n] = e;
      });
    }
  }, {
    key: "oo",
    value: function oo(t, e) {
      var n = Yo[t];
      return "".concat(this.so, "/v1/").concat(e, ":").concat(n);
    }
  }]);

  return _class3;
}());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Initializes the WebChannelConnection for the browser. */

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** The Platform's 'window' implementation or null if not available. */


function tu() {
  // `window` is not always available, e.g. in ReactNative and WebWorkers.
  // eslint-disable-next-line no-restricted-globals
  return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */


function eu() {
  // `document` is not always available, e.g. in ReactNative and WebWorkers.
  // eslint-disable-next-line no-restricted-globals
  return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function nu(t) {
  return new Ss(t,
  /* useProto3Json= */
  !0);
}
/**
 * An instance of the Platform's 'TextEncoder' implementation.
 */

/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */


var su = /*#__PURE__*/function () {
  function su(
  /**
   * The AsyncQueue to run backoff operations on.
   */
  t,
  /**
   * The ID to use when scheduling backoff operations on the AsyncQueue.
   */
  e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.5;
    var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 6e4;

    _classCallCheck(this, su);

    this.js = t, this.timerId = e, this.lo = n, this.fo = s, this._o = i, this.wo = 0, this.mo = null,
    /** The last backoff attempt, as epoch milliseconds. */
    this.yo = Date.now(), this.reset();
  }
  /**
   * Resets the backoff delay.
   *
   * The very next backoffAndWait() will have no delay. If it is called again
   * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
   * subsequent ones will increase according to the backoffFactor.
   */


  _createClass(su, [{
    key: "reset",
    value: function reset() {
      this.wo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */

  }, {
    key: "po",
    value: function po() {
      this.wo = this._o;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */

  }, {
    key: "Io",
    value: function Io(t) {
      var _this154 = this;

      // Cancel any pending backoff operation.
      this.cancel(); // First schedule using the current base (which may be 0 and should be
      // honored as such).

      var e = Math.floor(this.wo + this.To()),
          n = Math.max(0, Date.now() - this.yo),
          s = Math.max(0, e - n); // Guard against lastAttemptTime being in the future due to a clock change.

      s > 0 && M("ExponentialBackoff", "Backing off for ".concat(s, " ms (base delay: ").concat(this.wo, " ms, delay with jitter: ").concat(e, " ms, last attempt: ").concat(n, " ms ago)")), this.mo = this.js.enqueueAfterDelay(this.timerId, s, function () {
        return _this154.yo = Date.now(), t();
      }), // Apply backoff factor to determine next delay and ensure it is within
      // bounds.
      this.wo *= this.fo, this.wo < this.lo && (this.wo = this.lo), this.wo > this._o && (this.wo = this._o);
    }
  }, {
    key: "Eo",
    value: function Eo() {
      null !== this.mo && (this.mo.skipDelay(), this.mo = null);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      null !== this.mo && (this.mo.cancel(), this.mo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */

  }, {
    key: "To",
    value: function To() {
      return (Math.random() - .5) * this.wo;
    }
  }]);

  return su;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */


var iu = /*#__PURE__*/function () {
  function iu(t, e, n, s, i, r, o, u) {
    _classCallCheck(this, iu);

    this.js = t, this.Ao = n, this.Ro = s, this.bo = i, this.authCredentialsProvider = r, this.appCheckCredentialsProvider = o, this.listener = u, this.state = 0
    /* Initial */
    ,
    /**
     * A close count that's incremented every time the stream is closed; used by
     * getCloseGuardedDispatcher() to invalidate callbacks that happen after
     * close.
     */
    this.Po = 0, this.vo = null, this.Vo = null, this.stream = null, this.So = new su(t, e);
  }
  /**
   * Returns true if start() has been called and no error has occurred. True
   * indicates the stream is open or in the process of opening (which
   * encompasses respecting backoff, getting auth tokens, and starting the
   * actual RPC). Use isOpen() to determine if the stream is open and ready for
   * outbound requests.
   */


  _createClass(iu, [{
    key: "Do",
    value: function Do() {
      return 1
      /* Starting */
      === this.state || 5
      /* Backoff */
      === this.state || this.Co();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */

  }, {
    key: "Co",
    value: function Co() {
      return 2
      /* Open */
      === this.state || 3
      /* Healthy */
      === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */

  }, {
    key: "start",
    value: function start() {
      4
      /* Error */
      !== this.state ? this.auth() : this.xo();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.t0 = this.Do();

                if (!_context16.t0) {
                  _context16.next = 4;
                  break;
                }

                _context16.next = 4;
                return this.close(0
                /* Initial */
                );

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */

  }, {
    key: "No",
    value: function No() {
      this.state = 0
      /* Initial */
      , this.So.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */

  }, {
    key: "ko",
    value: function ko() {
      var _this155 = this;

      // Starts the idle time if we are in state 'Open' and are not yet already
      // running a timer (in which case the previous idle timeout still applies).
      this.Co() && null === this.vo && (this.vo = this.js.enqueueAfterDelay(this.Ao, 6e4, function () {
        return _this155.Oo();
      }));
    }
    /** Sends a message to the underlying stream. */

  }, {
    key: "Mo",
    value: function Mo(t) {
      this.Fo(), this.stream.send(t);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */

  }, {
    key: "Oo",
    value: function () {
      var _Oo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!this.Co()) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt("return", this.close(0
                /* Initial */
                ));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function Oo() {
        return _Oo.apply(this, arguments);
      }

      return Oo;
    }()
    /** Marks the stream as active again. */

  }, {
    key: "Fo",
    value: function Fo() {
      this.vo && (this.vo.cancel(), this.vo = null);
    }
    /** Cancels the health check delayed operation. */

  }, {
    key: "$o",
    value: function $o() {
      this.Vo && (this.Vo.cancel(), this.Vo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t, e) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.Fo();
                this.$o();
                this.So.cancel();
                // Invalidates any stream-related callbacks (e.g. from auth or the
                // underlying stream), guaranteeing they won't execute.
                this.Po++;
                4
                /* Error */
                !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
                this.So.reset() : e && e.code === G.RESOURCE_EXHAUSTED ? ( // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                F(e.toString()), F("Using maximum backoff delay to prevent overloading the backend."), this.So.po()) : e && e.code === G.UNAUTHENTICATED && 3
                /* Healthy */
                !== this.state && ( // "unauthenticated" error means the token was rejected. This should rarely
                // happen since both Auth and AppCheck ensure a sufficient TTL when we
                // request a token. If a user manually resets their system clock this can
                // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
                // before we received the first message and we need to invalidate the token
                // to ensure that we fetch a new token.
                this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken());
                // Clean up the underlying stream because we are no longer interested in events.
                null !== this.stream && (this.Bo(), this.stream.close(), this.stream = null);
                // This state must be assigned before calling onClose() to allow the callback to
                // inhibit backoff or otherwise manipulate the state in its non-started state.
                this.state = t;
                _context18.next = 9;
                return this.listener.Jr(e);

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function close(_x21, _x22) {
        return _close.apply(this, arguments);
      }

      return close;
    }()
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */

  }, {
    key: "Bo",
    value: function Bo() {}
  }, {
    key: "auth",
    value: function auth() {
      var _this156 = this;

      this.state = 1
      /* Starting */
      ;
      var t = this.Lo(this.Po),
          e = this.Po; // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.

      Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then(function (_ref24) {
        var _ref25 = _slicedToArray(_ref24, 2),
            t = _ref25[0],
            n = _ref25[1];

        // Stream can be stopped while waiting for authentication.
        // TODO(mikelehen): We really should just use dispatchIfNotClosed
        // and let this dispatch onto the queue, but that opened a spec test can
        // of worms that I don't want to deal with in this PR.
        _this156.Po === e && // Normally we'd have to schedule the callback on the AsyncQueue.
        // However, the following calls are safe to be called outside the
        // AsyncQueue since they don't chain asynchronous calls
        _this156.Uo(t, n);
      }, function (e) {
        t(function () {
          var t = new Q(G.UNKNOWN, "Fetching auth token failed: " + e.message);
          return _this156.qo(t);
        });
      });
    }
  }, {
    key: "Uo",
    value: function Uo(t, e) {
      var _this157 = this;

      var n = this.Lo(this.Po);
      this.stream = this.Ko(t, e), this.stream.zr(function () {
        n(function () {
          return _this157.state = 2
          /* Open */
          , _this157.Vo = _this157.js.enqueueAfterDelay(_this157.Ro, 1e4, function () {
            return _this157.Co() && (_this157.state = 3
            /* Healthy */
            ), Promise.resolve();
          }), _this157.listener.zr();
        });
      }), this.stream.Jr(function (t) {
        n(function () {
          return _this157.qo(t);
        });
      }), this.stream.onMessage(function (t) {
        n(function () {
          return _this157.onMessage(t);
        });
      });
    }
  }, {
    key: "xo",
    value: function xo() {
      var _this158 = this;

      this.state = 5
      /* Backoff */
      , this.So.Io( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this158.state = 0
                /* Initial */
                , _this158.start();

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      })));
    } // Visible for tests

  }, {
    key: "qo",
    value: function qo(t) {
      // In theory the stream could close cleanly, however, in our current model
      // we never expect this to happen because if we stop a stream ourselves,
      // this callback will never be called. To prevent cases where we retry
      // without a backoff accidentally, we set the stream to error in all cases.
      return M("PersistentStream", "close with error: ".concat(t)), this.stream = null, this.close(4
      /* Error */
      , t);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */

  }, {
    key: "Lo",
    value: function Lo(t) {
      var _this159 = this;

      return function (e) {
        _this159.js.enqueueAndForget(function () {
          return _this159.Po === t ? e() : (M("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
        });
      };
    }
  }]);

  return iu;
}();
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */


var ru = /*#__PURE__*/function (_iu) {
  _inherits(ru, _iu);

  var _super26 = _createSuper(ru);

  function ru(t, e, n, s, i, r) {
    var _this160;

    _classCallCheck(this, ru);

    _this160 = _super26.call(this, t, "listen_stream_connection_backoff"
    /* ListenStreamConnectionBackoff */
    , "listen_stream_idle"
    /* ListenStreamIdle */
    , "health_check_timeout"
    /* HealthCheckTimeout */
    , e, n, s, r), _this160.wt = i;
    return _this160;
  }

  _createClass(ru, [{
    key: "Ko",
    value: function Ko(t, e) {
      return this.bo.ho("Listen", t, e);
    }
  }, {
    key: "onMessage",
    value: function onMessage(t) {
      // A successful response means the stream is healthy
      this.So.reset();

      var e = Qs(this.wt, t),
          n = function (t) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        if (!("targetChange" in t)) return ct.min();
        var e = t.targetChange;
        return e.targetIds && e.targetIds.length ? ct.min() : e.readTime ? Ns(e.readTime) : ct.min();
      }(t);

      return this.listener.Go(e, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */

  }, {
    key: "Qo",
    value: function Qo(t) {
      var e = {};
      e.database = Ls(this.wt), e.addTarget = function (t, e) {
        var n;
        var s = e.target;
        return n = $e(s) ? {
          documents: Hs(t, s)
        } : {
          query: Js(t, s)
        }, n.targetId = e.targetId, e.resumeToken.approximateByteSize() > 0 ? n.resumeToken = Cs(t, e.resumeToken) : e.snapshotVersion.compareTo(ct.min()) > 0 && ( // TODO(wuandy): Consider removing above check because it is most likely true.
        // Right now, many tests depend on this behaviour though (leaving min() out
        // of serialization).
        n.readTime = Ds(t, e.snapshotVersion.toTimestamp())), n;
      }(this.wt, t);
      var n = Xs(this.wt, t);
      n && (e.labels = n), this.Mo(e);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */

  }, {
    key: "jo",
    value: function jo(t) {
      var e = {};
      e.database = Ls(this.wt), e.removeTarget = t, this.Mo(e);
    }
  }]);

  return ru;
}(iu);
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */


var ou = /*#__PURE__*/function (_iu2) {
  _inherits(ou, _iu2);

  var _super27 = _createSuper(ou);

  function ou(t, e, n, s, i, r) {
    var _this161;

    _classCallCheck(this, ou);

    _this161 = _super27.call(this, t, "write_stream_connection_backoff"
    /* WriteStreamConnectionBackoff */
    , "write_stream_idle"
    /* WriteStreamIdle */
    , "health_check_timeout"
    /* HealthCheckTimeout */
    , e, n, s, r), _this161.wt = i, _this161.Wo = !1;
    return _this161;
  }
  /**
   * Tracks whether or not a handshake has been successfully exchanged and
   * the stream is ready to accept mutations.
   */


  _createClass(ou, [{
    key: "zo",
    get: function get() {
      return this.Wo;
    } // Override of PersistentStream.start

  }, {
    key: "start",
    value: function start() {
      this.Wo = !1, this.lastStreamToken = void 0, _get(_getPrototypeOf(ou.prototype), "start", this).call(this);
    }
  }, {
    key: "Bo",
    value: function Bo() {
      this.Wo && this.Ho([]);
    }
  }, {
    key: "Ko",
    value: function Ko(t, e) {
      return this.bo.ho("Write", t, e);
    }
  }, {
    key: "onMessage",
    value: function onMessage(t) {
      if ( // Always capture the last stream token.
      U(!!t.streamToken), this.lastStreamToken = t.streamToken, this.Wo) {
        // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.So.reset();
        var e = zs(t.writeResults, t.commitTime),
            n = Ns(t.commitTime);
        return this.listener.Jo(n, e);
      } // The first response is always the handshake response


      return U(!t.writeResults || 0 === t.writeResults.length), this.Wo = !0, this.listener.Yo();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */

  }, {
    key: "Xo",
    value: function Xo() {
      // TODO(dimond): Support stream resumption. We intentionally do not set the
      // stream token on the handshake, ignoring any stream token we might have.
      var t = {};
      t.database = Ls(this.wt), this.Mo(t);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */

  }, {
    key: "Ho",
    value: function Ho(t) {
      var _this162 = this;

      var e = {
        streamToken: this.lastStreamToken,
        writes: t.map(function (t) {
          return js(_this162.wt, t);
        })
      };
      this.Mo(e);
    }
  }]);

  return ou;
}(iu);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */

/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */


var uu = /*#__PURE__*/function (_ref27) {
  _inherits(uu, _ref27);

  var _super28 = _createSuper(uu);

  function uu(t, e, n, s) {
    var _this163;

    _classCallCheck(this, uu);

    _this163 = _super28.call(this), _this163.authCredentials = t, _this163.appCheckCredentials = e, _this163.bo = n, _this163.wt = s, _this163.Zo = !1;
    return _this163;
  }

  _createClass(uu, [{
    key: "tu",
    value: function tu() {
      if (this.Zo) throw new Q(G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */

  }, {
    key: "ro",
    value: function ro(t, e, n) {
      var _this164 = this;

      return this.tu(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(function (_ref28) {
        var _ref29 = _slicedToArray(_ref28, 2),
            s = _ref29[0],
            i = _ref29[1];

        return _this164.bo.ro(t, e, n, s, i);
      }).catch(function (t) {
        throw "FirebaseError" === t.name ? (t.code === G.UNAUTHENTICATED && (_this164.authCredentials.invalidateToken(), _this164.appCheckCredentials.invalidateToken()), t) : new Q(G.UNKNOWN, t.toString());
      });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */

  }, {
    key: "ao",
    value: function ao(t, e, n) {
      var _this165 = this;

      return this.tu(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(function (_ref30) {
        var _ref31 = _slicedToArray(_ref30, 2),
            s = _ref31[0],
            i = _ref31[1];

        return _this165.bo.ao(t, e, n, s, i);
      }).catch(function (t) {
        throw "FirebaseError" === t.name ? (t.code === G.UNAUTHENTICATED && (_this165.authCredentials.invalidateToken(), _this165.appCheckCredentials.invalidateToken()), t) : new Q(G.UNKNOWN, t.toString());
      });
    }
  }, {
    key: "terminate",
    value: function terminate() {
      this.Zo = !0;
    }
  }]);

  return uu;
}( /*#__PURE__*/function () {
  function _class4() {
    _classCallCheck(this, _class4);
  }

  return _createClass(_class4);
}()); // TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.

/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */


var cu = /*#__PURE__*/function () {
  function cu(t, e) {
    _classCallCheck(this, cu);

    this.asyncQueue = t, this.onlineStateHandler = e,
    /** The current OnlineState. */
    this.state = "Unknown"
    /* Unknown */
    ,
    /**
     * A count of consecutive failures to open the stream. If it reaches the
     * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
     * Offline.
     */
    this.eu = 0,
    /**
     * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
     * transition from OnlineState.Unknown to OnlineState.Offline without waiting
     * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
     */
    this.nu = null,
    /**
     * Whether the client should log a warning message if it fails to connect to
     * the backend (initially true, cleared after a successful stream, or if we've
     * logged the message already).
     */
    this.su = !0;
  }
  /**
   * Called by RemoteStore when a watch stream is started (including on each
   * backoff attempt).
   *
   * If this is the first attempt, it sets the OnlineState to Unknown and starts
   * the onlineStateTimer.
   */


  _createClass(cu, [{
    key: "iu",
    value: function iu() {
      var _this166 = this;

      0 === this.eu && (this.ru("Unknown"
      /* Unknown */
      ), this.nu = this.asyncQueue.enqueueAfterDelay("online_state_timeout"
      /* OnlineStateTimeout */
      , 1e4, function () {
        return _this166.nu = null, _this166.ou("Backend didn't respond within 10 seconds."), _this166.ru("Offline"
        /* Offline */
        ), Promise.resolve();
      }));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */

  }, {
    key: "uu",
    value: function uu(t) {
      "Online"
      /* Online */
      === this.state ? this.ru("Unknown"
      /* Unknown */
      ) : (this.eu++, this.eu >= 1 && (this.cu(), this.ou("Connection failed 1 times. Most recent error: ".concat(t.toString())), this.ru("Offline"
      /* Offline */
      )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */

  }, {
    key: "set",
    value: function set(t) {
      this.cu(), this.eu = 0, "Online"
      /* Online */
      === t && ( // We've connected to watch at least once. Don't warn the developer
      // about being offline going forward.
      this.su = !1), this.ru(t);
    }
  }, {
    key: "ru",
    value: function ru(t) {
      t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }
  }, {
    key: "ou",
    value: function ou(t) {
      var e = "Could not reach Cloud Firestore backend. ".concat(t, "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.");
      this.su ? (F(e), this.su = !1) : M("OnlineStateTracker", e);
    }
  }, {
    key: "cu",
    value: function cu() {
      null !== this.nu && (this.nu.cancel(), this.nu = null);
    }
  }]);

  return cu;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var au = /*#__PURE__*/_createClass(function au(
/**
 * The local store, used to fill the write pipeline with outbound mutations.
 */
t,
/** The client-side proxy for interacting with the backend. */
e, n, s, i) {
  var _this167 = this;

  _classCallCheck(this, au);

  this.localStore = t, this.datastore = e, this.asyncQueue = n, this.remoteSyncer = {},
  /**
   * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
   * LocalStore via fillWritePipeline() and have or will send to the write
   * stream.
   *
   * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
   * restart the write stream. When the stream is established the writes in the
   * pipeline will be sent in order.
   *
   * Writes remain in writePipeline until they are acknowledged by the backend
   * and thus will automatically be re-sent if the stream is interrupted /
   * restarted before they're acknowledged.
   *
   * Write responses from the backend are linked to their originating request
   * purely based on order, and so we can just shift() writes from the front of
   * the writePipeline as we receive responses.
   */
  this.au = [],
  /**
   * A mapping of watched targets that the client cares about tracking and the
   * user has explicitly called a 'listen' for this target.
   *
   * These targets may or may not have been sent to or acknowledged by the
   * server. On re-establishing the listen stream, these targets should be sent
   * to the server. The targets removed with unlistens are removed eagerly
   * without waiting for confirmation from the listen stream.
   */
  this.hu = new Map(),
  /**
   * A set of reasons for why the RemoteStore may be offline. If empty, the
   * RemoteStore may start its network connections.
   */
  this.lu = new Set(),
  /**
   * Event handlers that get called when the network is disabled or enabled.
   *
   * PORTING NOTE: These functions are used on the Web client to create the
   * underlying streams (to support tree-shakeable streams). On Android and iOS,
   * the streams are created during construction of RemoteStore.
   */
  this.fu = [], this.du = i, this.du.Br(function (t) {
    n.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.t0 = yu(_this167);

              if (!_context21.t0) {
                _context21.next = 5;
                break;
              }

              M("RemoteStore", "Restarting streams for network reachability change.");
              _context21.next = 5;
              return function () {
                var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
                  var e;
                  return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          e = K(t);
                          e.lu.add(4
                          /* ConnectivityChange */
                          );
                          _context20.next = 4;
                          return lu(e);

                        case 4:
                          e._u.set("Unknown"
                          /* Unknown */
                          );

                          e.lu.delete(4
                          /* ConnectivityChange */
                          );
                          _context20.next = 8;
                          return hu(e);

                        case 8:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20);
                }));

                return function (_x23) {
                  return _ref33.apply(this, arguments);
                };
              }()(_this167);

            case 5:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    })));
  }), this._u = new cu(n, s);
});

function hu(_x24) {
  return _hu.apply(this, arguments);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */


function _hu() {
  _hu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(t) {
    var _iterator87, _step87, e;

    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) {
        switch (_context77.prev = _context77.next) {
          case 0:
            if (!yu(t)) {
              _context77.next = 18;
              break;
            }

            _iterator87 = _createForOfIteratorHelper(t.fu);
            _context77.prev = 2;

            _iterator87.s();

          case 4:
            if ((_step87 = _iterator87.n()).done) {
              _context77.next = 10;
              break;
            }

            e = _step87.value;
            _context77.next = 8;
            return e(
            /* enabled= */
            !0);

          case 8:
            _context77.next = 4;
            break;

          case 10:
            _context77.next = 15;
            break;

          case 12:
            _context77.prev = 12;
            _context77.t0 = _context77["catch"](2);

            _iterator87.e(_context77.t0);

          case 15:
            _context77.prev = 15;

            _iterator87.f();

            return _context77.finish(15);

          case 18:
          case "end":
            return _context77.stop();
        }
      }
    }, _callee77, null, [[2, 12, 15, 18]]);
  }));
  return _hu.apply(this, arguments);
}

function lu(_x25) {
  return _lu.apply(this, arguments);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */


function _lu() {
  _lu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(t) {
    var _iterator88, _step88, e;

    return _regeneratorRuntime.wrap(function _callee78$(_context78) {
      while (1) {
        switch (_context78.prev = _context78.next) {
          case 0:
            _iterator88 = _createForOfIteratorHelper(t.fu);
            _context78.prev = 1;

            _iterator88.s();

          case 3:
            if ((_step88 = _iterator88.n()).done) {
              _context78.next = 9;
              break;
            }

            e = _step88.value;
            _context78.next = 7;
            return e(
            /* enabled= */
            !1);

          case 7:
            _context78.next = 3;
            break;

          case 9:
            _context78.next = 14;
            break;

          case 11:
            _context78.prev = 11;
            _context78.t0 = _context78["catch"](1);

            _iterator88.e(_context78.t0);

          case 14:
            _context78.prev = 14;

            _iterator88.f();

            return _context78.finish(14);

          case 17:
          case "end":
            return _context78.stop();
        }
      }
    }, _callee78, null, [[1, 11, 14, 17]]);
  }));
  return _lu.apply(this, arguments);
}

function fu(t, e) {
  var n = K(t);
  n.hu.has(e.targetId) || ( // Mark this as something the client is currently listening for.
  n.hu.set(e.targetId, e), gu(n) ? // The listen will be sent in onWatchStreamOpen
  mu(n) : Mu(n).Co() && _u(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */


function du(t, e) {
  var n = K(t),
      s = Mu(n);
  n.hu.delete(e), s.Co() && wu(n, e), 0 === n.hu.size && (s.Co() ? s.ko() : yu(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
  // have no listeners, since without any listens to send we cannot
  // confirm if the stream is healthy and upgrade to OnlineState.Online.
  n._u.set("Unknown"
  /* Unknown */
  ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */


function _u(t, e) {
  t.wu.Nt(e.targetId), Mu(t).Qo(e);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */


function wu(t, e) {
  t.wu.Nt(e), Mu(t).jo(e);
}

function mu(t) {
  t.wu = new Rs({
    getRemoteKeysForTarget: function getRemoteKeysForTarget(e) {
      return t.remoteSyncer.getRemoteKeysForTarget(e);
    },
    te: function te(e) {
      return t.hu.get(e) || null;
    }
  }), Mu(t).start(), t._u.iu();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */


function gu(t) {
  return yu(t) && !Mu(t).Do() && t.hu.size > 0;
}

function yu(t) {
  return 0 === K(t).lu.size;
}

function pu(t) {
  t.wu = void 0;
}

function Iu(_x26) {
  return _Iu.apply(this, arguments);
}

function _Iu() {
  _Iu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(t) {
    return _regeneratorRuntime.wrap(function _callee79$(_context79) {
      while (1) {
        switch (_context79.prev = _context79.next) {
          case 0:
            t.hu.forEach(function (e, n) {
              _u(t, e);
            });

          case 1:
          case "end":
            return _context79.stop();
        }
      }
    }, _callee79);
  }));
  return _Iu.apply(this, arguments);
}

function Tu(_x27, _x28) {
  return _Tu.apply(this, arguments);
}

function _Tu() {
  _Tu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(t, e) {
    return _regeneratorRuntime.wrap(function _callee80$(_context80) {
      while (1) {
        switch (_context80.prev = _context80.next) {
          case 0:
            pu(t), // If we still need the watch stream, retry the connection.
            gu(t) ? (t._u.uu(e), mu(t)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            t._u.set("Unknown"
            /* Unknown */
            );

          case 1:
          case "end":
            return _context80.stop();
        }
      }
    }, _callee80);
  }));
  return _Tu.apply(this, arguments);
}

function Eu(_x29, _x30, _x31) {
  return _Eu.apply(this, arguments);
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */


function _Eu() {
  _Eu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(t, e, n) {
    var _e56;

    return _regeneratorRuntime.wrap(function _callee82$(_context82) {
      while (1) {
        switch (_context82.prev = _context82.next) {
          case 0:
            if (!( // Mark the client as online since we got a message from the server
            t._u.set("Online"
            /* Online */
            ), e instanceof Es && 2
            /* Removed */
            === e.state && e.cause)) {
              _context82.next = 13;
              break;
            }

            _context82.prev = 1;
            _context82.next = 4;
            return (
              /** Handles an error on a target */
              function () {
                var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(t, e) {
                  var n, _iterator89, _step89, s;

                  return _regeneratorRuntime.wrap(function _callee81$(_context81) {
                    while (1) {
                      switch (_context81.prev = _context81.next) {
                        case 0:
                          n = e.cause;
                          _iterator89 = _createForOfIteratorHelper(e.targetIds);
                          _context81.prev = 2;

                          _iterator89.s();

                        case 4:
                          if ((_step89 = _iterator89.n()).done) {
                            _context81.next = 14;
                            break;
                          }

                          s = _step89.value;
                          _context81.t0 = t.hu.has(s);

                          if (!_context81.t0) {
                            _context81.next = 12;
                            break;
                          }

                          _context81.next = 10;
                          return t.remoteSyncer.rejectListen(s, n);

                        case 10:
                          t.hu.delete(s);
                          t.wu.removeTarget(s);

                        case 12:
                          _context81.next = 4;
                          break;

                        case 14:
                          _context81.next = 19;
                          break;

                        case 16:
                          _context81.prev = 16;
                          _context81.t1 = _context81["catch"](2);

                          _iterator89.e(_context81.t1);

                        case 19:
                          _context81.prev = 19;

                          _iterator89.f();

                          return _context81.finish(19);

                        case 22:
                        case "end":
                          return _context81.stop();
                      }
                    }
                  }, _callee81, null, [[2, 16, 19, 22]]);
                }));

                return function (_x133, _x134) {
                  return _ref67.apply(this, arguments);
                };
              }()
              /**
              * Attempts to fill our write pipeline with writes from the LocalStore.
              *
              * Called internally to bootstrap or refill the write pipeline and by
              * SyncEngine whenever there are new mutations to process.
              *
              * Starts the write stream if necessary.
              */
              (t, e)
            );

          case 4:
            _context82.next = 11;
            break;

          case 6:
            _context82.prev = 6;
            _context82.t0 = _context82["catch"](1);
            M("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), _context82.t0);
            _context82.next = 11;
            return Au(t, _context82.t0);

          case 11:
            _context82.next = 29;
            break;

          case 13:
            if (!(e instanceof Is ? t.wu.Ut(e) : e instanceof Ts ? t.wu.zt(e) : t.wu.Gt(e), !n.isEqual(ct.min()))) {
              _context82.next = 29;
              break;
            }

            _context82.prev = 14;
            _context82.next = 17;
            return vo(t.localStore);

          case 17:
            _e56 = _context82.sent;
            _context82.t1 = n.compareTo(_e56) >= 0;

            if (!_context82.t1) {
              _context82.next = 22;
              break;
            }

            _context82.next = 22;
            return (
              /**
              * Takes a batch of changes from the Datastore, repackages them as a
              * RemoteEvent, and passes that on to the listener, which is typically the
              * SyncEngine.
              */
              function (t, e) {
                var n = t.wu.Yt(e); // Update in-memory resume tokens. LocalStore will update the
                // persistent view of these when applying the completed RemoteEvent.

                return n.targetChanges.forEach(function (n, s) {
                  if (n.resumeToken.approximateByteSize() > 0) {
                    var i = t.hu.get(s); // A watched target might have been removed already.

                    i && t.hu.set(s, i.withResumeToken(n.resumeToken, e));
                  }
                }), // Re-establish listens for the targets that have been invalidated by
                // existence filter mismatches.
                n.targetMismatches.forEach(function (e) {
                  var n = t.hu.get(e);
                  if (!n) // A watched target might have been removed already.
                    return; // Clear the resume token for the target, since we're in a known mismatch
                  // state.

                  t.hu.set(e, n.withResumeToken(Jt.EMPTY_BYTE_STRING, n.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                  // deliberately don't send a resume token so that we get a full update.
                  wu(t, e); // Mark the target we send as being on behalf of an existence filter
                  // mismatch, but don't actually retain that in listenTargets. This ensures
                  // that we flag the first re-listen this way without impacting future
                  // listens of this target (that might happen e.g. on reconnect).

                  var s = new Li(n.target, e, 1
                  /* ExistenceFilterMismatch */
                  , n.sequenceNumber);

                  _u(t, s);
                }), t.remoteSyncer.applyRemoteEvent(n);
              }(t, n)
            );

          case 22:
            _context82.next = 29;
            break;

          case 24:
            _context82.prev = 24;
            _context82.t2 = _context82["catch"](14);
            M("RemoteStore", "Failed to raise snapshot:", _context82.t2);
            _context82.next = 29;
            return Au(t, _context82.t2);

          case 29:
          case "end":
            return _context82.stop();
        }
      }
    }, _callee82, null, [[1, 6], [14, 24]]);
  }));
  return _Eu.apply(this, arguments);
}

function Au(_x32, _x33, _x34) {
  return _Au.apply(this, arguments);
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */


function _Au() {
  _Au = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(t, e, n) {
    return _regeneratorRuntime.wrap(function _callee84$(_context84) {
      while (1) {
        switch (_context84.prev = _context84.next) {
          case 0:
            if (Ct(e)) {
              _context84.next = 2;
              break;
            }

            throw e;

          case 2:
            t.lu.add(1
            /* IndexedDbFailed */
            );
            _context84.next = 5;
            return lu(t);

          case 5:
            t._u.set("Offline"
            /* Offline */
            );

            n || ( // Use a simple read operation to determine if IndexedDB recovered.
            // Ideally, we would expose a health check directly on SimpleDb, but
            // RemoteStore only has access to persistence through LocalStore.
            n = function n() {
              return vo(t.localStore);
            });
            // Probe IndexedDB periodically and re-enable network
            t.asyncQueue.enqueueRetryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83() {
              return _regeneratorRuntime.wrap(function _callee83$(_context83) {
                while (1) {
                  switch (_context83.prev = _context83.next) {
                    case 0:
                      M("RemoteStore", "Retrying IndexedDB access");
                      _context83.next = 3;
                      return n();

                    case 3:
                      t.lu.delete(1
                      /* IndexedDbFailed */
                      );
                      _context83.next = 6;
                      return hu(t);

                    case 6:
                    case "end":
                      return _context83.stop();
                  }
                }
              }, _callee83);
            })));

          case 8:
          case "end":
            return _context84.stop();
        }
      }
    }, _callee84);
  }));
  return _Au.apply(this, arguments);
}

function Ru(t, e) {
  return e().catch(function (n) {
    return Au(t, n, e);
  });
}

function bu(_x35) {
  return _bu.apply(this, arguments);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */


function _bu() {
  _bu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(t) {
    var e, n, s, _t119;

    return _regeneratorRuntime.wrap(function _callee85$(_context85) {
      while (1) {
        switch (_context85.prev = _context85.next) {
          case 0:
            e = K(t), n = Fu(e);
            s = e.au.length > 0 ? e.au[e.au.length - 1].batchId : -1;

          case 2:
            if (!Pu(e)) {
              _context85.next = 19;
              break;
            }

            _context85.prev = 3;
            _context85.next = 6;
            return Do(e.localStore, s);

          case 6:
            _t119 = _context85.sent;

            if (!(null === _t119)) {
              _context85.next = 10;
              break;
            }

            0 === e.au.length && n.ko();
            return _context85.abrupt("break", 19);

          case 10:
            s = _t119.batchId, vu(e, _t119);
            _context85.next = 17;
            break;

          case 13:
            _context85.prev = 13;
            _context85.t0 = _context85["catch"](3);
            _context85.next = 17;
            return Au(e, _context85.t0);

          case 17:
            _context85.next = 2;
            break;

          case 19:
            Vu(e) && Su(e);

          case 20:
          case "end":
            return _context85.stop();
        }
      }
    }, _callee85, null, [[3, 13]]);
  }));
  return _bu.apply(this, arguments);
}

function Pu(t) {
  return yu(t) && t.au.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */


function vu(t, e) {
  t.au.push(e);
  var n = Fu(t);
  n.Co() && n.zo && n.Ho(e.mutations);
}

function Vu(t) {
  return yu(t) && !Fu(t).Do() && t.au.length > 0;
}

function Su(t) {
  Fu(t).start();
}

function Du(_x36) {
  return _Du.apply(this, arguments);
}

function _Du() {
  _Du = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(t) {
    return _regeneratorRuntime.wrap(function _callee86$(_context86) {
      while (1) {
        switch (_context86.prev = _context86.next) {
          case 0:
            Fu(t).Xo();

          case 1:
          case "end":
            return _context86.stop();
        }
      }
    }, _callee86);
  }));
  return _Du.apply(this, arguments);
}

function Cu(_x37) {
  return _Cu.apply(this, arguments);
}

function _Cu() {
  _Cu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(t) {
    var e, _iterator90, _step90, n;

    return _regeneratorRuntime.wrap(function _callee87$(_context87) {
      while (1) {
        switch (_context87.prev = _context87.next) {
          case 0:
            e = Fu(t); // Send the write pipeline now that the stream is established.

            _iterator90 = _createForOfIteratorHelper(t.au);

            try {
              for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                n = _step90.value;
                e.Ho(n.mutations);
              }
            } catch (err) {
              _iterator90.e(err);
            } finally {
              _iterator90.f();
            }

          case 3:
          case "end":
            return _context87.stop();
        }
      }
    }, _callee87);
  }));
  return _Cu.apply(this, arguments);
}

function xu(_x38, _x39, _x40) {
  return _xu.apply(this, arguments);
}

function _xu() {
  _xu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(t, e, n) {
    var s, i;
    return _regeneratorRuntime.wrap(function _callee88$(_context88) {
      while (1) {
        switch (_context88.prev = _context88.next) {
          case 0:
            s = t.au.shift(), i = $i.from(s, e, n);
            _context88.next = 3;
            return Ru(t, function () {
              return t.remoteSyncer.applySuccessfulWrite(i);
            });

          case 3:
            _context88.next = 5;
            return bu(t);

          case 5:
          case "end":
            return _context88.stop();
        }
      }
    }, _callee88);
  }));
  return _xu.apply(this, arguments);
}

function Nu(_x41, _x42) {
  return _Nu.apply(this, arguments);
}

function _Nu() {
  _Nu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(t, e) {
    return _regeneratorRuntime.wrap(function _callee90$(_context90) {
      while (1) {
        switch (_context90.prev = _context90.next) {
          case 0:
            _context90.t0 = e && Fu(t).zo;

            if (!_context90.t0) {
              _context90.next = 4;
              break;
            }

            _context90.next = 4;
            return function () {
              var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(t, e) {
                var _n43, n;

                return _regeneratorRuntime.wrap(function _callee89$(_context89) {
                  while (1) {
                    switch (_context89.prev = _context89.next) {
                      case 0:
                        if (!(n = e.code, ns(n) && n !== G.ABORTED)) {
                          _context89.next = 7;
                          break;
                        }

                        // This was a permanent error, the request itself was the problem
                        // so it's not going to succeed if we resend it.
                        _n43 = t.au.shift(); // In this case it's also unlikely that the server itself is melting
                        // down -- this was just a bad request so inhibit backoff on the next
                        // restart.

                        Fu(t).No();
                        _context89.next = 5;
                        return Ru(t, function () {
                          return t.remoteSyncer.rejectFailedWrite(_n43.batchId, e);
                        });

                      case 5:
                        _context89.next = 7;
                        return bu(t);

                      case 7:
                      case "end":
                        return _context89.stop();
                    }
                  }
                }, _callee89);
              }));

              return function (_x135, _x136) {
                return _ref69.apply(this, arguments);
              };
            }()(t, e);

          case 4:
            // The write stream might have been started by refilling the write
            // pipeline for failed writes
            Vu(t) && Su(t);

          case 5:
          case "end":
            return _context90.stop();
        }
      }
    }, _callee90);
  }));
  return _Nu.apply(this, arguments);
}

function ku(_x43, _x44) {
  return _ku.apply(this, arguments);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */


function _ku() {
  _ku = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(t, e) {
    var n, s;
    return _regeneratorRuntime.wrap(function _callee91$(_context91) {
      while (1) {
        switch (_context91.prev = _context91.next) {
          case 0:
            n = K(t);
            n.asyncQueue.verifyOperationInProgress(), M("RemoteStore", "RemoteStore received new credentials");
            s = yu(n); // Tear down and re-create our network streams. This will ensure we get a
            // fresh auth token for the new user and re-fill the write pipeline with
            // new mutations from the LocalStore (since mutations are per-user).

            n.lu.add(3
            /* CredentialChange */
            );
            _context91.next = 6;
            return lu(n);

          case 6:
            s && // Don't set the network status to Unknown if we are offline.
            n._u.set("Unknown"
            /* Unknown */
            );
            _context91.next = 9;
            return n.remoteSyncer.handleCredentialChange(e);

          case 9:
            n.lu.delete(3
            /* CredentialChange */
            );
            _context91.next = 12;
            return hu(n);

          case 12:
          case "end":
            return _context91.stop();
        }
      }
    }, _callee91);
  }));
  return _ku.apply(this, arguments);
}

function Ou(_x45, _x46) {
  return _Ou.apply(this, arguments);
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */


function _Ou() {
  _Ou = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(t, e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee92$(_context92) {
      while (1) {
        switch (_context92.prev = _context92.next) {
          case 0:
            n = K(t);

            if (!e) {
              _context92.next = 7;
              break;
            }

            n.lu.delete(2
            /* IsSecondary */
            );
            _context92.next = 5;
            return hu(n);

          case 5:
            _context92.next = 13;
            break;

          case 7:
            _context92.t0 = e;

            if (_context92.t0) {
              _context92.next = 13;
              break;
            }

            n.lu.add(2
            /* IsSecondary */
            );
            _context92.next = 12;
            return lu(n);

          case 12:
            n._u.set("Unknown"
            /* Unknown */
            );

          case 13:
          case "end":
            return _context92.stop();
        }
      }
    }, _callee92);
  }));
  return _Ou.apply(this, arguments);
}

function Mu(t) {
  return t.mu || ( // Create stream (but note that it is not started yet).
  t.mu = function (t, e, n) {
    var s = K(t);
    return s.tu(), new ru(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
  }
  /**
  * @license
  * Copyright 2018 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */
  (t.datastore, t.asyncQueue, {
    zr: Iu.bind(null, t),
    Jr: Tu.bind(null, t),
    Go: Eu.bind(null, t)
  }), t.fu.push( /*#__PURE__*/function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e) {
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (!e) {
                _context22.next = 4;
                break;
              }

              t.mu.No(), gu(t) ? mu(t) : t._u.set("Unknown"
              /* Unknown */
              );
              _context22.next = 7;
              break;

            case 4:
              _context22.next = 6;
              return t.mu.stop();

            case 6:
              pu(t);

            case 7:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    return function (_x47) {
      return _ref34.apply(this, arguments);
    };
  }())), t.mu;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */


function Fu(t) {
  return t.gu || ( // Create stream (but note that it is not started yet).
  t.gu = function (t, e, n) {
    var s = K(t);
    return s.tu(), new ou(e, s.bo, s.authCredentials, s.appCheckCredentials, s.wt, n);
  }(t.datastore, t.asyncQueue, {
    zr: Du.bind(null, t),
    Jr: Nu.bind(null, t),
    Yo: Cu.bind(null, t),
    Jo: xu.bind(null, t)
  }), t.fu.push( /*#__PURE__*/function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e) {
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              if (!e) {
                _context23.next = 6;
                break;
              }

              t.gu.No();
              _context23.next = 4;
              return bu(t);

            case 4:
              _context23.next = 9;
              break;

            case 6:
              _context23.next = 8;
              return t.gu.stop();

            case 8:
              t.au.length > 0 && (M("RemoteStore", "Stopping write stream with ".concat(t.au.length, " pending writes")), t.au = []);

            case 9:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    return function (_x48) {
      return _ref35.apply(this, arguments);
    };
  }())), t.gu;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */


var $u = /*#__PURE__*/function () {
  function $u(t, e, n, s, i) {
    _classCallCheck(this, $u);

    this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = s, this.removalCallback = i, this.deferred = new j(), this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
    // and so we attach a dummy catch callback to avoid
    // 'UnhandledPromiseRejectionWarning' log spam.
    this.deferred.promise.catch(function (t) {});
  }
  /**
   * Creates and returns a DelayedOperation that has been scheduled to be
   * executed on the provided asyncQueue after the provided delayMs.
   *
   * @param asyncQueue - The queue to schedule the operation on.
   * @param id - A Timer ID identifying the type of operation this is.
   * @param delayMs - The delay (ms) before the operation should be scheduled.
   * @param op - The operation to run.
   * @param removalCallback - A callback to be called synchronously once the
   *   operation is executed or canceled, notifying the AsyncQueue to remove it
   *   from its delayedOperations list.
   *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
   *   the DelayedOperation class public.
   */


  _createClass($u, [{
    key: "start",
    value:
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */
    function start(t) {
      var _this168 = this;

      this.timerHandle = setTimeout(function () {
        return _this168.handleDelayElapsed();
      }, t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */

  }, {
    key: "skipDelay",
    value: function skipDelay() {
      return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */

  }, {
    key: "cancel",
    value: function cancel(t) {
      null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new Q(G.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }
  }, {
    key: "handleDelayElapsed",
    value: function handleDelayElapsed() {
      var _this169 = this;

      this.asyncQueue.enqueueAndForget(function () {
        return null !== _this169.timerHandle ? (_this169.clearTimeout(), _this169.op().then(function (t) {
          return _this169.deferred.resolve(t);
        })) : Promise.resolve();
      });
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    })
  }], [{
    key: "createAndSchedule",
    value: function createAndSchedule(t, e, n, s, i) {
      var r = Date.now() + n,
          o = new $u(t, e, r, s, i);
      return o.start(n), o;
    }
  }]);

  return $u;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */


function Bu(t, e) {
  if (F("AsyncQueue", "".concat(e, ": ").concat(t)), Ct(t)) return new Q(G.UNAVAILABLE, "".concat(e, ": ").concat(t));
  throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */


var Lu = /*#__PURE__*/function () {
  /** The default ordering is by key if the comparator is omitted */
  function Lu(t) {
    _classCallCheck(this, Lu);

    // We are adding document key comparator to the end as it's the only
    // guaranteed unique property of a document.
    this.comparator = t ? function (e, n) {
      return t(e, n) || dt.comparator(e.key, n.key);
    } : function (t, e) {
      return dt.comparator(t.key, e.key);
    }, this.keyedMap = cs(), this.sortedSet = new qt(this.comparator);
  }
  /**
   * Returns an empty copy of the existing DocumentSet, using the same
   * comparator.
   */


  _createClass(Lu, [{
    key: "has",
    value: function has(t) {
      return null != this.keyedMap.get(t);
    }
  }, {
    key: "get",
    value: function get(t) {
      return this.keyedMap.get(t);
    }
  }, {
    key: "first",
    value: function first() {
      return this.sortedSet.minKey();
    }
  }, {
    key: "last",
    value: function last() {
      return this.sortedSet.maxKey();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */

  }, {
    key: "indexOf",
    value: function indexOf(t) {
      var e = this.keyedMap.get(t);
      return e ? this.sortedSet.indexOf(e) : -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */

  }, {
    key: "forEach",
    value: function forEach(t) {
      this.sortedSet.inorderTraversal(function (e, n) {
        return t(e), !1;
      });
    }
    /** Inserts or updates a document with the same key */

  }, {
    key: "add",
    value: function add(t) {
      // First remove the element if we have it.
      var e = this.delete(t.key);
      return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }
    /** Deletes a document with a given key */

  }, {
    key: "delete",
    value: function _delete(t) {
      var e = this.get(t);
      return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      if (!(t instanceof Lu)) return !1;
      if (this.size !== t.size) return !1;
      var e = this.sortedSet.getIterator(),
          n = t.sortedSet.getIterator();

      for (; e.hasNext();) {
        var _t90 = e.getNext().key,
            s = n.getNext().key;
        if (!_t90.isEqual(s)) return !1;
      }

      return !0;
    }
  }, {
    key: "toString",
    value: function toString() {
      var t = [];
      return this.forEach(function (e) {
        t.push(e.toString());
      }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }
  }, {
    key: "copy",
    value: function copy(t, e) {
      var n = new Lu();
      return n.comparator = this.comparator, n.keyedMap = t, n.sortedSet = e, n;
    }
  }], [{
    key: "emptySet",
    value: function emptySet(t) {
      return new Lu(t.comparator);
    }
  }]);

  return Lu;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */


var Uu = /*#__PURE__*/function () {
  function Uu() {
    _classCallCheck(this, Uu);

    this.yu = new qt(dt.comparator);
  }

  _createClass(Uu, [{
    key: "track",
    value: function track(t) {
      var e = t.doc.key,
          n = this.yu.get(e);
      n ? // Merge the new change with the existing change.
      0
      /* Added */
      !== t.type && 3
      /* Metadata */
      === n.type ? this.yu = this.yu.insert(e, t) : 3
      /* Metadata */
      === t.type && 1
      /* Removed */
      !== n.type ? this.yu = this.yu.insert(e, {
        type: n.type,
        doc: t.doc
      }) : 2
      /* Modified */
      === t.type && 2
      /* Modified */
      === n.type ? this.yu = this.yu.insert(e, {
        type: 2
        /* Modified */
        ,
        doc: t.doc
      }) : 2
      /* Modified */
      === t.type && 0
      /* Added */
      === n.type ? this.yu = this.yu.insert(e, {
        type: 0
        /* Added */
        ,
        doc: t.doc
      }) : 1
      /* Removed */
      === t.type && 0
      /* Added */
      === n.type ? this.yu = this.yu.remove(e) : 1
      /* Removed */
      === t.type && 2
      /* Modified */
      === n.type ? this.yu = this.yu.insert(e, {
        type: 1
        /* Removed */
        ,
        doc: n.doc
      }) : 0
      /* Added */
      === t.type && 1
      /* Removed */
      === n.type ? this.yu = this.yu.insert(e, {
        type: 2
        /* Modified */
        ,
        doc: t.doc
      }) : // This includes these cases, which don't make sense:
      // Added->Added
      // Removed->Removed
      // Modified->Added
      // Removed->Modified
      // Metadata->Added
      // Removed->Metadata
      L() : this.yu = this.yu.insert(e, t);
    }
  }, {
    key: "pu",
    value: function pu() {
      var t = [];
      return this.yu.inorderTraversal(function (e, n) {
        t.push(n);
      }), t;
    }
  }]);

  return Uu;
}();

var qu = /*#__PURE__*/function () {
  function qu(t, e, n, s, i, r, o, u) {
    _classCallCheck(this, qu);

    this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = s, this.mutatedKeys = i, this.fromCache = r, this.syncStateChanged = o, this.excludesMetadataChanges = u;
  }
  /** Returns a view snapshot as if all documents in the snapshot were added. */


  _createClass(qu, [{
    key: "hasPendingWrites",
    get: function get() {
      return !this.mutatedKeys.isEmpty();
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      if (!(this.fromCache === t.fromCache && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && dn(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
      var e = this.docChanges,
          n = t.docChanges;
      if (e.length !== n.length) return !1;

      for (var _t91 = 0; _t91 < e.length; _t91++) {
        if (e[_t91].type !== n[_t91].type || !e[_t91].doc.isEqual(n[_t91].doc)) return !1;
      }

      return !0;
    }
  }], [{
    key: "fromInitialDocuments",
    value: function fromInitialDocuments(t, e, n, s) {
      var i = [];
      return e.forEach(function (t) {
        i.push({
          type: 0
          /* Added */
          ,
          doc: t
        });
      }), new qu(t, e, Lu.emptySet(e), i, n, s,
      /* syncStateChanged= */
      !0,
      /* excludesMetadataChanges= */
      !1);
    }
  }]);

  return qu;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */


var Ku = /*#__PURE__*/_createClass(function Ku() {
  _classCallCheck(this, Ku);

  this.Iu = void 0, this.listeners = [];
});

var Gu = /*#__PURE__*/_createClass(function Gu() {
  _classCallCheck(this, Gu);

  this.queries = new is(function (t) {
    return _n(t);
  }, dn), this.onlineState = "Unknown"
  /* Unknown */
  , this.Tu = new Set();
});

function Qu(_x49, _x50) {
  return _Qu.apply(this, arguments);
}

function _Qu() {
  _Qu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(t, e) {
    var n, s, i, r, _n44;

    return _regeneratorRuntime.wrap(function _callee93$(_context93) {
      while (1) {
        switch (_context93.prev = _context93.next) {
          case 0:
            n = K(t), s = e.query;
            i = !1, r = n.queries.get(s);

            if (!(r || (i = !0, r = new Ku()), i)) {
              _context93.next = 13;
              break;
            }

            _context93.prev = 3;
            _context93.next = 6;
            return n.onListen(s);

          case 6:
            r.Iu = _context93.sent;
            _context93.next = 13;
            break;

          case 9:
            _context93.prev = 9;
            _context93.t0 = _context93["catch"](3);
            _n44 = Bu(_context93.t0, "Initialization of query '".concat(wn(e.query), "' failed"));
            return _context93.abrupt("return", void e.onError(_n44));

          case 13:
            if (n.queries.set(s, r), r.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
            e.Eu(n.onlineState), r.Iu) {
              e.Au(r.Iu) && Hu(n);
            }

          case 14:
          case "end":
            return _context93.stop();
        }
      }
    }, _callee93, null, [[3, 9]]);
  }));
  return _Qu.apply(this, arguments);
}

function ju(_x51, _x52) {
  return _ju.apply(this, arguments);
}

function _ju() {
  _ju = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(t, e) {
    var n, s, i, r, _t120;

    return _regeneratorRuntime.wrap(function _callee94$(_context94) {
      while (1) {
        switch (_context94.prev = _context94.next) {
          case 0:
            n = K(t), s = e.query;
            i = !1;
            r = n.queries.get(s);

            if (r) {
              _t120 = r.listeners.indexOf(e);
              _t120 >= 0 && (r.listeners.splice(_t120, 1), i = 0 === r.listeners.length);
            }

            if (!i) {
              _context94.next = 6;
              break;
            }

            return _context94.abrupt("return", (n.queries.delete(s), n.onUnlisten(s)));

          case 6:
          case "end":
            return _context94.stop();
        }
      }
    }, _callee94);
  }));
  return _ju.apply(this, arguments);
}

function Wu(t, e) {
  var n = K(t);
  var s = !1;

  var _iterator61 = _createForOfIteratorHelper(e),
      _step61;

  try {
    for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
      var _t92 = _step61.value;
      var _e43 = _t92.query,
          i = n.queries.get(_e43);

      if (i) {
        var _iterator62 = _createForOfIteratorHelper(i.listeners),
            _step62;

        try {
          for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
            var _e44 = _step62.value;
            _e44.Au(_t92) && (s = !0);
          }
        } catch (err) {
          _iterator62.e(err);
        } finally {
          _iterator62.f();
        }

        i.Iu = _t92;
      }
    }
  } catch (err) {
    _iterator61.e(err);
  } finally {
    _iterator61.f();
  }

  s && Hu(n);
}

function zu(t, e, n) {
  var s = K(t),
      i = s.queries.get(e);

  if (i) {
    var _iterator63 = _createForOfIteratorHelper(i.listeners),
        _step63;

    try {
      for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
        var _t93 = _step63.value;

        _t93.onError(n);
      }
    } catch (err) {
      _iterator63.e(err);
    } finally {
      _iterator63.f();
    }
  } // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
  // after an error.


  s.queries.delete(e);
} // Call all global snapshot listeners that have been set.


function Hu(t) {
  t.Tu.forEach(function (t) {
    t.next();
  });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */


var Ju = /*#__PURE__*/function () {
  function Ju(t, e, n) {
    _classCallCheck(this, Ju);

    this.query = t, this.Ru = e,
    /**
     * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
     * observer. This flag is set to true once we've actually raised an event.
     */
    this.bu = !1, this.Pu = null, this.onlineState = "Unknown"
    /* Unknown */
    , this.options = n || {};
  }
  /**
   * Applies the new ViewSnapshot to this listener, raising a user-facing event
   * if applicable (depending on what changed, whether the user has opted into
   * metadata-only changes, etc.). Returns true if a user-facing event was
   * indeed raised.
   */


  _createClass(Ju, [{
    key: "Au",
    value: function Au(t) {
      if (!this.options.includeMetadataChanges) {
        // Remove the metadata only changes.
        var _e45 = [];

        var _iterator64 = _createForOfIteratorHelper(t.docChanges),
            _step64;

        try {
          for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
            var n = _step64.value;
            3
            /* Metadata */
            !== n.type && _e45.push(n);
          }
        } catch (err) {
          _iterator64.e(err);
        } finally {
          _iterator64.f();
        }

        t = new qu(t.query, t.docs, t.oldDocs, _e45, t.mutatedKeys, t.fromCache, t.syncStateChanged,
        /* excludesMetadataChanges= */
        !0);
      }

      var e = !1;
      return this.bu ? this.vu(t) && (this.Ru.next(t), e = !0) : this.Vu(t, this.onlineState) && (this.Su(t), e = !0), this.Pu = t, e;
    }
  }, {
    key: "onError",
    value: function onError(t) {
      this.Ru.error(t);
    }
    /** Returns whether a snapshot was raised. */

  }, {
    key: "Eu",
    value: function Eu(t) {
      this.onlineState = t;
      var e = !1;
      return this.Pu && !this.bu && this.Vu(this.Pu, t) && (this.Su(this.Pu), e = !0), e;
    }
  }, {
    key: "Vu",
    value: function Vu(t, e) {
      // Always raise the first event when we're synced
      if (!t.fromCache) return !0; // NOTE: We consider OnlineState.Unknown as online (it should become Offline
      // or Online if we wait long enough).

      var n = "Offline"
      /* Offline */
      !== e; // Don't raise the event if we're online, aren't synced yet (checked
      // above) and are waiting for a sync.

      return (!this.options.Du || !n) && (!t.docs.isEmpty() || "Offline"
      /* Offline */
      === e); // Raise data from cache if we have any documents or we are offline
    }
  }, {
    key: "vu",
    value: function vu(t) {
      // We don't need to handle includeDocumentMetadataChanges here because
      // the Metadata only changes have already been stripped out if needed.
      // At this point the only changes we will see are the ones we should
      // propagate.
      if (t.docChanges.length > 0) return !0;
      var e = this.Pu && this.Pu.hasPendingWrites !== t.hasPendingWrites;
      return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges; // Generally we should have hit one of the cases above, but it's possible
      // to get here if there were only metadata docChanges and they got
      // stripped out.
    }
  }, {
    key: "Su",
    value: function Su(t) {
      t = qu.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache), this.bu = !0, this.Ru.next(t);
    }
  }]);

  return Ju;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */


var Yu = /*#__PURE__*/function () {
  function Yu(t, // How many bytes this element takes to store in the bundle.
  e) {
    _classCallCheck(this, Yu);

    this.payload = t, this.byteLength = e;
  }

  _createClass(Yu, [{
    key: "Cu",
    value: function Cu() {
      return "metadata" in this.payload;
    }
  }]);

  return Yu;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Helper to convert objects from bundles to model objects in the SDK.
 */


var Xu = /*#__PURE__*/function () {
  function Xu(t) {
    _classCallCheck(this, Xu);

    this.wt = t;
  }

  _createClass(Xu, [{
    key: "Wi",
    value: function Wi(t) {
      return Fs(this.wt, t);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */

  }, {
    key: "zi",
    value: function zi(t) {
      return t.metadata.exists ? Ks(this.wt, t.document, !1) : xe.newNoDocument(this.Wi(t.metadata.name), this.Hi(t.metadata.readTime));
    }
  }, {
    key: "Hi",
    value: function Hi(t) {
      return Ns(t);
    }
  }]);

  return Xu;
}();
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */


var Zu = /*#__PURE__*/function () {
  function Zu(t, e, n) {
    _classCallCheck(this, Zu);

    this.xu = t, this.localStore = e, this.wt = n,
    /** Batched queries to be saved into storage */
    this.queries = [],
    /** Batched documents to be saved into storage */
    this.documents = [],
    /** The collection groups affected by this bundle. */
    this.collectionGroups = new Set(), this.progress = tc(t);
  }
  /**
   * Adds an element from the bundle to the loader.
   *
   * Returns a new progress if adding the element leads to a new progress,
   * otherwise returns null.
   */


  _createClass(Zu, [{
    key: "Nu",
    value: function Nu(t) {
      this.progress.bytesLoaded += t.byteLength;
      var e = this.progress.documentsLoaded;
      if (t.payload.namedQuery) this.queries.push(t.payload.namedQuery);else if (t.payload.documentMetadata) {
        this.documents.push({
          metadata: t.payload.documentMetadata
        }), t.payload.documentMetadata.exists || ++e;
        var n = ht.fromString(t.payload.documentMetadata.name);
        this.collectionGroups.add(n.get(n.length - 2));
      } else t.payload.document && (this.documents[this.documents.length - 1].document = t.payload.document, ++e);
      return e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }
  }, {
    key: "ku",
    value: function ku(t) {
      var e = new Map(),
          n = new Xu(this.wt);

      var _iterator65 = _createForOfIteratorHelper(t),
          _step65;

      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var s = _step65.value;

          if (s.metadata.queries) {
            var _t94 = n.Wi(s.metadata.name);

            var _iterator66 = _createForOfIteratorHelper(s.metadata.queries),
                _step66;

            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var _n29 = _step66.value;

                var _s21 = (e.get(_n29) || ws()).add(_t94);

                e.set(_n29, _s21);
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }
          }
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }

      return e;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */

  }, {
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var t, e, _iterator67, _step67, _t95;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return Fo(this.localStore, new Xu(this.wt), this.documents, this.xu.id);

              case 2:
                t = _context24.sent;
                e = this.ku(this.documents);
                _iterator67 = _createForOfIteratorHelper(this.queries);
                _context24.prev = 5;

                _iterator67.s();

              case 7:
                if ((_step67 = _iterator67.n()).done) {
                  _context24.next = 13;
                  break;
                }

                _t95 = _step67.value;
                _context24.next = 11;
                return $o(this.localStore, _t95, e.get(_t95.name));

              case 11:
                _context24.next = 7;
                break;

              case 13:
                _context24.next = 18;
                break;

              case 15:
                _context24.prev = 15;
                _context24.t0 = _context24["catch"](5);

                _iterator67.e(_context24.t0);

              case 18:
                _context24.prev = 18;

                _iterator67.f();

                return _context24.finish(18);

              case 21:
                return _context24.abrupt("return", (this.progress.taskState = "Success", {
                  progress: this.progress,
                  Ou: this.collectionGroups,
                  Mu: t
                }));

              case 22:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this, [[5, 15, 18, 21]]);
      }));

      function complete() {
        return _complete.apply(this, arguments);
      }

      return complete;
    }()
  }]);

  return Zu;
}();
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */


function tc(t) {
  return {
    taskState: "Running",
    documentsLoaded: 0,
    bytesLoaded: 0,
    totalDocuments: t.totalDocuments,
    totalBytes: t.totalBytes
  };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ec = /*#__PURE__*/_createClass(function ec(t) {
  _classCallCheck(this, ec);

  this.key = t;
});

var nc = /*#__PURE__*/_createClass(function nc(t) {
  _classCallCheck(this, nc);

  this.key = t;
});
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */


var sc = /*#__PURE__*/function () {
  function sc(t,
  /** Documents included in the remote target */
  e) {
    _classCallCheck(this, sc);

    this.query = t, this.Fu = e, this.$u = null,
    /**
     * A flag whether the view is current with the backend. A view is considered
     * current after it has seen the current flag from the backend and did not
     * lose consistency within the watch stream (e.g. because of an existence
     * filter mismatch).
     */
    this.current = !1,
    /** Documents in the view but not in the remote target */
    this.Bu = ws(),
    /** Document Keys that have local changes */
    this.mutatedKeys = ws(), this.Lu = yn(t), this.Uu = new Lu(this.Lu);
  }
  /**
   * The set of remote documents that the server has told us belongs to the target associated with
   * this view.
   */


  _createClass(sc, [{
    key: "qu",
    get: function get() {
      return this.Fu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */

  }, {
    key: "Ku",
    value: function Ku(t, e) {
      var _this170 = this;

      var n = e ? e.Gu : new Uu(),
          s = e ? e.Uu : this.Uu;
      var i = e ? e.mutatedKeys : this.mutatedKeys,
          r = s,
          o = !1; // Track the last doc in a (full) limit. This is necessary, because some
      // update (a delete, or an update moving a doc past the old limit) might
      // mean there is some other document in the local cache that either should
      // come (1) between the old last limit doc and the new last document, in the
      // case of updates, or (2) after the new last document, in the case of
      // deletes. So we keep this doc at the old limit to compare the updates to.
      // Note that this should never get used in a refill (when previousChanges is
      // set), because there will only be adds -- no deletes or updates.

      var u = "F"
      /* First */
      === this.query.limitType && s.size === this.query.limit ? s.last() : null,
          c = "L"
      /* Last */
      === this.query.limitType && s.size === this.query.limit ? s.first() : null; // Drop documents out to meet limit/limitToLast requirement.

      if (t.inorderTraversal(function (t, e) {
        var a = s.get(t),
            h = mn(_this170.query, e) ? e : null,
            l = !!a && _this170.mutatedKeys.has(a.key),
            f = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
        // mutated during the lifetime of the view.
        _this170.mutatedKeys.has(h.key) && h.hasCommittedMutations);

        var d = !1; // Calculate change

        if (a && h) {
          a.data.isEqual(h.data) ? l !== f && (n.track({
            type: 3
            /* Metadata */
            ,
            doc: h
          }), d = !0) : _this170.Qu(a, h) || (n.track({
            type: 2
            /* Modified */
            ,
            doc: h
          }), d = !0, (u && _this170.Lu(h, u) > 0 || c && _this170.Lu(h, c) < 0) && ( // This doc moved from inside the limit to outside the limit.
          // That means there may be some other doc in the local cache
          // that should be included instead.
          o = !0));
        } else !a && h ? (n.track({
          type: 0
          /* Added */
          ,
          doc: h
        }), d = !0) : a && !h && (n.track({
          type: 1
          /* Removed */
          ,
          doc: a
        }), d = !0, (u || c) && ( // A doc was removed from a full limit query. We'll need to
        // requery from the local cache to see if we know about some other
        // doc that should be in the results.
        o = !0));

        d && (h ? (r = r.add(h), i = f ? i.add(t) : i.delete(t)) : (r = r.delete(t), i = i.delete(t)));
      }), null !== this.query.limit) for (; r.size > this.query.limit;) {
        var _t96 = "F"
        /* First */
        === this.query.limitType ? r.last() : r.first();

        r = r.delete(_t96.key), i = i.delete(_t96.key), n.track({
          type: 1
          /* Removed */
          ,
          doc: _t96
        });
      }
      return {
        Uu: r,
        Gu: n,
        Oi: o,
        mutatedKeys: i
      };
    }
  }, {
    key: "Qu",
    value: function Qu(t, e) {
      // We suppress the initial change event for documents that were modified as
      // part of a write acknowledgment (e.g. when the value of a server transform
      // is applied) as Watch will send us the same document again.
      // By suppressing the event, we only raise two user visible events (one with
      // `hasPendingWrites` and the final state of the document) instead of three
      // (one with `hasPendingWrites`, the modified document with
      // `hasPendingWrites` and the final state of the document).
      return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.

  }, {
    key: "applyChanges",
    value: function applyChanges(t, e, n) {
      var _this171 = this;

      var s = this.Uu;
      this.Uu = t.Uu, this.mutatedKeys = t.mutatedKeys; // Sort changes based on type and query comparator

      var i = t.Gu.pu();
      i.sort(function (t, e) {
        return function (t, e) {
          var n = function n(t) {
            switch (t) {
              case 0
              /* Added */
              :
                return 1;

              case 2
              /* Modified */
              :
              case 3
              /* Metadata */
              :
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;

              case 1
              /* Removed */
              :
                return 0;

              default:
                return L();
            }
          };

          return n(t) - n(e);
        }
        /**
        * @license
        * Copyright 2020 Google LLC
        *
        * Licensed under the Apache License, Version 2.0 (the "License");
        * you may not use this file except in compliance with the License.
        * You may obtain a copy of the License at
        *
        *   http://www.apache.org/licenses/LICENSE-2.0
        *
        * Unless required by applicable law or agreed to in writing, software
        * distributed under the License is distributed on an "AS IS" BASIS,
        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        * See the License for the specific language governing permissions and
        * limitations under the License.
        */
        (t.type, e.type) || _this171.Lu(t.doc, e.doc);
      }), this.ju(n);
      var r = e ? this.Wu() : [],
          o = 0 === this.Bu.size && this.current ? 1
      /* Synced */
      : 0
      /* Local */
      ,
          u = o !== this.$u;

      if (this.$u = o, 0 !== i.length || u) {
        return {
          snapshot: new qu(this.query, t.Uu, s, i, t.mutatedKeys, 0
          /* Local */
          === o, u,
          /* excludesMetadataChanges= */
          !1),
          zu: r
        };
      } // no changes


      return {
        zu: r
      };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */

  }, {
    key: "Eu",
    value: function Eu(t) {
      return this.current && "Offline"
      /* Offline */
      === t ? ( // If we're offline, set `current` to false and then call applyChanges()
      // to refresh our syncState and generate a ViewChange as appropriate. We
      // are guaranteed to get a new TargetChange that sets `current` back to
      // true once the client is back online.
      this.current = !1, this.applyChanges({
        Uu: this.Uu,
        Gu: new Uu(),
        mutatedKeys: this.mutatedKeys,
        Oi: !1
      },
      /* updateLimboDocuments= */
      !1)) : {
        zu: []
      };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */

  }, {
    key: "Hu",
    value: function Hu(t) {
      // If the remote end says it's part of this query, it's not in limbo.
      return !this.Fu.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
      !!this.Uu.has(t) && !this.Uu.get(t).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */

  }, {
    key: "ju",
    value: function ju(t) {
      var _this172 = this;

      t && (t.addedDocuments.forEach(function (t) {
        return _this172.Fu = _this172.Fu.add(t);
      }), t.modifiedDocuments.forEach(function (t) {}), t.removedDocuments.forEach(function (t) {
        return _this172.Fu = _this172.Fu.delete(t);
      }), this.current = t.current);
    }
  }, {
    key: "Wu",
    value: function Wu() {
      var _this173 = this;

      // We can only determine limbo documents when we're in-sync with the server.
      if (!this.current) return []; // TODO(klimt): Do this incrementally so that it's not quadratic when
      // updating many documents.

      var t = this.Bu;
      this.Bu = ws(), this.Uu.forEach(function (t) {
        _this173.Hu(t.key) && (_this173.Bu = _this173.Bu.add(t.key));
      }); // Diff the new limbo docs with the old limbo docs.

      var e = [];
      return t.forEach(function (t) {
        _this173.Bu.has(t) || e.push(new nc(t));
      }), this.Bu.forEach(function (n) {
        t.has(n) || e.push(new ec(n));
      }), e;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.

  }, {
    key: "Ju",
    value: function Ju(t) {
      this.Fu = t.ji, this.Bu = ws();
      var e = this.Ku(t.documents);
      return this.applyChanges(e,
      /*updateLimboDocuments=*/
      !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.

  }, {
    key: "Yu",
    value: function Yu() {
      return qu.fromInitialDocuments(this.query, this.Uu, this.mutatedKeys, 0
      /* Local */
      === this.$u);
    }
  }]);

  return sc;
}();
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */


var ic = /*#__PURE__*/_createClass(function ic(
/**
 * The query itself.
 */
t,
/**
 * The target number created by the client that is used in the watch
 * stream to identify this query.
 */
e,
/**
 * The view is responsible for computing the final merged truth of what
 * docs are in the query. It gets notified of local and remote changes,
 * and applies the query filters and limits to determine the most correct
 * possible results.
 */
n) {
  _classCallCheck(this, ic);

  this.query = t, this.targetId = e, this.view = n;
});
/** Tracks a limbo resolution. */


var rc = /*#__PURE__*/_createClass(function rc(t) {
  _classCallCheck(this, rc);

  this.key = t,
  /**
   * Set to true once we've received a document. This is used in
   * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
   * decide whether it needs to manufacture a delete event for the target once
   * the target is CURRENT.
   */
  this.Xu = !1;
});
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */


var oc = /*#__PURE__*/function () {
  function oc(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
  s, i, r) {
    _classCallCheck(this, oc);

    this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = s, this.currentUser = i, this.maxConcurrentLimboResolutions = r, this.Zu = {}, this.tc = new is(function (t) {
      return _n(t);
    }, dn), this.ec = new Map(),
    /**
     * The keys of documents that are in limbo for which we haven't yet started a
     * limbo resolution query. The strings in this set are the result of calling
     * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
     *
     * The `Set` type was chosen because it provides efficient lookup and removal
     * of arbitrary elements and it also maintains insertion order, providing the
     * desired queue-like FIFO semantics.
     */
    this.nc = new Set(),
    /**
     * Keeps track of the target ID for each document that is in limbo with an
     * active target.
     */
    this.sc = new qt(dt.comparator),
    /**
     * Keeps track of the information about an active limbo resolution for each
     * active target ID that was started for the purpose of limbo resolution.
     */
    this.ic = new Map(), this.rc = new io(),
    /** Stores user completion handlers, indexed by User and BatchId. */
    this.oc = {},
    /** Stores user callbacks waiting for all pending writes to be acknowledged. */
    this.uc = new Map(), this.cc = kr.Rn(), this.onlineState = "Unknown"
    /* Unknown */
    , // The primary state is set to `true` or `false` immediately after Firestore
    // startup. In the interim, a client should only be considered primary if
    // `isPrimary` is true.
    this.ac = void 0;
  }

  _createClass(oc, [{
    key: "isPrimaryClient",
    get: function get() {
      return !0 === this.ac;
    }
  }]);

  return oc;
}();
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */


function uc(_x53, _x54) {
  return _uc.apply(this, arguments);
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */


function _uc() {
  _uc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(t, e) {
    var n, s, i, r, _t121, _r9;

    return _regeneratorRuntime.wrap(function _callee95$(_context95) {
      while (1) {
        switch (_context95.prev = _context95.next) {
          case 0:
            n = Mc(t);
            r = n.tc.get(e);

            if (!r) {
              _context95.next = 6;
              break;
            }

            // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
            // already exists when EventManager calls us for the first time. This
            // happens when the primary tab is already listening to this query on
            // behalf of another tab and the user of the primary also starts listening
            // to the query. EventManager will not have an assigned target ID in this
            // case and calls `listen` to obtain this ID.
            s = r.targetId, n.sharedClientState.addLocalQueryTarget(s), i = r.view.Yu();
            _context95.next = 15;
            break;

          case 6:
            _context95.next = 8;
            return Co(n.localStore, ln(e));

          case 8:
            _t121 = _context95.sent;
            n.isPrimaryClient && fu(n.remoteStore, _t121);
            _r9 = n.sharedClientState.addLocalQueryTarget(_t121.targetId);
            s = _t121.targetId;
            _context95.next = 14;
            return cc(n, e, s, "current" === _r9);

          case 14:
            i = _context95.sent;

          case 15:
            return _context95.abrupt("return", i);

          case 16:
          case "end":
            return _context95.stop();
        }
      }
    }, _callee95);
  }));
  return _uc.apply(this, arguments);
}

function cc(_x55, _x56, _x57, _x58) {
  return _cc.apply(this, arguments);
}
/** Stops listening to the query. */


function _cc() {
  _cc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(t, e, n, s) {
    var i, r, o, u, c, a;
    return _regeneratorRuntime.wrap(function _callee97$(_context97) {
      while (1) {
        switch (_context97.prev = _context97.next) {
          case 0:
            // PORTING NOTE: On Web only, we inject the code that registers new Limbo
            // targets based on view changes. This allows us to only depend on Limbo
            // changes when user code includes queries.
            t.hc = function (e, n, s) {
              return function () {
                var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(t, e, n, s) {
                  var i, r, o;
                  return _regeneratorRuntime.wrap(function _callee96$(_context96) {
                    while (1) {
                      switch (_context96.prev = _context96.next) {
                        case 0:
                          i = e.view.Ku(n);
                          _context96.t0 = i.Oi;

                          if (!_context96.t0) {
                            _context96.next = 6;
                            break;
                          }

                          _context96.next = 5;
                          return No(t.localStore, e.query,
                          /* usePreviousResults= */
                          !1).then(function (_ref71) {
                            var t = _ref71.documents;
                            return e.view.Ku(t, i);
                          });

                        case 5:
                          i = _context96.sent;

                        case 6:
                          r = s && s.targetChanges.get(e.targetId), o = e.view.applyChanges(i,
                          /* updateLimboDocuments= */
                          t.isPrimaryClient, r);
                          return _context96.abrupt("return", (Tc(t, e.targetId, o.zu), o.snapshot));

                        case 8:
                        case "end":
                          return _context96.stop();
                      }
                    }
                  }, _callee96);
                }));

                return function (_x137, _x138, _x139, _x140) {
                  return _ref70.apply(this, arguments);
                };
              }()(t, e, n, s);
            };

            _context97.next = 3;
            return No(t.localStore, e,
            /* usePreviousResults= */
            !0);

          case 3:
            i = _context97.sent;
            r = new sc(e, i.ji);
            o = r.Ku(i.documents);
            u = ps.createSynthesizedTargetChangeForCurrentChange(n, s && "Offline"
            /* Offline */
            !== t.onlineState);
            c = r.applyChanges(o,
            /* updateLimboDocuments= */
            t.isPrimaryClient, u);
            Tc(t, n, c.zu);
            a = new ic(e, n, r);
            return _context97.abrupt("return", (t.tc.set(e, a), t.ec.has(n) ? t.ec.get(n).push(e) : t.ec.set(n, [e]), c.snapshot));

          case 11:
          case "end":
            return _context97.stop();
        }
      }
    }, _callee97);
  }));
  return _cc.apply(this, arguments);
}

function ac(_x59, _x60) {
  return _ac.apply(this, arguments);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */


function _ac() {
  _ac = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(t, e) {
    var n, s, i;
    return _regeneratorRuntime.wrap(function _callee98$(_context98) {
      while (1) {
        switch (_context98.prev = _context98.next) {
          case 0:
            n = K(t), s = n.tc.get(e), i = n.ec.get(s.targetId);

            if (!(i.length > 1)) {
              _context98.next = 3;
              break;
            }

            return _context98.abrupt("return", (n.ec.set(s.targetId, i.filter(function (t) {
              return !dn(t, e);
            })), void n.tc.delete(e)));

          case 3:
            if (!n.isPrimaryClient) {
              _context98.next = 11;
              break;
            }

            // We need to remove the local query target first to allow us to verify
            // whether any other client is still interested in this target.
            n.sharedClientState.removeLocalQueryTarget(s.targetId);
            _context98.t0 = n.sharedClientState.isActiveQueryTarget(s.targetId);

            if (_context98.t0) {
              _context98.next = 9;
              break;
            }

            _context98.next = 9;
            return xo(n.localStore, s.targetId,
            /*keepPersistedTargetData=*/
            !1).then(function () {
              n.sharedClientState.clearQueryState(s.targetId), du(n.remoteStore, s.targetId), pc(n, s.targetId);
            }).catch(bt);

          case 9:
            _context98.next = 14;
            break;

          case 11:
            pc(n, s.targetId);
            _context98.next = 14;
            return xo(n.localStore, s.targetId,
            /*keepPersistedTargetData=*/
            !0);

          case 14:
          case "end":
            return _context98.stop();
        }
      }
    }, _callee98);
  }));
  return _ac.apply(this, arguments);
}

function hc(_x61, _x62, _x63) {
  return _hc.apply(this, arguments);
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */


function _hc() {
  _hc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(t, e, n) {
    var s, _t122, _e58;

    return _regeneratorRuntime.wrap(function _callee99$(_context99) {
      while (1) {
        switch (_context99.prev = _context99.next) {
          case 0:
            s = Fc(t);
            _context99.prev = 1;
            _context99.next = 4;
            return function (t, e) {
              var n = K(t),
                  s = ut.now(),
                  i = e.reduce(function (t, e) {
                return t.add(e.key);
              }, ws());
              var r, o;
              return n.persistence.runTransaction("Locally write mutations", "readwrite", function (t) {
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                var u = os(),
                    c = ws();
                return n.Ui.getEntries(t, i).next(function (t) {
                  u = t, u.forEach(function (t, e) {
                    e.isValidDocument() || (c = c.add(t));
                  });
                }).next(function () {
                  return n.localDocuments.getOverlayedDocuments(t, u);
                }).next(function (i) {
                  r = i; // For non-idempotent mutations (such as `FieldValue.increment()`),
                  // we record the base state in a separate patch mutation. This is
                  // later used to guarantee consistent values and prevents flicker
                  // even if the backend sends us an update that already includes our
                  // transform.

                  var o = [];

                  var _iterator91 = _createForOfIteratorHelper(e),
                      _step91;

                  try {
                    for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                      var _t123 = _step91.value;

                      var _e57 = Gn(_t123, r.get(_t123.key).overlayedDocument);

                      null != _e57 && // NOTE: The base state should only be applied if there's some
                      // existing document to override, so use a Precondition of
                      // exists=true
                      o.push(new Wn(_t123.key, _e57, Ce(_e57.value.mapValue), $n.exists(!0)));
                    }
                  } catch (err) {
                    _iterator91.e(err);
                  } finally {
                    _iterator91.f();
                  }

                  return n.mutationQueue.addMutationBatch(t, s, o, e);
                }).next(function (e) {
                  o = e;
                  var s = e.applyToLocalDocumentSet(r, c);
                  return n.documentOverlayCache.saveOverlays(t, e.batchId, s);
                });
              }).then(function () {
                return {
                  batchId: o.batchId,
                  changes: as(r)
                };
              });
            }(s.localStore, e);

          case 4:
            _t122 = _context99.sent;
            s.sharedClientState.addPendingMutation(_t122.batchId);

            (function (t, e, n) {
              var s = t.oc[t.currentUser.toKey()];
              s || (s = new qt(it));
              s = s.insert(e, n), t.oc[t.currentUser.toKey()] = s;
            }
            /**
            * Resolves or rejects the user callback for the given batch and then discards
            * it.
            */
            )(s, _t122.batchId, n);

            _context99.next = 9;
            return Rc(s, _t122.changes);

          case 9:
            _context99.next = 11;
            return bu(s.remoteStore);

          case 11:
            _context99.next = 17;
            break;

          case 13:
            _context99.prev = 13;
            _context99.t0 = _context99["catch"](1);
            // If we can't persist the mutation, we reject the user callback and
            // don't send the mutation. The user can then retry the write.
            _e58 = Bu(_context99.t0, "Failed to persist write");
            n.reject(_e58);

          case 17:
          case "end":
            return _context99.stop();
        }
      }
    }, _callee99, null, [[1, 13]]);
  }));
  return _hc.apply(this, arguments);
}

function lc(_x64, _x65) {
  return _lc.apply(this, arguments);
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */


function _lc() {
  _lc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(t, e) {
    var n, _t124;

    return _regeneratorRuntime.wrap(function _callee100$(_context100) {
      while (1) {
        switch (_context100.prev = _context100.next) {
          case 0:
            n = K(t);
            _context100.prev = 1;
            _context100.next = 4;
            return Vo(n.localStore, e);

          case 4:
            _t124 = _context100.sent;
            e.targetChanges.forEach(function (t, e) {
              var s = n.ic.get(e);
              s && ( // Since this is a limbo resolution lookup, it's for a single document
              // and it could be added, modified, or removed, but not a combination.
              U(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? s.Xu = !0 : t.modifiedDocuments.size > 0 ? U(s.Xu) : t.removedDocuments.size > 0 && (U(s.Xu), s.Xu = !1));
            });
            _context100.next = 8;
            return Rc(n, _t124, e);

          case 8:
            _context100.next = 14;
            break;

          case 10:
            _context100.prev = 10;
            _context100.t0 = _context100["catch"](1);
            _context100.next = 14;
            return bt(_context100.t0);

          case 14:
          case "end":
            return _context100.stop();
        }
      }
    }, _callee100, null, [[1, 10]]);
  }));
  return _lc.apply(this, arguments);
}

function fc(t, e, n) {
  var s = K(t); // If we are the secondary client, we explicitly ignore the remote store's
  // online state (the local client may go offline, even though the primary
  // tab remains online) and only apply the primary tab's online state from
  // SharedClientState.

  if (s.isPrimaryClient && 0
  /* RemoteStore */
  === n || !s.isPrimaryClient && 1
  /* SharedClientState */
  === n) {
    var _t97 = [];
    s.tc.forEach(function (n, s) {
      var i = s.view.Eu(e);
      i.snapshot && _t97.push(i.snapshot);
    }), function (t, e) {
      var n = K(t);
      n.onlineState = e;
      var s = !1;
      n.queries.forEach(function (t, n) {
        var _iterator68 = _createForOfIteratorHelper(n.listeners),
            _step68;

        try {
          for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) // Run global snapshot listeners if a consistent snapshot has been emitted.
          {
            var _t98 = _step68.value;
            _t98.Eu(e) && (s = !0);
          }
        } catch (err) {
          _iterator68.e(err);
        } finally {
          _iterator68.f();
        }
      }), s && Hu(n);
    }(s.eventManager, e), _t97.length && s.Zu.Go(_t97), s.onlineState = e, s.isPrimaryClient && s.sharedClientState.setOnlineState(e);
  }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */


function dc(_x66, _x67, _x68) {
  return _dc.apply(this, arguments);
}

function _dc() {
  _dc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(t, e, n) {
    var s, i, r, _t125, _n45, _i19;

    return _regeneratorRuntime.wrap(function _callee101$(_context101) {
      while (1) {
        switch (_context101.prev = _context101.next) {
          case 0:
            s = K(t); // PORTING NOTE: Multi-tab only.

            s.sharedClientState.updateQueryState(e, "rejected", n);
            i = s.ic.get(e), r = i && i.key;

            if (!r) {
              _context101.next = 14;
              break;
            }

            // TODO(klimt): We really only should do the following on permission
            // denied errors, but we don't have the cause code here.
            // It's a limbo doc. Create a synthetic event saying it was deleted.
            // This is kind of a hack. Ideally, we would have a method in the local
            // store to purge a document. However, it would be tricky to keep all of
            // the local store's invariants with another method.
            _t125 = new qt(dt.comparator); // TODO(b/217189216): This limbo document should ideally have a read time,
            // so that it is picked up by any read-time based scans. The backend,
            // however, does not send a read time for target removals.

            _t125 = _t125.insert(r, xe.newNoDocument(r, ct.min()));
            _n45 = ws().add(r), _i19 = new ys(ct.min(),
            /* targetChanges= */
            new Map(),
            /* targetMismatches= */
            new Qt(it), _t125, _n45);
            _context101.next = 9;
            return lc(s, _i19);

          case 9:
            // Since this query failed, we won't want to manually unlisten to it.
            // We only remove it from bookkeeping after we successfully applied the
            // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
            // this query when the RemoteStore restarts the Watch stream, which should
            // re-trigger the target failure.
            s.sc = s.sc.remove(r);
            s.ic.delete(e);
            Ac(s);
            _context101.next = 16;
            break;

          case 14:
            _context101.next = 16;
            return xo(s.localStore, e,
            /* keepPersistedTargetData */
            !1).then(function () {
              return pc(s, e, n);
            }).catch(bt);

          case 16:
          case "end":
            return _context101.stop();
        }
      }
    }, _callee101);
  }));
  return _dc.apply(this, arguments);
}

function _c(_x69, _x70) {
  return _c2.apply(this, arguments);
}

function _c2() {
  _c2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102(t, e) {
    var n, s, _t126;

    return _regeneratorRuntime.wrap(function _callee102$(_context102) {
      while (1) {
        switch (_context102.prev = _context102.next) {
          case 0:
            n = K(t), s = e.batch.batchId;
            _context102.prev = 1;
            _context102.next = 4;
            return Po(n.localStore, e);

          case 4:
            _t126 = _context102.sent;
            yc(n, s,
            /*error=*/
            null);
            gc(n, s);
            n.sharedClientState.updateMutationState(s, "acknowledged");
            _context102.next = 10;
            return Rc(n, _t126);

          case 10:
            _context102.next = 16;
            break;

          case 12:
            _context102.prev = 12;
            _context102.t0 = _context102["catch"](1);
            _context102.next = 16;
            return bt(_context102.t0);

          case 16:
          case "end":
            return _context102.stop();
        }
      }
    }, _callee102, null, [[1, 12]]);
  }));
  return _c2.apply(this, arguments);
}

function wc(_x71, _x72, _x73) {
  return _wc.apply(this, arguments);
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */


function _wc() {
  _wc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(t, e, n) {
    var s, _t127;

    return _regeneratorRuntime.wrap(function _callee103$(_context103) {
      while (1) {
        switch (_context103.prev = _context103.next) {
          case 0:
            s = K(t);
            _context103.prev = 1;
            _context103.next = 4;
            return function (t, e) {
              var n = K(t);
              return n.persistence.runTransaction("Reject batch", "readwrite-primary", function (t) {
                var s;
                return n.mutationQueue.lookupMutationBatch(t, e).next(function (e) {
                  return U(null !== e), s = e.keys(), n.mutationQueue.removeMutationBatch(t, e);
                }).next(function () {
                  return n.mutationQueue.performConsistencyCheck(t);
                }).next(function () {
                  return n.documentOverlayCache.removeOverlaysForBatchId(t, s, e);
                }).next(function () {
                  return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, s);
                }).next(function () {
                  return n.localDocuments.getDocuments(t, s);
                });
              });
            }
            /**
            * Returns the largest (latest) batch id in mutation queue that is pending
            * server response.
            *
            * Returns `BATCHID_UNKNOWN` if the queue is empty.
            */
            (s.localStore, e);

          case 4:
            _t127 = _context103.sent;
            yc(s, e, n);
            gc(s, e);
            s.sharedClientState.updateMutationState(e, "rejected", n);
            _context103.next = 10;
            return Rc(s, _t127);

          case 10:
            _context103.next = 16;
            break;

          case 12:
            _context103.prev = 12;
            _context103.t0 = _context103["catch"](1);
            _context103.next = 16;
            return bt(_context103.t0);

          case 16:
          case "end":
            return _context103.stop();
        }
      }
    }, _callee103, null, [[1, 12]]);
  }));
  return _wc.apply(this, arguments);
}

function mc(_x74, _x75) {
  return _mc.apply(this, arguments);
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */


function _mc() {
  _mc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(t, e) {
    var n, _t128, s, _n46;

    return _regeneratorRuntime.wrap(function _callee104$(_context104) {
      while (1) {
        switch (_context104.prev = _context104.next) {
          case 0:
            n = K(t);
            yu(n.remoteStore) || M("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
            _context104.prev = 2;
            _context104.next = 5;
            return function (t) {
              var e = K(t);
              return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function (t) {
                return e.mutationQueue.getHighestUnacknowledgedBatchId(t);
              });
            }(n.localStore);

          case 5:
            _t128 = _context104.sent;

            if (!(-1 === _t128)) {
              _context104.next = 8;
              break;
            }

            return _context104.abrupt("return", void e.resolve());

          case 8:
            s = n.uc.get(_t128) || [];
            s.push(e), n.uc.set(_t128, s);
            _context104.next = 16;
            break;

          case 12:
            _context104.prev = 12;
            _context104.t0 = _context104["catch"](2);
            _n46 = Bu(_context104.t0, "Initialization of waitForPendingWrites() operation failed");
            e.reject(_n46);

          case 16:
          case "end":
            return _context104.stop();
        }
      }
    }, _callee104, null, [[2, 12]]);
  }));
  return _mc.apply(this, arguments);
}

function gc(t, e) {
  (t.uc.get(e) || []).forEach(function (t) {
    t.resolve();
  }), t.uc.delete(e);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */


function yc(t, e, n) {
  var s = K(t);
  var i = s.oc[s.currentUser.toKey()]; // NOTE: Mutations restored from persistence won't have callbacks, so it's
  // okay for there to be no callback for this ID.

  if (i) {
    var _t99 = i.get(e);

    _t99 && (n ? _t99.reject(n) : _t99.resolve(), i = i.remove(e)), s.oc[s.currentUser.toKey()] = i;
  }
}

function pc(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  t.sharedClientState.removeLocalQueryTarget(e);

  var _iterator69 = _createForOfIteratorHelper(t.ec.get(e)),
      _step69;

  try {
    for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
      var s = _step69.value;
      t.tc.delete(s), n && t.Zu.lc(s, n);
    }
  } catch (err) {
    _iterator69.e(err);
  } finally {
    _iterator69.f();
  }

  if (t.ec.delete(e), t.isPrimaryClient) {
    t.rc.us(e).forEach(function (e) {
      t.rc.containsKey(e) || // We removed the last reference for this key
      Ic(t, e);
    });
  }
}

function Ic(t, e) {
  t.nc.delete(e.path.canonicalString()); // It's possible that the target already got removed because the query failed. In that case,
  // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.

  var n = t.sc.get(e);
  null !== n && (du(t.remoteStore, n), t.sc = t.sc.remove(e), t.ic.delete(n), Ac(t));
}

function Tc(t, e, n) {
  var _iterator70 = _createForOfIteratorHelper(n),
      _step70;

  try {
    for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
      var s = _step70.value;
      if (s instanceof ec) t.rc.addReference(s.key, e), Ec(t, s);else if (s instanceof nc) {
        M("SyncEngine", "Document no longer in limbo: " + s.key), t.rc.removeReference(s.key, e);
        t.rc.containsKey(s.key) || // We removed the last reference for this key
        Ic(t, s.key);
      } else L();
    }
  } catch (err) {
    _iterator70.e(err);
  } finally {
    _iterator70.f();
  }
}

function Ec(t, e) {
  var n = e.key,
      s = n.path.canonicalString();
  t.sc.get(n) || t.nc.has(s) || (M("SyncEngine", "New document in limbo: " + n), t.nc.add(s), Ac(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */


function Ac(t) {
  for (; t.nc.size > 0 && t.sc.size < t.maxConcurrentLimboResolutions;) {
    var e = t.nc.values().next().value;
    t.nc.delete(e);
    var n = new dt(ht.fromString(e)),
        s = t.cc.next();
    t.ic.set(s, new rc(n)), t.sc = t.sc.insert(n, s), fu(t.remoteStore, new Li(ln(rn(n.path)), s, 2
    /* LimboResolution */
    , $t.ot));
  }
}

function Rc(_x76, _x77, _x78) {
  return _Rc.apply(this, arguments);
}

function _Rc() {
  _Rc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(t, e, n) {
    var s, i, r, o;
    return _regeneratorRuntime.wrap(function _callee106$(_context106) {
      while (1) {
        switch (_context106.prev = _context106.next) {
          case 0:
            s = K(t), i = [], r = [], o = [];
            _context106.t0 = s.tc.isEmpty();

            if (_context106.t0) {
              _context106.next = 9;
              break;
            }

            s.tc.forEach(function (t, u) {
              o.push(s.hc(u, e, n).then(function (t) {
                if (t) {
                  s.isPrimaryClient && s.sharedClientState.updateQueryState(u.targetId, t.fromCache ? "not-current" : "current"), i.push(t);

                  var _e59 = To.Vi(u.targetId, t);

                  r.push(_e59);
                }
              }));
            });
            _context106.next = 6;
            return Promise.all(o);

          case 6:
            s.Zu.Go(i);
            _context106.next = 9;
            return function () {
              var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(t, e) {
                var n, _iterator92, _step92, _t129, _e60, _t130, _s34, _i20;

                return _regeneratorRuntime.wrap(function _callee105$(_context105) {
                  while (1) {
                    switch (_context105.prev = _context105.next) {
                      case 0:
                        n = K(t);
                        _context105.prev = 1;
                        _context105.next = 4;
                        return n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function (t) {
                          return Pt.forEach(e, function (e) {
                            return Pt.forEach(e.Pi, function (s) {
                              return n.persistence.referenceDelegate.addReference(t, e.targetId, s);
                            }).next(function () {
                              return Pt.forEach(e.vi, function (s) {
                                return n.persistence.referenceDelegate.removeReference(t, e.targetId, s);
                              });
                            });
                          });
                        });

                      case 4:
                        _context105.next = 11;
                        break;

                      case 6:
                        _context105.prev = 6;
                        _context105.t0 = _context105["catch"](1);

                        if (Ct(_context105.t0)) {
                          _context105.next = 10;
                          break;
                        }

                        throw _context105.t0;

                      case 10:
                        // If `notifyLocalViewChanges` fails, we did not advance the sequence
                        // number for the documents that were included in this transaction.
                        // This might trigger them to be deleted earlier than they otherwise
                        // would have, but it should not invalidate the integrity of the data.
                        M("LocalStore", "Failed to update sequence numbers: " + _context105.t0);

                      case 11:
                        _iterator92 = _createForOfIteratorHelper(e);

                        try {
                          for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
                            _t129 = _step92.value;
                            _e60 = _t129.targetId;

                            if (!_t129.fromCache) {
                              _t130 = n.$i.get(_e60), _s34 = _t130.snapshotVersion, _i20 = _t130.withLastLimboFreeSnapshotVersion(_s34); // Advance the last limbo free snapshot version

                              n.$i = n.$i.insert(_e60, _i20);
                            }
                          }
                        } catch (err) {
                          _iterator92.e(err);
                        } finally {
                          _iterator92.f();
                        }

                      case 13:
                      case "end":
                        return _context105.stop();
                    }
                  }
                }, _callee105, null, [[1, 6]]);
              }));

              return function (_x141, _x142) {
                return _ref72.apply(this, arguments);
              };
            }()(s.localStore, r);

          case 9:
          case "end":
            return _context106.stop();
        }
      }
    }, _callee106);
  }));
  return _Rc.apply(this, arguments);
}

function bc(_x79, _x80) {
  return _bc.apply(this, arguments);
}

function _bc() {
  _bc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(t, e) {
    var n, _t131;

    return _regeneratorRuntime.wrap(function _callee107$(_context107) {
      while (1) {
        switch (_context107.prev = _context107.next) {
          case 0:
            n = K(t);

            if (n.currentUser.isEqual(e)) {
              _context107.next = 11;
              break;
            }

            M("SyncEngine", "User change. New user:", e.toKey());
            _context107.next = 5;
            return bo(n.localStore, e);

          case 5:
            _t131 = _context107.sent;
            n.currentUser = e;

            // Fails tasks waiting for pending writes requested by previous user.
            (function (t, e) {
              t.uc.forEach(function (t) {
                t.forEach(function (t) {
                  t.reject(new Q(G.CANCELLED, e));
                });
              }), t.uc.clear();
            })(n, "'waitForPendingWrites' promise is rejected due to a user change.");

            // TODO(b/114226417): Consider calling this only in the primary tab.
            n.sharedClientState.handleUserChange(e, _t131.removedBatchIds, _t131.addedBatchIds);
            _context107.next = 11;
            return Rc(n, _t131.Ki);

          case 11:
          case "end":
            return _context107.stop();
        }
      }
    }, _callee107);
  }));
  return _bc.apply(this, arguments);
}

function Pc(t, e) {
  var n = K(t),
      s = n.ic.get(e);
  if (s && s.Xu) return ws().add(s.key);
  {
    var _t100 = ws();

    var _s22 = n.ec.get(e);

    if (!_s22) return _t100;

    var _iterator71 = _createForOfIteratorHelper(_s22),
        _step71;

    try {
      for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
        var _e46 = _step71.value;

        var _s23 = n.tc.get(_e46);

        _t100 = _t100.unionWith(_s23.view.qu);
      }
    } catch (err) {
      _iterator71.e(err);
    } finally {
      _iterator71.f();
    }

    return _t100;
  }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */


function vc(_x81, _x82) {
  return _vc.apply(this, arguments);
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */
// PORTING NOTE: Multi-Tab only.


function _vc() {
  _vc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(t, e) {
    var n, s, i;
    return _regeneratorRuntime.wrap(function _callee108$(_context108) {
      while (1) {
        switch (_context108.prev = _context108.next) {
          case 0:
            n = K(t);
            _context108.next = 3;
            return No(n.localStore, e.query,
            /* usePreviousResults= */
            !0);

          case 3:
            s = _context108.sent;
            i = e.view.Ju(s);
            return _context108.abrupt("return", (n.isPrimaryClient && Tc(n, e.targetId, i.zu), i));

          case 6:
          case "end":
            return _context108.stop();
        }
      }
    }, _callee108);
  }));
  return _vc.apply(this, arguments);
}

function Vc(_x83, _x84) {
  return _Vc.apply(this, arguments);
}
/** Applies a mutation state to an existing batch.  */
// PORTING NOTE: Multi-Tab only.


function _Vc() {
  _Vc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(t, e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee109$(_context109) {
      while (1) {
        switch (_context109.prev = _context109.next) {
          case 0:
            n = K(t);
            return _context109.abrupt("return", Oo(n.localStore, e).then(function (t) {
              return Rc(n, t);
            }));

          case 2:
          case "end":
            return _context109.stop();
        }
      }
    }, _callee109);
  }));
  return _Vc.apply(this, arguments);
}

function Sc(_x85, _x86, _x87, _x88) {
  return _Sc.apply(this, arguments);
}
/** Applies a query target change from a different tab. */
// PORTING NOTE: Multi-Tab only.


function _Sc() {
  _Sc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(t, e, n, s) {
    var i, r;
    return _regeneratorRuntime.wrap(function _callee110$(_context110) {
      while (1) {
        switch (_context110.prev = _context110.next) {
          case 0:
            i = K(t);
            _context110.next = 3;
            return function (t, e) {
              var n = K(t),
                  s = K(n.mutationQueue);
              return n.persistence.runTransaction("Lookup mutation documents", "readonly", function (t) {
                return s.yn(t, e).next(function (e) {
                  return e ? n.localDocuments.getDocuments(t, e) : Pt.resolve(null);
                });
              });
            } // PORTING NOTE: Multi-Tab only.
            (i.localStore, e);

          case 3:
            r = _context110.sent;

            if (!(null !== r)) {
              _context110.next = 15;
              break;
            }

            if (!("pending" === n)) {
              _context110.next = 10;
              break;
            }

            _context110.next = 8;
            return bu(i.remoteStore);

          case 8:
            _context110.next = 11;
            break;

          case 10:
            "acknowledged" === n || "rejected" === n ? ( // NOTE: Both these methods are no-ops for batches that originated from
            // other clients.
            yc(i, e, s || null), gc(i, e), function (t, e) {
              K(K(t).mutationQueue).In(e);
            } // PORTING NOTE: Multi-Tab only.
            (i.localStore, e)) : L();

          case 11:
            _context110.next = 13;
            return Rc(i, r);

          case 13:
            _context110.next = 16;
            break;

          case 15:
            // A throttled tab may not have seen the mutation before it was completed
            // and removed from the mutation queue, in which case we won't have cached
            // the affected documents. In this case we can safely ignore the update
            // since that means we didn't apply the mutation locally at all (if we
            // had, we would have cached the affected documents), and so we will just
            // see any resulting document changes via normal remote document updates
            // as applicable.
            M("SyncEngine", "Cannot apply mutation batch with id: " + e);

          case 16:
          case "end":
            return _context110.stop();
        }
      }
    }, _callee110);
  }));
  return _Sc.apply(this, arguments);
}

function Dc(_x89, _x90) {
  return _Dc.apply(this, arguments);
}

function _Dc() {
  _Dc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(t, e) {
    var n, _t132, _e61, _iterator93, _step93, _t133, _t134, _e62;

    return _regeneratorRuntime.wrap(function _callee111$(_context111) {
      while (1) {
        switch (_context111.prev = _context111.next) {
          case 0:
            n = K(t);

            if (!(Mc(n), Fc(n), !0 === e && !0 !== n.ac)) {
              _context111.next = 13;
              break;
            }

            _t132 = n.sharedClientState.getAllActiveQueryTargets();
            _context111.next = 5;
            return Cc(n, _t132.toArray());

          case 5:
            _e61 = _context111.sent;
            n.ac = !0;
            _context111.next = 9;
            return Ou(n.remoteStore, !0);

          case 9:
            _iterator93 = _createForOfIteratorHelper(_e61);

            try {
              for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
                _t133 = _step93.value;
                fu(n.remoteStore, _t133);
              }
            } catch (err) {
              _iterator93.e(err);
            } finally {
              _iterator93.f();
            }

            _context111.next = 25;
            break;

          case 13:
            if (!(!1 === e && !1 !== n.ac)) {
              _context111.next = 25;
              break;
            }

            _t134 = [];
            _e62 = Promise.resolve();
            n.ec.forEach(function (s, i) {
              n.sharedClientState.isLocalQueryTarget(i) ? _t134.push(i) : _e62 = _e62.then(function () {
                return pc(n, i), xo(n.localStore, i,
                /*keepPersistedTargetData=*/
                !0);
              }), du(n.remoteStore, i);
            });
            _context111.next = 19;
            return _e62;

          case 19:
            _context111.next = 21;
            return Cc(n, _t134);

          case 21:
            // PORTING NOTE: Multi-Tab only.
            (function (t) {
              var e = K(t);
              e.ic.forEach(function (t, n) {
                du(e.remoteStore, n);
              }), e.rc.cs(), e.ic = new Map(), e.sc = new qt(dt.comparator);
            }
            /**
            * Reconcile the query views of the provided query targets with the state from
            * persistence. Raises snapshots for any changes that affect the local
            * client and returns the updated state of all target's query data.
            *
            * @param syncEngine - The sync engine implementation
            * @param targets - the list of targets with views that need to be recomputed
            * @param transitionToPrimary - `true` iff the tab transitions from a secondary
            * tab to a primary tab
            */
            // PORTING NOTE: Multi-Tab only.
            )(n);

            n.ac = !1;
            _context111.next = 25;
            return Ou(n.remoteStore, !1);

          case 25:
          case "end":
            return _context111.stop();
        }
      }
    }, _callee111);
  }));
  return _Dc.apply(this, arguments);
}

function Cc(_x91, _x92, _x93) {
  return _Cc.apply(this, arguments);
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */
// PORTING NOTE: Multi-Tab only.


function _Cc() {
  _Cc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(t, e, n) {
    var s, i, r, _iterator94, _step94, _t135, _e63, _n47, _iterator95, _step95, _t136, _e64, _n48, _n49;

    return _regeneratorRuntime.wrap(function _callee112$(_context112) {
      while (1) {
        switch (_context112.prev = _context112.next) {
          case 0:
            s = K(t), i = [], r = [];
            _iterator94 = _createForOfIteratorHelper(e);
            _context112.prev = 2;

            _iterator94.s();

          case 4:
            if ((_step94 = _iterator94.n()).done) {
              _context112.next = 45;
              break;
            }

            _t135 = _step94.value;
            _e63 = void 0;
            _n47 = s.ec.get(_t135);

            if (!(_n47 && 0 !== _n47.length)) {
              _context112.next = 34;
              break;
            }

            _context112.next = 11;
            return Co(s.localStore, ln(_n47[0]));

          case 11:
            _e63 = _context112.sent;
            _iterator95 = _createForOfIteratorHelper(_n47);
            _context112.prev = 13;

            _iterator95.s();

          case 15:
            if ((_step95 = _iterator95.n()).done) {
              _context112.next = 24;
              break;
            }

            _t136 = _step95.value;
            _e64 = s.tc.get(_t136);
            _context112.next = 20;
            return vc(s, _e64);

          case 20:
            _n48 = _context112.sent;
            _n48.snapshot && r.push(_n48.snapshot);

          case 22:
            _context112.next = 15;
            break;

          case 24:
            _context112.next = 29;
            break;

          case 26:
            _context112.prev = 26;
            _context112.t0 = _context112["catch"](13);

            _iterator95.e(_context112.t0);

          case 29:
            _context112.prev = 29;

            _iterator95.f();

            return _context112.finish(29);

          case 32:
            _context112.next = 42;
            break;

          case 34:
            _context112.next = 36;
            return ko(s.localStore, _t135);

          case 36:
            _n49 = _context112.sent;
            _context112.next = 39;
            return Co(s.localStore, _n49);

          case 39:
            _e63 = _context112.sent;
            _context112.next = 42;
            return cc(s, xc(_n49), _t135,
            /*current=*/
            !1);

          case 42:
            i.push(_e63);

          case 43:
            _context112.next = 4;
            break;

          case 45:
            _context112.next = 50;
            break;

          case 47:
            _context112.prev = 47;
            _context112.t1 = _context112["catch"](2);

            _iterator94.e(_context112.t1);

          case 50:
            _context112.prev = 50;

            _iterator94.f();

            return _context112.finish(50);

          case 53:
            return _context112.abrupt("return", (s.Zu.Go(r), i));

          case 54:
          case "end":
            return _context112.stop();
        }
      }
    }, _callee112, null, [[2, 47, 50, 53], [13, 26, 29, 32]]);
  }));
  return _Cc.apply(this, arguments);
}

function xc(t) {
  return sn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F"
  /* First */
  , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */
// PORTING NOTE: Multi-Tab only.


function Nc(t) {
  var e = K(t);
  return K(K(e.localStore).persistence).Ri();
}
/** Applies a query target change from a different tab. */
// PORTING NOTE: Multi-Tab only.


function kc(_x94, _x95, _x96, _x97) {
  return _kc.apply(this, arguments);
}
/** Adds or removes Watch targets for queries from different tabs. */


function _kc() {
  _kc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(t, e, n, s) {
    var i, r, _t137, _s35;

    return _regeneratorRuntime.wrap(function _callee113$(_context113) {
      while (1) {
        switch (_context113.prev = _context113.next) {
          case 0:
            i = K(t);

            if (!i.ac) {
              _context113.next = 3;
              break;
            }

            return _context113.abrupt("return", void M("SyncEngine", "Ignoring unexpected query state notification."));

          case 3:
            r = i.ec.get(e);

            if (!(r && r.length > 0)) {
              _context113.next = 20;
              break;
            }

            _context113.t0 = n;
            _context113.next = _context113.t0 === "current" ? 8 : _context113.t0 === "not-current" ? 8 : _context113.t0 === "rejected" ? 15 : 19;
            break;

          case 8:
            _context113.next = 10;
            return Oo(i.localStore, gn(r[0]));

          case 10:
            _t137 = _context113.sent;
            _s35 = ys.createSynthesizedRemoteEventForCurrentChange(e, "current" === n);
            _context113.next = 14;
            return Rc(i, _t137, _s35);

          case 14:
            return _context113.abrupt("break", 20);

          case 15:
            _context113.next = 17;
            return xo(i.localStore, e,
            /* keepPersistedTargetData */
            !0);

          case 17:
            pc(i, e, s);
            return _context113.abrupt("break", 20);

          case 19:
            L();

          case 20:
          case "end":
            return _context113.stop();
        }
      }
    }, _callee113);
  }));
  return _kc.apply(this, arguments);
}

function Oc(_x98, _x99, _x100) {
  return _Oc.apply(this, arguments);
}

function _Oc() {
  _Oc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(t, e, n) {
    var s, _iterator96, _step96, _t138, _e65, _n50, _iterator97, _step97, _loop8;

    return _regeneratorRuntime.wrap(function _callee114$(_context115) {
      while (1) {
        switch (_context115.prev = _context115.next) {
          case 0:
            s = Mc(t);

            if (!s.ac) {
              _context115.next = 45;
              break;
            }

            _iterator96 = _createForOfIteratorHelper(e);
            _context115.prev = 3;

            _iterator96.s();

          case 5:
            if ((_step96 = _iterator96.n()).done) {
              _context115.next = 21;
              break;
            }

            _t138 = _step96.value;

            if (!s.ec.has(_t138)) {
              _context115.next = 10;
              break;
            }

            // A target might have been added in a previous attempt
            M("SyncEngine", "Adding an already active target " + _t138);
            return _context115.abrupt("continue", 19);

          case 10:
            _context115.next = 12;
            return ko(s.localStore, _t138);

          case 12:
            _e65 = _context115.sent;
            _context115.next = 15;
            return Co(s.localStore, _e65);

          case 15:
            _n50 = _context115.sent;
            _context115.next = 18;
            return cc(s, xc(_e65), _n50.targetId,
            /*current=*/
            !1);

          case 18:
            fu(s.remoteStore, _n50);

          case 19:
            _context115.next = 5;
            break;

          case 21:
            _context115.next = 26;
            break;

          case 23:
            _context115.prev = 23;
            _context115.t0 = _context115["catch"](3);

            _iterator96.e(_context115.t0);

          case 26:
            _context115.prev = 26;

            _iterator96.f();

            return _context115.finish(26);

          case 29:
            _iterator97 = _createForOfIteratorHelper(n);
            _context115.prev = 30;
            _loop8 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop8() {
              var t;
              return _regeneratorRuntime.wrap(function _loop8$(_context114) {
                while (1) {
                  switch (_context114.prev = _context114.next) {
                    case 0:
                      t = _step97.value;
                      _context114.t0 = s.ec.has(t);

                      if (!_context114.t0) {
                        _context114.next = 5;
                        break;
                      }

                      _context114.next = 5;
                      return xo(s.localStore, t,
                      /* keepPersistedTargetData */
                      !1).then(function () {
                        du(s.remoteStore, t), pc(s, t);
                      }).catch(bt);

                    case 5:
                    case "end":
                      return _context114.stop();
                  }
                }
              }, _loop8);
            });

            _iterator97.s();

          case 33:
            if ((_step97 = _iterator97.n()).done) {
              _context115.next = 37;
              break;
            }

            return _context115.delegateYield(_loop8(), "t1", 35);

          case 35:
            _context115.next = 33;
            break;

          case 37:
            _context115.next = 42;
            break;

          case 39:
            _context115.prev = 39;
            _context115.t2 = _context115["catch"](30);

            _iterator97.e(_context115.t2);

          case 42:
            _context115.prev = 42;

            _iterator97.f();

            return _context115.finish(42);

          case 45:
          case "end":
            return _context115.stop();
        }
      }
    }, _callee114, null, [[3, 23, 26, 29], [30, 39, 42, 45]]);
  }));
  return _Oc.apply(this, arguments);
}

function Mc(t) {
  var e = K(t);
  return e.remoteStore.remoteSyncer.applyRemoteEvent = lc.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = Pc.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = dc.bind(null, e), e.Zu.Go = Wu.bind(null, e.eventManager), e.Zu.lc = zu.bind(null, e.eventManager), e;
}

function Fc(t) {
  var e = K(t);
  return e.remoteStore.remoteSyncer.applySuccessfulWrite = _c.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = wc.bind(null, e), e;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */


function $c(t, e, n) {
  var s = K(t); // eslint-disable-next-line @typescript-eslint/no-floating-promises

  /** Loads a bundle and returns the list of affected collection groups. */
  (function () {
    var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t, e, n) {
      var _s24, i, r, _t101, o;

      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 3;
              return e.getMetadata();

            case 3:
              _s24 = _context25.sent;
              _context25.next = 6;
              return function (t, e) {
                var n = K(t),
                    s = Ns(e.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", function (t) {
                  return n.Ds.getBundleMetadata(t, e.id);
                }).then(function (t) {
                  return !!t && t.createTime.compareTo(s) >= 0;
                });
              }
              /**
              * Saves the given `BundleMetadata` to local persistence.
              */
              (t.localStore, _s24);

            case 6:
              if (!_context25.sent) {
                _context25.next = 11;
                break;
              }

              _context25.next = 9;
              return e.close();

            case 9:
              n._completeWith(function (t) {
                return {
                  taskState: "Success",
                  documentsLoaded: t.totalDocuments,
                  bytesLoaded: t.totalBytes,
                  totalDocuments: t.totalDocuments,
                  totalBytes: t.totalBytes
                };
              }(_s24));

              return _context25.abrupt("return", Promise.resolve(new Set()));

            case 11:
              n._updateProgress(tc(_s24));

              i = new Zu(_s24, t.localStore, e.wt);
              _context25.next = 15;
              return e.fc();

            case 15:
              r = _context25.sent;

            case 16:
              if (!r) {
                _context25.next = 26;
                break;
              }

              _context25.next = 19;
              return i.Nu(r);

            case 19:
              _t101 = _context25.sent;
              _t101 && n._updateProgress(_t101);
              _context25.next = 23;
              return e.fc();

            case 23:
              r = _context25.sent;

            case 24:
              _context25.next = 16;
              break;

            case 26:
              _context25.next = 28;
              return i.complete();

            case 28:
              o = _context25.sent;
              _context25.next = 31;
              return Rc(t, o.Mu,
              /* remoteEvent */
              void 0);

            case 31:
              _context25.next = 33;
              return function (t, e) {
                var n = K(t);
                return n.persistence.runTransaction("Save bundle", "readwrite", function (t) {
                  return n.Ds.saveBundleMetadata(t, e);
                });
              }
              /**
              * Returns a promise of a `NamedQuery` associated with given query name. Promise
              * resolves to undefined if no persisted data can be found.
              */
              (t.localStore, _s24);

            case 33:
              n._completeWith(o.progress);

              return _context25.abrupt("return", Promise.resolve(o.Ou));

            case 37:
              _context25.prev = 37;
              _context25.t0 = _context25["catch"](0);
              return _context25.abrupt("return", ($("SyncEngine", "Loading bundle failed with ".concat(_context25.t0)), n._failWith(_context25.t0), Promise.resolve(new Set())));

            case 40:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, null, [[0, 37]]);
    }));

    return function (_x101, _x102, _x103) {
      return _ref36.apply(this, arguments);
    };
  })()
  /**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

  /**
  * Provides all components needed for Firestore with in-memory persistence.
  * Uses EagerGC garbage collection.
  */
  (s, e, n).then(function (t) {
    s.sharedClientState.notifyBundleLoaded(t);
  });
}

var Bc = /*#__PURE__*/function () {
  function Bc() {
    _classCallCheck(this, Bc);

    this.synchronizeTabs = !1;
  }

  _createClass(Bc, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this.wt = nu(t.databaseInfo.databaseId);
                this.sharedClientState = this.dc(t);
                this.persistence = this._c(t);
                _context26.next = 5;
                return this.persistence.start();

              case 5:
                this.localStore = this.wc(t);
                this.gcScheduler = this.mc(t, this.localStore);
                this.indexBackfillerScheduler = this.gc(t, this.localStore);

              case 8:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function initialize(_x104) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "mc",
    value: function mc(t, e) {
      return null;
    }
  }, {
    key: "gc",
    value: function gc(t, e) {
      return null;
    }
  }, {
    key: "wc",
    value: function wc(t) {
      return Ro(this.persistence, new Eo(), t.initialUser, this.wt);
    }
  }, {
    key: "_c",
    value: function _c(t) {
      return new ho(fo.Ms, this.wt);
    }
  }, {
    key: "dc",
    value: function dc(t) {
      return new zo();
    }
  }, {
    key: "terminate",
    value: function () {
      var _terminate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.gcScheduler && this.gcScheduler.stop();
                _context27.next = 3;
                return this.sharedClientState.shutdown();

              case 3:
                _context27.next = 5;
                return this.persistence.shutdown();

              case 5:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function terminate() {
        return _terminate.apply(this, arguments);
      }

      return terminate;
    }()
  }]);

  return Bc;
}();
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */


var Lc = /*#__PURE__*/function (_Bc) {
  _inherits(Lc, _Bc);

  var _super29 = _createSuper(Lc);

  function Lc(t, e, n) {
    var _this174;

    _classCallCheck(this, Lc);

    _this174 = _super29.call(this), _this174.yc = t, _this174.cacheSizeBytes = e, _this174.forceOwnership = n, _this174.synchronizeTabs = !1;
    return _this174;
  }

  _createClass(Lc, [{
    key: "initialize",
    value: function () {
      var _initialize2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t) {
        var _this175 = this;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return _get(_getPrototypeOf(Lc.prototype), "initialize", this).call(this, t);

              case 2:
                _context28.next = 4;
                return this.yc.initialize(this, t);

              case 4:
                _context28.next = 6;
                return Fc(this.yc.syncEngine);

              case 6:
                _context28.next = 8;
                return bu(this.yc.remoteStore);

              case 8:
                _context28.next = 10;
                return this.persistence.ci(function () {
                  return _this175.gcScheduler && !_this175.gcScheduler.started && _this175.gcScheduler.start(), _this175.indexBackfillerScheduler && !_this175.indexBackfillerScheduler.started && _this175.indexBackfillerScheduler.start(), Promise.resolve();
                });

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function initialize(_x105) {
        return _initialize2.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "wc",
    value: function wc(t) {
      return Ro(this.persistence, new Eo(), t.initialUser, this.wt);
    }
  }, {
    key: "mc",
    value: function mc(t, e) {
      var n = this.persistence.referenceDelegate.garbageCollector;
      return new Ur(n, t.asyncQueue, e);
    }
  }, {
    key: "gc",
    value: function gc(t, e) {
      var n = new Ft(e, this.persistence);
      return new Mt(t.asyncQueue, n);
    }
  }, {
    key: "_c",
    value: function _c(t) {
      var e = Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey),
          n = void 0 !== this.cacheSizeBytes ? Pr.withCacheSize(this.cacheSizeBytes) : Pr.DEFAULT;
      return new go(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, tu(), eu(), this.wt, this.sharedClientState, !!this.forceOwnership);
    }
  }, {
    key: "dc",
    value: function dc(t) {
      return new zo();
    }
  }]);

  return Lc;
}(Bc);
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */


var Uc = /*#__PURE__*/function (_Lc) {
  _inherits(Uc, _Lc);

  var _super30 = _createSuper(Uc);

  function Uc(t, e) {
    var _this176;

    _classCallCheck(this, Uc);

    _this176 = _super30.call(this, t, e,
    /* forceOwnership= */
    !1), _this176.yc = t, _this176.cacheSizeBytes = e, _this176.synchronizeTabs = !0;
    return _this176;
  }

  _createClass(Uc, [{
    key: "initialize",
    value: function () {
      var _initialize3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t) {
        var _this177 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return _get(_getPrototypeOf(Uc.prototype), "initialize", this).call(this, t);

              case 2:
                e = this.yc.syncEngine;
                _context30.t0 = this.sharedClientState instanceof Wo;

                if (!_context30.t0) {
                  _context30.next = 8;
                  break;
                }

                this.sharedClientState.syncEngine = {
                  kr: Sc.bind(null, e),
                  Or: kc.bind(null, e),
                  Mr: Oc.bind(null, e),
                  Ri: Nc.bind(null, e),
                  Nr: Vc.bind(null, e)
                };
                _context30.next = 8;
                return this.sharedClientState.start();

              case 8:
                _context30.next = 10;
                return this.persistence.ci( /*#__PURE__*/function () {
                  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t) {
                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            _context29.next = 2;
                            return Dc(_this177.yc.syncEngine, t);

                          case 2:
                            _this177.gcScheduler && (t && !_this177.gcScheduler.started ? _this177.gcScheduler.start() : t || _this177.gcScheduler.stop());
                            _this177.indexBackfillerScheduler && (t && !_this177.indexBackfillerScheduler.started ? _this177.indexBackfillerScheduler.start() : t || _this177.indexBackfillerScheduler.stop());

                          case 4:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));

                  return function (_x107) {
                    return _ref37.apply(this, arguments);
                  };
                }());

              case 10:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function initialize(_x106) {
        return _initialize3.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "dc",
    value: function dc(t) {
      var e = tu();
      if (!Wo.V(e)) throw new Q(G.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
      var n = Io(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
      return new Wo(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }
  }]);

  return Uc;
}(Lc);
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */


var qc = /*#__PURE__*/function () {
  function qc() {
    _classCallCheck(this, qc);
  }

  _createClass(qc, [{
    key: "initialize",
    value: function () {
      var _initialize4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(t, e) {
        var _this178 = this;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.t0 = this.localStore;

                if (_context31.t0) {
                  _context31.next = 12;
                  break;
                }

                this.localStore = t.localStore;
                this.sharedClientState = t.sharedClientState;
                this.datastore = this.createDatastore(e);
                this.remoteStore = this.createRemoteStore(e);
                this.eventManager = this.createEventManager(e);
                this.syncEngine = this.createSyncEngine(e,
                /* startAsPrimary=*/
                !t.synchronizeTabs);

                this.sharedClientState.onlineStateHandler = function (t) {
                  return fc(_this178.syncEngine, t, 1
                  /* SharedClientState */
                  );
                };

                this.remoteStore.remoteSyncer.handleCredentialChange = bc.bind(null, this.syncEngine);
                _context31.next = 12;
                return Ou(this.remoteStore, this.syncEngine.isPrimaryClient);

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function initialize(_x108, _x109) {
        return _initialize4.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "createEventManager",
    value: function createEventManager(t) {
      return new Gu();
    }
  }, {
    key: "createDatastore",
    value: function createDatastore(t) {
      var e = nu(t.databaseInfo.databaseId),
          n = (s = t.databaseInfo, new Zo(s));
      var s;
      /** Return the Platform-specific connectivity monitor. */

      return function (t, e, n, s) {
        return new uu(t, e, n, s);
      }(t.authCredentials, t.appCheckCredentials, n, e);
    }
  }, {
    key: "createRemoteStore",
    value: function createRemoteStore(t) {
      var _this179 = this;

      return e = this.localStore, n = this.datastore, s = t.asyncQueue, i = function i(t) {
        return fc(_this179.syncEngine, t, 0
        /* RemoteStore */
        );
      }, r = Jo.V() ? new Jo() : new Ho(), new au(e, n, s, i, r);
      var e, n, s, i, r;
      /** Re-enables the network. Idempotent. */
    }
  }, {
    key: "createSyncEngine",
    value: function createSyncEngine(t, e) {
      return function (t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
      s, i, r, o) {
        var u = new oc(t, e, n, s, i, r);
        return o && (u.ac = !0), u;
      }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }
  }, {
    key: "terminate",
    value: function terminate() {
      return function () {
        var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  e = K(t);
                  M("RemoteStore", "RemoteStore shutting down.");
                  e.lu.add(5
                  /* Shutdown */
                  );
                  _context32.next = 5;
                  return lu(e);

                case 5:
                  e.du.shutdown();

                  // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                  // triggering spurious listener events with cached data, etc.
                  e._u.set("Unknown"
                  /* Unknown */
                  );

                case 7:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32);
        }));

        return function (_x110) {
          return _ref38.apply(this, arguments);
        };
      }()(this.remoteStore);
    }
  }]);

  return qc;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */

/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */


function Kc(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10240;
  var n = 0; // The TypeScript definition for ReadableStreamReader changed. We use
  // `any` here to allow this code to compile with different versions.
  // See https://github.com/microsoft/TypeScript/issues/42970
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    read: function read() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        var s;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (!(n < t.byteLength)) {
                  _context33.next = 3;
                  break;
                }

                s = {
                  value: t.slice(n, n + e),
                  done: !1
                };
                return _context33.abrupt("return", (n += e, s));

              case 3:
                return _context33.abrupt("return", {
                  done: !0
                });

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }))();
    },
    cancel: function cancel() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }))();
    },
    releaseLock: function releaseLock() {},
    closed: Promise.reject("unimplemented")
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */


var Gc = /*#__PURE__*/function () {
  function Gc(t) {
    _classCallCheck(this, Gc);

    this.observer = t,
    /**
     * When set to true, will not raise future events. Necessary to deal with
     * async detachment of listener.
     */
    this.muted = !1;
  }

  _createClass(Gc, [{
    key: "next",
    value: function next(t) {
      this.observer.next && this.Ic(this.observer.next, t);
    }
  }, {
    key: "error",
    value: function error(t) {
      this.observer.error ? this.Ic(this.observer.error, t) : console.error("Uncaught Error in snapshot listener:", t);
    }
  }, {
    key: "Tc",
    value: function Tc() {
      this.muted = !0;
    }
  }, {
    key: "Ic",
    value: function Ic(t, e) {
      var _this180 = this;

      this.muted || setTimeout(function () {
        _this180.muted || t(e);
      }, 0);
    }
  }]);

  return Gc;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */


var Qc = /*#__PURE__*/function () {
  function Qc(
  /** The reader to read from underlying binary bundle data source. */
  t, e) {
    var _this181 = this;

    _classCallCheck(this, Qc);

    this.Ec = t, this.wt = e,
    /** Cached bundle metadata. */
    this.metadata = new j(),
    /**
     * Internal buffer to hold bundle content, accumulating incomplete element
     * content.
     */
    this.buffer = new Uint8Array(), this.Ac = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
    this.Rc().then(function (t) {
      t && t.Cu() ? _this181.metadata.resolve(t.payload.metadata) : _this181.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             ".concat(JSON.stringify(null == t ? void 0 : t.payload))));
    }, function (t) {
      return _this181.metadata.reject(t);
    });
  }

  _createClass(Qc, [{
    key: "close",
    value: function close() {
      return this.Ec.cancel();
    }
  }, {
    key: "getMetadata",
    value: function () {
      var _getMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", this.metadata.promise);

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function getMetadata() {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
  }, {
    key: "fc",
    value: function () {
      var _fc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this.getMetadata();

              case 2:
                return _context36.abrupt("return", this.Rc());

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function fc() {
        return _fc.apply(this, arguments);
      }

      return fc;
    }()
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */

  }, {
    key: "Rc",
    value: function () {
      var _Rc2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var t, e, n, s;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.bc();

              case 2:
                t = _context37.sent;

                if (!(null === t)) {
                  _context37.next = 5;
                  break;
                }

                return _context37.abrupt("return", null);

              case 5:
                e = this.Ac.decode(t), n = Number(e);
                isNaN(n) && this.Pc("length string (".concat(e, ") is not valid number"));
                _context37.next = 9;
                return this.vc(n);

              case 9:
                s = _context37.sent;
                return _context37.abrupt("return", new Yu(JSON.parse(s), t.length + n));

              case 11:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function Rc() {
        return _Rc2.apply(this, arguments);
      }

      return Rc;
    }()
    /** First index of '{' from the underlying buffer. */

  }, {
    key: "Vc",
    value: function Vc() {
      return this.buffer.findIndex(function (t) {
        return t === "{".charCodeAt(0);
      });
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */

  }, {
    key: "bc",
    value: function () {
      var _bc2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var t, e;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!(this.Vc() < 0)) {
                  _context38.next = 7;
                  break;
                }

                _context38.next = 3;
                return this.Sc();

              case 3:
                if (!_context38.sent) {
                  _context38.next = 5;
                  break;
                }

                return _context38.abrupt("break", 7);

              case 5:
                _context38.next = 0;
                break;

              case 7:
                if (!(0 === this.buffer.length)) {
                  _context38.next = 9;
                  break;
                }

                return _context38.abrupt("return", null);

              case 9:
                t = this.Vc(); // Broke out of the loop because underlying stream is closed, but still
                // cannot find an open bracket.

                t < 0 && this.Pc("Reached the end of bundle when a length string is expected.");
                e = this.buffer.slice(0, t); // Update the internal buffer to drop the read length.

                return _context38.abrupt("return", (this.buffer = this.buffer.slice(t), e));

              case 13:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function bc() {
        return _bc2.apply(this, arguments);
      }

      return bc;
    }()
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */

  }, {
    key: "vc",
    value: function () {
      var _vc2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (!(this.buffer.length < t)) {
                  _context39.next = 8;
                  break;
                }

                _context39.next = 3;
                return this.Sc();

              case 3:
                _context39.t0 = _context39.sent;

                if (!_context39.t0) {
                  _context39.next = 6;
                  break;
                }

                this.Pc("Reached the end of bundle when more is expected.");

              case 6:
                _context39.next = 0;
                break;

              case 8:
                e = this.Ac.decode(this.buffer.slice(0, t)); // Update the internal buffer to drop the read json string.

                return _context39.abrupt("return", (this.buffer = this.buffer.slice(t), e));

              case 10:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function vc(_x111) {
        return _vc2.apply(this, arguments);
      }

      return vc;
    }()
  }, {
    key: "Pc",
    value: function Pc(t) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      throw this.Ec.cancel(), new Error("Invalid bundle format: ".concat(t));
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */

  }, {
    key: "Sc",
    value: function () {
      var _Sc2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var t, e;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.Ec.read();

              case 2:
                t = _context40.sent;

                if (!t.done) {
                  e = new Uint8Array(this.buffer.length + t.value.length);
                  e.set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e;
                }

                return _context40.abrupt("return", t.done);

              case 5:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function Sc() {
        return _Sc2.apply(this, arguments);
      }

      return Sc;
    }()
  }]);

  return Qc;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */


var jc = /*#__PURE__*/function () {
  function jc(t) {
    _classCallCheck(this, jc);

    this.datastore = t, // The version of each document that was read during this transaction.
    this.readVersions = new Map(), this.mutations = [], this.committed = !1,
    /**
     * A deferred usage error that occurred previously in this transaction that
     * will cause the transaction to fail once it actually commits.
     */
    this.lastWriteError = null,
    /**
     * Set of documents that have been written in the transaction.
     *
     * When there's more than one write to the same key in a transaction, any
     * writes after the first are handled differently.
     */
    this.writtenDocs = new Set();
  }

  _createClass(jc, [{
    key: "lookup",
    value: function () {
      var _lookup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(t) {
        var _this182 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (!(this.ensureCommitNotCalled(), this.mutations.length > 0)) {
                  _context42.next = 2;
                  break;
                }

                throw new Q(G.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");

              case 2:
                _context42.next = 4;
                return function () {
                  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(t, e) {
                    var n, s, i, r, o, u;
                    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
                      while (1) {
                        switch (_context41.prev = _context41.next) {
                          case 0:
                            n = K(t);
                            s = Ls(n.wt) + "/documents";
                            i = {
                              documents: e.map(function (t) {
                                return Ms(n.wt, t);
                              })
                            };
                            _context41.next = 5;
                            return n.ao("BatchGetDocuments", s, i);

                          case 5:
                            r = _context41.sent;
                            o = new Map();
                            r.forEach(function (t) {
                              var e = Gs(n.wt, t);
                              o.set(e.key.toString(), e);
                            });
                            u = [];
                            return _context41.abrupt("return", (e.forEach(function (t) {
                              var e = o.get(t.toString());
                              U(!!e), u.push(e);
                            }), u));

                          case 10:
                          case "end":
                            return _context41.stop();
                        }
                      }
                    }, _callee41);
                  }));

                  return function (_x113, _x114) {
                    return _ref39.apply(this, arguments);
                  };
                }()(this.datastore, t);

              case 4:
                e = _context42.sent;
                return _context42.abrupt("return", (e.forEach(function (t) {
                  return _this182.recordVersion(t);
                }), e));

              case 6:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function lookup(_x112) {
        return _lookup.apply(this, arguments);
      }

      return lookup;
    }()
  }, {
    key: "set",
    value: function set(t, e) {
      this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
  }, {
    key: "update",
    value: function update(t, e) {
      try {
        this.write(e.toMutation(t, this.preconditionForUpdate(t)));
      } catch (t) {
        this.lastWriteError = t;
      }

      this.writtenDocs.add(t.toString());
    }
  }, {
    key: "delete",
    value: function _delete(t) {
      this.write(new Yn(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this183 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!(this.ensureCommitNotCalled(), this.lastWriteError)) {
                  _context44.next = 2;
                  break;
                }

                throw this.lastWriteError;

              case 2:
                t = this.readVersions; // For each mutation, note that the doc was written.

                this.mutations.forEach(function (e) {
                  t.delete(e.key.toString());
                });
                // For each document that was read but not written to, we want to perform
                // a `verify` operation.
                t.forEach(function (t, e) {
                  var n = dt.fromPath(e);

                  _this183.mutations.push(new Xn(n, _this183.precondition(n)));
                });
                _context44.next = 7;
                return function () {
                  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(t, e) {
                    var n, s, i;
                    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
                      while (1) {
                        switch (_context43.prev = _context43.next) {
                          case 0:
                            n = K(t), s = Ls(n.wt) + "/documents", i = {
                              writes: e.map(function (t) {
                                return js(n.wt, t);
                              })
                            };
                            _context43.next = 3;
                            return n.ro("Commit", s, i);

                          case 3:
                          case "end":
                            return _context43.stop();
                        }
                      }
                    }, _callee43);
                  }));

                  return function (_x115, _x116) {
                    return _ref40.apply(this, arguments);
                  };
                }()(this.datastore, this.mutations);

              case 7:
                this.committed = !0;

              case 8:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function commit() {
        return _commit.apply(this, arguments);
      }

      return commit;
    }()
  }, {
    key: "recordVersion",
    value: function recordVersion(t) {
      var e;
      if (t.isFoundDocument()) e = t.version;else {
        if (!t.isNoDocument()) throw L(); // For deleted docs, we must use baseVersion 0 when we overwrite them.

        e = ct.min();
      }
      var n = this.readVersions.get(t.key.toString());

      if (n) {
        if (!e.isEqual(n)) // This transaction will fail no matter what.
          throw new Q(G.ABORTED, "Document version changed between two reads.");
      } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */

  }, {
    key: "precondition",
    value: function precondition(t) {
      var e = this.readVersions.get(t.toString());
      return !this.writtenDocs.has(t.toString()) && e ? $n.updateTime(e) : $n.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */

  }, {
    key: "preconditionForUpdate",
    value: function preconditionForUpdate(t) {
      var e = this.readVersions.get(t.toString()); // The first time a document is written, we want to take into account the
      // read time and existence

      if (!this.writtenDocs.has(t.toString()) && e) {
        if (e.isEqual(ct.min())) // The document doesn't exist, so fail the transaction.
          // This has to be validated locally because you can't send a
          // precondition that a document does not exist without changing the
          // semantics of the backend write to be an insert. This is the reverse
          // of what we want, since we want to assert that the document doesn't
          // exist but then send the update and have it fail. Since we can't
          // express that to the backend, we have to validate locally.
          // Note: this can change once we can send separate verify writes in the
          // transaction.
          throw new Q(G.INVALID_ARGUMENT, "Can't update a document that doesn't exist."); // Document exists, base precondition on document update time.

        return $n.updateTime(e);
      } // Document was not read, so we just use the preconditions for a blind
      // update.


      return $n.exists(!0);
    }
  }, {
    key: "write",
    value: function write(t) {
      this.ensureCommitNotCalled(), this.mutations.push(t);
    }
  }, {
    key: "ensureCommitNotCalled",
    value: function ensureCommitNotCalled() {}
  }]);

  return jc;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */


var Wc = /*#__PURE__*/function () {
  function Wc(t, e, n, s, i) {
    _classCallCheck(this, Wc);

    this.asyncQueue = t, this.datastore = e, this.options = n, this.updateFunction = s, this.deferred = i, this.Dc = n.maxAttempts, this.So = new su(this.asyncQueue, "transaction_retry"
    /* TransactionRetry */
    );
  }
  /** Runs the transaction and sets the result on deferred. */


  _createClass(Wc, [{
    key: "run",
    value: function run() {
      this.Dc -= 1, this.Cc();
    }
  }, {
    key: "Cc",
    value: function Cc() {
      var _this184 = this;

      this.So.Io( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var t, e;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                t = new jc(_this184.datastore), e = _this184.xc(t);
                e && e.then(function (e) {
                  _this184.asyncQueue.enqueueAndForget(function () {
                    return t.commit().then(function () {
                      _this184.deferred.resolve(e);
                    }).catch(function (t) {
                      _this184.Nc(t);
                    });
                  });
                }).catch(function (t) {
                  _this184.Nc(t);
                });

              case 2:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      })));
    }
  }, {
    key: "xc",
    value: function xc(t) {
      try {
        var e = this.updateFunction(t);
        return !oe(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
      } catch (t) {
        // Do not retry errors thrown by user provided updateFunction.
        return this.deferred.reject(t), null;
      }
    }
  }, {
    key: "Nc",
    value: function Nc(t) {
      var _this185 = this;

      this.Dc > 0 && this.kc(t) ? (this.Dc -= 1, this.asyncQueue.enqueueAndForget(function () {
        return _this185.Cc(), Promise.resolve();
      })) : this.deferred.reject(t);
    }
  }, {
    key: "kc",
    value: function kc(t) {
      if ("FirebaseError" === t.name) {
        // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
        // non-matching document versions with ABORTED. These errors should be retried.
        var e = t.code;
        return "aborted" === e || "failed-precondition" === e || !ns(e);
      }

      return !1;
    }
  }]);

  return Wc;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */


var zc = /*#__PURE__*/function () {
  function zc(t, e,
  /**
   * Asynchronous queue responsible for all of our internal processing. When
   * we get incoming work from the user (via public API) or the network
   * (incoming GRPC messages), we should always schedule onto this queue.
   * This ensures all of our work is properly serialized (e.g. we don't
   * start processing a new operation while the previous one is waiting for
   * an async I/O to complete).
   */
  n, s) {
    var _this186 = this;

    _classCallCheck(this, zc);

    this.authCredentials = t, this.appCheckCredentials = e, this.asyncQueue = n, this.databaseInfo = s, this.user = C.UNAUTHENTICATED, this.clientId = st.I(), this.authCredentialListener = function () {
      return Promise.resolve();
    }, this.appCheckCredentialListener = function () {
      return Promise.resolve();
    }, this.authCredentials.start(n, /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(t) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                M("FirestoreClient", "Received user=", t.uid);
                _context46.next = 3;
                return _this186.authCredentialListener(t);

              case 3:
                _this186.user = t;

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      return function (_x117) {
        return _ref42.apply(this, arguments);
      };
    }()), this.appCheckCredentials.start(n, function (t) {
      return M("FirestoreClient", "Received new app check token=", t), _this186.appCheckCredentialListener(t, _this186.user);
    });
  }

  _createClass(zc, [{
    key: "getConfiguration",
    value: function () {
      var _getConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", {
                  asyncQueue: this.asyncQueue,
                  databaseInfo: this.databaseInfo,
                  clientId: this.clientId,
                  authCredentials: this.authCredentials,
                  appCheckCredentials: this.appCheckCredentials,
                  initialUser: this.user,
                  maxConcurrentLimboResolutions: 100
                });

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function getConfiguration() {
        return _getConfiguration.apply(this, arguments);
      }

      return getConfiguration;
    }()
  }, {
    key: "setCredentialChangeListener",
    value: function setCredentialChangeListener(t) {
      this.authCredentialListener = t;
    }
  }, {
    key: "setAppCheckTokenChangeListener",
    value: function setAppCheckTokenChangeListener(t) {
      this.appCheckCredentialListener = t;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */

  }, {
    key: "verifyNotTerminated",
    value: function verifyNotTerminated() {
      if (this.asyncQueue.isShuttingDown) throw new Q(G.FAILED_PRECONDITION, "The client has already been terminated.");
    }
  }, {
    key: "terminate",
    value: function terminate() {
      var _this187 = this;

      this.asyncQueue.enterRestrictedMode();
      var t = new j();
      return this.asyncQueue.enqueueAndForgetEvenWhileRestricted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        var n;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.prev = 0;
                _context48.t0 = _this187.onlineComponents;

                if (!_context48.t0) {
                  _context48.next = 5;
                  break;
                }

                _context48.next = 5;
                return _this187.onlineComponents.terminate();

              case 5:
                _context48.t1 = _this187.offlineComponents;

                if (!_context48.t1) {
                  _context48.next = 9;
                  break;
                }

                _context48.next = 9;
                return _this187.offlineComponents.terminate();

              case 9:
                // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                _this187.authCredentials.shutdown();

                _this187.appCheckCredentials.shutdown();

                t.resolve();
                _context48.next = 18;
                break;

              case 14:
                _context48.prev = 14;
                _context48.t2 = _context48["catch"](0);
                n = Bu(_context48.t2, "Failed to shutdown persistence");
                t.reject(n);

              case 18:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, null, [[0, 14]]);
      }))), t.promise;
    }
  }]);

  return zc;
}();

function Hc(_x118, _x119) {
  return _Hc.apply(this, arguments);
}

function _Hc() {
  _Hc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(t, e) {
    var n, s;
    return _regeneratorRuntime.wrap(function _callee116$(_context117) {
      while (1) {
        switch (_context117.prev = _context117.next) {
          case 0:
            t.asyncQueue.verifyOperationInProgress(), M("FirestoreClient", "Initializing OfflineComponentProvider");
            _context117.next = 3;
            return t.getConfiguration();

          case 3:
            n = _context117.sent;
            _context117.next = 6;
            return e.initialize(n);

          case 6:
            s = n.initialUser;
            t.setCredentialChangeListener( /*#__PURE__*/function () {
              var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(t) {
                return _regeneratorRuntime.wrap(function _callee115$(_context116) {
                  while (1) {
                    switch (_context116.prev = _context116.next) {
                      case 0:
                        _context116.t0 = s.isEqual(t);

                        if (_context116.t0) {
                          _context116.next = 5;
                          break;
                        }

                        _context116.next = 4;
                        return bo(e.localStore, t);

                      case 4:
                        s = t;

                      case 5:
                      case "end":
                        return _context116.stop();
                    }
                  }
                }, _callee115);
              }));

              return function (_x143) {
                return _ref73.apply(this, arguments);
              };
            }()), // When a user calls clearPersistence() in one client, all other clients
            // need to be terminated to allow the delete to succeed.
            e.persistence.setDatabaseDeletedListener(function () {
              return t.terminate();
            }), t.offlineComponents = e;

          case 8:
          case "end":
            return _context117.stop();
        }
      }
    }, _callee116);
  }));
  return _Hc.apply(this, arguments);
}

function Jc(_x120, _x121) {
  return _Jc.apply(this, arguments);
}

function _Jc() {
  _Jc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(t, e) {
    var n, s;
    return _regeneratorRuntime.wrap(function _callee117$(_context118) {
      while (1) {
        switch (_context118.prev = _context118.next) {
          case 0:
            t.asyncQueue.verifyOperationInProgress();
            _context118.next = 3;
            return Yc(t);

          case 3:
            n = _context118.sent;
            M("FirestoreClient", "Initializing OnlineComponentProvider");
            _context118.next = 7;
            return t.getConfiguration();

          case 7:
            s = _context118.sent;
            _context118.next = 10;
            return e.initialize(n, s);

          case 10:
            // The CredentialChangeListener of the online component provider takes
            // precedence over the offline component provider.
            t.setCredentialChangeListener(function (t) {
              return ku(e.remoteStore, t);
            });
            t.setAppCheckTokenChangeListener(function (t, n) {
              return ku(e.remoteStore, n);
            });
            t.onlineComponents = e;

          case 13:
          case "end":
            return _context118.stop();
        }
      }
    }, _callee117);
  }));
  return _Jc.apply(this, arguments);
}

function Yc(_x122) {
  return _Yc.apply(this, arguments);
}

function _Yc() {
  _Yc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(t) {
    return _regeneratorRuntime.wrap(function _callee118$(_context119) {
      while (1) {
        switch (_context119.prev = _context119.next) {
          case 0:
            _context119.t0 = t.offlineComponents;

            if (_context119.t0) {
              _context119.next = 5;
              break;
            }

            M("FirestoreClient", "Using default OfflineComponentProvider");
            _context119.next = 5;
            return Hc(t, new Bc());

          case 5:
            return _context119.abrupt("return", t.offlineComponents);

          case 6:
          case "end":
            return _context119.stop();
        }
      }
    }, _callee118);
  }));
  return _Yc.apply(this, arguments);
}

function Xc(_x123) {
  return _Xc.apply(this, arguments);
}

function _Xc() {
  _Xc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(t) {
    return _regeneratorRuntime.wrap(function _callee119$(_context120) {
      while (1) {
        switch (_context120.prev = _context120.next) {
          case 0:
            _context120.t0 = t.onlineComponents;

            if (_context120.t0) {
              _context120.next = 5;
              break;
            }

            M("FirestoreClient", "Using default OnlineComponentProvider");
            _context120.next = 5;
            return Jc(t, new qc());

          case 5:
            return _context120.abrupt("return", t.onlineComponents);

          case 6:
          case "end":
            return _context120.stop();
        }
      }
    }, _callee119);
  }));
  return _Xc.apply(this, arguments);
}

function Zc(t) {
  return Yc(t).then(function (t) {
    return t.persistence;
  });
}

function ta(t) {
  return Yc(t).then(function (t) {
    return t.localStore;
  });
}

function ea(t) {
  return Xc(t).then(function (t) {
    return t.remoteStore;
  });
}

function na(t) {
  return Xc(t).then(function (t) {
    return t.syncEngine;
  });
}

function sa(_x124) {
  return _sa.apply(this, arguments);
}
/** Enables the network connection and re-enqueues all pending operations. */


function _sa() {
  _sa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(t) {
    var e, n;
    return _regeneratorRuntime.wrap(function _callee120$(_context121) {
      while (1) {
        switch (_context121.prev = _context121.next) {
          case 0:
            _context121.next = 2;
            return Xc(t);

          case 2:
            e = _context121.sent;
            n = e.eventManager;
            return _context121.abrupt("return", (n.onListen = uc.bind(null, e.syncEngine), n.onUnlisten = ac.bind(null, e.syncEngine), n));

          case 5:
          case "end":
            return _context121.stop();
        }
      }
    }, _callee120);
  }));
  return _sa.apply(this, arguments);
}

function ia(t) {
  return t.asyncQueue.enqueue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
    var e, n;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.next = 2;
            return Zc(t);

          case 2:
            e = _context49.sent;
            _context49.next = 5;
            return ea(t);

          case 5:
            n = _context49.sent;
            return _context49.abrupt("return", (e.setNetworkEnabled(!0), function (t) {
              var e = K(t);
              return e.lu.delete(0
              /* UserDisabled */
              ), hu(e);
            }(n)));

          case 7:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  })));
}
/** Disables the network connection. Pending operations will not complete. */


function ra(t) {
  return t.asyncQueue.enqueue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
    var e, n;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.next = 2;
            return Zc(t);

          case 2:
            e = _context51.sent;
            _context51.next = 5;
            return ea(t);

          case 5:
            n = _context51.sent;
            return _context51.abrupt("return", (e.setNetworkEnabled(!1), function () {
              var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(t) {
                var e;
                return _regeneratorRuntime.wrap(function _callee50$(_context50) {
                  while (1) {
                    switch (_context50.prev = _context50.next) {
                      case 0:
                        e = K(t);
                        e.lu.add(0
                        /* UserDisabled */
                        );
                        _context50.next = 4;
                        return lu(e);

                      case 4:
                        // Set the OnlineState to Offline so get()s return from cache, etc.
                        e._u.set("Offline"
                        /* Offline */
                        );

                      case 5:
                      case "end":
                        return _context50.stop();
                    }
                  }
                }, _callee50);
              }));

              return function (_x125) {
                return _ref46.apply(this, arguments);
              };
            }()(n)));

          case 7:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  })));
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */


function oa(t, e) {
  var n = new j();
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.t0 = function () {
              var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(t, e, n) {
                var s, _s25;

                return _regeneratorRuntime.wrap(function _callee52$(_context52) {
                  while (1) {
                    switch (_context52.prev = _context52.next) {
                      case 0:
                        _context52.prev = 0;
                        _context52.next = 3;
                        return function (t, e) {
                          var n = K(t);
                          return n.persistence.runTransaction("read document", "readonly", function (t) {
                            return n.localDocuments.getDocument(t, e);
                          });
                        }(t, e);

                      case 3:
                        s = _context52.sent;
                        s.isFoundDocument() ? n.resolve(s) : s.isNoDocument() ? n.resolve(null) : n.reject(new Q(G.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
                        _context52.next = 11;
                        break;

                      case 7:
                        _context52.prev = 7;
                        _context52.t0 = _context52["catch"](0);
                        _s25 = Bu(_context52.t0, "Failed to get document '".concat(e, " from cache"));
                        n.reject(_s25);

                      case 11:
                      case "end":
                        return _context52.stop();
                    }
                  }
                }, _callee52, null, [[0, 7]]);
              }));

              return function (_x126, _x127, _x128) {
                return _ref48.apply(this, arguments);
              };
            }()
            /**
            * Retrieves a latency-compensated document from the backend via a
            * SnapshotListener.
            */
            ;

            _context53.next = 3;
            return ta(t);

          case 3:
            _context53.t1 = _context53.sent;
            _context53.t2 = e;
            _context53.t3 = n;
            return _context53.abrupt("return", (0, _context53.t0)(_context53.t1, _context53.t2, _context53.t3));

          case 7:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }))), n.promise;
}

function ua(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var s = new j();
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            _context54.t0 = function (t, e, n, s, i) {
              var r = new Gc({
                next: function next(r) {
                  // Remove query first before passing event to user to avoid
                  // user actions affecting the now stale query.
                  e.enqueueAndForget(function () {
                    return ju(t, o);
                  });
                  var u = r.docs.has(n);
                  !u && r.fromCache ? // TODO(dimond): If we're online and the document doesn't
                  // exist then we resolve with a doc.exists set to false. If
                  // we're offline however, we reject the Promise in this
                  // case. Two options: 1) Cache the negative response from
                  // the server so we can deliver that even when you're
                  // offline 2) Actually reject the Promise in the online case
                  // if the document doesn't exist.
                  i.reject(new Q(G.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && r.fromCache && s && "server" === s.source ? i.reject(new Q(G.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(r);
                },
                error: function error(t) {
                  return i.reject(t);
                }
              }),
                  o = new Ju(rn(n.path), r, {
                includeMetadataChanges: !0,
                Du: !0
              });
              return Qu(t, o);
            };

            _context54.next = 3;
            return sa(t);

          case 3:
            _context54.t1 = _context54.sent;
            _context54.t2 = t.asyncQueue;
            _context54.t3 = e;
            _context54.t4 = n;
            _context54.t5 = s;
            return _context54.abrupt("return", (0, _context54.t0)(_context54.t1, _context54.t2, _context54.t3, _context54.t4, _context54.t5));

          case 9:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }))), s.promise;
}

function ca(t, e) {
  var n = new j();
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _context56.t0 = function () {
              var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(t, e, n) {
                var s, i, r, o, _s26;

                return _regeneratorRuntime.wrap(function _callee55$(_context55) {
                  while (1) {
                    switch (_context55.prev = _context55.next) {
                      case 0:
                        _context55.prev = 0;
                        _context55.next = 3;
                        return No(t, e,
                        /* usePreviousResults= */
                        !0);

                      case 3:
                        s = _context55.sent;
                        i = new sc(e, s.ji);
                        r = i.Ku(s.documents);
                        o = i.applyChanges(r,
                        /* updateLimboDocuments= */
                        !1);
                        n.resolve(o.snapshot);
                        _context55.next = 14;
                        break;

                      case 10:
                        _context55.prev = 10;
                        _context55.t0 = _context55["catch"](0);
                        _s26 = Bu(_context55.t0, "Failed to execute query '".concat(e, " against cache"));
                        n.reject(_s26);

                      case 14:
                      case "end":
                        return _context55.stop();
                    }
                  }
                }, _callee55, null, [[0, 10]]);
              }));

              return function (_x129, _x130, _x131) {
                return _ref51.apply(this, arguments);
              };
            }()
            /**
            * Retrieves a latency-compensated query snapshot from the backend via a
            * SnapshotListener.
            */
            ;

            _context56.next = 3;
            return ta(t);

          case 3:
            _context56.t1 = _context56.sent;
            _context56.t2 = e;
            _context56.t3 = n;
            return _context56.abrupt("return", (0, _context56.t0)(_context56.t1, _context56.t2, _context56.t3));

          case 7:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }))), n.promise;
}

function aa(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var s = new j();
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            _context57.t0 = function (t, e, n, s, i) {
              var r = new Gc({
                next: function next(n) {
                  // Remove query first before passing event to user to avoid
                  // user actions affecting the now stale query.
                  e.enqueueAndForget(function () {
                    return ju(t, o);
                  }), n.fromCache && "server" === s.source ? i.reject(new Q(G.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: function error(t) {
                  return i.reject(t);
                }
              }),
                  o = new Ju(n, r, {
                includeMetadataChanges: !0,
                Du: !0
              });
              return Qu(t, o);
            };

            _context57.next = 3;
            return sa(t);

          case 3:
            _context57.t1 = _context57.sent;
            _context57.t2 = t.asyncQueue;
            _context57.t3 = e;
            _context57.t4 = n;
            _context57.t5 = s;
            return _context57.abrupt("return", (0, _context57.t0)(_context57.t1, _context57.t2, _context57.t3, _context57.t4, _context57.t5));

          case 9:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  }))), s.promise;
}

function ha(t, e) {
  var n = new Gc(e);
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            _context58.t0 = function (t, e) {
              K(t).Tu.add(e), // Immediately fire an initial event, indicating all existing listeners
              // are in-sync.
              e.next();
            };

            _context58.next = 3;
            return sa(t);

          case 3:
            _context58.t1 = _context58.sent;
            _context58.t2 = n;
            return _context58.abrupt("return", (0, _context58.t0)(_context58.t1, _context58.t2));

          case 6:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  }))), function () {
    n.Tc(), t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
      return _regeneratorRuntime.wrap(function _callee59$(_context59) {
        while (1) {
          switch (_context59.prev = _context59.next) {
            case 0:
              _context59.t0 = function (t, e) {
                K(t).Tu.delete(e);
              };

              _context59.next = 3;
              return sa(t);

            case 3:
              _context59.t1 = _context59.sent;
              _context59.t2 = n;
              return _context59.abrupt("return", (0, _context59.t0)(_context59.t1, _context59.t2));

            case 6:
            case "end":
              return _context59.stop();
          }
        }
      }, _callee59);
    })));
  };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */


function la(t, e, n) {
  var s = new j();
  return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
    var i;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            _context60.next = 2;
            return function (t) {
              return Xc(t).then(function (t) {
                return t.datastore;
              });
            }(t);

          case 2:
            i = _context60.sent;
            new Wc(t.asyncQueue, i, n, e, s).run();

          case 4:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60);
  }))), s.promise;
}

function fa(t, e, n, s) {
  var i = function (t, e) {
    var n;
    n = "string" == typeof t ? new TextEncoder().encode(t) : t;
    return function (t, e) {
      return new Qc(t, e);
    }(function (t, e) {
      if (t instanceof Uint8Array) return Kc(t, e);
      if (t instanceof ArrayBuffer) return Kc(new Uint8Array(t), e);
      if (t instanceof ReadableStream) return t.getReader();
      throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
    }(n), e);
  }
  /**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */
  (n, nu(e));

  t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            _context61.t0 = $c;
            _context61.next = 3;
            return na(t);

          case 3:
            _context61.t1 = _context61.sent;
            _context61.t2 = i;
            _context61.t3 = s;
            (0, _context61.t0)(_context61.t1, _context61.t2, _context61.t3);

          case 7:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  })));
}

function da(t, e) {
  return t.asyncQueue.enqueue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.t0 = function (t, e) {
              var n = K(t);
              return n.persistence.runTransaction("Get named query", "readonly", function (t) {
                return n.Ds.getNamedQuery(t, e);
              });
            };

            _context62.next = 3;
            return ta(t);

          case 3:
            _context62.t1 = _context62.sent;
            _context62.t2 = e;
            return _context62.abrupt("return", (0, _context62.t0)(_context62.t1, _context62.t2));

          case 6:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62);
  })));
}

var _a = new Map();
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function wa(t, e, n) {
  if (!n) throw new Q(G.INVALID_ARGUMENT, "Function ".concat(t, "() cannot be called with an empty ").concat(e, "."));
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */


function ma(t, e, n, s) {
  if (!0 === e && !0 === s) throw new Q(G.INVALID_ARGUMENT, "".concat(t, " and ").concat(n, " cannot be used together."));
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */


function ga(t) {
  if (!dt.isDocumentKey(t)) throw new Q(G.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but ".concat(t, " has ").concat(t.length, "."));
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */


function ya(t) {
  if (dt.isDocumentKey(t)) throw new Q(G.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but ".concat(t, " has ").concat(t.length, "."));
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */

/** Returns a string describing the type / value of the provided input. */


function pa(t) {
  if (void 0 === t) return "undefined";
  if (null === t) return "null";
  if ("string" == typeof t) return t.length > 20 && (t = "".concat(t.substring(0, 20), "...")), JSON.stringify(t);
  if ("number" == typeof t || "boolean" == typeof t) return "" + t;

  if ("object" == typeof t) {
    if (t instanceof Array) return "an array";
    {
      var e =
      /** try to get the constructor name for an object. */
      function (t) {
        if (t.constructor) return t.constructor.name;
        return null;
      }
      /**
      * Casts `obj` to `T`, optionally unwrapping Compat types to expose the
      * underlying instance. Throws if  `obj` is not an instance of `T`.
      *
      * This cast is used in the Lite and Full SDK to verify instance types for
      * arguments passed to the public API.
      * @internal
      */
      (t);

      return e ? "a custom ".concat(e, " object") : "an object";
    }
  }

  return "function" == typeof t ? "a function" : L();
}

function Ia(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
  if ("_delegate" in t && ( // Unwrap Compat types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t = t._delegate), !(t instanceof e)) {
    if (e.name === t.constructor.name) throw new Q(G.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
    {
      var n = pa(t);
      throw new Q(G.INVALID_ARGUMENT, "Expected type '".concat(e.name, "', but it was: ").concat(n));
    }
  }

  return t;
}

function Ta(t, e) {
  if (e <= 0) throw new Q(G.INVALID_ARGUMENT, "Function ".concat(t, "() requires a positive number, but it was: ").concat(e, "."));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// settings() defaults:

/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */


var Ea = /*#__PURE__*/function () {
  function Ea(t) {
    _classCallCheck(this, Ea);

    var e;

    if (void 0 === t.host) {
      if (void 0 !== t.ssl) throw new Q(G.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
      this.host = "firestore.googleapis.com", this.ssl = true;
    } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;

    if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;else {
      if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new Q(G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
      this.cacheSizeBytes = t.cacheSizeBytes;
    }
    this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.useFetchStreams = !!t.useFetchStreams, ma("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling);
  }

  _createClass(Ea, [{
    key: "isEqual",
    value: function isEqual(t) {
      return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
  }]);

  return Ea;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */


var Aa = /*#__PURE__*/function () {
  /** @hideconstructor */
  function Aa(t, e, n) {
    _classCallCheck(this, Aa);

    this._authCredentials = e, this._appCheckCredentials = n,
    /**
     * Whether it's a Firestore or Firestore Lite instance.
     */
    this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new Ea({}), this._settingsFrozen = !1, t instanceof re ? this._databaseId = t : (this._app = t, this._databaseId = function (t) {
      if (!Object.prototype.hasOwnProperty.apply(t.options, ["projectId"])) throw new Q(G.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
      return new re(t.options.projectId);
    }
    /**
    * Modify this instance to communicate with the Cloud Firestore emulator.
    *
    * Note: This must be called before this instance has been used to do any
    * operations.
    *
    * @param firestore - The `Firestore` instance to configure to connect to the
    * emulator.
    * @param host - the emulator host (ex: localhost).
    * @param port - the emulator port (ex: 9000).
    * @param options.mockUserToken - the mock auth token to use for unit testing
    * Security Rules.
    */
    (t));
  }
  /**
   * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
   * instance.
   */


  _createClass(Aa, [{
    key: "app",
    get: function get() {
      if (!this._app) throw new Q(G.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
      return this._app;
    }
  }, {
    key: "_initialized",
    get: function get() {
      return this._settingsFrozen;
    }
  }, {
    key: "_terminated",
    get: function get() {
      return void 0 !== this._terminateTask;
    }
  }, {
    key: "_setSettings",
    value: function _setSettings(t) {
      if (this._settingsFrozen) throw new Q(G.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
      this._settings = new Ea(t), void 0 !== t.credentials && (this._authCredentials = function (t) {
        if (!t) return new z();

        switch (t.type) {
          case "gapi":
            var e = t.client; // Make sure this really is a Gapi client.

            return U(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), new X(e, t.sessionIndex || "0", t.iamToken || null);

          case "provider":
            return t.client;

          default:
            throw new Q(G.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
        }
      }(t.credentials));
    }
  }, {
    key: "_getSettings",
    value: function _getSettings() {
      return this._settings;
    }
  }, {
    key: "_freezeSettings",
    value: function _freezeSettings() {
      return this._settingsFrozen = !0, this._settings;
    }
  }, {
    key: "_delete",
    value: function _delete() {
      return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        app: this._app,
        databaseId: this._databaseId,
        settings: this._settings
      };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */

  }, {
    key: "_terminate",
    value: function _terminate() {
      /**
      * Removes all components associated with the provided instance. Must be called
      * when the `Firestore` instance is terminated.
      */
      return function (t) {
        var e = _a.get(t);

        e && (M("ComponentProvider", "Removing Datastore"), _a.delete(t), e.terminate());
      }(this), Promise.resolve();
    }
  }]);

  return Aa;
}();

function Ra(t, e, n) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var i;

  var r = (t = Ia(t, Aa))._getSettings();

  if ("firestore.googleapis.com" !== r.host && r.host !== e && $("Host has been set in both settings() and useEmulator(), emulator host will be used"), t._setSettings(Object.assign(Object.assign({}, r), {
    host: "".concat(e, ":").concat(n),
    ssl: !1
  })), s.mockUserToken) {
    var _e47, _n30;

    if ("string" == typeof s.mockUserToken) _e47 = s.mockUserToken, _n30 = C.MOCK_USER;else {
      // Let createMockUserToken validate first (catches common mistakes like
      // invalid field "uid" and missing field "sub" / "user_id".)
      _e47 = createMockUserToken(s.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);

      var _r7 = s.mockUserToken.sub || s.mockUserToken.user_id;

      if (!_r7) throw new Q(G.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
      _n30 = new C(_r7);
    }
    t._authCredentials = new H(new W(_e47, _n30));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */


var ba = /*#__PURE__*/function () {
  /** @hideconstructor */
  function ba(t,
  /**
   * If provided, the `FirestoreDataConverter` associated with this instance.
   */
  e, n) {
    _classCallCheck(this, ba);

    this.converter = e, this._key = n,
    /** The type of this Firestore reference. */
    this.type = "document", this.firestore = t;
  }

  _createClass(ba, [{
    key: "_path",
    get: function get() {
      return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */

  }, {
    key: "id",
    get: function get() {
      return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */

  }, {
    key: "path",
    get: function get() {
      return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */

  }, {
    key: "parent",
    get: function get() {
      return new va(this.firestore, this.converter, this._key.path.popLast());
    }
  }, {
    key: "withConverter",
    value: function withConverter(t) {
      return new ba(this.firestore, t, this._key);
    }
  }]);

  return ba;
}();
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */


var Pa = /*#__PURE__*/function () {
  // This is the lite version of the Query class in the main SDK.

  /** @hideconstructor protected */
  function Pa(t,
  /**
   * If provided, the `FirestoreDataConverter` associated with this instance.
   */
  e, n) {
    _classCallCheck(this, Pa);

    this.converter = e, this._query = n,
    /** The type of this Firestore reference. */
    this.type = "query", this.firestore = t;
  }

  _createClass(Pa, [{
    key: "withConverter",
    value: function withConverter(t) {
      return new Pa(this.firestore, t, this._query);
    }
  }]);

  return Pa;
}();
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link query}).
 */


var va = /*#__PURE__*/function (_Pa) {
  _inherits(va, _Pa);

  var _super31 = _createSuper(va);

  /** @hideconstructor */
  function va(t, e, n) {
    var _this188;

    _classCallCheck(this, va);

    _this188 = _super31.call(this, t, e, rn(n)), _this188._path = n,
    /** The type of this Firestore reference. */
    _this188.type = "collection";
    return _this188;
  }
  /** The collection's identifier. */


  _createClass(va, [{
    key: "id",
    get: function get() {
      return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */

  }, {
    key: "path",
    get: function get() {
      return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */

  }, {
    key: "parent",
    get: function get() {
      var t = this._path.popLast();

      return t.isEmpty() ? null : new ba(this.firestore,
      /* converter= */
      null, new dt(t));
    }
  }, {
    key: "withConverter",
    value: function withConverter(t) {
      return new va(this.firestore, t, this._path);
    }
  }]);

  return va;
}(Pa);

function Va(t, e) {
  for (var _len7 = arguments.length, n = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
    n[_key7 - 2] = arguments[_key7];
  }

  if (t = getModularInstance(t), wa("collection", "path", e), t instanceof Aa) {
    var s = ht.fromString.apply(ht, [e].concat(n));
    return ya(s), new va(t,
    /* converter= */
    null, s);
  }

  {
    if (!(t instanceof ba || t instanceof va)) throw new Q(G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");

    var _s27 = t._path.child(ht.fromString.apply(ht, [e].concat(n)));

    return ya(_s27), new va(t.firestore,
    /* converter= */
    null, _s27);
  }
} // TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106

/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */


function Sa(t, e) {
  if (t = Ia(t, Aa), wa("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new Q(G.INVALID_ARGUMENT, "Invalid collection ID '".concat(e, "' passed to function collectionGroup(). Collection IDs must not contain '/'."));
  return new Pa(t,
  /* converter= */
  null,
  /**
  * Creates a new Query for a collection group query that matches all documents
  * within the provided collection group.
  */
  function (t) {
    return new nn(ht.emptyPath(), t);
  }(e));
}

function Da(t, e) {
  for (var _len8 = arguments.length, n = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    n[_key8 - 2] = arguments[_key8];
  }

  if (t = getModularInstance(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
  // 'undefined' and 'null'.
  1 === arguments.length && (e = st.I()), wa("doc", "path", e), t instanceof Aa) {
    var s = ht.fromString.apply(ht, [e].concat(n));
    return ga(s), new ba(t,
    /* converter= */
    null, new dt(s));
  }

  {
    if (!(t instanceof ba || t instanceof va)) throw new Q(G.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");

    var _s28 = t._path.child(ht.fromString.apply(ht, [e].concat(n)));

    return ga(_s28), new ba(t.firestore, t instanceof va ? t.converter : null, new dt(_s28));
  }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */


function Ca(t, e) {
  return t = getModularInstance(t), e = getModularInstance(e), (t instanceof ba || t instanceof va) && (e instanceof ba || e instanceof va) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */


function xa(t, e) {
  return t = getModularInstance(t), e = getModularInstance(e), t instanceof Pa && e instanceof Pa && t.firestore === e.firestore && dn(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Na = /*#__PURE__*/function () {
  function Na() {
    var _this189 = this;

    _classCallCheck(this, Na);

    // The last promise in the queue.
    this.Oc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
    // retried with backoff.
    this.Mc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
    // be changed again.
    this.Fc = !1, // Operations scheduled to be queued in the future. Operations are
    // automatically removed after they are run or canceled.
    this.$c = [], // visible for testing
    this.Bc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
    // assertion sanity-checks.
    this.Lc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
    this.Uc = !1, // List of TimerIds to fast-forward delays for.
    this.qc = [], // Backoff timer used to schedule retries for retryable operations
    this.So = new su(this, "async_queue_retry"
    /* AsyncQueueRetry */
    ), // Visibility handler that triggers an immediate retry of all retryable
    // operations. Meant to speed up recovery when we regain file system access
    // after page comes into foreground.
    this.Kc = function () {
      var t = eu();
      t && M("AsyncQueue", "Visibility state changed to " + t.visibilityState), _this189.So.Eo();
    };
    var t = eu();
    t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Kc);
  }

  _createClass(Na, [{
    key: "isShuttingDown",
    get: function get() {
      return this.Fc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */

  }, {
    key: "enqueueAndForget",
    value: function enqueueAndForget(t) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.enqueue(t);
    }
  }, {
    key: "enqueueAndForgetEvenWhileRestricted",
    value: function enqueueAndForgetEvenWhileRestricted(t) {
      this.Gc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.Qc(t);
    }
  }, {
    key: "enterRestrictedMode",
    value: function enterRestrictedMode(t) {
      if (!this.Fc) {
        this.Fc = !0, this.Uc = t || !1;
        var e = eu();
        e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Kc);
      }
    }
  }, {
    key: "enqueue",
    value: function enqueue(t) {
      var _this190 = this;

      if (this.Gc(), this.Fc) // Return a Promise which never resolves.
        return new Promise(function () {}); // Create a deferred Promise that we can return to the callee. This
      // allows us to return a "hanging Promise" only to the callee and still
      // advance the queue even when the operation is not run.

      var e = new j();
      return this.Qc(function () {
        return _this190.Fc && _this190.Uc ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise);
      }).then(function () {
        return e.promise;
      });
    }
  }, {
    key: "enqueueRetryable",
    value: function enqueueRetryable(t) {
      var _this191 = this;

      this.enqueueAndForget(function () {
        return _this191.Mc.push(t), _this191.jc();
      });
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */

  }, {
    key: "jc",
    value: function () {
      var _jc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        var _this192 = this;

        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                if (!(0 !== this.Mc.length)) {
                  _context63.next = 14;
                  break;
                }

                _context63.prev = 1;
                _context63.next = 4;
                return this.Mc[0]();

              case 4:
                this.Mc.shift();
                this.So.reset();
                _context63.next = 13;
                break;

              case 8:
                _context63.prev = 8;
                _context63.t0 = _context63["catch"](1);

                if (Ct(_context63.t0)) {
                  _context63.next = 12;
                  break;
                }

                throw _context63.t0;

              case 12:
                // Failure will be handled by AsyncQueue
                M("AsyncQueue", "Operation failed with retryable error: " + _context63.t0);

              case 13:
                this.Mc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                // This is necessary to run retryable operations that failed during
                // their initial attempt since we don't know whether they are already
                // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                // call scheduled here.
                // Since `backoffAndRun()` cancels an existing backoff and schedules a
                // new backoff on every call, there is only ever a single additional
                // operation in the queue.
                this.So.Io(function () {
                  return _this192.jc();
                });

              case 14:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this, [[1, 8]]);
      }));

      function jc() {
        return _jc.apply(this, arguments);
      }

      return jc;
    }()
  }, {
    key: "Qc",
    value: function Qc(t) {
      var _this193 = this;

      var e = this.Oc.then(function () {
        return _this193.Lc = !0, t().catch(function (t) {
          _this193.Bc = t, _this193.Lc = !1;

          var e =
          /**
          * Chrome includes Error.message in Error.stack. Other browsers do not.
          * This returns expected output of message + stack when available.
          * @param error - Error or FirestoreError
          */
          function (t) {
            var e = t.message || "";
            t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
            return e;
          }
          /**
          * @license
          * Copyright 2017 Google LLC
          *
          * Licensed under the Apache License, Version 2.0 (the "License");
          * you may not use this file except in compliance with the License.
          * You may obtain a copy of the License at
          *
          *   http://www.apache.org/licenses/LICENSE-2.0
          *
          * Unless required by applicable law or agreed to in writing, software
          * distributed under the License is distributed on an "AS IS" BASIS,
          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
          * See the License for the specific language governing permissions and
          * limitations under the License.
          */
          (t); // Re-throw the error so that this.tail becomes a rejected Promise and
          // all further attempts to chain (via .then) will just short-circuit
          // and return the rejected Promise.


          throw F("INTERNAL UNHANDLED ERROR: ", e), t;
        }).then(function (t) {
          return _this193.Lc = !1, t;
        });
      });
      return this.Oc = e, e;
    }
  }, {
    key: "enqueueAfterDelay",
    value: function enqueueAfterDelay(t, e, n) {
      var _this194 = this;

      this.Gc(), // Fast-forward delays for timerIds that have been overriden.
      this.qc.indexOf(t) > -1 && (e = 0);
      var s = $u.createAndSchedule(this, t, e, n, function (t) {
        return _this194.Wc(t);
      });
      return this.$c.push(s), s;
    }
  }, {
    key: "Gc",
    value: function Gc() {
      this.Bc && L();
    }
  }, {
    key: "verifyOperationInProgress",
    value: function verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */

  }, {
    key: "zc",
    value: function () {
      var _zc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        var t;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                t = this.Oc;
                _context64.next = 3;
                return t;

              case 3:
                if (t !== this.Oc) {
                  _context64.next = 0;
                  break;
                }

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function zc() {
        return _zc.apply(this, arguments);
      }

      return zc;
    }()
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */

  }, {
    key: "Hc",
    value: function Hc(t) {
      var _iterator72 = _createForOfIteratorHelper(this.$c),
          _step72;

      try {
        for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
          var e = _step72.value;
          if (e.timerId === t) return !0;
        }
      } catch (err) {
        _iterator72.e(err);
      } finally {
        _iterator72.f();
      }

      return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */

  }, {
    key: "Jc",
    value: function Jc(t) {
      var _this195 = this;

      // Note that draining may generate more delayed ops, so we do that first.
      return this.zc().then(function () {
        // Run ops in the same order they'd run if they ran naturally.
        _this195.$c.sort(function (t, e) {
          return t.targetTimeMs - e.targetTimeMs;
        });

        var _iterator73 = _createForOfIteratorHelper(_this195.$c),
            _step73;

        try {
          for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
            var e = _step73.value;
            if (e.skipDelay(), "all"
            /* All */
            !== t && e.timerId === t) break;
          }
        } catch (err) {
          _iterator73.e(err);
        } finally {
          _iterator73.f();
        }

        return _this195.zc();
      });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */

  }, {
    key: "Yc",
    value: function Yc(t) {
      this.qc.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */

  }, {
    key: "Wc",
    value: function Wc(t) {
      // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
      var e = this.$c.indexOf(t);
      this.$c.splice(e, 1);
    }
  }]);

  return Na;
}();

function ka(t) {
  /**
  * Returns true if obj is an object and contains at least one of the specified
  * methods.
  */
  return function (t, e) {
    if ("object" != typeof t || null === t) return !1;
    var n = t;

    var _iterator74 = _createForOfIteratorHelper(e),
        _step74;

    try {
      for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
        var _t102 = _step74.value;
        if (_t102 in n && "function" == typeof n[_t102]) return !0;
      }
    } catch (err) {
      _iterator74.e(err);
    } finally {
      _iterator74.f();
    }

    return !1;
  }
  /**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

  /**
  * Represents the task of loading a Firestore bundle. It provides progress of bundle
  * loading, as well as task completion and error events.
  *
  * The API is compatible with `Promise<LoadBundleTaskProgress>`.
  */
  (t, ["next", "error", "complete"]);
}

var Oa = /*#__PURE__*/function () {
  function Oa() {
    _classCallCheck(this, Oa);

    this._progressObserver = {}, this._taskCompletionResolver = new j(), this._lastProgress = {
      taskState: "Running",
      totalBytes: 0,
      totalDocuments: 0,
      bytesLoaded: 0,
      documentsLoaded: 0
    };
  }
  /**
   * Registers functions to listen to bundle loading progress events.
   * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
   *   each time a Firestore document is loaded from the bundle.
   * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
   *   error, and there should be no more updates after this.
   * @param complete - Called when the loading task is complete.
   */


  _createClass(Oa, [{
    key: "onProgress",
    value: function onProgress(t, e, n) {
      this._progressObserver = {
        next: t,
        error: e,
        complete: n
      };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */

  }, {
    key: "catch",
    value: function _catch(t) {
      return this._taskCompletionResolver.promise.catch(t);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */

  }, {
    key: "then",
    value: function then(t, e) {
      return this._taskCompletionResolver.promise.then(t, e);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */

  }, {
    key: "_completeWith",
    value: function _completeWith(t) {
      this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */

  }, {
    key: "_failWith",
    value: function _failWith(t) {
      this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */

  }, {
    key: "_updateProgress",
    value: function _updateProgress(t) {
      this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }
  }]);

  return Oa;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** DOMException error code constants. */


var Ma = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link getFirestore}.
 */

var Fa = /*#__PURE__*/function (_Aa) {
  _inherits(Fa, _Aa);

  var _super32 = _createSuper(Fa);

  /** @hideconstructor */
  function Fa(t, e, n) {
    var _this196;

    _classCallCheck(this, Fa);

    _this196 = _super32.call(this, t, e, n),
    /**
     * Whether it's a {@link Firestore} or Firestore Lite instance.
     */
    _this196.type = "firestore", _this196._queue = new Na(), _this196._persistenceKey = "name" in t ? t.name : "[DEFAULT]";
    return _this196;
  }

  _createClass(Fa, [{
    key: "_terminate",
    value: function _terminate() {
      return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
      // usage throws an exception.
      Ua(this), this._firestoreClient.terminate();
    }
  }]);

  return Fa;
}(Aa);
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link getFirestore}. If the custom settings are empty, this function is
 * equivalent to calling {@link getFirestore}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @returns A newly initialized {@link Firestore} instance.
 */


function $a(t, e) {
  var n = _getProvider(t, "firestore");

  if (n.isInitialized()) {
    var _t103 = n.getImmediate(),
        s = n.getOptions();

    if (deepEqual(s, e)) return _t103;
    throw new Q(G.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
  }

  if (void 0 !== e.cacheSizeBytes && -1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new Q(G.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
  return n.initialize({
    options: e
  });
}
/**
 * Returns the existing {@link Firestore} instance that is associated with the
 * provided {@link @firebase/app#FirebaseApp}. If no instance exists, initializes a new
 * instance with default settings.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned {@link Firestore}
 * instance is associated with.
 * @returns The {@link Firestore} instance of the provided app.
 */


function Ba() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();
  return _getProvider(e, "firestore").getImmediate();
}
/**
 * @internal
 */


function La(t) {
  return t._firestoreClient || Ua(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}

function Ua(t) {
  var e;

  var n = t._freezeSettings(),
      s = function (t, e, n, s) {
    return new ie(t, e, n, s.host, s.ssl, s.experimentalForceLongPolling, s.experimentalAutoDetectLongPolling, s.useFetchStreams);
  }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, n);

  t._firestoreClient = new zc(t._authCredentials, t._appCheckCredentials, t._queue, s);
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link getFirestore} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 */


function qa(t, e) {
  Xa(t = Ia(t, Fa));

  var n = La(t),
      s = t._freezeSettings(),
      i = new qc();

  return Ga(n, i, new Lc(i, s.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 */


function Ka(t) {
  Xa(t = Ia(t, Fa));

  var e = La(t),
      n = t._freezeSettings(),
      s = new qc();

  return Ga(e, s, new Uc(s, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */


function Ga(t, e, n) {
  var s = new j();
  return t.asyncQueue.enqueue( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            _context65.prev = 0;
            _context65.next = 3;
            return Hc(t, n);

          case 3:
            _context65.next = 5;
            return Jc(t, e);

          case 5:
            s.resolve();
            _context65.next = 13;
            break;

          case 8:
            _context65.prev = 8;
            _context65.t0 = _context65["catch"](0);

            if (
            /**
            * Decides whether the provided error allows us to gracefully disable
            * persistence (as opposed to crashing the client).
            */
            function (t) {
              if ("FirebaseError" === t.name) return t.code === G.FAILED_PRECONDITION || t.code === G.UNIMPLEMENTED;
              if ("undefined" != typeof DOMException && t instanceof DOMException) // There are a few known circumstances where we can open IndexedDb but
                // trying to read/write will fail (e.g. quota exceeded). For
                // well-understood cases, we attempt to detect these and then gracefully
                // fall back to memory persistence.
                // NOTE: Rather than continue to add to this list, we could decide to
                // always fall back, with the risk that we might accidentally hide errors
                // representing actual SDK bugs.
                // When the browser is out of quota we could get either quota exceeded
                // or an aborted error depending on whether the error happened during
                // schema migration.
                return 22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                11 === t.code;
              return !0;
            }
            /**
            * Clears the persistent storage. This includes pending writes and cached
            * documents.
            *
            * Must be called while the {@link Firestore} instance is not started (after the app is
            * terminated or when the app is first initialized). On startup, this function
            * must be called before other functions (other than {@link
            * initializeFirestore} or {@link getFirestore})). If the {@link Firestore}
            * instance is still running, the promise will be rejected with the error code
            * of `failed-precondition`.
            *
            * Note: `clearIndexedDbPersistence()` is primarily intended to help write
            * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
            * dropping existing data but does not attempt to securely overwrite or
            * otherwise make cached data unrecoverable. For applications that are sensitive
            * to the disclosure of cached data in between user sessions, we strongly
            * recommend not enabling persistence at all.
            *
            * @param firestore - The {@link Firestore} instance to clear persistence for.
            * @returns A `Promise` that is resolved when the persistent storage is
            * cleared. Otherwise, the promise is rejected with an error.
            */
            (_context65.t0)) {
              _context65.next = 12;
              break;
            }

            throw _context65.t0;

          case 12:
            console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + _context65.t0), s.reject(_context65.t0);

          case 13:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65, null, [[0, 8]]);
  }))).then(function () {
    return s.promise;
  });
}

function Qa(t) {
  if (t._initialized && !t._terminated) throw new Q(G.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
  var e = new j();
  return t._queue.enqueueAndForgetEvenWhileRestricted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            _context67.prev = 0;
            _context67.next = 3;
            return function () {
              var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(t) {
                var e;
                return _regeneratorRuntime.wrap(function _callee66$(_context66) {
                  while (1) {
                    switch (_context66.prev = _context66.next) {
                      case 0:
                        if (Vt.V()) {
                          _context66.next = 2;
                          break;
                        }

                        return _context66.abrupt("return", Promise.resolve());

                      case 2:
                        e = t + "main";
                        _context66.next = 5;
                        return Vt.delete(e);

                      case 5:
                      case "end":
                        return _context66.stop();
                    }
                  }
                }, _callee66);
              }));

              return function (_x132) {
                return _ref60.apply(this, arguments);
              };
            }()(Io(t._databaseId, t._persistenceKey));

          case 3:
            e.resolve();
            _context67.next = 9;
            break;

          case 6:
            _context67.prev = 6;
            _context67.t0 = _context67["catch"](0);
            e.reject(_context67.t0);

          case 9:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67, null, [[0, 6]]);
  }))), e.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */


function ja(t) {
  return function (t) {
    var e = new j();
    return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
      return _regeneratorRuntime.wrap(function _callee68$(_context68) {
        while (1) {
          switch (_context68.prev = _context68.next) {
            case 0:
              _context68.t0 = mc;
              _context68.next = 3;
              return na(t);

            case 3:
              _context68.t1 = _context68.sent;
              _context68.t2 = e;
              return _context68.abrupt("return", (0, _context68.t0)(_context68.t1, _context68.t2));

            case 6:
            case "end":
              return _context68.stop();
          }
        }
      }, _callee68);
    }))), e.promise;
  }(La(t = Ia(t, Fa)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */


function Wa(t) {
  return ia(La(t = Ia(t, Fa)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */


function za(t) {
  return ra(La(t = Ia(t, Fa)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link getFirestore}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */


function Ha(t) {
  return _removeServiceInstance(t.app, "firestore"), t._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */


function Ja(t, e) {
  var n = La(t = Ia(t, Fa)),
      s = new Oa();
  return fa(n, t._databaseId, e, s), s;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */


function Ya(t, e) {
  return da(La(t = Ia(t, Fa)), e).then(function (e) {
    return e ? new Pa(t, null, e.query) : null;
  });
}

function Xa(t) {
  if (t._initialized || t._terminated) throw new Q(G.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */


var Za = /*#__PURE__*/function () {
  /**
   * Creates a `FieldPath` from the provided field names. If more than one field
   * name is provided, the path will point to a nested field in a document.
   *
   * @param fieldNames - A list of field names.
   */
  function Za() {
    _classCallCheck(this, Za);

    for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      t[_key9] = arguments[_key9];
    }

    for (var e = 0; e < t.length; ++e) {
      if (0 === t[e].length) throw new Q(G.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
    }

    this._internalPath = new ft(t);
  }
  /**
   * Returns true if this `FieldPath` is equal to the provided one.
   *
   * @param other - The `FieldPath` to compare against.
   * @returns true if this `FieldPath` is equal to the provided one.
   */


  _createClass(Za, [{
    key: "isEqual",
    value: function isEqual(t) {
      return this._internalPath.isEqual(t._internalPath);
    }
  }]);

  return Za;
}();
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */


function th() {
  return new Za("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An immutable object representing an array of bytes.
 */


var eh = /*#__PURE__*/function () {
  /** @hideconstructor */
  function eh(t) {
    _classCallCheck(this, eh);

    this._byteString = t;
  }
  /**
   * Creates a new `Bytes` object from the given Base64 string, converting it to
   * bytes.
   *
   * @param base64 - The Base64 string used to create the `Bytes` object.
   */


  _createClass(eh, [{
    key: "toBase64",
    value:
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */
    function toBase64() {
      return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */

  }, {
    key: "toUint8Array",
    value: function toUint8Array() {
      return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */

  }, {
    key: "toString",
    value: function toString() {
      return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */

  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this._byteString.isEqual(t._byteString);
    }
  }], [{
    key: "fromBase64String",
    value: function fromBase64String(t) {
      try {
        return new eh(Jt.fromBase64String(t));
      } catch (t) {
        throw new Q(G.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
      }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */

  }, {
    key: "fromUint8Array",
    value: function fromUint8Array(t) {
      return new eh(Jt.fromUint8Array(t));
    }
  }]);

  return eh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */


var nh = /*#__PURE__*/_createClass(
/**
 * @param _methodName - The public API endpoint that returns this class.
 * @hideconstructor
 */
function nh(t) {
  _classCallCheck(this, nh);

  this._methodName = t;
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */


var sh = /*#__PURE__*/function () {
  /**
   * Creates a new immutable `GeoPoint` object with the provided latitude and
   * longitude values.
   * @param latitude - The latitude as number between -90 and 90.
   * @param longitude - The longitude as number between -180 and 180.
   */
  function sh(t, e) {
    _classCallCheck(this, sh);

    if (!isFinite(t) || t < -90 || t > 90) throw new Q(G.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
    if (!isFinite(e) || e < -180 || e > 180) throw new Q(G.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
    this._lat = t, this._long = e;
  }
  /**
   * The latitude of this `GeoPoint` instance.
   */


  _createClass(sh, [{
    key: "latitude",
    get: function get() {
      return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */

  }, {
    key: "longitude",
    get: function get() {
      return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */

  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        latitude: this._lat,
        longitude: this._long
      };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */

  }, {
    key: "_compareTo",
    value: function _compareTo(t) {
      return it(this._lat, t._lat) || it(this._long, t._long);
    }
  }]);

  return sh;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ih = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */

var rh = /*#__PURE__*/function () {
  function rh(t, e, n) {
    _classCallCheck(this, rh);

    this.data = t, this.fieldMask = e, this.fieldTransforms = n;
  }

  _createClass(rh, [{
    key: "toMutation",
    value: function toMutation(t, e) {
      return null !== this.fieldMask ? new Wn(t, this.data, this.fieldMask, e, this.fieldTransforms) : new jn(t, this.data, e, this.fieldTransforms);
    }
  }]);

  return rh;
}();
/** The result of parsing "update" data (i.e. for an updateData call). */


var oh = /*#__PURE__*/function () {
  function oh(t, // The fieldMask does not include document transforms.
  e, n) {
    _classCallCheck(this, oh);

    this.data = t, this.fieldMask = e, this.fieldTransforms = n;
  }

  _createClass(oh, [{
    key: "toMutation",
    value: function toMutation(t, e) {
      return new Wn(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
  }]);

  return oh;
}();

function uh(t) {
  switch (t) {
    case 0
    /* Set */
    : // fall through

    case 2
    /* MergeSet */
    : // fall through

    case 1
    /* Update */
    :
      return !0;

    case 3
    /* Argument */
    :
    case 4
    /* ArrayArgument */
    :
      return !1;

    default:
      throw L();
  }
}
/** A "context" object passed around while parsing user data. */


var ch = /*#__PURE__*/function () {
  /**
   * Initializes a ParseContext with the given source and path.
   *
   * @param settings - The settings for the parser.
   * @param databaseId - The database ID of the Firestore instance.
   * @param serializer - The serializer to use to generate the Value proto.
   * @param ignoreUndefinedProperties - Whether to ignore undefined properties
   * rather than throw.
   * @param fieldTransforms - A mutable list of field transforms encountered
   * while parsing the data.
   * @param fieldMask - A mutable list of field paths encountered while parsing
   * the data.
   *
   * TODO(b/34871131): We don't support array paths right now, so path can be
   * null to indicate the context represents any location within an array (in
   * which case certain features will not work and errors will be somewhat
   * compromised).
   */
  function ch(t, e, n, s, i, r) {
    _classCallCheck(this, ch);

    this.settings = t, this.databaseId = e, this.wt = n, this.ignoreUndefinedProperties = s, // Minor hack: If fieldTransforms is undefined, we assume this is an
    // external call and we need to validate the entire path.
    void 0 === i && this.Xc(), this.fieldTransforms = i || [], this.fieldMask = r || [];
  }

  _createClass(ch, [{
    key: "path",
    get: function get() {
      return this.settings.path;
    }
  }, {
    key: "Zc",
    get: function get() {
      return this.settings.Zc;
    }
    /** Returns a new context with the specified settings overwritten. */

  }, {
    key: "ta",
    value: function ta(t) {
      return new ch(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.wt, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
  }, {
    key: "ea",
    value: function ea(t) {
      var e;
      var n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t),
          s = this.ta({
        path: n,
        na: !1
      });
      return s.sa(t), s;
    }
  }, {
    key: "ia",
    value: function ia(t) {
      var e;
      var n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t),
          s = this.ta({
        path: n,
        na: !1
      });
      return s.Xc(), s;
    }
  }, {
    key: "ra",
    value: function ra(t) {
      // TODO(b/34871131): We don't support array paths right now; so make path
      // undefined.
      return this.ta({
        path: void 0,
        na: !0
      });
    }
  }, {
    key: "oa",
    value: function oa(t) {
      return Vh(t, this.settings.methodName, this.settings.ua || !1, this.path, this.settings.ca);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */

  }, {
    key: "contains",
    value: function contains(t) {
      return void 0 !== this.fieldMask.find(function (e) {
        return t.isPrefixOf(e);
      }) || void 0 !== this.fieldTransforms.find(function (e) {
        return t.isPrefixOf(e.field);
      });
    }
  }, {
    key: "Xc",
    value: function Xc() {
      // TODO(b/34871131): Remove null check once we have proper paths for fields
      // within arrays.
      if (this.path) for (var t = 0; t < this.path.length; t++) {
        this.sa(this.path.get(t));
      }
    }
  }, {
    key: "sa",
    value: function sa(t) {
      if (0 === t.length) throw this.oa("Document fields must not be empty");
      if (uh(this.Zc) && ih.test(t)) throw this.oa('Document fields cannot begin and end with "__"');
    }
  }]);

  return ch;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */


var ah = /*#__PURE__*/function () {
  function ah(t, e, n) {
    _classCallCheck(this, ah);

    this.databaseId = t, this.ignoreUndefinedProperties = e, this.wt = n || nu(t);
  }
  /** Creates a new top-level parse context. */


  _createClass(ah, [{
    key: "aa",
    value: function aa(t, e, n) {
      var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      return new ch({
        Zc: t,
        methodName: e,
        ca: n,
        path: ft.emptyPath(),
        na: !1,
        ua: s
      }, this.databaseId, this.wt, this.ignoreUndefinedProperties);
    }
  }]);

  return ah;
}();

function hh(t) {
  var e = t._freezeSettings(),
      n = nu(t._databaseId);

  return new ah(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */


function lh(t, e, n, s, i) {
  var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var o = t.aa(r.merge || r.mergeFields ? 2
  /* MergeSet */
  : 0
  /* Set */
  , e, n, i);
  Rh("Data must be an object, but it was:", o, s);
  var u = Eh(s, o);
  var c, a;
  if (r.merge) c = new zt(o.fieldMask), a = o.fieldTransforms;else if (r.mergeFields) {
    var _t104 = [];

    var _iterator75 = _createForOfIteratorHelper(r.mergeFields),
        _step75;

    try {
      for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
        var _s29 = _step75.value;

        var _i16 = bh(e, _s29, n);

        if (!o.contains(_i16)) throw new Q(G.INVALID_ARGUMENT, "Field '".concat(_i16, "' is specified in your field mask but missing from your input data."));
        Sh(_t104, _i16) || _t104.push(_i16);
      }
    } catch (err) {
      _iterator75.e(err);
    } finally {
      _iterator75.f();
    }

    c = new zt(_t104), a = o.fieldTransforms.filter(function (t) {
      return c.covers(t.field);
    });
  } else c = null, a = o.fieldTransforms;
  return new rh(new De(u), c, a);
}

var fh = /*#__PURE__*/function (_nh) {
  _inherits(fh, _nh);

  var _super33 = _createSuper(fh);

  function fh() {
    _classCallCheck(this, fh);

    return _super33.apply(this, arguments);
  }

  _createClass(fh, [{
    key: "_toFieldTransform",
    value: function _toFieldTransform(t) {
      if (2
      /* MergeSet */
      !== t.Zc) throw 1
      /* Update */
      === t.Zc ? t.oa("".concat(this._methodName, "() can only appear at the top level of your update data")) : t.oa("".concat(this._methodName, "() cannot be used with set() unless you pass {merge:true}")); // No transform to add for a delete, but we need to add it to our
      // fieldMask so it gets deleted.

      return t.fieldMask.push(t.path), null;
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t instanceof fh;
    }
  }]);

  return fh;
}(nh);
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */


function dh(t, e, n) {
  return new ch({
    Zc: 3
    /* Argument */
    ,
    ca: e.settings.ca,
    methodName: t._methodName,
    na: n
  }, e.databaseId, e.wt, e.ignoreUndefinedProperties);
}

var _h = /*#__PURE__*/function (_nh2) {
  _inherits(_h, _nh2);

  var _super34 = _createSuper(_h);

  function _h() {
    _classCallCheck(this, _h);

    return _super34.apply(this, arguments);
  }

  _createClass(_h, [{
    key: "_toFieldTransform",
    value: function _toFieldTransform(t) {
      return new On(t.path, new vn());
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      return t instanceof _h;
    }
  }]);

  return _h;
}(nh);

var wh = /*#__PURE__*/function (_nh3) {
  _inherits(wh, _nh3);

  var _super35 = _createSuper(wh);

  function wh(t, e) {
    var _this197;

    _classCallCheck(this, wh);

    _this197 = _super35.call(this, t), _this197.ha = e;
    return _this197;
  }

  _createClass(wh, [{
    key: "_toFieldTransform",
    value: function _toFieldTransform(t) {
      var e = dh(this, t,
      /*array=*/
      !0),
          n = this.ha.map(function (t) {
        return Th(t, e);
      }),
          s = new Vn(n);
      return new On(t.path, s);
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      // TODO(mrschmidt): Implement isEquals
      return this === t;
    }
  }]);

  return wh;
}(nh);

var mh = /*#__PURE__*/function (_nh4) {
  _inherits(mh, _nh4);

  var _super36 = _createSuper(mh);

  function mh(t, e) {
    var _this198;

    _classCallCheck(this, mh);

    _this198 = _super36.call(this, t), _this198.ha = e;
    return _this198;
  }

  _createClass(mh, [{
    key: "_toFieldTransform",
    value: function _toFieldTransform(t) {
      var e = dh(this, t,
      /*array=*/
      !0),
          n = this.ha.map(function (t) {
        return Th(t, e);
      }),
          s = new Dn(n);
      return new On(t.path, s);
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      // TODO(mrschmidt): Implement isEquals
      return this === t;
    }
  }]);

  return mh;
}(nh);

var gh = /*#__PURE__*/function (_nh5) {
  _inherits(gh, _nh5);

  var _super37 = _createSuper(gh);

  function gh(t, e) {
    var _this199;

    _classCallCheck(this, gh);

    _this199 = _super37.call(this, t), _this199.la = e;
    return _this199;
  }

  _createClass(gh, [{
    key: "_toFieldTransform",
    value: function _toFieldTransform(t) {
      var e = new xn(t.wt, En(t.wt, this.la));
      return new On(t.path, e);
    }
  }, {
    key: "isEqual",
    value: function isEqual(t) {
      // TODO(mrschmidt): Implement isEquals
      return this === t;
    }
  }]);

  return gh;
}(nh);
/** Parse update data from an update() call. */


function yh(t, e, n, s) {
  var i = t.aa(1
  /* Update */
  , e, n);
  Rh("Data must be an object, but it was:", i, s);
  var r = [],
      o = De.empty();
  Lt(s, function (t, s) {
    var u = vh(e, t, n); // For Compat types, we have to "extract" the underlying types before
    // performing validation.

    s = getModularInstance(s);
    var c = i.ia(u);
    if (s instanceof fh) // Add it to the field mask, but don't add anything to updateData.
      r.push(u);else {
      var _t105 = Th(s, c);

      null != _t105 && (r.push(u), o.set(u, _t105));
    }
  });
  var u = new zt(r);
  return new oh(o, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */


function ph(t, e, n, s, i, r) {
  var o = t.aa(1
  /* Update */
  , e, n),
      u = [bh(e, s, n)],
      c = [i];
  if (r.length % 2 != 0) throw new Q(G.INVALID_ARGUMENT, "Function ".concat(e, "() needs to be called with an even number of arguments that alternate between field names and values."));

  for (var _t106 = 0; _t106 < r.length; _t106 += 2) {
    u.push(bh(e, r[_t106])), c.push(r[_t106 + 1]);
  }

  var a = [],
      h = De.empty(); // We iterate in reverse order to pick the last value for a field if the
  // user specified the field multiple times.

  for (var _t107 = u.length - 1; _t107 >= 0; --_t107) {
    if (!Sh(a, u[_t107])) {
      var _e48 = u[_t107];
      var _n31 = c[_t107]; // For Compat types, we have to "extract" the underlying types before
      // performing validation.

      _n31 = getModularInstance(_n31);

      var _s30 = o.ia(_e48);

      if (_n31 instanceof fh) // Add it to the field mask, but don't add anything to updateData.
        a.push(_e48);else {
        var _t108 = Th(_n31, _s30);

        null != _t108 && (a.push(_e48), h.set(_e48, _t108));
      }
    }
  }

  var l = new zt(a);
  return new oh(h, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */


function Ih(t, e, n) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  return Th(n, t.aa(s ? 4
  /* ArrayArgument */
  : 3
  /* Argument */
  , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */


function Th(t, e) {
  if (Ah( // Unwrap the API type from the Compat SDK. This will return the API type
  // from firestore-exp.
  t = getModularInstance(t))) return Rh("Unsupported field value:", e, t), Eh(t, e);
  if (t instanceof nh) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.

    /**
    * "Parses" the provided FieldValueImpl, adding any necessary transforms to
    * context.fieldTransforms.
    */
    return function (t, e) {
      // Sentinels are only supported with writes, and not within arrays.
      if (!uh(e.Zc)) throw e.oa("".concat(t._methodName, "() can only be used with update() and set()"));
      if (!e.path) throw e.oa("".concat(t._methodName, "() is not currently supported inside arrays"));

      var n = t._toFieldTransform(e);

      n && e.fieldTransforms.push(n);
    }
    /**
    * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
    *
    * @returns The parsed value
    */
    (t, e), null;
  if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;

  if ( // If context.path is null we are inside an array and we don't support
  // field mask paths more granular than the top-level array.
  e.path && e.fieldMask.push(e.path), t instanceof Array) {
    // TODO(b/34871131): Include the path containing the array in the error
    // message.
    // In the case of IN queries, the parsed data is an array (representing
    // the set of values to be included for the IN query) that may directly
    // contain additional arrays (each representing an individual field
    // value), so we disable this validation.
    if (e.settings.na && 4
    /* ArrayArgument */
    !== e.Zc) throw e.oa("Nested arrays are not supported");
    return function (t, e) {
      var n = [];
      var s = 0;

      var _iterator76 = _createForOfIteratorHelper(t),
          _step76;

      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var i = _step76.value;

          var _t109 = Th(i, e.ra(s));

          null == _t109 && ( // Just include nulls in the array for fields being replaced with a
          // sentinel.
          _t109 = {
            nullValue: "NULL_VALUE"
          }), n.push(_t109), s++;
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }

      return {
        arrayValue: {
          values: n
        }
      };
    }(t, e);
  }

  return function (t, e) {
    if (null === (t = getModularInstance(t))) return {
      nullValue: "NULL_VALUE"
    };
    if ("number" == typeof t) return En(e.wt, t);
    if ("boolean" == typeof t) return {
      booleanValue: t
    };
    if ("string" == typeof t) return {
      stringValue: t
    };

    if (t instanceof Date) {
      var n = ut.fromDate(t);
      return {
        timestampValue: Ds(e.wt, n)
      };
    }

    if (t instanceof ut) {
      // Firestore backend truncates precision down to microseconds. To ensure
      // offline mode works the same with regards to truncation, perform the
      // truncation immediately without waiting for the backend to do that.
      var _n32 = new ut(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));

      return {
        timestampValue: Ds(e.wt, _n32)
      };
    }

    if (t instanceof sh) return {
      geoPointValue: {
        latitude: t.latitude,
        longitude: t.longitude
      }
    };
    if (t instanceof eh) return {
      bytesValue: Cs(e.wt, t._byteString)
    };

    if (t instanceof ba) {
      var _n33 = e.databaseId,
          s = t.firestore._databaseId;
      if (!s.isEqual(_n33)) throw e.oa("Document reference is for database ".concat(s.projectId, "/").concat(s.database, " but should be for database ").concat(_n33.projectId, "/").concat(_n33.database));
      return {
        referenceValue: ks(t.firestore._databaseId || e.databaseId, t._key.path)
      };
    }

    throw e.oa("Unsupported field value: ".concat(pa(t)));
  }
  /**
  * Checks whether an object looks like a JSON object that should be converted
  * into a struct. Normal class/prototype instances are considered to look like
  * JSON objects since they should be converted to a struct value. Arrays, Dates,
  * GeoPoints, etc. are not considered to look like JSON objects since they map
  * to specific FieldValue types other than ObjectValue.
  */
  (t, e);
}

function Eh(t, e) {
  var n = {};
  return Ut(t) ? // If we encounter an empty object, we explicitly add it to the update
  // mask to ensure that the server creates a map entry.
  e.path && e.path.length > 0 && e.fieldMask.push(e.path) : Lt(t, function (t, s) {
    var i = Th(s, e.ea(t));
    null != i && (n[t] = i);
  }), {
    mapValue: {
      fields: n
    }
  };
}

function Ah(t) {
  return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof ut || t instanceof sh || t instanceof eh || t instanceof ba || t instanceof nh);
}

function Rh(t, e, n) {
  if (!Ah(n) || !function (t) {
    return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
  }(n)) {
    var s = pa(n);
    throw "an object" === s ? e.oa(t + " a custom object") : e.oa(t + " " + s);
  }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */


function bh(t, e, n) {
  if (( // If required, replace the FieldPath Compat class with with the firestore-exp
  // FieldPath.
  e = getModularInstance(e)) instanceof Za) return e._internalPath;
  if ("string" == typeof e) return vh(t, e);
  throw Vh("Field path arguments must be of type string or ", t,
  /* hasConverter= */
  !1,
  /* path= */
  void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */


var Ph = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */

function vh(t, e, n) {
  if (e.search(Ph) >= 0) throw Vh("Invalid field path (".concat(e, "). Paths must not contain '~', '*', '/', '[', or ']'"), t,
  /* hasConverter= */
  !1,
  /* path= */
  void 0, n);

  try {
    return _construct(Za, _toConsumableArray(e.split(".")))._internalPath;
  } catch (s) {
    throw Vh("Invalid field path (".concat(e, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"), t,
    /* hasConverter= */
    !1,
    /* path= */
    void 0, n);
  }
}

function Vh(t, e, n, s, i) {
  var r = s && !s.isEmpty(),
      o = void 0 !== i;
  var u = "Function ".concat(e, "() called with invalid data");
  n && (u += " (via `toFirestore()`)"), u += ". ";
  var c = "";
  return (r || o) && (c += " (found", r && (c += " in field ".concat(s)), o && (c += " in document ".concat(i)), c += ")"), new Q(G.INVALID_ARGUMENT, u + t + c);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */


function Sh(t, e) {
  return t.some(function (t) {
    return t.isEqual(e);
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */


var Dh = /*#__PURE__*/function () {
  // Note: This class is stripped down version of the DocumentSnapshot in
  // the legacy SDK. The changes are:
  // - No support for SnapshotMetadata.
  // - No support for SnapshotOptions.

  /** @hideconstructor protected */
  function Dh(t, e, n, s, i) {
    _classCallCheck(this, Dh);

    this._firestore = t, this._userDataWriter = e, this._key = n, this._document = s, this._converter = i;
  }
  /** Property of the `DocumentSnapshot` that provides the document's ID. */


  _createClass(Dh, [{
    key: "id",
    get: function get() {
      return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */

  }, {
    key: "ref",
    get: function get() {
      return new ba(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */

  }, {
    key: "exists",
    value: function exists() {
      return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */

  }, {
    key: "data",
    value: function data() {
      if (this._document) {
        if (this._converter) {
          // We only want to use the converter and create a new DocumentSnapshot
          // if a converter has been provided.
          var t = new Ch(this._firestore, this._userDataWriter, this._key, this._document,
          /* converter= */
          null);
          return this._converter.fromFirestore(t);
        }

        return this._userDataWriter.convertValue(this._document.data.value);
      }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */
    // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "get",
    value: function get(t) {
      if (this._document) {
        var e = this._document.data.field(xh("DocumentSnapshot.get", t));

        if (null !== e) return this._userDataWriter.convertValue(e);
      }
    }
  }]);

  return Dh;
}();
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */


var Ch = /*#__PURE__*/function (_Dh) {
  _inherits(Ch, _Dh);

  var _super38 = _createSuper(Ch);

  function Ch() {
    _classCallCheck(this, Ch);

    return _super38.apply(this, arguments);
  }

  _createClass(Ch, [{
    key: "data",
    value:
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */
    function data() {
      return _get(_getPrototypeOf(Ch.prototype), "data", this).call(this);
    }
  }]);

  return Ch;
}(Dh);
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */


function xh(t, e) {
  return "string" == typeof e ? vh(t, e) : e instanceof Za ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */


var Nh = /*#__PURE__*/function () {
  /** @hideconstructor */
  function Nh(t, e) {
    _classCallCheck(this, Nh);

    this.hasPendingWrites = t, this.fromCache = e;
  }
  /**
   * Returns true if this `SnapshotMetadata` is equal to the provided one.
   *
   * @param other - The `SnapshotMetadata` to compare against.
   * @returns true if this `SnapshotMetadata` is equal to the provided one.
   */


  _createClass(Nh, [{
    key: "isEqual",
    value: function isEqual(t) {
      return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
  }]);

  return Nh;
}();
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */


var kh = /*#__PURE__*/function (_Dh2) {
  _inherits(kh, _Dh2);

  var _super39 = _createSuper(kh);

  /** @hideconstructor protected */
  function kh(t, e, n, s, i, r) {
    var _this200;

    _classCallCheck(this, kh);

    _this200 = _super39.call(this, t, e, n, s, r), _this200._firestore = t, _this200._firestoreImpl = t, _this200.metadata = i;
    return _this200;
  }
  /**
   * Returns whether or not the data exists. True if the document exists.
   */


  _createClass(kh, [{
    key: "exists",
    value: function exists() {
      return _get(_getPrototypeOf(kh.prototype), "exists", this).call(this);
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */

  }, {
    key: "data",
    value: function data() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this._document) {
        if (this._converter) {
          // We only want to use the converter and create a new DocumentSnapshot
          // if a converter has been provided.
          var e = new Oh(this._firestore, this._userDataWriter, this._key, this._document, this.metadata,
          /* converter= */
          null);
          return this._converter.fromFirestore(e, t);
        }

        return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
      }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */
    // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "get",
    value: function get(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._document) {
        var n = this._document.data.field(xh("DocumentSnapshot.get", t));

        if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
      }
    }
  }]);

  return kh;
}(Dh);
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */


var Oh = /*#__PURE__*/function (_kh) {
  _inherits(Oh, _kh);

  var _super40 = _createSuper(Oh);

  function Oh() {
    _classCallCheck(this, Oh);

    return _super40.apply(this, arguments);
  }

  _createClass(Oh, [{
    key: "data",
    value:
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */
    function data() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _get(_getPrototypeOf(Oh.prototype), "data", this).call(this, t);
    }
  }]);

  return Oh;
}(kh);
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */


var Mh = /*#__PURE__*/function () {
  /** @hideconstructor */
  function Mh(t, e, n, s) {
    _classCallCheck(this, Mh);

    this._firestore = t, this._userDataWriter = e, this._snapshot = s, this.metadata = new Nh(s.hasPendingWrites, s.fromCache), this.query = n;
  }
  /** An array of all the documents in the `QuerySnapshot`. */


  _createClass(Mh, [{
    key: "docs",
    get: function get() {
      var t = [];
      return this.forEach(function (e) {
        return t.push(e);
      }), t;
    }
    /** The number of documents in the `QuerySnapshot`. */

  }, {
    key: "size",
    get: function get() {
      return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */

  }, {
    key: "empty",
    get: function get() {
      return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */

  }, {
    key: "forEach",
    value: function forEach(t, e) {
      var _this201 = this;

      this._snapshot.docs.forEach(function (n) {
        t.call(e, new Oh(_this201._firestore, _this201._userDataWriter, n.key, n, new Nh(_this201._snapshot.mutatedKeys.has(n.key), _this201._snapshot.fromCache), _this201.query.converter));
      });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */

  }, {
    key: "docChanges",
    value: function docChanges() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.includeMetadataChanges;
      if (e && this._snapshot.excludesMetadataChanges) throw new Q(G.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
      return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges =
      /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */
      function (t, e) {
        if (t._snapshot.oldDocs.isEmpty()) {
          var _e49 = 0;
          return t._snapshot.docChanges.map(function (n) {
            return {
              type: "added",
              doc: new Oh(t._firestore, t._userDataWriter, n.doc.key, n.doc, new Nh(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter),
              oldIndex: -1,
              newIndex: _e49++
            };
          });
        }

        {
          // A `DocumentSet` that is updated incrementally as changes are applied to use
          // to lookup the index of a document.
          var n = t._snapshot.oldDocs;
          return t._snapshot.docChanges.filter(function (t) {
            return e || 3
            /* Metadata */
            !== t.type;
          }).map(function (e) {
            var s = new Oh(t._firestore, t._userDataWriter, e.doc.key, e.doc, new Nh(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
            var i = -1,
                r = -1;
            return 0
            /* Added */
            !== e.type && (i = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1
            /* Removed */
            !== e.type && (n = n.add(e.doc), r = n.indexOf(e.doc.key)), {
              type: Fh(e.type),
              doc: s,
              oldIndex: i,
              newIndex: r
            };
          });
        }
      }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
  }]);

  return Mh;
}();

function Fh(t) {
  switch (t) {
    case 0
    /* Added */
    :
      return "added";

    case 2
    /* Modified */
    :
    case 3
    /* Metadata */
    :
      return "modified";

    case 1
    /* Removed */
    :
      return "removed";

    default:
      return L();
  }
} // TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata

/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */


function $h(t, e) {
  return t instanceof kh && e instanceof kh ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof Mh && e instanceof Mh && t._firestore === e._firestore && xa(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Bh(t) {
  if ("L"
  /* Last */
  === t.limitType && 0 === t.explicitOrderBy.length) throw new Q(G.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * endBefore:1}, {@link (endAt:1)}, {@link limit} or {@link limitToLast} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */


var Lh = /*#__PURE__*/_createClass(function Lh() {
  _classCallCheck(this, Lh);
});
/**
 * Creates a new immutable instance of {@link Query} that is extended to also include
 * additional query constraints.
 *
 * @param query - The {@link Query} instance to use as a base for the new constraints.
 * @param queryConstraints - The list of {@link QueryConstraint}s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */


function Uh(t) {
  for (var _len10 = arguments.length, e = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    e[_key10 - 1] = arguments[_key10];
  }

  for (var _i17 = 0, _e50 = e; _i17 < _e50.length; _i17++) {
    var n = _e50[_i17];
    t = n._apply(t);
  }

  return t;
}

var qh = /*#__PURE__*/function (_Lh) {
  _inherits(qh, _Lh);

  var _super41 = _createSuper(qh);

  function qh(t, e, n) {
    var _this202;

    _classCallCheck(this, qh);

    _this202 = _super41.call(this), _this202.fa = t, _this202.da = e, _this202._a = n, _this202.type = "where";
    return _this202;
  }

  _createClass(qh, [{
    key: "_apply",
    value: function _apply(t) {
      var e = hh(t.firestore),
          n = function (t, e, n, s, i, r, o) {
        var u;

        if (i.isKeyField()) {
          if ("array-contains"
          /* ARRAY_CONTAINS */
          === r || "array-contains-any"
          /* ARRAY_CONTAINS_ANY */
          === r) throw new Q(G.INVALID_ARGUMENT, "Invalid Query. You can't perform '".concat(r, "' queries on documentId()."));

          if ("in"
          /* IN */
          === r || "not-in"
          /* NOT_IN */
          === r) {
            sl(o, r);
            var _e51 = [];

            var _iterator77 = _createForOfIteratorHelper(o),
                _step77;

            try {
              for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                var _n34 = _step77.value;

                _e51.push(nl(s, t, _n34));
              }
            } catch (err) {
              _iterator77.e(err);
            } finally {
              _iterator77.f();
            }

            u = {
              arrayValue: {
                values: _e51
              }
            };
          } else u = nl(s, t, o);
        } else "in"
        /* IN */
        !== r && "not-in"
        /* NOT_IN */
        !== r && "array-contains-any"
        /* ARRAY_CONTAINS_ANY */
        !== r || sl(o, r), u = Ih(n, e, o,
        /* allowArrays= */
        "in"
        /* IN */
        === r || "not-in"
        /* NOT_IN */
        === r);

        var c = qe.create(i, r, u);
        return function (t, e) {
          if (e.ht()) {
            var _n35 = cn(t);

            if (null !== _n35 && !_n35.isEqual(e.field)) throw new Q(G.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '".concat(_n35.toString(), "' and '").concat(e.field.toString(), "'"));

            var _s31 = un(t);

            null !== _s31 && il(t, e.field, _s31);
          }

          var n = function (t, e) {
            var _iterator78 = _createForOfIteratorHelper(t.filters),
                _step78;

            try {
              for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
                var _n36 = _step78.value;
                if (e.indexOf(_n36.op) >= 0) return _n36.op;
              }
            } catch (err) {
              _iterator78.e(err);
            } finally {
              _iterator78.f();
            }

            return null;
          }(t,
          /**
          * Given an operator, returns the set of operators that cannot be used with it.
          *
          * Operators in a query must adhere to the following set of rules:
          * 1. Only one array operator is allowed.
          * 2. Only one disjunctive operator is allowed.
          * 3. `NOT_EQUAL` cannot be used with another `NOT_EQUAL` operator.
          * 4. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
          *
          * Array operators: `ARRAY_CONTAINS`, `ARRAY_CONTAINS_ANY`
          * Disjunctive operators: `IN`, `ARRAY_CONTAINS_ANY`, `NOT_IN`
          */
          function (t) {
            switch (t) {
              case "!="
              /* NOT_EQUAL */
              :
                return ["!="
                /* NOT_EQUAL */
                , "not-in"
                /* NOT_IN */
                ];

              case "array-contains"
              /* ARRAY_CONTAINS */
              :
                return ["array-contains"
                /* ARRAY_CONTAINS */
                , "array-contains-any"
                /* ARRAY_CONTAINS_ANY */
                , "not-in"
                /* NOT_IN */
                ];

              case "in"
              /* IN */
              :
                return ["array-contains-any"
                /* ARRAY_CONTAINS_ANY */
                , "in"
                /* IN */
                , "not-in"
                /* NOT_IN */
                ];

              case "array-contains-any"
              /* ARRAY_CONTAINS_ANY */
              :
                return ["array-contains"
                /* ARRAY_CONTAINS */
                , "array-contains-any"
                /* ARRAY_CONTAINS_ANY */
                , "in"
                /* IN */
                , "not-in"
                /* NOT_IN */
                ];

              case "not-in"
              /* NOT_IN */
              :
                return ["array-contains"
                /* ARRAY_CONTAINS */
                , "array-contains-any"
                /* ARRAY_CONTAINS_ANY */
                , "in"
                /* IN */
                , "not-in"
                /* NOT_IN */
                , "!="
                /* NOT_EQUAL */
                ];

              default:
                return [];
            }
          }(e.op));

          if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
            throw n === e.op ? new Q(G.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '".concat(e.op.toString(), "' filter.")) : new Q(G.INVALID_ARGUMENT, "Invalid query. You cannot use '".concat(e.op.toString(), "' filters with '").concat(n.toString(), "' filters."));
        }(t, c), c;
      }(t._query, "where", e, t.firestore._databaseId, this.fa, this.da, this._a);

      return new Pa(t.firestore, t.converter, function (t, e) {
        var n = t.filters.concat([e]);
        return new nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
      }(t._query, n));
    }
  }]);

  return qh;
}(Lh);
/**
 * Creates a {@link QueryConstraint} that enforces that documents must contain the
 * specified field and that the value should satisfy the relation constraint
 * provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link Query}.
 */


function Kh(t, e, n) {
  var s = e,
      i = xh("where", t);
  return new qh(i, s, n);
}

var Gh = /*#__PURE__*/function (_Lh2) {
  _inherits(Gh, _Lh2);

  var _super42 = _createSuper(Gh);

  function Gh(t, e) {
    var _this203;

    _classCallCheck(this, Gh);

    _this203 = _super42.call(this), _this203.fa = t, _this203.wa = e, _this203.type = "orderBy";
    return _this203;
  }

  _createClass(Gh, [{
    key: "_apply",
    value: function _apply(t) {
      var e = function (t, e, n) {
        if (null !== t.startAt) throw new Q(G.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
        if (null !== t.endAt) throw new Q(G.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
        var s = new Xe(e, n);
        return function (t, e) {
          if (null === un(t)) {
            // This is the first order by. It must match any inequality.
            var _n37 = cn(t);

            null !== _n37 && il(t, _n37, e.field);
          }
        }(t, s), s;
      }
      /**
      * Create a `Bound` from a query and a document.
      *
      * Note that the `Bound` will always include the key of the document
      * and so only the provided document will compare equal to the returned
      * position.
      *
      * Will throw if the document does not contain all fields of the order by
      * of the query or if any of the fields in the order by are an uncommitted
      * server timestamp.
      */
      (t._query, this.fa, this.wa);

      return new Pa(t.firestore, t.converter, function (t, e) {
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var n = t.explicitOrderBy.concat([e]);
        return new nn(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
      }(t._query, e));
    }
  }]);

  return Gh;
}(Lh);
/**
 * Creates a {@link QueryConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link Query}.
 */


function Qh(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";
  var n = e,
      s = xh("orderBy", t);
  return new Gh(s, n);
}

var jh = /*#__PURE__*/function (_Lh3) {
  _inherits(jh, _Lh3);

  var _super43 = _createSuper(jh);

  function jh(t, e, n) {
    var _this204;

    _classCallCheck(this, jh);

    _this204 = _super43.call(this), _this204.type = t, _this204.ma = e, _this204.ga = n;
    return _this204;
  }

  _createClass(jh, [{
    key: "_apply",
    value: function _apply(t) {
      return new Pa(t.firestore, t.converter, fn(t._query, this.ma, this.ga));
    }
  }]);

  return jh;
}(Lh);
/**
 * Creates a {@link QueryConstraint} that only returns the first matching documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */


function Wh(t) {
  return Ta("limit", t), new jh("limit", t, "F"
  /* First */
  );
}
/**
 * Creates a {@link QueryConstraint} that only returns the last matching documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link Query}.
 */


function zh(t) {
  return Ta("limitToLast", t), new jh("limitToLast", t, "L"
  /* Last */
  );
}

var Hh = /*#__PURE__*/function (_Lh4) {
  _inherits(Hh, _Lh4);

  var _super44 = _createSuper(Hh);

  function Hh(t, e, n) {
    var _this205;

    _classCallCheck(this, Hh);

    _this205 = _super44.call(this), _this205.type = t, _this205.ya = e, _this205.pa = n;
    return _this205;
  }

  _createClass(Hh, [{
    key: "_apply",
    value: function _apply(t) {
      var e = el(t, this.type, this.ya, this.pa);
      return new Pa(t.firestore, t.converter, function (t, e) {
        return new nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
      }(t._query, e));
    }
  }]);

  return Hh;
}(Lh);

function Jh() {
  for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    t[_key11] = arguments[_key11];
  }

  return new Hh("startAt", t,
  /*inclusive=*/
  !0);
}

function Yh() {
  for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    t[_key12] = arguments[_key12];
  }

  return new Hh("startAfter", t,
  /*inclusive=*/
  !1);
}

var Xh = /*#__PURE__*/function (_Lh5) {
  _inherits(Xh, _Lh5);

  var _super45 = _createSuper(Xh);

  function Xh(t, e, n) {
    var _this206;

    _classCallCheck(this, Xh);

    _this206 = _super45.call(this), _this206.type = t, _this206.ya = e, _this206.pa = n;
    return _this206;
  }

  _createClass(Xh, [{
    key: "_apply",
    value: function _apply(t) {
      var e = el(t, this.type, this.ya, this.pa);
      return new Pa(t.firestore, t.converter, function (t, e) {
        return new nn(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
      }(t._query, e));
    }
  }]);

  return Xh;
}(Lh);

function Zh() {
  for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    t[_key13] = arguments[_key13];
  }

  return new Xh("endBefore", t,
  /*inclusive=*/
  !1);
}

function tl() {
  for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    t[_key14] = arguments[_key14];
  }

  return new Xh("endAt", t,
  /*inclusive=*/
  !0);
}
/** Helper function to create a bound from a document or fields */


function el(t, e, n, s) {
  if (n[0] = getModularInstance(n[0]), n[0] instanceof Dh) return function (t, e, n, s, i) {
    if (!s) throw new Q(G.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for ".concat(n, "()."));
    var r = []; // Because people expect to continue/end a query at the exact document
    // provided, we need to use the implicit sort order rather than the explicit
    // sort order, because it's guaranteed to contain the document key. That way
    // the position becomes unambiguous and the query continues/ends exactly at
    // the provided document. Without the key (by using the explicit sort
    // orders), multiple documents could match the position, yielding duplicate
    // results.

    var _iterator79 = _createForOfIteratorHelper(hn(t)),
        _step79;

    try {
      for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
        var _n38 = _step79.value;
        if (_n38.field.isKeyField()) r.push(ye(e, s.key));else {
          var _t110 = s.data.field(_n38.field);

          if (ee(_t110)) throw new Q(G.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + _n38.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');

          if (null === _t110) {
            var _t111 = _n38.field.canonicalString();

            throw new Q(G.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '".concat(_t111, "' (used as the orderBy) does not exist."));
          }

          r.push(_t110);
        }
      }
    } catch (err) {
      _iterator79.e(err);
    } finally {
      _iterator79.f();
    }

    return new Ye(r, i);
  }
  /**
  * Converts a list of field values to a `Bound` for the given query.
  */
  (t._query, t.firestore._databaseId, e, n[0]._document, s);
  {
    var i = hh(t.firestore);
    return function (t, e, n, s, i, r) {
      // Use explicit order by's because it has to match the query the user made
      var o = t.explicitOrderBy;
      if (i.length > o.length) throw new Q(G.INVALID_ARGUMENT, "Too many arguments provided to ".concat(s, "(). The number of arguments must be less than or equal to the number of orderBy() clauses"));
      var u = [];

      for (var _r8 = 0; _r8 < i.length; _r8++) {
        var c = i[_r8];

        if (o[_r8].field.isKeyField()) {
          if ("string" != typeof c) throw new Q(G.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in ".concat(s, "(), but got a ").concat(typeof c));
          if (!an(t) && -1 !== c.indexOf("/")) throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by documentId(), the value passed to ".concat(s, "() must be a plain document ID, but '").concat(c, "' contains a slash."));

          var _n39 = t.path.child(ht.fromString(c));

          if (!dt.isDocumentKey(_n39)) throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by documentId(), the value passed to ".concat(s, "() must result in a valid document path, but '").concat(_n39, "' is not because it contains an odd number of segments."));

          var _i18 = new dt(_n39);

          u.push(ye(e, _i18));
        } else {
          var _t112 = Ih(n, s, c);

          u.push(_t112);
        }
      }

      return new Ye(u, r);
    }
    /**
    * Parses the given `documentIdValue` into a `ReferenceValue`, throwing
    * appropriate errors if the value is anything other than a `DocumentReference`
    * or `string`, or if the string is malformed.
    */
    (t._query, t.firestore._databaseId, i, e, n, s);
  }
}

function nl(t, e, n) {
  if ("string" == typeof (n = getModularInstance(n))) {
    if ("" === n) throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
    if (!an(e) && -1 !== n.indexOf("/")) throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '".concat(n, "' contains a '/' character."));
    var s = e.path.child(ht.fromString(n));
    if (!dt.isDocumentKey(s)) throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '".concat(s, "' is not because it has an odd number of segments (").concat(s.length, ")."));
    return ye(t, new dt(s));
  }

  if (n instanceof ba) return ye(t, n._key);
  throw new Q(G.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ".concat(pa(n), "."));
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */


function sl(t, e) {
  if (!Array.isArray(t) || 0 === t.length) throw new Q(G.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '".concat(e.toString(), "' filters."));
  if (t.length > 10) throw new Q(G.INVALID_ARGUMENT, "Invalid Query. '".concat(e.toString(), "' filters support a maximum of 10 elements in the value array."));
}

function il(t, e, n) {
  if (!n.isEqual(e)) throw new Q(G.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '".concat(e.toString(), "' and so you must also use '").concat(e.toString(), "' as your first argument to orderBy(), but your first orderBy() is on field '").concat(n.toString(), "' instead."));
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var rl = {
  maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */

var ol = /*#__PURE__*/function () {
  function ol() {
    _classCallCheck(this, ol);
  }

  _createClass(ol, [{
    key: "convertValue",
    value: function convertValue(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";

      switch (le(t)) {
        case 0
        /* NullValue */
        :
          return null;

        case 1
        /* BooleanValue */
        :
          return t.booleanValue;

        case 2
        /* NumberValue */
        :
          return Zt(t.integerValue || t.doubleValue);

        case 3
        /* TimestampValue */
        :
          return this.convertTimestamp(t.timestampValue);

        case 4
        /* ServerTimestampValue */
        :
          return this.convertServerTimestamp(t, e);

        case 5
        /* StringValue */
        :
          return t.stringValue;

        case 6
        /* BlobValue */
        :
          return this.convertBytes(te(t.bytesValue));

        case 7
        /* RefValue */
        :
          return this.convertReference(t.referenceValue);

        case 8
        /* GeoPointValue */
        :
          return this.convertGeoPoint(t.geoPointValue);

        case 9
        /* ArrayValue */
        :
          return this.convertArray(t.arrayValue, e);

        case 10
        /* ObjectValue */
        :
          return this.convertObject(t.mapValue, e);

        default:
          throw L();
      }
    }
  }, {
    key: "convertObject",
    value: function convertObject(t, e) {
      var _this207 = this;

      var n = {};
      return Lt(t.fields, function (t, s) {
        n[t] = _this207.convertValue(s, e);
      }), n;
    }
  }, {
    key: "convertGeoPoint",
    value: function convertGeoPoint(t) {
      return new sh(Zt(t.latitude), Zt(t.longitude));
    }
  }, {
    key: "convertArray",
    value: function convertArray(t, e) {
      var _this208 = this;

      return (t.values || []).map(function (t) {
        return _this208.convertValue(t, e);
      });
    }
  }, {
    key: "convertServerTimestamp",
    value: function convertServerTimestamp(t, e) {
      switch (e) {
        case "previous":
          var n = ne(t);
          return null == n ? null : this.convertValue(n, e);

        case "estimate":
          return this.convertTimestamp(se(t));

        default:
          return null;
      }
    }
  }, {
    key: "convertTimestamp",
    value: function convertTimestamp(t) {
      var e = Xt(t);
      return new ut(e.seconds, e.nanos);
    }
  }, {
    key: "convertDocumentKey",
    value: function convertDocumentKey(t, e) {
      var n = ht.fromString(t);
      U(ui(n));
      var s = new re(n.get(1), n.get(3)),
          i = new dt(n.popFirst(5));
      return s.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
      F("Document ".concat(i, " contains a document reference within a different database (").concat(s.projectId, "/").concat(s.database, ") which is not supported. It will be treated as a reference in the current database (").concat(e.projectId, "/").concat(e.database, ") instead.")), i;
    }
  }]);

  return ol;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */


function ul(t, e, n) {
  var s; // Cast to `any` in order to satisfy the union type constraint on
  // toFirestore().
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return s = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, s;
}

var cl = /*#__PURE__*/function (_ol) {
  _inherits(cl, _ol);

  var _super46 = _createSuper(cl);

  function cl(t) {
    var _this209;

    _classCallCheck(this, cl);

    _this209 = _super46.call(this), _this209.firestore = t;
    return _this209;
  }

  _createClass(cl, [{
    key: "convertBytes",
    value: function convertBytes(t) {
      return new eh(t);
    }
  }, {
    key: "convertReference",
    value: function convertReference(t) {
      var e = this.convertDocumentKey(t, this.firestore._databaseId);
      return new ba(this.firestore,
      /* converter= */
      null, e);
    }
  }]);

  return cl;
}(ol);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */


var al = /*#__PURE__*/function () {
  /** @hideconstructor */
  function al(t, e) {
    _classCallCheck(this, al);

    this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = hh(t);
  }

  _createClass(al, [{
    key: "set",
    value: function set(t, e, n) {
      this._verifyNotCommitted();

      var s = hl(t, this._firestore),
          i = ul(s.converter, e, n),
          r = lh(this._dataReader, "WriteBatch.set", s._key, i, null !== s.converter, n);
      return this._mutations.push(r.toMutation(s._key, $n.none())), this;
    }
  }, {
    key: "update",
    value: function update(t, e, n) {
      this._verifyNotCommitted();

      var i = hl(t, this._firestore); // For Compat types, we have to "extract" the underlying types before
      // performing validation.

      var r;

      for (var _len15 = arguments.length, s = new Array(_len15 > 3 ? _len15 - 3 : 0), _key15 = 3; _key15 < _len15; _key15++) {
        s[_key15 - 3] = arguments[_key15];
      }

      return r = "string" == typeof (e = getModularInstance(e)) || e instanceof Za ? ph(this._dataReader, "WriteBatch.update", i._key, e, n, s) : yh(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(r.toMutation(i._key, $n.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */

  }, {
    key: "delete",
    value: function _delete(t) {
      this._verifyNotCommitted();

      var e = hl(t, this._firestore);
      return this._mutations = this._mutations.concat(new Yn(e._key, $n.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */

  }, {
    key: "commit",
    value: function commit() {
      return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
  }, {
    key: "_verifyNotCommitted",
    value: function _verifyNotCommitted() {
      if (this._committed) throw new Q(G.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
  }]);

  return al;
}();

function hl(t, e) {
  if ((t = getModularInstance(t)).firestore !== e) throw new Q(G.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
  return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.

/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */


function ll(t) {
  t = Ia(t, ba);
  var e = Ia(t.firestore, Fa);
  return ua(La(e), t._key).then(function (n) {
    return bl(e, t, n);
  });
}

var fl = /*#__PURE__*/function (_ol2) {
  _inherits(fl, _ol2);

  var _super47 = _createSuper(fl);

  function fl(t) {
    var _this210;

    _classCallCheck(this, fl);

    _this210 = _super47.call(this), _this210.firestore = t;
    return _this210;
  }

  _createClass(fl, [{
    key: "convertBytes",
    value: function convertBytes(t) {
      return new eh(t);
    }
  }, {
    key: "convertReference",
    value: function convertReference(t) {
      var e = this.convertDocumentKey(t, this.firestore._databaseId);
      return new ba(this.firestore,
      /* converter= */
      null, e);
    }
  }]);

  return fl;
}(ol);
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */


function dl(t) {
  t = Ia(t, ba);
  var e = Ia(t.firestore, Fa),
      n = La(e),
      s = new fl(e);
  return oa(n, t._key).then(function (n) {
    return new kh(e, s, t._key, n, new Nh(null !== n && n.hasLocalMutations,
    /* fromCache= */
    !0), t.converter);
  });
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */


function _l(t) {
  t = Ia(t, ba);
  var e = Ia(t.firestore, Fa);
  return ua(La(e), t._key, {
    source: "server"
  }).then(function (n) {
    return bl(e, t, n);
  });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */


function wl(t) {
  t = Ia(t, Pa);
  var e = Ia(t.firestore, Fa),
      n = La(e),
      s = new fl(e);
  return Bh(t._query), aa(n, t._query).then(function (n) {
    return new Mh(e, s, t, n);
  });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */


function ml(t) {
  t = Ia(t, Pa);
  var e = Ia(t.firestore, Fa),
      n = La(e),
      s = new fl(e);
  return ca(n, t._query).then(function (n) {
    return new Mh(e, s, t, n);
  });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */


function gl(t) {
  t = Ia(t, Pa);
  var e = Ia(t.firestore, Fa),
      n = La(e),
      s = new fl(e);
  return aa(n, t._query, {
    source: "server"
  }).then(function (n) {
    return new Mh(e, s, t, n);
  });
}

function yl(t, e, n) {
  t = Ia(t, ba);
  var s = Ia(t.firestore, Fa),
      i = ul(t.converter, e, n);
  return Rl(s, [lh(hh(s), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $n.none())]);
}

function pl(t, e, n) {
  t = Ia(t, ba);
  var i = Ia(t.firestore, Fa),
      r = hh(i);
  var o;

  for (var _len16 = arguments.length, s = new Array(_len16 > 3 ? _len16 - 3 : 0), _key16 = 3; _key16 < _len16; _key16++) {
    s[_key16 - 3] = arguments[_key16];
  }

  o = "string" == typeof ( // For Compat types, we have to "extract" the underlying types before
  // performing validation.
  e = getModularInstance(e)) || e instanceof Za ? ph(r, "updateDoc", t._key, e, n, s) : yh(r, "updateDoc", t._key, e);
  return Rl(i, [o.toMutation(t._key, $n.exists(!0))]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */


function Il(t) {
  return Rl(Ia(t.firestore, Fa), [new Yn(t._key, $n.none())]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */


function Tl(t, e) {
  var n = Ia(t.firestore, Fa),
      s = Da(t),
      i = ul(t.converter, e);
  return Rl(n, [lh(hh(t.firestore), "addDoc", s._key, i, null !== t.converter, {}).toMutation(s._key, $n.exists(!1))]).then(function () {
    return s;
  });
}

function El(t) {
  for (var _len17 = arguments.length, e = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
    e[_key17 - 1] = arguments[_key17];
  }

  var n, s, i;
  t = getModularInstance(t);
  var r = {
    includeMetadataChanges: !1
  },
      o = 0;
  "object" != typeof e[o] || ka(e[o]) || (r = e[o], o++);
  var u = {
    includeMetadataChanges: r.includeMetadataChanges
  };

  if (ka(e[o])) {
    var _t113 = e[o];
    e[o] = null === (n = _t113.next) || void 0 === n ? void 0 : n.bind(_t113), e[o + 1] = null === (s = _t113.error) || void 0 === s ? void 0 : s.bind(_t113), e[o + 2] = null === (i = _t113.complete) || void 0 === i ? void 0 : i.bind(_t113);
  }

  var c, a, h;
  if (t instanceof ba) a = Ia(t.firestore, Fa), h = rn(t._key.path), c = {
    next: function next(n) {
      e[o] && e[o](bl(a, t, n));
    },
    error: e[o + 1],
    complete: e[o + 2]
  };else {
    var _n40 = Ia(t, Pa);

    a = Ia(_n40.firestore, Fa), h = _n40._query;

    var _s32 = new fl(a);

    c = {
      next: function next(t) {
        e[o] && e[o](new Mh(a, _s32, _n40, t));
      },
      error: e[o + 1],
      complete: e[o + 2]
    }, Bh(t._query);
  }
  return function (t, e, n, s) {
    var i = new Gc(s),
        r = new Ju(e, i, n);
    return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
      return _regeneratorRuntime.wrap(function _callee69$(_context69) {
        while (1) {
          switch (_context69.prev = _context69.next) {
            case 0:
              _context69.t0 = Qu;
              _context69.next = 3;
              return sa(t);

            case 3:
              _context69.t1 = _context69.sent;
              _context69.t2 = r;
              return _context69.abrupt("return", (0, _context69.t0)(_context69.t1, _context69.t2));

            case 6:
            case "end":
              return _context69.stop();
          }
        }
      }, _callee69);
    }))), function () {
      i.Tc(), t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.t0 = ju;
                _context70.next = 3;
                return sa(t);

              case 3:
                _context70.t1 = _context70.sent;
                _context70.t2 = r;
                return _context70.abrupt("return", (0, _context70.t0)(_context70.t1, _context70.t2));

              case 6:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70);
      })));
    };
  }(La(a), h, u, c);
}

function Al(t, e) {
  return ha(La(t = Ia(t, Fa)), ka(e) ? e : {
    next: e
  });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */


function Rl(t, e) {
  return function (t, e) {
    var n = new j();
    return t.asyncQueue.enqueueAndForget( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71() {
      return _regeneratorRuntime.wrap(function _callee71$(_context71) {
        while (1) {
          switch (_context71.prev = _context71.next) {
            case 0:
              _context71.t0 = hc;
              _context71.next = 3;
              return na(t);

            case 3:
              _context71.t1 = _context71.sent;
              _context71.t2 = e;
              _context71.t3 = n;
              return _context71.abrupt("return", (0, _context71.t0)(_context71.t1, _context71.t2, _context71.t3));

            case 7:
            case "end":
              return _context71.stop();
          }
        }
      }, _callee71);
    }))), n.promise;
  }(La(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */


function bl(t, e, n) {
  var s = n.docs.get(e._key),
      i = new fl(t);
  return new kh(t, i, e._key, s, new Nh(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */


var Pl = /*#__PURE__*/function (_ref65) {
  _inherits(Pl, _ref65);

  var _super48 = _createSuper(Pl);

  // This class implements the same logic as the Transaction API in the Lite SDK
  // but is subclassed in order to return its own DocumentSnapshot types.

  /** @hideconstructor */
  function Pl(t, e) {
    var _this211;

    _classCallCheck(this, Pl);

    _this211 = _super48.call(this, t, e), _this211._firestore = t;
    return _this211;
  }
  /**
   * Reads the document referenced by the provided {@link DocumentReference}.
   *
   * @param documentRef - A reference to the document to be read.
   * @returns A `DocumentSnapshot` with the read data.
   */


  _createClass(Pl, [{
    key: "get",
    value: function get(t) {
      var _this212 = this;

      var e = hl(t, this._firestore),
          n = new fl(this._firestore);
      return _get(_getPrototypeOf(Pl.prototype), "get", this).call(this, t).then(function (t) {
        return new kh(_this212._firestore, n, e._key, t._document, new Nh(
        /* hasPendingWrites= */
        !1,
        /* fromCache= */
        !1), e.converter);
      });
    }
  }]);

  return Pl;
}( /*#__PURE__*/function () {
  /** @hideconstructor */
  function _class5(t, e) {
    _classCallCheck(this, _class5);

    this._firestore = t, this._transaction = e, this._dataReader = hh(t);
  }
  /**
   * Reads the document referenced by the provided {@link DocumentReference}.
   *
   * @param documentRef - A reference to the document to be read.
   * @returns A `DocumentSnapshot` with the read data.
   */


  _createClass(_class5, [{
    key: "get",
    value: function get(t) {
      var _this213 = this;

      var e = hl(t, this._firestore),
          n = new cl(this._firestore);
      return this._transaction.lookup([e._key]).then(function (t) {
        if (!t || 1 !== t.length) return L();
        var s = t[0];
        if (s.isFoundDocument()) return new Dh(_this213._firestore, n, s.key, s, e.converter);
        if (s.isNoDocument()) return new Dh(_this213._firestore, n, e._key, null, e.converter);
        throw L();
      });
    }
  }, {
    key: "set",
    value: function set(t, e, n) {
      var s = hl(t, this._firestore),
          i = ul(s.converter, e, n),
          r = lh(this._dataReader, "Transaction.set", s._key, i, null !== s.converter, n);
      return this._transaction.set(s._key, r), this;
    }
  }, {
    key: "update",
    value: function update(t, e, n) {
      var i = hl(t, this._firestore); // For Compat types, we have to "extract" the underlying types before
      // performing validation.

      var r;

      for (var _len18 = arguments.length, s = new Array(_len18 > 3 ? _len18 - 3 : 0), _key18 = 3; _key18 < _len18; _key18++) {
        s[_key18 - 3] = arguments[_key18];
      }

      return r = "string" == typeof (e = getModularInstance(e)) || e instanceof Za ? ph(this._dataReader, "Transaction.update", i._key, e, n, s) : yh(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, r), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */

  }, {
    key: "delete",
    value: function _delete(t) {
      var e = hl(t, this._firestore);
      return this._transaction.delete(e._key), this;
    }
  }]);

  return _class5;
}());
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */


function vl(t, e, n) {
  t = Ia(t, Fa);
  var s = Object.assign(Object.assign({}, rl), n);
  !function (t) {
    if (t.maxAttempts < 1) throw new Q(G.INVALID_ARGUMENT, "Max attempts must be at least 1");
  }(s);
  return la(La(t), function (n) {
    return e(new Pl(t, n));
  }, s);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */


function Vl() {
  return new fh("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */


function Sl() {
  return new _h("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */


function Dl() {
  for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    t[_key19] = arguments[_key19];
  }

  // NOTE: We don't actually parse the data until it's used in set() or
  // update() since we'd need the Firestore instance to do this.
  return new wh("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */


function Cl() {
  for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    t[_key20] = arguments[_key20];
  }

  // NOTE: We don't actually parse the data until it's used in set() or
  // update() since we'd need the Firestore instance to do this.
  return new mh("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */


function xl(t) {
  return new gh("increment", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */


function Nl(t) {
  return La(t = Ia(t, Fa)), new al(t, function (e) {
    return Rl(t, e);
  });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function kl(t, e) {
  La(t = Ia(t, Fa));
  var n = "string" == typeof e ? function (t) {
    try {
      return JSON.parse(t);
    } catch (t) {
      throw new Q(G.INVALID_ARGUMENT, "Failed to parse JSON:" + t.message);
    }
  }(e) : e,
      s = []; // PORTING NOTE: We don't return an error if the user has not enabled
  // persistence since `enableIndexeddbPersistence()` can fail on the Web.

  if (Array.isArray(n.indexes)) {
    var _iterator80 = _createForOfIteratorHelper(n.indexes),
        _step80;

    try {
      for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
        var _t114 = _step80.value;

        var _e52 = Ol(_t114, "collectionGroup"),
            _n41 = [];

        if (Array.isArray(_t114.fields)) {
          var _iterator81 = _createForOfIteratorHelper(_t114.fields),
              _step81;

          try {
            for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
              var _e53 = _step81.value;

              var _t115 = vh("setIndexConfiguration", Ol(_e53, "fieldPath"));

              "CONTAINS" === _e53.arrayConfig ? _n41.push(new gt(_t115, 2
              /* CONTAINS */
              )) : "ASCENDING" === _e53.order ? _n41.push(new gt(_t115, 0
              /* ASCENDING */
              )) : "DESCENDING" === _e53.order && _n41.push(new gt(_t115, 1
              /* DESCENDING */
              ));
            }
          } catch (err) {
            _iterator81.e(err);
          } finally {
            _iterator81.f();
          }
        }

        s.push(new _t(_t.UNKNOWN_ID, _e52, _n41, yt.empty()));
      }
    } catch (err) {
      _iterator80.e(err);
    } finally {
      _iterator80.f();
    }
  } // TODO(indexing): Configure indexes


  return Promise.resolve();
}

function Ol(t, e) {
  if ("string" != typeof t[e]) throw new Q(G.INVALID_ARGUMENT, "Missing string value for: " + e);
  return t[e];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */


!function (t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  !function (t) {
    x = t;
  }(SDK_VERSION), _registerComponent(new Component("firestore", function (t, _ref66) {
    var n = _ref66.options;
    var s = t.getProvider("app").getImmediate(),
        i = new Fa(s, new J(t.getProvider("auth-internal")), new tt(t.getProvider("app-check-internal")));
    return n = Object.assign({
      useFetchStreams: e
    }, n), i._setSettings(n), i;
  }, "PUBLIC")), registerVersion(D, "3.4.10", t), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
  registerVersion(D, "3.4.10", "esm2017");
}();
export { ol as AbstractUserDataWriter, eh as Bytes, Ma as CACHE_SIZE_UNLIMITED, va as CollectionReference, ba as DocumentReference, kh as DocumentSnapshot, Za as FieldPath, nh as FieldValue, Fa as Firestore, Q as FirestoreError, sh as GeoPoint, Oa as LoadBundleTask, Pa as Query, Lh as QueryConstraint, Oh as QueryDocumentSnapshot, Mh as QuerySnapshot, Nh as SnapshotMetadata, ut as Timestamp, Pl as Transaction, al as WriteBatch, re as _DatabaseId, dt as _DocumentKey, et as _EmptyAppCheckTokenProvider, z as _EmptyAuthCredentialsProvider, ft as _FieldPath, Ia as _cast, q as _debugAssert, Ht as _isBase64Available, $ as _logWarn, kl as _setIndexConfiguration, ma as _validateIsNotUsedTogether, Tl as addDoc, Cl as arrayRemove, Dl as arrayUnion, Qa as clearIndexedDbPersistence, Va as collection, Sa as collectionGroup, Ra as connectFirestoreEmulator, Il as deleteDoc, Vl as deleteField, za as disableNetwork, Da as doc, th as documentId, qa as enableIndexedDbPersistence, Ka as enableMultiTabIndexedDbPersistence, Wa as enableNetwork, tl as endAt, Zh as endBefore, La as ensureFirestoreConfigured, Rl as executeWrite, ll as getDoc, dl as getDocFromCache, _l as getDocFromServer, wl as getDocs, ml as getDocsFromCache, gl as getDocsFromServer, Ba as getFirestore, xl as increment, $a as initializeFirestore, Wh as limit, zh as limitToLast, Ja as loadBundle, Ya as namedQuery, El as onSnapshot, Al as onSnapshotsInSync, Qh as orderBy, Uh as query, xa as queryEqual, Ca as refEqual, vl as runTransaction, Sl as serverTimestamp, yl as setDoc, O as setLogLevel, $h as snapshotEqual, Yh as startAfter, Jh as startAt, Ha as terminate, pl as updateDoc, ja as waitForPendingWrites, Kh as where, Nl as writeBatch };